import React, { useState, useEffect, useCallback, useRef, useMemo, memo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Typography, Button, Tag, Badge, Spin, Alert, Tooltip, Menu, Avatar, Space, Input, InputNumber, Statistic, Drawer, Tabs, Carousel, Modal, List, Empty, Timeline, Skeleton, Divider, Progress, Select, Checkbox, Image as AntImage } from 'antd';
import { StarFilled, StarOutlined, BellFilled, ClockCircleOutlined, UserOutlined, DollarOutlined, CloseOutlined, HeartOutlined, HeartFilled, LockOutlined, CheckCircleOutlined, CloseCircleOutlined, MenuOutlined, QuestionCircleOutlined, PlayCircleOutlined, DoubleLeftOutlined, DoubleRightOutlined, UnorderedListOutlined, HistoryOutlined, TrophyOutlined, CrownOutlined, ThunderboltOutlined, EditOutlined, FullscreenOutlined, FullscreenExitOutlined, SearchOutlined, LineChartOutlined, BellOutlined, UpOutlined, DownOutlined, SwapOutlined, DeleteOutlined, SendOutlined, SoundOutlined, BarChartOutlined, SettingOutlined, PlayCircleFilled, StopOutlined, CloseCircleFilled, RobotOutlined, BulbOutlined, RiseOutlined, FallOutlined, FireOutlined, LeftOutlined, RightOutlined, TeamOutlined, ShoppingOutlined, ShopOutlined, SafetyOutlined } from '@ant-design/icons';
import Countdown from 'react-countdown';
import auctionService from '../services/auctionService';
import pusherService from '../services/pusherService';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';
import favoriteService from '../services/favoriteService';
import { toggleFavoriteLot } from '../redux/userSlice';
import { loadConfettiPreset } from 'tsparticles-preset-confetti';
import Particles from 'react-tsparticles';
import LoadingSpinner, { AuctionCountdown } from '../components/LoadingSpinner';
import { startServerTimeSync, getServerNow } from '../utils/serverTime';
import env from '../env';
import VideoPreviewModal from '../components/VideoPreviewModal';
import { validateVideoUrl, validateLiveStreamUrl } from '../utils/videoUtils';
import LiveStreamEmbed from '../components/LiveAuction/LiveStreamEmbed';
import LiveStreamPanel from '../components/LiveAuction/LiveStreamPanel';
import OnlineUsers from '../components/OnlineUsers';
import ContactAgentsOwner from '../components/Common/ContactAgentsOwner';
import AnnouncementModal from '../components/LiveAuction/AnnouncementModal';
import ComparisonModal from '../components/LiveAuction/ComparisonModal';
import AchievementUnlockedModal from '../components/LiveAuction/AchievementUnlockedModal';
import { getLotCardStyle } from '../components/LiveAuction/getLotCardStyle';
import { formatCurrency, formatPrice, formatCurrencyClean } from '../utils/format';
import { checkIfLotClosed, isLotCancelled, isCloseToReserve, isReserveMet, announcementSounds } from '../components/LiveAuction/LotUtil';
import CancelledLotContent from '../components/LiveAuction/CancelledLotContent';
import ActiveLotContent from '../components/LiveAuction/ActiveLotContent';
import ClosedLotStatus from '../components/LiveAuction/ClosedLotStatus';
import FavoriteButton from '../components/LiveAuction/FavoriteButton';
import SubscribeButton from '../components/LiveAuction/SubscribeButton';
import BidRejectionModal from '../components/LiveAuction/BidRejectionModal';
import AIPriceRecommendation from '../components/LiveAuction/AIPriceRecommendation';
import { GetSidebarMenu } from '../components/LiveAuction/GetSidebarMenu';
import { BidHistoryViewer } from '../components/LiveAuction/BidHistoryViewer';
import { LotSpecifications } from '../components/LiveAuction/LotSpecifications';
import StatisticsModal from '../components/LiveAuction/StatisticsModal';
import SoundModal from '../components/LiveAuction/SoundModal';
import BidActivityDrawer from '../components/LiveAuction/BidActivityDrawer';
import BidReminderModal from '../components/LiveAuction/BidReminderModal';
import MaxBidDashboardModal from '../components/LiveAuction/MaxBidDashboardModal';
import TemplateBidsModal from '../components/LiveAuction/TemplateBidsModal';
import AnnouncementBanner from '../components/LiveAuction/AnnouncementBanner';
import LotSearchModal from '../components/LiveAuction/LotSearchModal';
import HelpModal from '../components/LiveAuction/HelpModal';

const { Title, Text } = Typography;

const mapActivityBidToHistoryBid = (bid) => ({
    id: bid.id,
    lot_id: bid.lot_id,
    user_id: bid.user_id,
    user: bid.user,
    amount: bid.amount,
    is_winning: bid.is_winning,
    created_at: bid.created_at,
    is_start_bid: bid.is_start_bid || false,
    is_vendor_bid: bid.is_vendor_bid || false
});

const mergeLotBidHistories = (primaryBids, supplementalBids) => {
    const bidsById = new Map();

    primaryBids.forEach((bid) => {
        if (bid?.id != null) {
            bidsById.set(bid.id, bid);
        }
    });

    supplementalBids.forEach((bid) => {
        if (bid?.id != null && !bidsById.has(bid.id)) {
            bidsById.set(bid.id, bid);
        }
    });

    return Array.from(bidsById.values()).sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
};

const getLotBidsFromActivity = (bidActivityData, lotId) =>
    bidActivityData
        .filter((bid) => Number(bid.lot_id) === Number(lotId))
        .map(mapActivityBidToHistoryBid);

const styles = `
    @media (max-width: 576px) {
        .lot-card {
            height: 140px !important;
        }
        .lot-title {
            font-size: 11px !important;
            margin: 2px 0 8px 0 !important;
        }
        .lot-price {
            font-size: 14px !important;
            margin: 2px 0 !important;
        }
        .lot-reserve {
            font-size: 9px !important;
        }
        .lot-status {
            font-size: 12px !important;
            padding: 4px 6px !important;
        }
        .lot-timer {
            font-size: 9px !important;
            padding: 1px 6px !important;
        }
        .lot-favorite {
            font-size: 12px !important;
            padding: 1px !important;
        }
        .lot-container {
            padding: 4px 8px !important;
        }
        .lot-content {
            padding: 4px !important;
        }
        .lot-cancelled {
            font-size: 12px !important;
            margin: 2px 0 !important;
        }
        .lot-cancelled-title {
            font-size: 10px !important;
            margin-bottom: 8px !important;
        }
        .lot-cancelled-price {
            font-size: 12px !important;
        }
        .lot-cancelled-reserve {
            font-size: 8px !important;
        }
        .auction-title-mobile {
            font-size: 13px !important;
        }
        .auction-title-mobile .anticon {
            font-size: 12px !important;
        }
    }
    
    @media (max-width: 480px) {
        .auction-title-mobile {
            font-size: 12px !important;
        }
        .auction-title-mobile .anticon {
            font-size: 11px !important;
        }
    }
    
    @media (min-width: 768px) {
        .detail-panel-desktop {
            height: 100vh !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
        }
        
        .sidebar-desktop {
            height: 100vh !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
        }
    }
    
    /* Hide vertical sidebar on mobile and tablet */
    @media (max-width: 991px) {
        .sidebar-desktop {
            display: none !important;
        }
        
        /* Scrollable toolbar on mobile and tablet */
        .auction-header-mobile {
            overflow-x: visible !important;
            overflow-y: visible !important;
        }
        
        .toolbar-scrollable {
            scrollbar-width: thin;
            scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
            flex-wrap: nowrap !important;
        }
        
        .toolbar-scrollable > * {
            flex-shrink: 0 !important;
            flex-grow: 0 !important;
            white-space: nowrap !important;
        }
        
        .toolbar-scrollable::-webkit-scrollbar {
            height: 4px;
        }
        
        .toolbar-scrollable::-webkit-scrollbar-track {
            background: transparent;
        }
        
        .toolbar-scrollable::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 2px;
        }
        
        .toolbar-scrollable::-webkit-scrollbar-thumb:hover {
            background-color: rgba(0, 0, 0, 0.3);
        }
    }
    
    /* Mobile/Tablet Layout - Stack vertically and position detail panel below */
    @media (max-width: 991px) {
        /* Allow the parent Row to scroll naturally - remove gutter on mobile/tablet */
        .ant-row {
            overflow-y: visible !important;
            overflow-x: hidden !important;
            height: auto !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
        
        /* Remove gutter spacing from Cols on mobile/tablet */
        .ant-col {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        
        /* Add padding between lots on mobile/tablet */
        .lot-container {
            padding-left: 8px !important;
            padding-right: 8px !important;
        }
        
        /* Main content section - lots grid/list - no scrollbar - full width */
        .main-content-section {
            order: 1 !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            min-height: auto !important;
            max-height: none !important;
            overflow: visible !important;
            overflow-y: visible !important;
            flex-shrink: 0 !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        
        /* Detail panel - positioned below, same as desktop but no scrollbar - full width */
        .detail-panel-desktop {
            order: 2 !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            max-height: none !important;
            position: relative !important;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
            border-top: 2px solid #d9d9d9 !important;
            overflow: visible !important;
            overflow-y: visible !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        
        /* Hide scrollbars on mobile/tablet */
        .main-content-section::-webkit-scrollbar,
        .detail-panel-desktop::-webkit-scrollbar {
            display: none !important;
        }
        
        .main-content-section,
        .detail-panel-desktop {
            -ms-overflow-style: none !important;
            scrollbar-width: none !important;
        }
        
        /* Hide scrollbar for horizontal menu on mobile/tablet */
        .horizontal-menu-scroll::-webkit-scrollbar {
            display: none !important;
        }
        
        .horizontal-menu-scroll {
            -ms-overflow-style: none !important;
            scrollbar-width: none !important;
        }
        
        /* Fixed horizontal menu on mobile/tablet */
        .horizontal-menu-mobile {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            z-index: 1001 !important;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
        }
        
        /* Fixed header on mobile/tablet - below horizontal menu */
        .auction-header-mobile {
            position: fixed !important;
            top: 60px !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            z-index: 1000 !important;
            background: #fafafa !important;
        }
        
        /* Add top padding to main content to account for fixed header and menu */
        .main-content-section {
            padding-top: 140px !important;
        }
        
        /* Fixed bidding buttons at bottom on mobile/tablet */
        .bidding-buttons-mobile {
            position: fixed !important;
            bottom: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            z-index: 999 !important;
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
            padding: 12px !important;
            border-top: 2px solid #d9d9d9 !important;
            box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15) !important;
        }
        
        /* Add bottom padding to scrollable content to account for fixed bidding buttons or subscribe button */
        .detail-panel-desktop .ant-card-body > div[style*="flex"] {
            padding-bottom: 120px !important;
        }
        
        /* Ensure SubscribeButton in fixed container is styled properly */
        .bidding-buttons-mobile .subscribe-button-container {
            width: 100%;
        }
    }
    
    /* For mobile specifically */
    @media (max-width: 576px) {
        .detail-panel-desktop {
            border-radius: 16px 16px 0 0 !important;
        }
    }
    
    /* Full screen layout for auction details page */
    .auction-detail-fullscreen {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        overflow: auto !important;
        background: #f5f5f5 !important;
        z-index: 1000 !important;
    }
    
    /* Hide header and footer on auction details page */
    .main-header,
    .main-footer {
        display: none !important;
    }
    
    /* Enhanced small and beautiful tabs for lot details */
    .lot-details-tabs .ant-tabs-nav {
        margin: 0 !important;
        margin-bottom: 12px !important;
        padding: 0 !important;
    }
    
    .lot-details-tabs .ant-tabs-nav::before {
        border-bottom: 1px solid #f0f0f0 !important;
    }
    
    .lot-details-tabs .ant-tabs-tab {
        padding: 6px 14px !important;
        margin: 0 2px 0 0 !important;
        font-size: 13px !important;
        font-weight: 500 !important;
        height: 32px !important;
        line-height: 20px !important;
        color: #8c8c8c !important;
        transition: all 0.2s ease !important;
        border-radius: 6px 6px 0 0 !important;
        border: none !important;
        background: transparent !important;
    }
    
    .lot-details-tabs .ant-tabs-tab:hover {
        color: #1890ff !important;
        background: rgba(24, 144, 255, 0.06) !important;
    }
    
    .lot-details-tabs .ant-tabs-tab-active {
        color: #1890ff !important;
        font-weight: 600 !important;
        background: rgba(24, 144, 255, 0.08) !important;
    }
    
    .lot-details-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #1890ff !important;
    }
    
    .lot-details-tabs .ant-tabs-ink-bar {
        height: 2px !important;
        background: linear-gradient(90deg, #1890ff 0%, #40a9ff 100%) !important;
        border-radius: 2px 2px 0 0 !important;
    }
    
    .lot-details-tabs .ant-tabs-content-holder {
        padding: 0 !important;
        margin: 0 !important;
    }
    
    .lot-details-tabs .ant-tabs-content {
        padding: 0 !important;
        margin: 0 !important;
    }
    
    .lot-details-tabs .ant-tabs-tabpane {
        padding: 0 !important;
    }
    
    /* Mobile responsive adjustments */
    @media (max-width: 576px) {
        .lot-details-tabs .ant-tabs-tab {
            padding: 4px 10px !important;
            font-size: 12px !important;
            height: 28px !important;
            line-height: 20px !important;
        }
    }
    
    /* Reserve Met Notification Animations */
    @keyframes reserveMetSlideIn {
        from {
            opacity: 0;
            transform: translateX(-50%) translateY(-100px);
        }
        to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
        }
    }
    
    @keyframes reserveMetSlideOut {
        from {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
        }
        to {
            opacity: 0;
            transform: translateX(-50%) translateY(-100px);
        }
    }
    
    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
    }
`;

// Lot Card Component
const LotCard = ({
    lot,
    isSelected,
    onSelect,
    onFavorite,
    isFavorite,
    isAvailable,
    currentUser,
    auctionOwnerId,
    renderTimer,
    statusLoadingLots,
    timeoutLoadingLots,
    outbidNotifications,
    successfulOutbidNotifications,
    competitionOutbidNotifications,
    newBidLots,
    timeRemaining,
    auction,
    bidReminders,
    setReminderModalVisible,
    isInComparison,
    onToggleComparison,
    scrollToDetails,
    isTabletOrMobile,
    activeAutoBids
}) => {
    return (
        <Card
            hoverable={true}
            style={getLotCardStyle(lot, {
                currentUser,
                auctionOwnerId,
                isSelected,
                newBidLots,
                isAvailable
            })}
            className="lot-card notranslate"
            translate="no"
            onClick={() => onSelect(lot)}
        >
            <Space direction="vertical" style={{
                width: '100%',
                height: '100%',
                padding: '6px',
                justifyContent: 'space-between'
            }} className="lot-content">
                {isLotCancelled(lot) ? (
                    <CancelledLotContent lot={lot} />
                ) : (
                    <ActiveLotContent
                        lot={lot}
                        currentUser={currentUser}
                        auctionOwnerId={auctionOwnerId}
                        renderTimer={renderTimer}
                        statusLoadingLots={statusLoadingLots}
                        activeAutoBids={activeAutoBids}
                    />
                )}
                <FavoriteButton
                    isFavorite={isFavorite}
                    onFavorite={(e) => {
                        e.stopPropagation();
                        onFavorite(lot.id, e);
                    }}
                />
                {onToggleComparison && (
                    <Tooltip title={isInComparison ? "Remove from comparison" : "Add to comparison"}>
                        <div
                            style={{
                                position: 'absolute',
                                bottom: 3,
                                right: 8,
                                zIndex: 20,
                                pointerEvents: 'auto'
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                checked={isInComparison}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    onToggleComparison(lot.id);
                                }}
                                onClick={(e) => e.stopPropagation()}
                                data-tour="comparison-checkbox"
                            />
                        </div>
                    </Tooltip>
                )}
                {lot.status === 'active' && bidReminders && bidReminders[lot.id] && (
                    <Tooltip title={`Reminder set: ${bidReminders[lot.id].reminderSeconds}s before closing`}>
                        <div
                            style={{
                                position: 'absolute',
                                bottom: 8,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                background: 'rgba(250, 173, 20, 0.9)',
                                padding: '4px 4px',
                                borderRadius: '12px',
                                zIndex: 10,
                                pointerEvents: 'none'
                            }}
                        >
                            <BellOutlined style={{
                                fontSize: '12px',
                                color: '#fff'
                            }} />
                            <span style={{
                                fontSize: '10px',
                                color: '#fff',
                                fontWeight: '600'
                            }}>
                                Reminder: {bidReminders[lot.id].reminderSeconds}s
                            </span>
                        </div>
                    </Tooltip>
                )}
                {lot.pending_bid_user_id && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(250, 173, 20, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'none'
                    }}>
                        <Tag color="orange" style={{ margin: 0 }}>
                            {lot.pending_bid_user_id === currentUser?.id ? (
                                'Your Bid Pending...'
                            ) : (
                                `Pending Bid: ${formatCurrency(lot.pending_bid_amount)}`
                            )}
                        </Tag>
                    </div>
                )}
                {outbidNotifications.has(lot.id) && (
                    <div
                        data-tour="counter-bid-colors"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(255, 77, 79, 0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            animation: 'pulse 2s infinite'
                        }}>
                        <div style={{ textAlign: 'center' }}>
                            <Tag color="red" style={{ margin: 0, fontWeight: 'bold', marginBottom: '4px' }}>
                                You've Been Outbid!
                            </Tag>
                            <div style={{
                                fontSize: '10px',
                                color: '#ff4d4f',
                                fontWeight: 'bold',
                                textShadow: '0 0 4px rgba(255,255,255,0.8)'
                            }}>
                                New bid: ${formatCurrency(lot.current_price)}
                            </div>
                        </div>
                    </div>
                )}
                {successfulOutbidNotifications.has(lot.id) && (
                    <div
                        data-tour="counter-bid-colors"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(82, 196, 26, 0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            animation: 'pulse 2s infinite'
                        }}>
                        <div style={{ textAlign: 'center' }}>
                            <Tag color="green" style={{ margin: 0, fontWeight: 'bold', marginBottom: '4px' }}>
                                You Outbid Them!
                            </Tag>
                            <div style={{
                                fontSize: '10px',
                                color: '#52c41a',
                                fontWeight: 'bold',
                                textShadow: '0 0 4px rgba(255,255,255,0.8)'
                            }}>
                                Your bid: ${formatCurrency(lot.current_price)}
                            </div>
                        </div>
                    </div>
                )}
                {competitionOutbidNotifications.has(lot.id) && (
                    <div
                        data-tour="counter-bid-colors"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(24, 144, 255, 0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            animation: 'pulse 2s infinite'
                        }}>
                        <div style={{ textAlign: 'center' }}>
                            <Tag color="blue" style={{ margin: 0, fontWeight: 'bold', marginBottom: '4px' }}>
                                Competition Outbid!
                            </Tag>
                            <div style={{
                                fontSize: '10px',
                                color: '#1890ff',
                                fontWeight: 'bold',
                                textShadow: '0 0 4px rgba(255,255,255,0.8)'
                            }}>
                                New bid: ${formatCurrency(lot.current_price)}
                            </div>
                        </div>
                    </div>
                )}
                {timeoutLoadingLots.has(lot.id) && !checkIfLotClosed(lot) && (
                    <div style={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px',
                        pointerEvents: 'none',
                        zIndex: 10
                    }}>
                        <Tag color="orange" style={{
                            margin: 0,
                            fontWeight: 'bold',
                            fontSize: '10px',
                            padding: '2px 6px'
                        }}>
                            ⏰ Timing Out
                        </Tag>
                    </div>
                )}

                {/* Urgency Message - Show when <= 15 seconds (only for users who don't have the last bid and are not the auction owner) */}
                {timeRemaining !== null &&
                    timeRemaining <= 15 &&
                    timeRemaining > 5 &&
                    lot.status === 'active' &&
                    lot.last_bid_user_id !== currentUser?.id &&
                    currentUser?.id !== auction?.user_id && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(250, 173, 20, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            animation: 'pulse 1s ease-in-out infinite',
                            border: '2px solid #faad14',
                            borderRadius: '8px'
                        }}>
                            <div style={{ textAlign: 'center' }}>
                                <Tag color="orange" style={{ margin: 0, fontWeight: 'bold', marginBottom: '4px' }}>
                                    ⏰ Hurry up!
                                </Tag>
                                <div style={{
                                    fontSize: '10px',
                                    color: '#faad14',
                                    fontWeight: 'bold',
                                    textShadow: '0 0 4px rgba(255,255,255,0.8)'
                                }}>
                                    {timeRemaining}s remaining
                                </div>
                            </div>
                        </div>
                    )}

                {/* Critical Time Message - Show when <= 5 seconds (bidding disabled for everyone) */}
                {timeRemaining !== null &&
                    timeRemaining <= 5 &&
                    timeRemaining > 0 &&
                    lot.status === 'active' && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(255, 77, 79, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            animation: 'pulse 0.5s ease-in-out infinite',
                            border: '2px solid #ff4d4f',
                            borderRadius: '8px'
                        }}>
                            <div style={{ textAlign: 'center' }}>
                                <Tag color="red" style={{ margin: 0, fontWeight: 'bold', marginBottom: '4px' }}>
                                    🚫 Bidding locked
                                </Tag>
                                <div style={{
                                    fontSize: '10px',
                                    color: '#ff4d4f',
                                    fontWeight: 'bold',
                                    textShadow: '0 0 4px rgba(255,255,255,0.8)'
                                }}>
                                    Disabled for last {timeRemaining}s
                                </div>
                            </div>
                        </div>
                    )}

                {/* Scroll to Details Button - Mobile/Tablet Only */}
                {isTabletOrMobile && isSelected && scrollToDetails && (
                    <Button
                        type="primary"
                        icon={<DownOutlined />}
                        onClick={(e) => {
                            e.stopPropagation();
                            scrollToDetails();
                        }}
                        size="small"
                        style={{
                            position: 'absolute',
                            bottom: '8px',
                            left: '8px',
                            zIndex: 30,
                            height: '32px',
                            padding: '0 12px',
                            fontSize: '11px',
                            fontWeight: 500,
                            borderRadius: '16px',
                            boxShadow: '0 2px 8px rgba(24, 144, 255, 0.4)',
                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            pointerEvents: 'auto'
                        }}
                    >
                        Details
                    </Button>
                )}
            </Space>
        </Card>
    );
};

// Memoize LotCard to prevent unnecessary re-renders when other lots are selected
const MemoizedLotCard = memo(LotCard, (prevProps, nextProps) => {
    // Only re-render if these props change
    return (
        prevProps.lot.id === nextProps.lot.id &&
        prevProps.isSelected === nextProps.isSelected &&
        prevProps.isFavorite === nextProps.isFavorite &&
        prevProps.isAvailable === nextProps.isAvailable &&
        prevProps.isInComparison === nextProps.isInComparison &&
        prevProps.timeRemaining === nextProps.timeRemaining &&
        prevProps.lot.status === nextProps.lot.status &&
        prevProps.lot.current_price === nextProps.lot.current_price &&
        prevProps.lot.last_bid_user_id === nextProps.lot.last_bid_user_id &&
        prevProps.outbidNotifications.has(prevProps.lot.id) === nextProps.outbidNotifications.has(nextProps.lot.id) &&
        prevProps.successfulOutbidNotifications.has(prevProps.lot.id) === nextProps.successfulOutbidNotifications.has(nextProps.lot.id) &&
        prevProps.competitionOutbidNotifications.has(prevProps.lot.id) === nextProps.competitionOutbidNotifications.has(nextProps.lot.id) &&
        prevProps.newBidLots.has(prevProps.lot.id) === nextProps.newBidLots.has(nextProps.lot.id) &&
        prevProps.statusLoadingLots.has(prevProps.lot.id) === nextProps.statusLoadingLots.has(nextProps.lot.id) &&
        prevProps.timeoutLoadingLots.has(prevProps.lot.id) === nextProps.timeoutLoadingLots.has(nextProps.lot.id) &&
        prevProps.activeAutoBids.has(prevProps.lot.id) === nextProps.activeAutoBids.has(nextProps.lot.id) &&
        (prevProps.bidReminders?.[prevProps.lot.id]?.reminderSeconds || 0) === (nextProps.bidReminders?.[nextProps.lot.id]?.reminderSeconds || 0)
    );
});


// Lot Details Component
const LotDetails = ({ lot, auctionSlug }) => (
    <div>
        <Row gutter={[16, 16]}>



            <Col span={12}>
                {/* <Statistic
                    title="Status"
                    value={lot.status === 'closed' ? 'Closed' : 'Active'}
                    valueStyle={{ 
                        color: lot.status === 'closed' ? '#ff4d4f' : '#52c41a'
                    }}
                /> */}
                Lot #{lot.lot_number}
            </Col>
        </Row>
        <div style={{ marginTop: 24 }}>
            <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>Description</Text>
            <div style={{
                padding: 16,
                background: '#fafafa',
                borderRadius: 8,
                border: '1px solid #f0f0f0'
            }}>
                {lot.description}
            </div>
        </div>

        {/* Navigation Links */}
        <div style={{ marginTop: 24, padding: 16, background: '#f6f6f6', borderRadius: 8 }}>
            <Text strong style={{ display: 'block', marginBottom: 12 }}>View More Details</Text>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                    type="link"
                    style={{ padding: 0, height: 'auto', textAlign: 'left' }}
                    onClick={() => window.open(`/auctions/${auctionSlug}/lots/${lot.slug}`, '_blank')}
                >
                    📋 View Full Lot Details
                </Button>
                <Button
                    type="link"
                    style={{ padding: 0, height: 'auto', textAlign: 'left' }}
                    onClick={() => window.open(`/auctions/${auctionSlug}`, '_blank')}
                >
                    🏷️ View Auction Details
                </Button>
            </Space>
        </div>
    </div>
);


const LiveAuctionDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { currentUser } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [auction, setAuction] = useState(null);
    const [lots, setLots] = useState([]);
    const [selectedLot, setSelectedLot] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sidebarCounts, setSidebarCounts] = useState({
        total: 0,
        favorite: 0,
        held: 0,
        lost: 0,
        sold: 0,
        cancelled: 0,
        actively_bidding: 0
    });
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [isPresenceConnected, setIsPresenceConnected] = useState(false);

    // Sync local clock against the server's clock so lot/auction countdowns
    // agree across every viewer regardless of device clock drift or when
    // they joined - see utils/serverTime.js.
    useEffect(() => {
        startServerTimeSync();
    }, []);

    // Optimized data mapping function
    const mapMemberData = (member) => ({
        id: member.user_id || member.id,
        first_name: member.user_info?.first_name || member.info?.first_name || member.first_name,
        last_name: member.user_info?.last_name || member.info?.last_name || member.last_name,
        email: member.user_info?.email || member.info?.email || member.email
    });
    const [sidebarFilter, setSidebarFilter] = useState('all');
    const [sortBy, setSortBy] = useState('lot_number'); // 'lot_number', 'price', 'time_remaining', 'favorites'
    const previousSortByRef = useRef('lot_number'); // Store previous sort order before changing for actively_bidding
    const [notifications, setNotifications] = useState([]);
    const [bidding, setBidding] = useState(false);
    const [buyingNow, setBuyingNow] = useState(false);
    const [bidError, setBidError] = useState(null);
    const [autoBidAmount, setAutoBidAmount] = useState('');
    const [autoBidMaxAmount, setAutoBidMaxAmount] = useState('');
    const [autoBidActive, setAutoBidActive] = useState(false);
    const [customBidAmount, setCustomBidAmount] = useState('');
    const [validRoundedAmountApplied, setValidRoundedAmountApplied] = useState(false);
    const [showCustomBid, setShowCustomBid] = useState(false);
    const [showTemplateBidsModal, setShowTemplateBidsModal] = useState(false);
    const [stopAutoBid, setStopAutoBid] = useState(false);
    const [showAutoBidForm, setShowAutoBidForm] = useState(false);
    const [autoBidLotId, setAutoBidLotId] = useState(null);
    const [autoBidLotSlug, setAutoBidLotSlug] = useState(null);
    // Max-Bid Dashboard: Map of lotId -> { increment, maxAmount, lotSlug, lotName, intervalRef, stopRef, isBidding }
    const [activeAutoBids, setActiveAutoBids] = useState(new Map());
    const [showAutoBidDashboard, setShowAutoBidDashboard] = useState(false);
    const [showAutoBidDashboardView, setShowAutoBidDashboardView] = useState(false);
    // Track bidding in progress per lot to prevent race conditions
    const biddingInProgressRef = useRef(new Map());
    const bidActivityLoadedRef = useRef(false); // Track if bid activity has been loaded for current auction
    // Store checkAndBid functions for each lot so they can be called immediately when bid events arrive
    const autoBidCheckFunctionsRef = useRef(new Map());
    const [subscribedLotIds, setSubscribedLotIds] = useState([]);
    const [lotTimers, setLotTimers] = useState({});
    const [timerLoading, setTimerLoading] = useState({});
    const [closedLots, setClosedLots] = useState([]);
    const [hasInteracted, setHasInteracted] = useState(false);
    const [lastPlayedBid, setLastPlayedBid] = useState(null);
    const [soundTimeout, setSoundTimeout] = useState(null);
    const [isSequential, setIsSequential] = useState(false);
    const [activeLotId, setActiveLotId] = useState(null);
    const [isInvited, setIsInvited] = useState(false);
    const [invitationStatus, setInvitationStatus] = useState(null);
    const [isInvitationLoading, setIsInvitationLoading] = useState(true);
    const [bidModalVisible, setBidModalVisible] = useState(false);
    const [highlightedBids, setHighlightedBids] = useState({});
    const [newBidLots, setNewBidLots] = useState(new Set());
    const [activeFilter, setActiveFilter] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);
    const [isTabletOrMobile, setIsTabletOrMobile] = useState(window.innerWidth <= 991);
    const [processedEventIds] = useState(new Set());
    const [pendingBids] = useState(new Map());
    const [rejectedBids, setRejectedBids] = useState(new Map()); // Map of lotId -> array of rejected bids
    const [channelSubscribed, setChannelSubscribed] = useState(false);
    const [statusLoadingLots, setStatusLoadingLots] = useState(new Set());
    const [timeoutLoadingLots, setTimeoutLoadingLots] = useState(new Set());
    const [outbidNotifications, setOutbidNotifications] = useState(new Set());
    const [lastOutbidTime, setLastOutbidTime] = useState({});
    const [successfulOutbidNotifications, setSuccessfulOutbidNotifications] = useState(new Set());
    const [lastSuccessfulOutbidTime, setLastSuccessfulOutbidTime] = useState({});
    const [competitionOutbidNotifications, setCompetitionOutbidNotifications] = useState(new Set());
    const [lastCompetitionOutbidTime, setLastCompetitionOutbidTime] = useState({});
    const [processedBidNotifications] = useState(new Map());
    const [processedTimeoutEvents] = useState(new Set());
    const [showConfetti, setShowConfetti] = useState(false);
    const [confettiKey, setConfettiKey] = useState(0);
    // Use useRef to persist confettiTriggeredLots across renders
    // Load from localStorage on mount to prevent showing confetti again after refresh
    const confettiTriggeredLotsRef = useRef((() => {
        try {
            const stored = localStorage.getItem('confettiTriggeredLots');
            if (stored) {
                const lotIds = JSON.parse(stored);
                return new Set(lotIds);
            }
        } catch (e) {
            console.warn('Error loading confetti tracking from localStorage:', e);
        }
        return new Set();
    })());
    // Use useRef to persist successMessageTriggeredLots across renders
    // Load from localStorage on mount to prevent showing messages again after refresh
    const successMessageTriggeredLotsRef = useRef((() => {
        try {
            const stored = localStorage.getItem('successMessageTriggeredLots');
            if (stored) {
                const lotIds = JSON.parse(stored);
                return new Set(lotIds);
            }
        } catch (e) {
            console.warn('Error loading success message tracking from localStorage:', e);
        }
        return new Set();
    })());
    const [auctionHasStarted, setAuctionHasStarted] = useState(false);
    const [helpModalVisible, setHelpModalVisible] = useState(false);
    const [auctionVideoModalVisible, setAuctionVideoModalVisible] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const horizontalMenuRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    const detailPanelRef = useRef(null);
    const selectedLotRef = useRef(null);
    const [showScrollToLot, setShowScrollToLot] = useState(false);
    const [searchModalVisible, setSearchModalVisible] = useState(false);
    const [searchMode, setSearchMode] = useState('simple'); // 'simple' or 'advanced'
    const [simpleSearchQuery, setSimpleSearchQuery] = useState('');
    const [advancedSearch, setAdvancedSearch] = useState({
        title: '',
        description: '',
        lotNumber: '',
        minPrice: '',
        maxPrice: ''
    });
    const [lotLayout, setLotLayout] = useState('grid'); // 'grid', 'list'
    const [timeRemaining, setTimeRemaining] = useState(null); // Time remaining in seconds for selected lot
    const [allLotsTimeRemaining, setAllLotsTimeRemaining] = useState({}); // Time remaining for all lots
    const [bidHistory, setBidHistory] = useState([]);
    const [bidHistoryLoading, setBidHistoryLoading] = useState(false);
    const [bidHistoryModalVisible, setBidHistoryModalVisible] = useState(false);
    const [bidHistoryCache, setBidHistoryCache] = useState(new Map()); // Cache bid history per lot ID
    const [bidActivityCount, setBidActivityCount] = useState(0); // Track number of lots with bid activity
    const [lastViewedActivityCount, setLastViewedActivityCount] = useState(0); // Track last viewed activity count
    const [userInfoCache, setUserInfoCache] = useState(new Map()); // Cache user info by user ID (from bid history)
    const [showBiddingOptions, setShowBiddingOptions] = useState(true);
    const [bidReminders, setBidReminders] = useState(() => {
        // Load reminders from localStorage
        const saved = localStorage.getItem('bidReminders');
        return saved ? JSON.parse(saved) : {};
    }); // Map of lotId -> { reminderSeconds: number, triggered: boolean }
    const [reminderModalVisible, setReminderModalVisible] = useState(false);
    const [reminderDrawerVisible, setReminderDrawerVisible] = useState(false);
    const [comparisonLots, setComparisonLots] = useState([]); // Array of lot IDs for comparison
    const [comparisonModalVisible, setComparisonModalVisible] = useState(false);
    const [announcements, setAnnouncements] = useState([]); // Array of announcements {message, timestamp, user_name}
    const announcementTimeoutRef = useRef(null); // Ref to track auto-close timeout
    const [announcementModalVisible, setAnnouncementModalVisible] = useState(false);
    const [sendingAnnouncement, setSendingAnnouncement] = useState(false);
    const [availableVoices, setAvailableVoices] = useState([]); // Available text-to-speech voices

    // Sound modal state
    const [soundModalVisible, setSoundModalVisible] = useState(false);
    const [selectedSound, setSelectedSound] = useState(null); // Selected sound file for broadcasting
    const [vendorBidModalVisible, setVendorBidModalVisible] = useState(false);
    const [vendorBidAmount, setVendorBidAmount] = useState(null);
    const [previewingSound, setPreviewingSound] = useState(null); // Currently previewing sound
    const [broadcastingSound, setBroadcastingSound] = useState(false); // Broadcasting sound state
    const currentPlayingSoundRef = useRef(null); // Currently playing broadcasted sound (using ref for closure access)
    const announcementQueueRef = useRef([]); // Queue for announcements to prevent overlap
    const isProcessingAnnouncementRef = useRef(false); // Track if we're currently processing an announcement
    const announcementHandlersRef = useRef({
        announcement: null,
        soundStop: null,
        bound: false
    }); // Store handler references for proper cleanup
    const lastProcessedAnnouncementRef = useRef({
        id: null,
        timestamp: 0
    }); // Track last processed announcement to prevent duplicates within a short time window


    // Native browser Speech Synthesis API
    const [availableVoicesList, setAvailableVoicesList] = useState([]);
    const [speechSupported, setSpeechSupported] = useState(false);
    const currentUtteranceRef = useRef(null);

    // Load available voices
    const loadVoices = useCallback(() => {
        if ('speechSynthesis' in window) {
            const voices = window.speechSynthesis.getVoices();
            setAvailableVoicesList(voices);

            // Filter to English voices and sort them
            const englishVoices = voices
                .filter(voice => voice.lang && voice.lang.startsWith('en'))
                .sort((a, b) => {
                    // Prioritize natural-sounding voices
                    const aScore = a.name.includes('Female') || a.name.includes('Woman') ? 1 : 0;
                    const bScore = b.name.includes('Female') || b.name.includes('Woman') ? 1 : 0;
                    return bScore - aScore;
                });
            setAvailableVoices(englishVoices);
        }
    }, []);

    // Check if speech synthesis is supported and load voices
    useEffect(() => {
        if ('speechSynthesis' in window) {
            setSpeechSupported(true);
            loadVoices();

            // Some browsers load voices asynchronously
            if (window.speechSynthesis.onvoiceschanged !== undefined) {
                window.speechSynthesis.onvoiceschanged = loadVoices;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Speak function using native API
    const speak = useCallback((text, voiceName = null) => {
        if (!speechSupported || !('speechSynthesis' in window)) {
            console.warn('Speech synthesis not supported');
            return;
        }

        // Cancel any ongoing speech
        if (currentUtteranceRef.current) {
            window.speechSynthesis.cancel();
        }

        const utterance = new SpeechSynthesisUtterance(text);

        // Set voice if provided
        if (voiceName) {
            const voices = window.speechSynthesis.getVoices();
            const selectedVoice = voices.find(v => v.name === voiceName);
            if (selectedVoice) {
                utterance.voice = selectedVoice;
            }
        }

        // Set speech parameters
        utterance.rate = 0.9; // Slightly slower for clarity
        utterance.pitch = 1;
        utterance.volume = 1;

        // Store reference
        currentUtteranceRef.current = utterance;

        // Handle completion
        utterance.onend = () => {
            currentUtteranceRef.current = null;
        };

        // Handle errors
        utterance.onerror = (error) => {
            console.error('Speech synthesis error:', error);
            currentUtteranceRef.current = null;
        };

        // Speak
        window.speechSynthesis.speak(utterance);
    }, [speechSupported]);

    // Cancel speech function
    const cancelSpeech = useCallback(() => {
        if ('speechSynthesis' in window) {
            window.speechSynthesis.cancel();
            currentUtteranceRef.current = null;
        }
    }, []);

    // Process a single announcement - stops any previous sound/speech and starts new one
    const processAnnouncement = useCallback((announcement) => {
        // Stop any currently playing sound or speech completely
        if (currentPlayingSoundRef.current) {
            console.log('[Announcement] Stopping previous sound');
            currentPlayingSoundRef.current.pause();
            currentPlayingSoundRef.current.currentTime = 0;
            currentPlayingSoundRef.current = null;
        }

        // Stop any ongoing speech completely
        if ('speechSynthesis' in window) {
            console.log('[Announcement] Stopping previous speech');
            window.speechSynthesis.cancel();
            currentUtteranceRef.current = null;
        }

        // Clear the queue - we only process the latest announcement
        announcementQueueRef.current = [];
        isProcessingAnnouncementRef.current = true;

        const { message, sound_file } = announcement;

        // If there's a sound file, play it first, then speak
        if (sound_file) {
            const announcementSound = new Audio(`/sounds/auction/${sound_file}`);
            announcementSound.volume = 0.7;
            currentPlayingSoundRef.current = announcementSound;

            announcementSound.play().catch((error) => {
                console.error('[Sound Broadcast] Sound play prevented:', error);
                // Try to play again after user interaction
                const playOnInteraction = () => {
                    announcementSound.play().catch(() => {
                        console.error('[Sound Broadcast] Sound play failed after interaction');
                    });
                    document.removeEventListener('click', playOnInteraction);
                    document.removeEventListener('touchstart', playOnInteraction);
                };
                document.addEventListener('click', playOnInteraction, { once: true });
                document.addEventListener('touchstart', playOnInteraction, { once: true });
                currentPlayingSoundRef.current = null;
            });

            // When sound finishes, start speech if there's a message
            announcementSound.onended = () => {
                currentPlayingSoundRef.current = null;

                // If there's a message, speak it after sound finishes
                if (message && message.trim() && speechSupported) {
                    const voices = window.speechSynthesis.getVoices();

                    // Try to find the preferred voice
                    let voiceToUse = null;
                    const storedVoicePreference = localStorage.getItem('announcement_voice_preference');
                    if (storedVoicePreference && voices) {
                        voiceToUse = voices.find(v => v.name === storedVoicePreference);
                    }

                    if (!voiceToUse && voices) {
                        const preferredVoices = [
                            'Google UK English Female',
                            'Microsoft Zira - English (United States)',
                            'Samantha',
                            'Karen',
                            'Alex'
                        ];

                        for (const preferredName of preferredVoices) {
                            const voice = voices.find(v => v.name.includes(preferredName) || v.name === preferredName);
                            if (voice) {
                                voiceToUse = voice;
                                break;
                            }
                        }
                    }

                    if (!voiceToUse && voices) {
                        voiceToUse = voices.find(v =>
                            v.lang && v.lang.startsWith('en') &&
                            (v.name.toLowerCase().includes('female') || v.name.toLowerCase().includes('woman'))
                        ) || voices.find(v => v.lang && v.lang.startsWith('en')) || voices[0];
                    }

                    const utterance = new SpeechSynthesisUtterance(message);
                    if (voiceToUse) {
                        utterance.voice = voiceToUse;
                    }
                    utterance.rate = 0.9;
                    utterance.pitch = 1;
                    utterance.volume = 1;

                    currentUtteranceRef.current = utterance;

                    utterance.onend = () => {
                        currentUtteranceRef.current = null;
                        isProcessingAnnouncementRef.current = false;
                    };

                    utterance.onerror = () => {
                        currentUtteranceRef.current = null;
                        isProcessingAnnouncementRef.current = false;
                    };

                    window.speechSynthesis.speak(utterance);
                } else {
                    // No message to speak, we're done
                    isProcessingAnnouncementRef.current = false;
                }
            };

            announcementSound.onerror = () => {
                console.error('[Sound Broadcast] Sound file error:', sound_file);
                currentPlayingSoundRef.current = null;

                // If sound fails, still try to speak if there's a message
                if (message && message.trim() && speechSupported) {
                    const voices = window.speechSynthesis.getVoices();
                    let voiceToUse = null;
                    const storedVoicePreference = localStorage.getItem('announcement_voice_preference');
                    if (storedVoicePreference && voices) {
                        voiceToUse = voices.find(v => v.name === storedVoicePreference);
                    }

                    if (!voiceToUse && voices) {
                        voiceToUse = voices.find(v =>
                            v.lang && v.lang.startsWith('en') &&
                            (v.name.toLowerCase().includes('female') || v.name.toLowerCase().includes('woman'))
                        ) || voices.find(v => v.lang && v.lang.startsWith('en')) || voices[0];
                    }

                    const utterance = new SpeechSynthesisUtterance(message);
                    if (voiceToUse) {
                        utterance.voice = voiceToUse;
                    }
                    utterance.rate = 0.9;
                    utterance.pitch = 1;
                    utterance.volume = 1;

                    currentUtteranceRef.current = utterance;

                    utterance.onend = () => {
                        currentUtteranceRef.current = null;
                        isProcessingAnnouncementRef.current = false;
                    };

                    utterance.onerror = () => {
                        currentUtteranceRef.current = null;
                        isProcessingAnnouncementRef.current = false;
                    };

                    window.speechSynthesis.speak(utterance);
                } else {
                    isProcessingAnnouncementRef.current = false;
                }
            };
        } else if (message && message.trim() && speechSupported) {
            // No sound file, just speak the message
            const voices = window.speechSynthesis.getVoices();
            let voiceToUse = null;
            const storedVoicePreference = localStorage.getItem('announcement_voice_preference');
            if (storedVoicePreference && voices) {
                voiceToUse = voices.find(v => v.name === storedVoicePreference);
            }

            if (!voiceToUse && voices) {
                const preferredVoices = [
                    'Google UK English Female',
                    'Microsoft Zira - English (United States)',
                    'Samantha',
                    'Karen',
                    'Alex'
                ];

                for (const preferredName of preferredVoices) {
                    const voice = voices.find(v => v.name.includes(preferredName) || v.name === preferredName);
                    if (voice) {
                        voiceToUse = voice;
                        break;
                    }
                }
            }

            if (!voiceToUse && voices) {
                voiceToUse = voices.find(v =>
                    v.lang && v.lang.startsWith('en') &&
                    (v.name.toLowerCase().includes('female') || v.name.toLowerCase().includes('woman'))
                ) || voices.find(v => v.lang && v.lang.startsWith('en')) || voices[0];
            }

            const utterance = new SpeechSynthesisUtterance(message);
            if (voiceToUse) {
                utterance.voice = voiceToUse;
            }
            utterance.rate = 0.9;
            utterance.pitch = 1;
            utterance.volume = 1;

            currentUtteranceRef.current = utterance;

            utterance.onend = () => {
                currentUtteranceRef.current = null;
                isProcessingAnnouncementRef.current = false;
            };

            utterance.onerror = () => {
                currentUtteranceRef.current = null;
                isProcessingAnnouncementRef.current = false;
            };

            window.speechSynthesis.speak(utterance);
        } else {
            // No sound and no message, we're done
            isProcessingAnnouncementRef.current = false;
        }
    }, [speechSupported]);

    // Bid rejection modal state
    const [bidRejectionModal, setBidRejectionModal] = useState({
        visible: false,
        lotNumber: null,
        errorMessage: '',
        minimumBid: null,
        isAutoBid: false,
        lotName: ''
    });
    const [statisticsModalVisible, setStatisticsModalVisible] = useState(false);
    // Track which lots have already shown reserve met notification (to avoid showing multiple times)
    const [reserveMetLots, setReserveMetLots] = useState(new Set());
    // Track reserve met notification state for animation
    const [reserveMetNotification, setReserveMetNotification] = useState(null);
    const [statistics, setStatistics] = useState(null);
    const [loadingStatistics, setLoadingStatistics] = useState(false);
    const [bidActivityData, setBidActivityData] = useState([]);
    const [loadingBidActivity, setLoadingBidActivity] = useState(false);
    const [controlPanelVisible, setControlPanelVisible] = useState(false);
    const [liveStreamUrl, setLiveStreamUrl] = useState(null);
    const [liveStreamInput, setLiveStreamInput] = useState('');
    const [updatingLiveStream, setUpdatingLiveStream] = useState(false);
    const [prefetchAuctionId, setPrefetchAuctionId] = useState(null);
    const [prefetchAuctionOwnerId, setPrefetchAuctionOwnerId] = useState(null);
    const [prefetchAuctionStartTime, setPrefetchAuctionStartTime] = useState(null);
    const [lotDetailsActiveTab, setLotDetailsActiveTab] = useState(null);
    const [achievementModalVisible, setAchievementModalVisible] = useState(false);
    const [unlockedAchievements, setUnlockedAchievements] = useState([]);
    const [organizerModalVisible, setOrganizerModalVisible] = useState(false);

    const handleAchievementModalClose = useCallback(() => {
        setAchievementModalVisible(false);
        setUnlockedAchievements([]);
    }, []);

    // Google Translate mutates the DOM and breaks React on this interactive page
    useEffect(() => {
        const isTranslated =
            document.body.classList.contains('translated-ltr') ||
            document.body.classList.contains('translated-rtl');
        const clearedKey = 'live_auction_translate_cleared';

        if (isTranslated && !sessionStorage.getItem(clearedKey)) {
            document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
            sessionStorage.setItem(clearedKey, '1');
            window.location.reload();
            return;
        }

        sessionStorage.removeItem(clearedKey);
    }, []);

    // Cleanup preview sound on unmount
    useEffect(() => {
        return () => {
            if (previewingSound) {
                previewingSound.pause();
                previewingSound.currentTime = 0;
            }
        };
    }, [previewingSound]);

    // Auto-close announcement popup after 3 seconds
    useEffect(() => {
        // Clear any existing timeout
        if (announcementTimeoutRef.current) {
            clearTimeout(announcementTimeoutRef.current);
            announcementTimeoutRef.current = null;
        }

        // If there are announcements, set timeout to clear them after 3 seconds
        if (announcements.length > 0) {
            announcementTimeoutRef.current = setTimeout(() => {
                setAnnouncements([]);
                announcementTimeoutRef.current = null;
            }, 3000); // 3 seconds
        }

        // Cleanup timeout on unmount or when announcements change
        return () => {
            if (announcementTimeoutRef.current) {
                clearTimeout(announcementTimeoutRef.current);
                announcementTimeoutRef.current = null;
            }
        };
    }, [announcements]);

    // Preview sound function
    const previewSound = (soundFile) => {
        // Stop any currently playing sound
        if (previewingSound) {
            previewingSound.pause();
            previewingSound.currentTime = 0;
        }

        const audio = new Audio(`/sounds/auction/${soundFile}`);
        audio.volume = 0.7;
        setPreviewingSound(audio);

        audio.play().catch((error) => {
            console.log('Sound preview error:', error);
            message.error('Could not play sound preview');
        });

        audio.onended = () => {
            setPreviewingSound(null);
        };

        audio.onerror = () => {
            setPreviewingSound(null);
            message.error('Sound file not found');
        };
    };

    const handleBroadcastSound = async () => {
        if (!selectedSound || !auction?.slug) {
            message.warning('Please select a sound');
            return;
        }

        // Stop any previewing sound
        if (previewingSound) {
            previewingSound.pause();
            previewingSound.currentTime = 0;
            setPreviewingSound(null);
        }

        setBroadcastingSound(true);
        try {
            const response = await auctionService.broadcastSound(auction.slug, selectedSound);
            console.log('Sound broadcast response:', response);
            message.success('Sound broadcasted successfully');
            setSelectedSound(null);
            setSoundModalVisible(false);
        } catch (error) {
            console.error('Error broadcasting sound:', error);
            message.error(error.response?.data?.message || 'Failed to broadcast sound');
        } finally {
            setBroadcastingSound(false);
        }
    };

    const handleUpdateLiveStream = async (streamUrl = liveStreamInput) => {
        const auctionSlug = auction?.slug || slug;
        if (!auctionSlug) return;

        const trimmedUrl = streamUrl?.trim() || '';
        if (trimmedUrl) {
            const validation = validateLiveStreamUrl(trimmedUrl);
            if (!validation.isValid) {
                message.error('Please enter a valid YouTube, TikTok, or Facebook live stream URL');
                return;
            }
        }

        setUpdatingLiveStream(true);
        try {
            const response = await auctionService.updateLiveStream(auctionSlug, trimmedUrl || null);
            const updatedUrl = response?.data?.live_stream_url ?? (trimmedUrl || null);
            setLiveStreamUrl(updatedUrl);
            setLiveStreamInput(updatedUrl || '');
            setAuction(prev => prev ? { ...prev, live_stream_url: updatedUrl } : prev);
            message.success(trimmedUrl ? 'Live stream updated successfully' : 'Live stream removed');
        } catch (error) {
            console.error('Error updating live stream:', error);
            message.error(error.response?.data?.message || 'Failed to update live stream');
        } finally {
            setUpdatingLiveStream(false);
        }
    };

    // Handle sending announcement
    const handleSendAnnouncement = useCallback(async (messageText, readAloud) => {
        if (!messageText || !auction?.slug) {
            message.warning('Please enter a message');
            return;
        }

        setSendingAnnouncement(true);
        try {
            const response = await auctionService.broadcastAnnouncement(
                auction.slug,
                messageText,
                readAloud
            );
            console.log('Announcement broadcast response:', response);
            setAnnouncementModalVisible(false);
        } catch (error) {
            console.error('Error broadcasting announcement:', error);
            console.error('Error response:', error.response);
            const errorMessage = error.response?.data?.message
                || error.response?.data?.error
                || error.message
                || 'Failed to broadcast announcement';
            message.error(errorMessage);
        } finally {
            setSendingAnnouncement(false);
        }
    }, [auction?.slug]);

    // Memoize cancel handler to prevent unnecessary re-renders
    const handleAnnouncementModalCancel = useCallback(() => {
        setAnnouncementModalVisible(false);
    }, []);

    // Add ref to track auto-bid stop state
    const autoBidStopRef = useRef(false);
    const autoBidIntervalRef = useRef(null);

    // Helper to clear loading state for a lot after timeout
    const clearLoadingStateWithTimeout = (lotId, timeoutMs = 10000) => {
        setTimeout(() => {
            setStatusLoadingLots(prev => {
                const newSet = new Set(prev);
                newSet.delete(lotId);
                return newSet;
            });
            setTimeoutLoadingLots(prev => {
                const newSet = new Set(prev);
                newSet.delete(lotId);
                return newSet;
            });
        }, timeoutMs);
    };

    // Helper to check if a lot is closed by ID
    const isLotClosedById = (lotId) => {
        return closedLots.includes(lotId);
    };

    // Check if auction has started
    const hasAuctionStarted = () => {
        if (!auction?.start_time) return false;
        return moment(getServerNow()).isAfter(moment(auction.start_time));
    };

    // Handle countdown completion
    const handleCountdownComplete = () => {
        setAuctionHasStarted(true);
        message.success('🎉 Auction is now live! Let the bidding begin!');
    };

    // Save reminders to localStorage whenever they change
    useEffect(() => {
        localStorage.setItem('bidReminders', JSON.stringify(bidReminders));
    }, [bidReminders]);

    // Set reminder for a lot
    const setReminder = (lotId, reminderSeconds) => {
        setBidReminders(prev => ({
            ...prev,
            [lotId]: {
                reminderSeconds,
                triggered: false,
                lotId
            }
        }));
        message.success(`Reminder set for ${reminderSeconds} second(s) before lot closes`);
    };

    // Remove reminder for a lot
    const removeReminder = (lotId) => {
        setBidReminders(prev => {
            const newReminders = { ...prev };
            delete newReminders[lotId];
            return newReminders;
        });
        message.success('Reminder removed');
    };

    // Check reminders and trigger notifications
    useEffect(() => {
        const checkReminders = () => {
            Object.keys(bidReminders).forEach(lotId => {
                const reminder = bidReminders[lotId];
                if (!reminder || reminder.triggered) return;

                const lot = lots.find(l => l.id === parseInt(lotId));
                if (!lot || lot.status !== 'active') return;

                const timeRemaining = allLotsTimeRemaining[lotId];
                if (timeRemaining === undefined || timeRemaining === null) return;

                // Check if reminder time has been reached (within 2 second window to avoid duplicates)
                if (timeRemaining <= reminder.reminderSeconds && timeRemaining > (reminder.reminderSeconds - 2)) {
                    // Trigger notification
                    const lotTitle = lot.title || `Lot #${lot.lot_number}`;
                    message.warning({
                        content: `⏰ Reminder: ${lotTitle} is closing in ${reminder.reminderSeconds} second(s)!`,
                        duration: 10,
                        icon: <BellOutlined style={{ color: '#faad14' }} />
                    });

                    // Mark as triggered
                    setBidReminders(prev => ({
                        ...prev,
                        [lotId]: {
                            ...prev[lotId],
                            triggered: true
                        }
                    }));

                    // Request browser notification if permission granted
                    if ('Notification' in window && Notification.permission === 'granted') {
                        new Notification(`Lot Closing Soon: ${lotTitle}`, {
                            body: `This lot is closing in ${reminder.reminderSeconds} second(s)!`,
                            icon: '/favicon.ico',
                            tag: `reminder-${lotId}-${reminder.reminderSeconds}`
                        });
                    }
                }
            });
        };

        // Check reminders every second for accurate timing
        const interval = setInterval(checkReminders, 1000);
        checkReminders(); // Initial check

        return () => clearInterval(interval);
    }, [bidReminders, allLotsTimeRemaining, lots]);

    // Request notification permission on mount
    useEffect(() => {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }, []);

    // Remove reminders for lots that are closed, cancelled, or timed out
    useEffect(() => {
        if (!lots || lots.length === 0) return;

        const closedStatuses = ['closed', 'cancelled', 'timeout'];

        setBidReminders(prev => {
            const newReminders = { ...prev };
            let hasChanges = false;

            // Check each lot with a reminder
            Object.keys(prev).forEach(lotId => {
                const lot = lots.find(l => l.id === parseInt(lotId));
                if (lot && closedStatuses.includes(lot.status)) {
                    delete newReminders[lotId];
                    hasChanges = true;
                }
            });

            return hasChanges ? newReminders : prev;
        });
    }, [lots]);

    // Update bid activity count when lots change (only when new bids arrive via Pusher, not when fetching for display)
    // Note: We don't watch bidHistoryCache here because it changes when fetching bid history for selected lots,
    // which shouldn't affect the notification counter. The counter is updated explicitly when new bids arrive via Pusher.
    useEffect(() => {
        // Only recalculate if we have lots with actual bid activity
        // This effect runs when lots array changes (new lots added/removed), not when cache is populated
        const lotsWithBids = lots.filter(lot => {
            const cachedBids = bidHistoryCache.get(lot.id);
            return cachedBids && cachedBids.length > 0;
        });
        // Only update if the count actually changed to avoid unnecessary re-renders
        if (lotsWithBids.length !== bidActivityCount) {
            setBidActivityCount(lotsWithBids.length);
        }
    }, [lots]); // Removed bidHistoryCache from dependencies

    // Fetch bid activity data once when auction loads (for badge count)
    // After initial load, updates come via Pusher in real-time (no need to refetch)
    useEffect(() => {
        // Reset ref when auction slug changes (user navigates to different auction)
        const currentAuctionSlug = auction?.slug;
        if (currentAuctionSlug) {
            // Check if this is a different auction (slug changed)
            const previousSlug = bidActivityLoadedRef.current;
            if (previousSlug !== currentAuctionSlug) {
                // Reset and fetch for new auction
                bidActivityLoadedRef.current = currentAuctionSlug;
                setBidActivityData([]); // Clear previous auction's data
                setLoadingBidActivity(true);
                auctionService.getAuctionBidActivity(currentAuctionSlug)
                    .then(response => {
                        if (response.status === 'success' && response.data) {
                            const activity = response.data;
                            setBidActivityData(activity);

                            // Seed per-lot bid history cache from activity feed
                            setBidHistoryCache((prev) => {
                                const newCache = new Map(prev);
                                const bidsByLot = new Map();

                                activity.forEach((bid) => {
                                    const lotId = Number(bid.lot_id);
                                    if (!bidsByLot.has(lotId)) {
                                        bidsByLot.set(lotId, []);
                                    }
                                    bidsByLot.get(lotId).push(mapActivityBidToHistoryBid(bid));
                                });

                                bidsByLot.forEach((bids, lotId) => {
                                    const existing = newCache.get(lotId) || [];
                                    newCache.set(lotId, mergeLotBidHistories(bids, existing));
                                });

                                return newCache;
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching bid activity:', error);
                    })
                    .finally(() => {
                        setLoadingBidActivity(false);
                    });
            }
            // If slug matches, we've already loaded - no action needed
        }
    }, [auction?.slug]); // Fetch only once when auction loads or changes

    // Handle fullscreen toggle
    const toggleFullscreen = useCallback(() => {
        if (!document.fullscreenElement) {
            // Enter fullscreen
            const element = document.documentElement;
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            setIsFullscreen(true);
        } else {
            // Exit fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            setIsFullscreen(false);
        }
    }, []);

    // Listen for fullscreen changes (e.g., when user presses F11 or ESC)
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('msfullscreenchange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('msfullscreenchange', handleFullscreenChange);
        };
    }, []);

    // Add the highlight animation styles
    const highlightStyles = `
        @keyframes highlight {
            0% {
                box-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
            }
            100% {
                box-shadow: none;
            }
        }
        
        @keyframes newBidHighlight {
            0% {
                box-shadow: 0 0 15px rgba(24, 144, 255, 0.8);
                border-color: #1890ff;
                transform: scale(1);
            }
            50% {
                box-shadow: 0 0 25px rgba(24, 144, 255, 1);
                border-color: #40a9ff;
                transform: scale(1.01);
            }
            100% {
                box-shadow: 0 0 15px rgba(24, 144, 255, 0.8);
                border-color: #1890ff;
                transform: scale(1);
            }
        }
        
        @keyframes pulse {
            0% {
                opacity: 0.7;
                transform: scale(1);
            }
            50% {
                opacity: 1;
                transform: scale(1.02);
            }
            100% {
                opacity: 0.7;
                transform: scale(1);
            }
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
        
        @keyframes shimmer {
            0% {
                transform: translateX(-100%);
            }
            50% {
                transform: translateX(100%);
            }
            100% {
                transform: translateX(100%);
            }
        }
        
        @keyframes winningPulse {
            0%, 100% {
                box-shadow: 0 4px 16px rgba(82, 196, 26, 0.3);
                border-color: #52c41a;
            }
            50% {
                box-shadow: 0 6px 24px rgba(82, 196, 26, 0.5);
                border-color: #73d13d;
            }
        }

        @keyframes lotClosing {
            0% {
                background: linear-gradient(135deg, rgba(114, 46, 209, 0.95), rgba(24, 144, 255, 0.95));
                transform: scale(1);
            }
            50% {
                background: linear-gradient(135deg, rgba(24, 144, 255, 0.95), rgba(114, 46, 209, 0.95));
                transform: scale(1.02);
            }
            100% {
                background: linear-gradient(135deg, rgba(114, 46, 209, 0.95), rgba(24, 144, 255, 0.95));
                transform: scale(1);
            }
        }

        @keyframes fadeInUp {
            0% {
                opacity: 0;
                transform: translateY(20px);
            }
            100% {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .lot-closing-animation {
            animation: fadeInUp 0.5s ease-out;
        }
    `;

    // Add the styles to the document
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.innerText = highlightStyles;
        document.head.appendChild(styleSheet);
        return () => {
            document.head.removeChild(styleSheet);
        };
    }, []);

    // Clear custom bid when selected lot changes - batched state update
    useEffect(() => {
        // Batch all state updates together to reduce re-renders
        setCustomBidAmount('');
        setShowCustomBid(false);
        setValidRoundedAmountApplied(false);
    }, [selectedLot?.id]);

    // Check if custom bid amount is already a valid rounded amount
    useEffect(() => {
        if (!customBidAmount || !selectedLot) {
            return;
        }

        const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
        const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
        const minBid = current + increment;
        const customAmount = parseFloat(customBidAmount);

        if (isNaN(customAmount)) {
            return;
        }

        // Check if the amount is already a valid rounded amount (matches exactly with rounded value and meets minimum)
        const roundedAmount = roundToIncrement(customAmount, increment);
        const isAlreadyValidRounded = customAmount === roundedAmount && roundedAmount >= minBid;

        if (isAlreadyValidRounded && !validRoundedAmountApplied) {
            setValidRoundedAmountApplied(true);
        }
    }, [customBidAmount, selectedLot?.id, selectedLot?.current_price, selectedLot?.default_increment, selectedLot?.increment]);

    // Calculate and update time remaining for selected lot
    // Optimized to avoid unnecessary interval recreation
    useEffect(() => {
        if (!selectedLot || checkIfLotClosed(selectedLot) || !selectedLot.last_bid_time) {
            setTimeRemaining(null);
            return;
        }

        const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
        const lastBidTime = selectedLot.last_bid_time;
        const selectedLotId = selectedLot.id;

        const updateTimeRemaining = () => {
            // Use closure values to avoid dependency on selectedLot object reference
            const endTime = moment(lastBidTime).add(closeTimeSeconds, 'seconds');
            const now = moment(getServerNow());
            const secondsLeft = Math.max(0, Math.floor(endTime.diff(now) / 1000));
            setTimeRemaining(secondsLeft);
        };

        // Update immediately
        updateTimeRemaining();

        // Update every second
        const interval = setInterval(updateTimeRemaining, 1000);

        return () => clearInterval(interval);
    }, [selectedLot?.id, selectedLot?.last_bid_time, selectedLot?.status, auction?.lot_close_time_seconds]);

    // Calculate and update time remaining for all lots
    useEffect(() => {
        const updateAllLotsTimeRemaining = () => {
            const timeRemainingMap = {};

            lots.forEach(lot => {
                if (!checkIfLotClosed(lot) && lot.last_bid_time && lot.status === 'active') {
                    const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                    const endTime = moment(lot.last_bid_time).add(closeTimeSeconds, 'seconds');
                    const now = moment(getServerNow());
                    const secondsLeft = Math.max(0, Math.floor(endTime.diff(now) / 1000));
                    timeRemainingMap[lot.id] = secondsLeft;
                }
            });

            setAllLotsTimeRemaining(timeRemainingMap);
        };

        // Update immediately
        updateAllLotsTimeRemaining();

        // Update every second
        const interval = setInterval(updateAllLotsTimeRemaining, 1000);

        return () => clearInterval(interval);
    }, [lots]);

    // Check if auction has started periodically
    useEffect(() => {
        if (!auction?.start_time) return;

        const checkAuctionStart = () => {
            if (hasAuctionStarted() && !auctionHasStarted) {
                setAuctionHasStarted(true);
            }
        };

        // Check immediately
        checkAuctionStart();

        // Check every second
        const interval = setInterval(checkAuctionStart, 1000);

        return () => clearInterval(interval);
    }, [auction?.start_time, auctionHasStarted]);

    // Store activeAutoBids in a ref so cleanup can access the latest value
    const activeAutoBidsRef = useRef(activeAutoBids);
    useEffect(() => {
        activeAutoBidsRef.current = activeAutoBids;
    }, [activeAutoBids]);

    // Cleanup auto-bid when component unmounts ONLY
    useEffect(() => {
        return () => {
            // Cleanup legacy auto-bid on unmount
            if (autoBidIntervalRef.current) {
                clearInterval(autoBidIntervalRef.current);
                autoBidIntervalRef.current = null;
            }
            autoBidStopRef.current = true;

            // Cleanup all active auto-bids using ref to get latest value
            activeAutoBidsRef.current.forEach((autoBidInfo, lotId) => {
                if (autoBidInfo.intervalRef) {
                    clearInterval(autoBidInfo.intervalRef);
                }
                biddingInProgressRef.current.delete(lotId);
            });
            biddingInProgressRef.current.clear();
            // Clear all checkAndBid function references
            autoBidCheckFunctionsRef.current.clear();
        };
    }, []); // Only run on unmount, not when activeAutoBids changes

    // Removed: Auto-bid should continue running on the original lot even when selectedLot changes

    // Stop auto-bid when any lot is closed or cancelled
    useEffect(() => {
        activeAutoBids.forEach((autoBidInfo, lotId) => {
            const lot = lots.find(l => l.id === lotId);
            if (lot && (lot.status === 'closed' || lot.status === 'cancelled')) {
                handleStopAutoBid(lotId);
            }
        });
    }, [lots, activeAutoBids]);

    const updateLotStatus = (lot) => {
        if (lot.status === 'closed') {
            if (lot.last_bid_user_id === currentUser?.id) {
                lot.is_held = true;
                lot.is_lost = false;
            } else if (lot.last_bid_user_id) {
                lot.is_held = false;
                lot.is_lost = true;
            }
        }
        return lot;
    };

    useEffect(() => {
        if (!slug) return;

        const prefetchLiveStream = async () => {
            try {
                const response = await auctionService.getAuction(slug);
                const auctionData = response?.data || response;
                if (auctionData?.live_stream_url) {
                    setLiveStreamUrl(auctionData.live_stream_url);
                    setLiveStreamInput(auctionData.live_stream_url);
                }
                if (auctionData?.id) {
                    setPrefetchAuctionId(auctionData.id);
                }
                if (auctionData?.user_id) {
                    setPrefetchAuctionOwnerId(auctionData.user_id);
                }
                if (auctionData?.start_time) {
                    setPrefetchAuctionStartTime(auctionData.start_time);
                }
            } catch (error) {
                console.error('Error prefetching live stream:', error);
            }
        };

        prefetchLiveStream();
    }, [slug]);

    useEffect(() => {
        const auctionId = auction?.id || prefetchAuctionId;
        if (!auctionId) return;

        const channelName = `auction.${auctionId}`;
        const channel = pusherService.pusher.subscribe(channelName);

        const handleLiveStreamUpdated = (data) => {
            const updatedUrl = data?.live_stream_url || null;
            setLiveStreamUrl(updatedUrl);
            setLiveStreamInput(updatedUrl || '');
            setAuction(prev => prev ? { ...prev, live_stream_url: updatedUrl } : prev);
        };

        channel.bind('auction.live_stream.updated', handleLiveStreamUpdated);

        return () => {
            channel.unbind('auction.live_stream.updated', handleLiveStreamUpdated);
        };
    }, [auction?.id, prefetchAuctionId]);

    useEffect(() => {
        const fetchAuctionData = async () => {
            setLoading(true);
            setIsInvitationLoading(true);
            try {
                // First fetch auction data to check if it's private
                const auctionResponse = await auctionService.getLiveAuctionDetails(slug);
                const auctionData = auctionResponse.data;
                setAuction(auctionData);
                setLiveStreamUrl(auctionData.live_stream_url || null);
                setLiveStreamInput(auctionData.live_stream_url || '');
                if (auctionData.start_time) {
                    setPrefetchAuctionStartTime(auctionData.start_time);
                }

                // Only fetch invitation status if auction is private AND user is not the auction owner
                // Auction owner doesn't need invitation check - they have full access
                if (auctionData.is_private && currentUser?.id !== auctionData.user_id) {
                    try {
                        const invitationResponse = await auctionService.checkInvitationStatus(slug);
                        setIsInvited(invitationResponse.is_invited || false);
                        setInvitationStatus(invitationResponse.status || 'not_invited');
                    } catch (invitationError) {
                        console.error('Error fetching invitation status:', invitationError);
                        setIsInvited(false);
                        setInvitationStatus('not_invited');
                    } finally {
                        setIsInvitationLoading(false);
                    }
                } else {
                    // Public auction or auction owner - no invitation check needed
                    setIsInvited(false);
                    setInvitationStatus(null);
                    setIsInvitationLoading(false);
                }

                // Mark lots as favorited based on current user's favorites
                const lotsWithFavorites = (auctionData.lots || []).map(lot => ({
                    ...lot,
                    is_favorite: currentUser?.favorite_lots?.includes(lot.id) || false
                }));

                // For sequential auctions, find the first available lot
                if (auctionData.is_sequential) {
                    // Find the first lot that is active and not closed/cancelled
                    const firstAvailableLot = lotsWithFavorites.find(lot =>
                        lot.status === 'active' &&
                        lot.status !== 'closed' &&
                        lot.status !== 'cancelled'
                    );

                    if (firstAvailableLot) {
                        setActiveLotId(firstAvailableLot.id);
                        setSelectedLot(firstAvailableLot);
                    } else {
                        // If no available lot found, select the first lot
                        setSelectedLot(lotsWithFavorites[0] || null);
                    }
                } else {
                    setSelectedLot(lotsWithFavorites[0] || null);
                }

                setLots(lotsWithFavorites);
                setIsSequential(auctionData.is_sequential || false);
                // Calculate actively bidding count for regular users (not auction owner)
                const isAuctionOwner = currentUser?.id === auctionData.user_id;
                const activelyBiddingCount = isAuctionOwner
                    ? 0 // Auction owners don't see this filter
                    : lotsWithFavorites.filter(l => {
                        if (l.status !== 'active') return false;
                        if (!currentUser?.id) return false;

                        // Quick check: if user is the last bidder, they definitely have bid
                        if (l.last_bid_user_id && Number(l.last_bid_user_id) === Number(currentUser.id)) {
                            return true;
                        }

                        // Primary check: has_bid property from backend (if available)
                        if (l.has_bid === true) return true;

                        // Check bid history cache for this lot (might not be populated yet on initial load)
                        const cachedBids = bidHistoryCache.get(l.id);
                        if (cachedBids && Array.isArray(cachedBids) && cachedBids.length > 0) {
                            const userHasBid = cachedBids.some(bid => {
                                const bidUserId = bid.user?.id || bid.user_id;
                                return bidUserId && Number(bidUserId) === Number(currentUser.id);
                            });
                            if (userHasBid) return true;
                        }

                        // Fallback: check if user has any bids in the bids array (if loaded)
                        if (l.bids && Array.isArray(l.bids) && l.bids.length > 0) {
                            const userHasBid = l.bids.some(bid => {
                                const bidUserId = bid.user?.id || bid.user_id;
                                return bidUserId && Number(bidUserId) === Number(currentUser.id);
                            });
                            if (userHasBid) return true;
                        }

                        return false;
                    }).length;

                setSidebarCounts({
                    total: lotsWithFavorites.length,
                    favorite: lotsWithFavorites.filter(l => l.is_favorite).length,
                    held: lotsWithFavorites.filter(l => l.is_held).length,
                    lost: lotsWithFavorites.filter(l => l.is_lost).length,
                    sold: lotsWithFavorites.filter(l => l.status === 'closed').length,
                    cancelled: lotsWithFavorites.filter(l => l.status === 'cancelled').length,
                    actively_bidding: activelyBiddingCount
                });
                setClosedLots(lotsWithFavorites.filter(lot => lot.status === 'closed').map(lot => lot.id));

                // Mark all already-closed lots (where user is winner) as having shown success message and confetti
                // This prevents showing success messages and confetti again on page refresh
                lotsWithFavorites.forEach(lot => {
                    if (lot.status === 'closed' && lot.last_bid_user_id === currentUser?.id) {
                        successMessageTriggeredLotsRef.current.add(lot.id);
                        confettiTriggeredLotsRef.current.add(lot.id);
                        console.log('[Message Debug] Marking pre-existing closed lot as already shown:', lot.id);
                    }
                });

                // Persist to localStorage
                try {
                    const successLotIds = Array.from(successMessageTriggeredLotsRef.current);
                    localStorage.setItem('successMessageTriggeredLots', JSON.stringify(successLotIds));

                    const confettiLotIds = Array.from(confettiTriggeredLotsRef.current);
                    localStorage.setItem('confettiTriggeredLots', JSON.stringify(confettiLotIds));
                } catch (e) {
                    console.warn('Error saving message/confetti tracking to localStorage:', e);
                }

                setError(null);

                // Check if auction has started
                setAuctionHasStarted(hasAuctionStarted());
            } catch (error) {
                //console.error('Error fetching auction data:', error);
                message.error('Failed to load auction details');
                setError('Failed to load auction details. Please try again later.');
                setIsInvited(false);
                setInvitationStatus('not_invited');
            } finally {
                setLoading(false);
                setIsInvitationLoading(false);
            }
        };
        fetchAuctionData();
    }, [slug]);

    // Subscribe to presence channel for all users (but only show UI to auction owner)
    useEffect(() => {
        if (!auction || !auction.id || !currentUser) return;

        console.log('🔄 Setting up presence subscription for all users, auction:', auction.id);

        const unsubscribe = pusherService.subscribeToPresence(auction.id, {
            onSubscriptionSucceeded: (data) => {
                console.log('✅ Presence subscription succeeded for all users:', data);
                setIsPresenceConnected(true);

                // Convert members object to array and extract user info
                const allMembers = Object.values(data.members || {}).map(mapMemberData);

                console.log('All online members:', allMembers);
                setOnlineUsers(allMembers);
            },
            onMemberAdded: (member) => {
                console.log('➕ Member added to presence channel:', member);

                // The member object has 'id' and 'info' properties
                const userData = mapMemberData(member);

                console.log('Extracted user data from member added:', userData);

                setOnlineUsers(prev => {
                    const exists = prev.some(user => user.id === userData.id);
                    if (!exists) {
                        return [...prev, userData];
                    }
                    return prev;
                });
            },
            onMemberRemoved: (member) => {
                console.log('➖ Member removed from presence channel:', member);
                console.log('Member removal data structure:', JSON.stringify(member, null, 2));

                // The member object has 'id' property
                const userId = member.id;
                console.log('Removing user with ID:', userId);

                setOnlineUsers(prev => {
                    console.log('Before removal - current users:', prev.map(u => ({ id: u.id, name: u.first_name })));
                    const filtered = prev.filter(user => user.id !== userId);
                    console.log('After removal - remaining users:', filtered.map(u => ({ id: u.id, name: u.first_name })));
                    return filtered;
                });
            },
            onSubscriptionError: (error) => {
                console.error('❌ Presence subscription error:', error);
                setIsPresenceConnected(false);
            }
        });

        return () => {
            console.log('🔌 Unsubscribing from presence channel');
            unsubscribe();
            setIsPresenceConnected(false);
        };
    }, [auction?.id, currentUser?.id]);

    // Optimized cleanup - only when needed, not periodic
    useEffect(() => {
        if (!isPresenceConnected || !auction?.id) return;

        let cleanupTimeout;

        const scheduleCleanup = () => {
            // Clear any existing timeout
            if (cleanupTimeout) clearTimeout(cleanupTimeout);

            // Schedule cleanup after 30 seconds of inactivity
            cleanupTimeout = setTimeout(() => {
                console.log('🧹 Running delayed cleanup of online users');
                syncWithPusherMembers();
            }, 30000);
        };

        const syncWithPusherMembers = () => {
            const channel = pusherService.pusher.channel(`presence-auction.${auction.id}`);
            if (channel && channel.members) {
                const currentMembers = Object.values(channel.members.members || {}).map(mapMemberData);

                // Simple length check first (faster than deep comparison)
                if (currentMembers.length !== onlineUsers.length) {
                    console.log('🔄 Member count changed, updating state');
                    setOnlineUsers(currentMembers);
                } else {
                    // Only do deep comparison if lengths match
                    const currentIds = currentMembers.map(m => m.id).sort();
                    const existingIds = onlineUsers.map(m => m.id).sort();
                    const hasChanges = currentIds.some((id, index) => id !== existingIds[index]);

                    if (hasChanges) {
                        console.log('🔄 Member list changed, updating state');
                        setOnlineUsers(currentMembers);
                    }
                }
            }
        };

        // Schedule initial cleanup
        scheduleCleanup();

        return () => {
            if (cleanupTimeout) clearTimeout(cleanupTimeout);
        };
    }, [isPresenceConnected, auction?.id, onlineUsers.length]);

    // Optimized visibility change listener
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden && isPresenceConnected && auction?.id) {
                console.log('👁️ Tab became visible - checking Connected Users');

                const channel = pusherService.pusher.channel(`presence-auction.${auction.id}`);
                if (channel && channel.members) {
                    const currentMembers = Object.values(channel.members.members || {}).map(mapMemberData);

                    // Fast length check first
                    if (currentMembers.length !== onlineUsers.length) {
                        console.log('🔄 Member count changed on visibility change');
                        setOnlineUsers(currentMembers);
                    }
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [isPresenceConnected, auction?.id, onlineUsers.length]);

    // Load from localStorage on mount
    useEffect(() => {
        const saved = localStorage.getItem('subscribedLotIds');
        if (saved) {
            setSubscribedLotIds(JSON.parse(saved));
        }
    }, []);

    // Save to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('subscribedLotIds', JSON.stringify(subscribedLotIds));
    }, [subscribedLotIds]);

    // Memoize favorites Set for O(1) lookup instead of O(n) array.includes
    const favoritesSet = useMemo(() => {
        return new Set(currentUser?.favorite_lots || []);
    }, [currentUser?.favorite_lots]);

    const isLotFavorite = useCallback((lotId) => {
        return favoritesSet.has(lotId);
    }, [favoritesSet]);

    // Memoize comparisonLots Set for O(1) lookup instead of O(n) array.includes
    const comparisonLotsSet = useMemo(() => {
        return new Set(comparisonLots);
    }, [comparisonLots]);

    // Initialize timers when lots are loaded
    useEffect(() => {
        if (lots.length > 0) {
            const initialTimers = {};
            lots.forEach(lot => {
                if (lot.status !== 'closed' && lot.last_bid_time) {
                    // Set initial timer from server data
                    const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                    const endTime = moment(lot.last_bid_time).add(closeTimeSeconds, 'seconds');
                    const now = moment();
                    const secondsLeft = Math.max(0, Math.floor(endTime.diff(now) / 1000));
                    if (secondsLeft > 0) {
                        initialTimers[lot.id] = secondsLeft;
                    } else {
                        setClosedLots(closed => closed.includes(Number(lot.id)) ? closed : [...closed, Number(lot.id)]);
                    }
                }
            });
            setLotTimers(initialTimers);
            // Clear any existing loading states
            setTimerLoading({});
        }
    }, [lots]);

    // Update the renderLotTimer function
    const renderLotTimer = (lot) => {
        if (lot.status === 'closed' || lot.status === 'cancelled' || lot.status === 'timeout') {
            return null;
        }

        // Show pending state if there's a pending bid
        if (lot.pending_bid_user_id) {
            return (
                <Tag
                    color="orange"
                    style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        margin: 0,
                        borderRadius: '12px',
                        padding: '4px 8px',
                        background: 'linear-gradient(135deg, #faad14, #ffc53d)',
                        border: 'none',
                        color: 'white',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 8px rgba(250, 173, 20, 0.4)',
                        animation: 'pulse 1.2s ease-in-out infinite'
                    }}
                    className="lot-timer"
                    data-tour="lot-timer"
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <div style={{
                            width: '6px',
                            height: '6px',
                            background: 'white',
                            borderRadius: '50%',
                            animation: 'pulse 0.8s ease-in-out infinite'
                        }} />
                        <span style={{ fontSize: '10px' }}>Pending...</span>
                    </div>
                </Tag>
            );
        }

        // Show loading state while checking invitation status (but NOT after pending bids)
        if (timerLoading[lot.id] && !lot.pending_bid_user_id) {
            return (
                <Tag
                    color="blue"
                    style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        margin: 0,
                        borderRadius: '12px',
                        padding: '4px 8px',
                        background: 'linear-gradient(135deg, #1890ff, #40a9ff)',
                        border: 'none',
                        color: 'white',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)',
                        animation: 'pulse 1.5s ease-in-out infinite'
                    }}
                    className="lot-timer"
                    data-tour="lot-timer"
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <div style={{
                            width: '8px',
                            height: '8px',
                            border: '1px solid rgba(255, 255, 255, 0.5)',
                            borderTop: '1px solid white',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }} />
                        <span style={{ fontSize: '10px' }}>Processing...</span>
                    </div>
                </Tag>
            );
        }

        if (!isLotAvailableForBidding(lot)) {
            return (
                <Tag
                    color="default"
                    style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        margin: 0,
                        borderRadius: '12px',
                        padding: '2px 8px'
                    }}
                    className="lot-timer"
                    data-tour="lot-timer"
                >
                    Waiting
                </Tag>
            );
        }

        const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
        const endTime = lot.last_bid_time ? moment(lot.last_bid_time).add(closeTimeSeconds, 'seconds').valueOf() : null;

        return (
            <Tag
                color="blue"
                style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    margin: 0,
                    borderRadius: '12px',
                    padding: '2px 8px'
                }}
                className="lot-timer"
            >
                {endTime ? (
                    <Countdown
                        date={endTime}
                        now={getServerNow}
                        renderer={({ minutes, seconds }) => (
                            <span>⏱️ {minutes}:{seconds.toString().padStart(2, '0')}</span>
                        )}
                        onComplete={() => handleLotCompletion(lot)}
                    />
                ) : (
                    'Live'
                )}
            </Tag>
        );
    };

    // Timer function for list layout (inline, no absolute positioning)
    const renderListTimer = (lot) => {
        if (lot.status === 'closed' || lot.status === 'cancelled' || lot.status === 'timeout') {
            return null;
        }

        // Show pending state if there's a pending bid
        if (lot.pending_bid_user_id) {
            return (
                <Tag
                    color="orange"
                    style={{
                        margin: 0,
                        borderRadius: '12px',
                        padding: '4px 8px',
                        background: 'linear-gradient(135deg, #faad14, #ffc53d)',
                        border: 'none',
                        color: 'white',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 8px rgba(250, 173, 20, 0.4)',
                        animation: 'pulse 1.2s ease-in-out infinite'
                    }}
                    className="lot-timer"
                    data-tour="lot-timer"
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <div style={{
                            width: '6px',
                            height: '6px',
                            background: 'white',
                            borderRadius: '50%',
                            animation: 'pulse 0.8s ease-in-out infinite'
                        }} />
                        <span style={{ fontSize: '10px' }}>Pending...</span>
                    </div>
                </Tag>
            );
        }

        // Show loading state while checking invitation status (but NOT after pending bids)
        if (timerLoading[lot.id] && !lot.pending_bid_user_id) {
            return (
                <Tag
                    color="blue"
                    style={{
                        margin: 0,
                        borderRadius: '12px',
                        padding: '4px 8px',
                        background: 'linear-gradient(135deg, #1890ff, #40a9ff)',
                        border: 'none',
                        color: 'white',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)',
                        animation: 'pulse 1.5s ease-in-out infinite'
                    }}
                    className="lot-timer"
                    data-tour="lot-timer"
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <div style={{
                            width: '8px',
                            height: '8px',
                            border: '1px solid rgba(255, 255, 255, 0.5)',
                            borderTop: '1px solid white',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }} />
                        <span style={{ fontSize: '10px' }}>Processing...</span>
                    </div>
                </Tag>
            );
        }

        if (!isLotAvailableForBidding(lot)) {
            return (
                <Tag
                    color="default"
                    style={{
                        margin: 0,
                        borderRadius: '12px',
                        padding: '2px 8px'
                    }}
                    className="lot-timer"
                    data-tour="lot-timer"
                >
                    Waiting
                </Tag>
            );
        }

        const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
        const endTime = lot.last_bid_time ? moment(lot.last_bid_time).add(closeTimeSeconds, 'seconds').valueOf() : null;

        return (
            <Tag
                color="blue"
                style={{
                    margin: 0,
                    borderRadius: '12px',
                    padding: '2px 8px'
                }}
                className="lot-timer"
            >
                {endTime ? (
                    <Countdown
                        date={endTime}
                        now={getServerNow}
                        renderer={({ minutes, seconds }) => (
                            <span>⏱️ {minutes}:{seconds.toString().padStart(2, '0')}</span>
                        )}
                        onComplete={() => handleLotCompletion(lot)}
                    />
                ) : (
                    'Live'
                )}
            </Tag>
        );
    };

    const renderSelectedLotTimer = (lot) => {
        if (!lot) return null;

        if (isLotCancelled(lot)) {
            return (
                <>
                    <Tag color="purple">Cancelled</Tag>
                    <div style={{ fontWeight: 'bold', color: '#722ed1', marginTop: 8 }}>
                        This lot has been cancelled - Reserve didn't meet
                    </div>
                </>
            );
        }

        if (checkIfLotClosed(lot)) {
            const isAuctionOwner = currentUser?.id === auction?.user_id;

            // Handle timeout status specifically
            if (lot.status === 'timeout') {
                return (
                    <>
                        <Tag color="red">Closed for Bidding</Tag>
                        <div style={{ fontWeight: 'bold', color: '#fa8c16', marginTop: 8 }}>
                            Timed Out
                        </div>
                    </>
                );
            }

            return (
                <>
                    <Tag color="red">Closed for Bidding</Tag>
                    <div style={{ fontWeight: 'bold', color: isAuctionOwner ? '#1890ff' : (lot.last_bid_user_id === currentUser?.id ? '#52c41a' : '#ff4d4f'), marginTop: 8 }}>
                        {isAuctionOwner ? (
                            'Sold'
                        ) : (
                            lot.last_bid_user_id === currentUser?.id ? 'You Won!' : 'Other Bidder Won'
                        )}
                    </div>
                </>
            );
        }

        if (!isLotAvailableForBidding(lot)) {
            return (
                <div>
                    <Tag color="default">
                        Waiting for Previous Lots
                    </Tag>
                </div>
            );
        }

        const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
        const endTime = lot.last_bid_time ? moment(lot.last_bid_time).add(closeTimeSeconds, 'seconds').valueOf() : null;

        return (
            <div>
                <Tag color="blue">
                    {endTime ? (
                        <Countdown
                            date={endTime}
                            now={getServerNow}
                            renderer={({ minutes, seconds }) => (
                                <span>Time left: {minutes}:{seconds.toString().padStart(2, '0')}</span>
                            )}
                            onComplete={() => handleLotCompletion(lot)}
                        />
                    ) : (
                        'Live'
                    )}
                </Tag>
            </div>
        );
    };

    // Add a helper function for lot completion
    const handleLotCompletion = (lot) => {
        console.log('[Lot Debug] Countdown completed for lot:', lot.id, '- optimistically updating status');

        // Optimistically determine status based on reserve price (like cancelled does)
        const currentPrice = parseFloat(lot.current_price || lot.starting_price || 0);
        const reservePrice = parseFloat(lot.reserve_price || 0);
        const hasReserve = lot.is_reserve && reservePrice > 0;

        // Determine status optimistically
        let optimisticStatus = 'closed';
        if (hasReserve && currentPrice < reservePrice) {
            optimisticStatus = 'cancelled';
        }

        console.log('[Lot Debug] Optimistic status:', optimisticStatus, 'for lot:', lot.id, {
            currentPrice,
            reservePrice,
            hasReserve
        });

        // Only show loading state if we can't determine the status (shouldn't happen, but safety check)
        // For cancelled, we don't show loading (it's instant)
        // For closed, we also don't show loading now (optimistic update)
        // We'll still wait for backend confirmation, but UI updates immediately

        setClosedLots(closed => closed.includes(Number(lot.id)) ? closed : [...closed, Number(lot.id)]);
        setLots(prevLots => {
            const newLots = prevLots.map(l => {
                if (l.id === Number(lot.id)) {
                    const updatedLot = { ...l, status: optimisticStatus };
                    // If closed and we have last_bid_user_id, preserve it for optimistic winner display
                    if (optimisticStatus === 'closed' && l.last_bid_user_id) {
                        updatedLot.last_bid_user_id = l.last_bid_user_id;
                    }
                    return updatedLot;
                }
                return l;
            });

            if (isSequential) {
                const currentIndex = newLots.findIndex(l => l.id === Number(lot.id));
                if (currentIndex !== -1 && currentIndex < newLots.length - 1) {
                    const nextLot = newLots[currentIndex + 1];
                    setActiveLotId(nextLot.id);
                    return newLots.map(l =>
                        l.id === nextLot.id
                            ? { ...l, status: 'active' }
                            : l
                    );
                }
            }
            return newLots;
        });

        // If closed and user is winner, show success message optimistically
        if (optimisticStatus === 'closed' && lot.last_bid_user_id === currentUser?.id) {
            console.log('[Message Debug] Showing optimistic winner message for lot:', lot.id);
            showSuccessMessage(lot.id, true, false, currentPrice);
            triggerConfetti(lot.id);
        }

        // Set a timeout to automatically clear any loading state after 10 seconds (safety fallback)
        clearLoadingStateWithTimeout(lot.id, 10000);

        // Backend confirmation will still come via Pusher and update the final state
        // This optimistic update makes the UI feel instant, just like cancelled and timeout
    };

    // Add a helper function for lot cancellation
    const handleLotCancellation = (lot) => {
        // No loading state for cancelled - it's instant (determined optimistically)
        // The isLotCancelled helper already handles showing cancelled status immediately

        setLots(prevLots => {
            const newLots = prevLots.map(l =>
                l.id === Number(lot.id)
                    ? { ...l, status: 'cancelled' }
                    : l
            );

            if (isSequential) {
                const currentIndex = newLots.findIndex(l => l.id === Number(lot.id));
                if (currentIndex !== -1 && currentIndex < newLots.length - 1) {
                    const nextLot = newLots[currentIndex + 1];
                    setActiveLotId(nextLot.id);
                    return newLots.map(l =>
                        l.id === nextLot.id
                            ? { ...l, status: 'active' }
                            : l
                    );
                }
            }
            return newLots;
        });
    };

    // Add this function to check for duplicate events
    const isDuplicateEvent = (eventId) => {
        if (processedEventIds.has(eventId)) {
            console.log('[Bid Debug] Skipping duplicate event:', eventId);
            return true;
        }
        processedEventIds.add(eventId);
        // Clean up old event IDs after 5 seconds
        setTimeout(() => {
            processedEventIds.delete(eventId);
        }, 5000);
        return false;
    };

    // Add function to check for duplicate bid notifications
    const isDuplicateBidNotification = (lotId, newBidAmount, previousBidAmount, notificationType) => {
        const notificationKey = `${lotId}-${newBidAmount}-${previousBidAmount}-${notificationType}`;
        if (processedBidNotifications.has(notificationKey)) {
            console.log('[Notification Debug] Skipping duplicate notification:', notificationKey);
            return true;
        }

        // Also check if we've shown a similar notification recently (within 2 seconds)
        const recentKey = `${lotId}-${notificationType}`;
        const now = Date.now();
        const lastNotification = processedBidNotifications.get(recentKey) || 0;

        if (now - lastNotification < 2000) {
            console.log('[Notification Debug] Skipping recent notification:', recentKey);
            return true;
        }

        processedBidNotifications.set(notificationKey, now);
        processedBidNotifications.set(recentKey, now);

        // Clean up old notification keys after 10 seconds
        setTimeout(() => {
            processedBidNotifications.delete(notificationKey);
        }, 10000);

        return false;
    };

    // Update the Pusher event handler
    useEffect(() => {
        if (!auction || !auction.id) return;
        const channelName = `auction.${auction.id}`;
        console.log('[Bid Debug] Subscribing to channel:', channelName);

        const channel = pusherService.pusher.subscribe(channelName);
        console.log('[Bid Debug] Channel subscription status:', {
            channel: channel.name,
            subscribed: channel.subscribed,
            timestamp: new Date().toISOString()
        });

        // Handle new bid event
        const handleBidEvent = (data) => {
            const eventTime = new Date().toISOString();
            console.log('[Bid Debug] Received bid event:', {
                event: data,
                timestamp: eventTime
            });

            // Generate a unique event ID for duplicate detection
            const eventId = data.e || `${data.l?.i}-${data.l?.p}-${data.l?.u}-${data.l?.t}`;

            // Skip if this is a duplicate event
            if (isDuplicateEvent(eventId)) {
                return;
            }

            // Handle full lot object updates (like cancelled status or closed from buy now)
            if (data.lot && data.lot.id) {
                const updatedLot = updateLotStatus(data.lot);

                // Explicitly ensure status is preserved from backend (especially for closed lots from buy now)
                if (data.lot.status === 'closed') {
                    updatedLot.status = 'closed';
                }

                // Check if current user should see confetti celebration for closed lots
                if (updatedLot.status === 'closed' && updatedLot.last_bid_user_id) {
                    const isWinner = updatedLot.last_bid_user_id === currentUser?.id;
                    const isAuctionOwner = auction?.user_id === currentUser?.id;

                    if (isWinner || isAuctionOwner) {
                        console.log('[Message Debug] Triggering success message from lot.closed event for lot:', updatedLot.id);
                        // Show success message with duplicate protection
                        showSuccessMessage(updatedLot.id, isWinner, isAuctionOwner, updatedLot.current_price);

                        // Trigger confetti celebration
                        triggerConfetti(updatedLot.id);
                    }
                }

                // Notify auction owner if lot closed without vendor bid (and vendor bid could have been placed)
                if (updatedLot.status === 'closed' && auction?.user_id === currentUser?.id) {
                    const existingLot = lots.find(l => l.id === updatedLot.id);
                    const hasVendorBid = existingLot?.owner_bid_tracking?.has_vendor_bid || updatedLot?.owner_bid_tracking?.has_vendor_bid || false;
                    const hasReservePrice = updatedLot.reserve_price && updatedLot.reserve_price > 0;
                    const hasBids = updatedLot.last_bid_user_id && updatedLot.last_bid_user_id !== null;
                    const isBelowReserve = hasReservePrice && updatedLot.current_price < updatedLot.reserve_price;

                    // Show notification if vendor bid could have been placed but wasn't
                    if (!hasVendorBid && hasReservePrice && hasBids && isBelowReserve) {
                        message.warning({
                            content: `Lot #${updatedLot.lot_number || updatedLot.id} closed below reserve price (${formatCurrency(updatedLot.current_price)}) without a vendor bid. The reserve price was ${formatCurrency(updatedLot.reserve_price)}.`,
                            duration: 8,
                            style: {
                                marginTop: '20vh',
                            }
                        });
                    }
                }

                // Clear loading state for this lot
                setStatusLoadingLots(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(updatedLot.id);
                    return newSet;
                });

                // Preserve favorite status and owner_bid_tracking
                const existingLot = lots.find(l => l.id === updatedLot.id);
                if (existingLot) {
                    updatedLot.is_favorite = existingLot.is_favorite;
                    // Preserve owner_bid_tracking if server response doesn't include it
                    if (!updatedLot.owner_bid_tracking && existingLot.owner_bid_tracking) {
                        updatedLot.owner_bid_tracking = existingLot.owner_bid_tracking;
                    }
                }

                // Batch state updates
                const updates = () => {
                    // Update lots - explicitly preserve status from backend
                    setLots(prevLots => {
                        const newLots = prevLots.map(l => {
                            if (l.id === updatedLot.id) {
                                return {
                                    ...l,
                                    ...updatedLot,
                                    // Explicitly set status to closed if backend says it's closed
                                    status: data.lot.status === 'closed' ? 'closed' : updatedLot.status
                                };
                            }
                            return l;
                        });
                        updateSidebarCounts(newLots);
                        return newLots;
                    });

                    // Update selected lot if it matches - explicitly preserve status from backend
                    setSelectedLot(prevSelected => {
                        if (prevSelected && prevSelected.id === updatedLot.id) {
                            return {
                                ...prevSelected,
                                ...updatedLot,
                                // Explicitly set status to closed if backend says it's closed
                                status: data.lot.status === 'closed' ? 'closed' : updatedLot.status
                            };
                        }
                        return prevSelected;
                    });

                    // Handle sequential lot activation for both closed and cancelled
                    if (isSequential && (updatedLot.status === 'closed' || updatedLot.status === 'cancelled')) {
                        const currentIndex = lots.findIndex(l => l.id === updatedLot.id);
                        if (currentIndex !== -1 && currentIndex < lots.length - 1) {
                            const nextLot = lots[currentIndex + 1];
                            setActiveLotId(nextLot.id);
                            setLots(prevLots =>
                                prevLots.map(l =>
                                    l.id === nextLot.id
                                        ? { ...l, status: 'active' }
                                        : l
                                )
                            );
                        }
                    }
                };

                // Execute updates in next tick to batch them
                setTimeout(updates, 0);
                return;
            }

            // Process the optimized event data (for bid updates)
            const updatedLot = {
                id: data.l?.i,
                current_price: data.l?.p,
                last_bid_user_id: data.l?.u,
                last_bid_time: data.l?.t,
                status: data.l?.s,
                pending_bid_user_id: null,
                pending_bid_amount: null,
                // Extract owner_bid_tracking from event (obt = owner_bid_tracking)
                owner_bid_tracking: data.l?.obt ? {
                    has_start_bid: data.l.obt.has_start_bid || false,
                    has_vendor_bid: data.l.obt.has_vendor_bid || false
                } : undefined
            };

            if (updatedLot.id) {
                // Show loading state
                setTimerLoading(prev => ({ ...prev, [updatedLot.id]: true }));

                const processedLot = updateLotStatus(updatedLot);

                // Get the most current lot state (after optimistic updates)
                const currentLotState = lots.find(l => l.id === processedLot.id);
                const existingLot = currentLotState || lots.find(l => l.id === processedLot.id);

                if (existingLot) {
                    processedLot.is_favorite = existingLot.is_favorite;
                    // Preserve lot identity fields - the socket payload only carries id/price/status/etc,
                    // not lot_number/title/slug, so without this "Lot #undefined" shows up in bid activity
                    if (processedLot.lot_number === undefined) {
                        processedLot.lot_number = existingLot.lot_number;
                    }
                    if (processedLot.title === undefined) {
                        processedLot.title = existingLot.title;
                    }
                    if (processedLot.slug === undefined) {
                        processedLot.slug = existingLot.slug;
                    }
                    // Preserve reserve_price and is_reserve for reserve met detection
                    if (!processedLot.reserve_price && existingLot.reserve_price) {
                        processedLot.reserve_price = existingLot.reserve_price;
                    }
                    if (processedLot.is_reserve === undefined && existingLot.is_reserve !== undefined) {
                        processedLot.is_reserve = existingLot.is_reserve;
                    }
                    // Use owner_bid_tracking from event if available, otherwise preserve from existing lot
                    // Event data takes precedence, but preserve existing vendor bid tracking if event doesn't include it
                    if (processedLot.owner_bid_tracking &&
                        (processedLot.owner_bid_tracking.has_vendor_bid || processedLot.owner_bid_tracking.has_start_bid)) {
                        // Event includes owner_bid_tracking with data, use it
                    } else if (existingLot.owner_bid_tracking &&
                        (existingLot.owner_bid_tracking.has_vendor_bid || existingLot.owner_bid_tracking.has_start_bid)) {
                        // Preserve from existing lot if event doesn't include it or has empty data
                        // This ensures vendor bid tracking from vendor.bid.placed event is preserved
                        processedLot.owner_bid_tracking = existingLot.owner_bid_tracking;
                    } else if (processedLot.owner_bid_tracking !== undefined) {
                        // Event explicitly sets owner_bid_tracking (even if null/empty), use it
                    }
                }

                // Debug: Log owner_bid_tracking to verify it's being set
                if (processedLot.owner_bid_tracking) {
                    console.log('[Bid Event] owner_bid_tracking received:', {
                        lotId: processedLot.id,
                        owner_bid_tracking: processedLot.owner_bid_tracking,
                        has_start_bid: processedLot.owner_bid_tracking.has_start_bid,
                        has_vendor_bid: processedLot.owner_bid_tracking.has_vendor_bid,
                        eventData: data.l?.obt
                    });
                }

                // Check if reserve price is met (only for auction owner)
                const isAuctionOwner = currentUser?.id === auction?.user_id;
                if (isAuctionOwner && existingLot && processedLot.reserve_price && processedLot.reserve_price > 0) {
                    const wasReserveMet = isReserveMet(existingLot);
                    const isNowReserveMet = isReserveMet(processedLot);

                    // If reserve was just met (wasn't met before, but is now)
                    if (!wasReserveMet && isNowReserveMet && !reserveMetLots.has(processedLot.id)) {
                        // Mark this lot as having shown the notification
                        setReserveMetLots(prev => new Set([...prev, processedLot.id]));

                        // Show animated notification
                        setReserveMetNotification({
                            lotId: processedLot.id,
                            lotNumber: processedLot.lot_number || processedLot.id,
                            lotTitle: processedLot.title || 'Lot',
                            currentPrice: processedLot.current_price,
                            reservePrice: processedLot.reserve_price
                        });

                        // Auto-hide notification after 8 seconds
                        setTimeout(() => {
                            setReserveMetNotification(null);
                        }, 8000);

                        // Play success sound if available
                        if (hasInteracted) {
                            playSound('bid', `reserve-met-${processedLot.id}-${Date.now()}`);
                        }
                    }
                }

                // Debug outbid detection
                console.log('[Outbid Debug]', {
                    lotId: processedLot.id,
                    existingLastBidUserId: existingLot?.last_bid_user_id,
                    newLastBidUserId: processedLot.last_bid_user_id,
                    currentUserId: currentUser?.id,
                    existingPrice: existingLot?.current_price,
                    newPrice: processedLot.current_price,
                    wasOutbid: existingLot &&
                        Number(existingLot.last_bid_user_id) === Number(currentUser?.id) &&
                        Number(processedLot.last_bid_user_id) !== Number(currentUser?.id) &&
                        processedLot.current_price > existingLot.current_price,
                    successfullyOutbid: existingLot &&
                        Number(existingLot.last_bid_user_id) !== Number(currentUser?.id) &&
                        Number(processedLot.last_bid_user_id) === Number(currentUser?.id) &&
                        processedLot.current_price > existingLot.current_price &&
                        existingLot.last_bid_user_id,
                    existingLotExists: !!existingLot,
                    priceIncreased: processedLot.current_price > existingLot?.current_price,
                    userChanged: Number(existingLot?.last_bid_user_id) !== Number(processedLot.last_bid_user_id),
                    numericComparison: {
                        existingUserId: Number(existingLot?.last_bid_user_id),
                        newUserId: Number(processedLot.last_bid_user_id),
                        currentUserId: Number(currentUser?.id)
                    }
                });

                // Check if current user was outbid
                if (existingLot &&
                    Number(existingLot.last_bid_user_id) === Number(currentUser?.id) &&
                    Number(processedLot.last_bid_user_id) !== Number(currentUser?.id) &&
                    processedLot.current_price > existingLot.current_price) {
                    console.log('[Outbid Debug] User was outbid');
                    handleOutbidNotification(
                        processedLot.id,
                        processedLot.current_price,
                        existingLot.current_price
                    );
                }

                // Check if current user successfully outbid someone else
                if (existingLot &&
                    Number(existingLot.last_bid_user_id) !== Number(currentUser?.id) &&
                    Number(processedLot.last_bid_user_id) === Number(currentUser?.id) &&
                    processedLot.current_price > existingLot.current_price &&
                    existingLot.last_bid_user_id) { // Only if there was actually a previous bidder
                    console.log('[Outbid Debug] User successfully outbid someone');
                    handleSuccessfulOutbidNotification(
                        processedLot.id,
                        processedLot.current_price,
                        existingLot.current_price
                    );
                }

                // Show competition outbid notification for all other users when someone successfully outbids
                if (existingLot &&
                    Number(existingLot.last_bid_user_id) !== Number(currentUser?.id) &&
                    Number(processedLot.last_bid_user_id) !== Number(currentUser?.id) &&
                    processedLot.current_price > existingLot.current_price &&
                    existingLot.last_bid_user_id) { // Only if there was actually a previous bidder and someone else outbid
                    console.log('[Outbid Debug] Competition outbid detected');
                    handleCompetitionOutbidNotification(
                        processedLot.id,
                        processedLot.current_price,
                        existingLot.current_price
                    );
                }

                // Batch state updates
                const updates = () => {
                    // Add to new bid lots for animation
                    setNewBidLots(prev => new Set([...prev, processedLot.id]));

                    // Remove from new bid lots after 7 seconds
                    setTimeout(() => {
                        setNewBidLots(prev => {
                            const newSet = new Set(prev);
                            newSet.delete(processedLot.id);
                            return newSet;
                        });
                    }, 7000);

                    // Update lots
                    setLots(prevLots => {
                        const newLots = prevLots.map(l => l.id === processedLot.id ? { ...l, ...processedLot } : l);
                        updateSidebarCounts(newLots);
                        return newLots;
                    });

                    // Update bid history cache for ALL lots when a bid comes in (ensures count updates for all users)
                    if (data.b && data.b.i && processedLot.last_bid_user_id && processedLot.current_price) {
                        const userId = data.b.u || processedLot.last_bid_user_id;

                        // Get user info
                        let userInfo = userInfoCache.get(userId);
                        if (!userInfo || (!userInfo.first_name && !userInfo.last_name)) {
                            const onlineUser = onlineUsers.find(u => Number(u.id) === Number(userId));
                            if (onlineUser) {
                                userInfo = { id: onlineUser.id, first_name: onlineUser.first_name, last_name: onlineUser.last_name };
                                setUserInfoCache(prev => {
                                    const newCache = new Map(prev);
                                    newCache.set(userId, userInfo);
                                    return newCache;
                                });
                            } else if (currentUser && Number(currentUser.id) === Number(userId)) {
                                userInfo = { id: currentUser.id, first_name: currentUser.first_name, last_name: currentUser.last_name };
                                setUserInfoCache(prev => {
                                    const newCache = new Map(prev);
                                    newCache.set(userId, userInfo);
                                    return newCache;
                                });
                            } else {
                                userInfo = { id: userId, first_name: null, last_name: null };
                            }
                        }

                        const newBid = {
                            id: data.b.i,
                            lot_id: processedLot.id,
                            amount: data.b.a || processedLot.current_price,
                            user_id: userId,
                            created_at: data.b.c ? new Date(data.b.c * 1000).toISOString() : (data.l?.t || new Date().toISOString()),
                            user: userInfo
                        };

                        // Always update cache (not just for selected lot)
                        setBidHistoryCache(prevCache => {
                            const newCache = new Map(prevCache);
                            const existingBids = newCache.get(processedLot.id) || [];

                            // Avoid duplicates
                            const bidExists = existingBids.some(b =>
                                b.id === newBid.id ||
                                (Number(b.user_id) === Number(newBid.user_id) &&
                                    Number(b.amount) === Number(newBid.amount) &&
                                    b.created_at === newBid.created_at)
                            );

                            if (!bidExists) {
                                const updated = [newBid, ...existingBids].sort((a, b) => {
                                    const dateA = new Date(a.created_at);
                                    const dateB = new Date(b.created_at);
                                    return dateB - dateA;
                                });

                                const maxAmount = Math.max(...updated.map(b => b.amount));
                                const finalBids = updated.map(bid => ({
                                    ...bid,
                                    is_winning: bid.amount === maxAmount && bid.amount === processedLot.current_price
                                }));

                                newCache.set(processedLot.id, finalBids);

                                // Update bid activity count
                                const allLotsWithBids = lots.filter(lot => {
                                    const cachedBids = lot.id === processedLot.id ? finalBids : newCache.get(lot.id);
                                    return cachedBids && cachedBids.length > 0;
                                });
                                setBidActivityCount(allLotsWithBids.length);

                                // Update bidActivityData when new bid arrives (for badge count)
                                setBidActivityData(prev => {
                                    const bidForActivity = {
                                        id: newBid.id,
                                        lot_id: processedLot.id,
                                        lot_number: processedLot.lot_number,
                                        lot_title: processedLot.title,
                                        lot_slug: processedLot.slug,
                                        user_id: newBid.user_id,
                                        user: newBid.user,
                                        amount: newBid.amount,
                                        is_winning: finalBids.find(b => b.id === newBid.id)?.is_winning || false,
                                        created_at: newBid.created_at
                                    };

                                    // Check if this bid already exists (avoid duplicates)
                                    const exists = prev.some(b => b.id === bidForActivity.id);
                                    if (exists) {
                                        return prev;
                                    }

                                    // Add new bid at the beginning and sort by created_at desc
                                    return [bidForActivity, ...prev].sort((a, b) => {
                                        return new Date(b.created_at) - new Date(a.created_at);
                                    });
                                });
                            }

                            return newCache;
                        });
                    }

                    // Update selected lot if it matches
                    setSelectedLot(prevSelected => {
                        if (prevSelected && prevSelected.id === processedLot.id) {
                            // Update bid history in real-time via Pusher
                            if (data.b && data.b.i) {
                                const newBid = {
                                    id: data.b.i,
                                    amount: data.b.a || processedLot.current_price,
                                    user_id: data.b.u || processedLot.last_bid_user_id,
                                    created_at: data.b.c ? new Date(data.b.c * 1000).toISOString() : (data.l?.t || new Date().toISOString()),
                                    is_winning: processedLot.current_price === (data.b.a || processedLot.current_price),
                                    user: (() => {
                                        const userId = data.b.u || processedLot.last_bid_user_id;

                                        // First, try to get user info from cached user info (from previous bid history fetches)
                                        const cachedUserInfo = userInfoCache.get(userId);
                                        if (cachedUserInfo && (cachedUserInfo.first_name || cachedUserInfo.last_name)) {
                                            return cachedUserInfo;
                                        }

                                        // Try to get user info from online users (presence channel)
                                        const onlineUser = onlineUsers.find(u => Number(u.id) === Number(userId));
                                        if (onlineUser) {
                                            // Cache this user info for future use
                                            setUserInfoCache(prev => {
                                                const newCache = new Map(prev);
                                                newCache.set(userId, {
                                                    id: onlineUser.id,
                                                    first_name: onlineUser.first_name,
                                                    last_name: onlineUser.last_name
                                                });
                                                return newCache;
                                            });
                                            return {
                                                id: onlineUser.id,
                                                first_name: onlineUser.first_name,
                                                last_name: onlineUser.last_name
                                            };
                                        }

                                        // Fallback to current user if it's their bid
                                        if (currentUser && Number(currentUser.id) === Number(userId)) {
                                            // Cache current user info
                                            setUserInfoCache(prev => {
                                                const newCache = new Map(prev);
                                                newCache.set(userId, {
                                                    id: currentUser.id,
                                                    first_name: currentUser.first_name,
                                                    last_name: currentUser.last_name
                                                });
                                                return newCache;
                                            });
                                            return {
                                                id: currentUser.id,
                                                first_name: currentUser.first_name,
                                                last_name: currentUser.last_name
                                            };
                                        }

                                        // Check cached bid history for this lot (they might have bid before)
                                        const cachedBidHistory = bidHistoryCache.get(processedLot.id);
                                        if (cachedBidHistory) {
                                            const existingBid = cachedBidHistory.find(b =>
                                                Number(b.user_id) === Number(userId) ||
                                                Number(b.user?.id) === Number(userId)
                                            );
                                            if (existingBid && existingBid.user && (existingBid.user.first_name || existingBid.user.last_name)) {
                                                const userInfo = {
                                                    id: existingBid.user.id,
                                                    first_name: existingBid.user.first_name,
                                                    last_name: existingBid.user.last_name
                                                };
                                                // Cache this user info
                                                setUserInfoCache(prev => {
                                                    const newCache = new Map(prev);
                                                    newCache.set(userId, userInfo);
                                                    return newCache;
                                                });
                                                return userInfo;
                                            }
                                        }

                                        // Check current bidHistory state for user info (from previous bids in this session)
                                        // We need to access it synchronously, so we'll check it after adding the bid

                                        // Return minimal user info if not found anywhere
                                        // We'll update it later when bid history is fetched or when we find the user info
                                        return {
                                            id: userId,
                                            first_name: null,
                                            last_name: null
                                        };
                                    })()
                                };

                                // Add bid to history in real-time (avoid duplicates) and update cache
                                setBidHistory(prev => {
                                    // Check if bid already exists
                                    const bidExists = prev.some(b => b.id === newBid.id);
                                    if (bidExists) return prev;

                                    // Before adding, try to enrich user info from existing bids in current history
                                    if (!newBid.user.first_name && !newBid.user.last_name && newBid.user.id) {
                                        const existingBidWithUser = prev.find(b =>
                                            (Number(b.user_id) === Number(newBid.user.id) ||
                                                Number(b.user?.id) === Number(newBid.user.id)) &&
                                            b.user && (b.user.first_name || b.user.last_name)
                                        );
                                        if (existingBidWithUser && existingBidWithUser.user) {
                                            newBid.user = {
                                                ...newBid.user,
                                                first_name: existingBidWithUser.user.first_name,
                                                last_name: existingBidWithUser.user.last_name
                                            };
                                            // Cache this user info
                                            setUserInfoCache(prevCache => {
                                                const newCache = new Map(prevCache);
                                                newCache.set(newBid.user.id, {
                                                    id: newBid.user.id,
                                                    first_name: newBid.user.first_name,
                                                    last_name: newBid.user.last_name
                                                });
                                                return newCache;
                                            });
                                        }
                                    }

                                    // Add new bid and sort by created_at descending
                                    const updated = [newBid, ...prev].sort((a, b) => {
                                        const dateA = new Date(a.created_at);
                                        const dateB = new Date(b.created_at);
                                        return dateB - dateA;
                                    });

                                    // Update winning status for all bids (only highest should be winning)
                                    const maxAmount = Math.max(...updated.map(b => b.amount));
                                    const finalBids = updated.map(bid => ({
                                        ...bid,
                                        is_winning: bid.amount === maxAmount && bid.amount === processedLot.current_price
                                    }));

                                    // Update cache for this lot
                                    setBidHistoryCache(prevCache => {
                                        const newCache = new Map(prevCache);
                                        newCache.set(processedLot.id, finalBids);
                                        // Update bid activity count
                                        const allLotsWithBids = lots.filter(lot => {
                                            const cachedBids = lot.id === processedLot.id ? finalBids : newCache.get(lot.id);
                                            return cachedBids && cachedBids.length > 0;
                                        });
                                        setBidActivityCount(allLotsWithBids.length);
                                        return newCache;
                                    });

                                    return finalBids;
                                });
                            }

                            return { ...prevSelected, ...processedLot };
                        }
                        return prevSelected;
                    });

                    // Handle sequential lot activation
                    if (isSequential && (processedLot.status === 'closed' || processedLot.status === 'cancelled')) {
                        const currentIndex = lots.findIndex(l => l.id === processedLot.id);
                        if (currentIndex !== -1 && currentIndex < lots.length - 1) {
                            const nextLot = lots[currentIndex + 1];
                            setActiveLotId(nextLot.id);
                            setLots(prevLots =>
                                prevLots.map(l =>
                                    l.id === nextLot.id
                                        ? { ...l, status: 'active' }
                                        : l
                                )
                            );
                        }
                    }
                };

                // Execute updates in next tick to batch them
                setTimeout(updates, 0);

                // Trigger auto bid check immediately if there's an active auto bid for this lot
                // and the current user is not the highest bidder (someone else bid)
                if (processedLot.id && processedLot.last_bid_user_id) {
                    const lotId = processedLot.id;
                    const newHighestBidderId = processedLot.last_bid_user_id;
                    const currentUserId = currentUser?.id;

                    // Check if there's an active auto bid for this lot using the ref
                    const checkAndBidFn = autoBidCheckFunctionsRef.current.get(lotId);
                    if (checkAndBidFn) {
                        // Only trigger if current user is NOT the highest bidder (someone else outbid them)
                        if (Number(newHighestBidderId) !== Number(currentUserId)) {
                            console.log('[Auto-Bid Debug] Bid event received for lot with active auto-bid, triggering immediate check', {
                                lotId,
                                newHighestBidderId,
                                currentUserId
                            });
                            // Trigger the check immediately (don't wait for interval)
                            // Use setTimeout to ensure state updates are processed first
                            setTimeout(() => {
                                const fn = autoBidCheckFunctionsRef.current.get(lotId);
                                if (fn) {
                                    fn();
                                }
                            }, 100);
                        } else {
                            console.log('[Auto-Bid Debug] Bid event received but current user is highest bidder, skipping auto-bid trigger', {
                                lotId,
                                newHighestBidderId,
                                currentUserId
                            });
                        }
                    }
                }

                // Play sound if needed
                if (subscribedLotIds.includes(processedLot.id) && hasInteracted) {
                    const bidId = `${processedLot.id}-${processedLot.last_bid_time}-${processedLot.last_bid_user_id}`;
                    if (processedLot.last_bid_user_id !== currentUser?.id) {
                        playSound('other', bidId);
                    }
                }

                // Remove loading state after a short delay
                setTimeout(() => {
                    setTimerLoading(prev => {
                        const newState = { ...prev };
                        delete newState[processedLot.id];
                        return newState;
                    });
                }, 500);
            }
        };

        // Handle pending bid event
        // Handle bid rejected event
        channel.bind('bid.rejected', (data) => {
            console.log('[Bid Debug] Received bid.rejected event:', data);

            if (!data || !data.l || !data.r) return;

            const lotId = data.l.i;
            const rejectedUserId = data.r.u;
            const attemptedAmount = data.r.a;
            const errorMessage = data.r.m;
            const minimumBid = data.r.min;

            // Process lot update (similar to bid.placed handler)
            const updatedLot = {
                id: lotId,
                current_price: data.l.p,
                last_bid_user_id: data.l.u,
                last_bid_time: data.l.bt || data.l.t, // Use 'bt' (bid time) or fallback to 't'
                status: data.l.s,
                default_increment: data.l.inc,
                increment: data.l.inc,
                starting_price: data.l.sp,
                pending_bid_user_id: null,
                pending_bid_amount: null
            };

            const processedLot = updateLotStatus(updatedLot);

            // Get existing lot to preserve favorite status and other fields
            const existingLot = lots.find(l => l.id === lotId);
            if (existingLot) {
                processedLot.is_favorite = existingLot.is_favorite;
                // Preserve other fields that might not be in the event
                processedLot.title = existingLot.title || processedLot.title;
                processedLot.description = existingLot.description || processedLot.description;
                processedLot.lot_number = existingLot.lot_number || processedLot.lot_number;
                processedLot.slug = existingLot.slug || processedLot.slug;
                processedLot.images = existingLot.images || processedLot.images;
            }

            // Batch state updates
            const updates = () => {
                // Update lots state for all users
                setLots(prevLots => {
                    const newLots = prevLots.map(l => l.id === lotId ? { ...l, ...processedLot } : l);
                    updateSidebarCounts(newLots);
                    return newLots;
                });

                // Update selected lot if it matches - ensure all fields are updated for template bids
                setSelectedLot(prevSelected => {
                    if (prevSelected && prevSelected.id === lotId) {
                        const updated = { ...prevSelected, ...processedLot };
                        // Ensure current_price and increment are properly set for template bid calculations
                        if (data.l.p !== undefined) updated.current_price = data.l.p;
                        if (data.l.inc !== undefined) {
                            updated.default_increment = data.l.inc;
                            updated.increment = data.l.inc;
                        }
                        if (data.l.sp !== undefined) updated.starting_price = data.l.sp;
                        if (data.l.bt) updated.last_bid_time = data.l.bt;
                        return updated;
                    }
                    return prevSelected;
                });

                // Clear timer loading state and restart timer with correct last_bid_time
                setTimerLoading(prev => {
                    const newState = { ...prev };
                    delete newState[lotId];
                    return newState;
                });

                // Restart timer if lot is still active and has last_bid_time
                if (processedLot.status === 'active' && processedLot.last_bid_time) {
                    // Parse last_bid_time properly (handle ISO string or timestamp)
                    const lastBidTime = moment(processedLot.last_bid_time);
                    if (!lastBidTime.isValid()) {
                        console.warn('[Bid Rejected] Invalid last_bid_time:', processedLot.last_bid_time);
                    } else {
                        const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                        const endTime = lastBidTime.add(closeTimeSeconds, 'seconds').valueOf();
                        const now = Date.now();
                        const remaining = Math.max(0, endTime - now);

                        if (remaining > 0) {
                            setLotTimers(prev => ({
                                ...prev,
                                [lotId]: endTime
                            }));
                        } else {
                            // Timer expired, remove it
                            setLotTimers(prev => {
                                const newTimers = { ...prev };
                                delete newTimers[lotId];
                                return newTimers;
                            });
                        }
                    }
                } else {
                    // Lot is closed/cancelled, remove timer
                    setLotTimers(prev => {
                        const newTimers = { ...prev };
                        delete newTimers[lotId];
                        return newTimers;
                    });
                }
            };

            // Execute updates in next tick to batch them
            setTimeout(updates, 0);

            // Track rejected bid for the user who attempted it (if it's the current user)
            if (currentUser && Number(rejectedUserId) === Number(currentUser.id)) {
                setRejectedBids(prev => {
                    const newMap = new Map(prev);
                    const rejectedBidsForLot = newMap.get(lotId) || [];

                    rejectedBidsForLot.push({
                        amount: attemptedAmount,
                        minimumBid: minimumBid,
                        errorMessage: errorMessage,
                        timestamp: new Date().toISOString(),
                        user: currentUser
                    });

                    newMap.set(lotId, rejectedBidsForLot);
                    return newMap;
                });

                // Get lot info for the notification
                const lot = lots.find(l => l.id === lotId);
                const lotNumber = lot?.lot_number || 'Unknown';

                // Show modal for the user who attempted the bid
                setBidRejectionModal({
                    visible: true,
                    lotNumber: lotNumber,
                    errorMessage: errorMessage,
                    minimumBid: minimumBid,
                    isAutoBid: false,
                    lotName: lot?.title || ''
                });
            }
        });

        channel.bind('bid.pending', (data) => {
            console.log('[Bid Debug] Received pending bid event:', data);
            const { lot_id, user_id, amount, timestamp } = data;

            // Get the current lot state before updating
            const currentLot = lots.find(l => l.id === lot_id);

            console.log('[Pending Bid Debug]', {
                lotId: lot_id,
                currentLastBidUserId: currentLot?.last_bid_user_id,
                newBidUserId: user_id,
                currentUserId: currentUser?.id,
                currentPrice: currentLot?.current_price,
                newBidAmount: amount,
                isCurrentUserBidding: Number(user_id) === Number(currentUser?.id),
                willOutbid: currentLot && amount > currentLot.current_price,
                numericComparison: {
                    currentLastBidUserId: Number(currentLot?.last_bid_user_id),
                    newBidUserId: Number(user_id),
                    currentUserId: Number(currentUser?.id)
                }
            });

            // Update UI for all users
            setLots(prevLots => prevLots.map(lot =>
                lot.id === lot_id
                    ? {
                        ...lot,
                        pending_bid_user_id: user_id,
                        pending_bid_amount: amount,
                        current_price: amount,
                        last_bid_user_id: user_id,
                        last_bid_time: timestamp
                    }
                    : lot
            ));

            setSelectedLot(prevSelected => {
                if (prevSelected && prevSelected.id === lot_id) {
                    return {
                        ...prevSelected,
                        pending_bid_user_id: user_id,
                        pending_bid_amount: amount,
                        current_price: amount,
                        last_bid_user_id: user_id,
                        last_bid_time: timestamp
                    };
                }
                return prevSelected;
            });

            // Stop timer and show loading state
            setLotTimers(prev => {
                const newTimers = { ...prev };
                delete newTimers[lot_id];
                return newTimers;
            });
            setTimerLoading(prev => ({ ...prev, [lot_id]: true }));

            // Play sound for other users
            if (hasInteracted && user_id !== currentUser?.id) {
                playSound('bid', `${lot_id}-${Date.now()}`);
            }
        });

        // Handle lot closed event
        channel.bind('lot.closed', (data) => {
            if (data.lot) {
                const updatedLot = updateLotStatus(data.lot);

                // Explicitly ensure status is 'closed' for closed lots
                updatedLot.status = 'closed';

                // Check if current user should see confetti celebration
                if (updatedLot.status === 'closed' && updatedLot.last_bid_user_id) {
                    const isWinner = updatedLot.last_bid_user_id === currentUser?.id;
                    const isAuctionOwner = auction?.user_id === currentUser?.id;

                    if (isWinner || isAuctionOwner) {
                        // Show success message with duplicate protection
                        showSuccessMessage(updatedLot.id, isWinner, isAuctionOwner, updatedLot.current_price);

                        // Trigger confetti celebration
                        triggerConfetti(updatedLot.id);
                    }
                }

                // Notify auction owner if lot closed without vendor bid (and vendor bid could have been placed)
                if (updatedLot.status === 'closed' && auction?.user_id === currentUser?.id) {
                    const existingLot = lots.find(l => l.id === updatedLot.id);
                    const hasVendorBid = existingLot?.owner_bid_tracking?.has_vendor_bid || updatedLot?.owner_bid_tracking?.has_vendor_bid || false;
                    const hasReservePrice = updatedLot.reserve_price && updatedLot.reserve_price > 0;
                    const hasBids = updatedLot.last_bid_user_id && updatedLot.last_bid_user_id !== null;
                    const isBelowReserve = hasReservePrice && updatedLot.current_price < updatedLot.reserve_price;

                    // Show notification if vendor bid could have been placed but wasn't
                    if (!hasVendorBid && hasReservePrice && hasBids && isBelowReserve) {
                        message.warning({
                            content: `Lot #${updatedLot.lot_number || updatedLot.id} closed below reserve price (${formatCurrency(updatedLot.current_price)}) without a vendor bid. The reserve price was ${formatCurrency(updatedLot.reserve_price)}.`,
                            duration: 8,
                            style: {
                                marginTop: '20vh',
                            }
                        });
                    }
                }

                // Preserve favorite status
                const existingLot = lots.find(l => l.id === updatedLot.id);
                if (existingLot) {
                    updatedLot.is_favorite = existingLot.is_favorite;
                }

                setLots(prevLots => {
                    const newLots = prevLots.map(l =>
                        l.id === updatedLot.id ? {
                            ...l,
                            ...updatedLot,
                            status: 'closed' // Explicitly set status to closed
                        } : l
                    );
                    updateSidebarCounts(newLots);
                    return newLots;
                });
                // If the lot is closed or cancelled, update selectedLot as well - ensure status is closed
                if ((updatedLot.status === 'closed' || updatedLot.status === 'cancelled') && selectedLot && selectedLot.id === updatedLot.id) {
                    setSelectedLot({
                        ...selectedLot,
                        ...updatedLot,
                        status: 'closed' // Explicitly set status to closed
                    });
                }
                // Sequential logic for both closed and cancelled lots
                if (isSequential && (updatedLot.status === 'closed' || updatedLot.status === 'cancelled')) {
                    const currentIndex = lots.findIndex(l => l.id === updatedLot.id);
                    if (currentIndex !== -1 && currentIndex < lots.length - 1) {
                        const nextActiveLot = lots.slice(currentIndex + 1).find(lot =>
                            lot.status === 'active'
                        );
                        if (nextActiveLot) {
                            setActiveLotId(nextActiveLot.id);
                            setLots(prevLots =>
                                prevLots.map(l =>
                                    l.id === nextActiveLot.id
                                        ? { ...l, status: 'active' }
                                        : l
                                )
                            );
                        }
                    }
                }
            }
        });

        // Handle Buy Now purchase event
        channel.bind('lot.purchased.buy.now', (data) => {
            console.log('[Buy Now Event] Received Buy Now purchase event:', data);
            console.log('[Buy Now Event] Event data structure:', {
                hasLot: !!data.lot,
                hasMessage: !!data.message,
                lotId: data.lot?.id,
                lotNumber: data.lot?.lot_number,
                lotStatus: data.lot?.status,
                fullData: data
            });

            // Update lot status and add to announcements (no popup message)
            if (data.lot) {
                const lotNumber = data.lot.lot_number;
                const lotTitle = data.lot.title || 'Unknown Lot';
                const buyNowPrice = data.buy_now_price || data.lot.buy_now_price || data.lot.current_price;
                const buyerName = data.buyer ? `${data.buyer.first_name} ${data.buyer.last_name}` : 'a buyer';

                // Add announcement to Latest Announcement section (no popup message)
                const announcementMessage = data.announcement || `📢 Lot #${lotNumber} sold at fixed price (Buy Now) for ${formatCurrency(buyNowPrice)}`;
                setAnnouncements(prev => [...prev, {
                    message: announcementMessage,
                    timestamp: data.timestamp || new Date().toISOString(),
                    user_name: buyerName,
                    type: 'buy_now'
                }]);

                console.log('[Buy Now Event] Announcement added to Latest Announcement for user:', currentUser?.id);

                // Play sound notification for everyone
                if (hasInteracted) {
                    playSound('bid', `${data.lot.id}-${Date.now()}`);
                }

                // Update lot status for everyone - use the full lot data from LotResource
                // When sold at fixed price, lot must be closed immediately
                if (data.lot && data.lot.id) {
                    const updatedLot = updateLotStatus(data.lot);

                    // Explicitly ensure status is 'closed' for buy now purchases
                    updatedLot.status = 'closed';

                    // Preserve favorite status
                    const existingLot = lots.find(l => l.id === updatedLot.id);
                    if (existingLot) {
                        updatedLot.is_favorite = existingLot.is_favorite;
                    }

                    // Update lots array for all users - ensure status is closed
                    setLots(prevLots => {
                        const newLots = prevLots.map(l =>
                            l.id === updatedLot.id ? {
                                ...l,
                                ...updatedLot,
                                status: 'closed' // Explicitly set status to closed
                            } : l
                        );
                        updateSidebarCounts(newLots);
                        return newLots;
                    });

                    // Update selected lot if it's the purchased one - ensure status is closed
                    setSelectedLot(prevSelected => {
                        if (prevSelected && prevSelected.id === updatedLot.id) {
                            return {
                                ...prevSelected,
                                ...updatedLot,
                                status: 'closed' // Explicitly set status to closed
                            };
                        }
                        return prevSelected;
                    });

                    // Clear loading state
                    setStatusLoadingLots(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(updatedLot.id);
                        return newSet;
                    });

                    // Handle sequential lot activation
                    if (isSequential && updatedLot.status === 'closed') {
                        const currentIndex = lots.findIndex(l => l.id === updatedLot.id);
                        if (currentIndex !== -1 && currentIndex < lots.length - 1) {
                            const nextLot = lots[currentIndex + 1];
                            if (nextLot && nextLot.status !== 'active') {
                                setActiveLotId(nextLot.id);
                                setLots(prevLots =>
                                    prevLots.map(l =>
                                        l.id === nextLot.id
                                            ? { ...l, status: 'active' }
                                            : l
                                    )
                                );
                            }
                        }
                    }
                }
            }
        });

        // Handle vendor bid placed event (price adjusted to 99% of reserve, lot stays active)
        channel.bind('vendor.bid.placed', (data) => {
            console.log('[Vendor Bid Placed] Received event:', data);

            if (data.lot && data.lot.id) {
                const updatedLot = updateLotStatus(data.lot);
                const lotId = updatedLot.id;

                // Check if lot is already closed - if so, don't apply vendor bid updates
                // This handles the case where vendor bid was processed but lot closed in the background
                const existingLot = lots.find(l => l.id === updatedLot.id);
                if (existingLot && (existingLot.status === 'closed' || existingLot.status === 'cancelled')) {
                    console.log('[Vendor Bid Placed] Lot is already closed, ignoring vendor bid update for lot:', lotId);
                    // Still update owner_bid_tracking to reflect that vendor bid was placed (for historical accuracy)
                    // But don't change the lot status or price
                    const updatedTracking = existingLot.owner_bid_tracking ? {
                        ...existingLot.owner_bid_tracking,
                        has_vendor_bid: true
                    } : {
                        has_start_bid: false,
                        has_vendor_bid: true
                    };
                    // Only update owner_bid_tracking, preserve closed status
                    setLots(prevLots => {
                        const newLots = prevLots.map(l =>
                            l.id === existingLot.id ? {
                                ...l,
                                owner_bid_tracking: updatedTracking
                            } : l
                        );
                        return newLots;
                    });
                    // Also update selected lot if it matches
                    setSelectedLot(prevSelected => {
                        if (prevSelected && prevSelected.id === existingLot.id) {
                            return {
                                ...prevSelected,
                                owner_bid_tracking: updatedTracking
                            };
                        }
                        return prevSelected;
                    });
                    return;
                }

                // Show loading state
                setTimerLoading(prev => ({ ...prev, [lotId]: true }));

                // Preserve favorite status and owner_bid_tracking
                if (existingLot) {
                    updatedLot.is_favorite = existingLot.is_favorite;
                    // Preserve owner_bid_tracking if server response doesn't include it
                    if (!updatedLot.owner_bid_tracking && existingLot.owner_bid_tracking) {
                        updatedLot.owner_bid_tracking = existingLot.owner_bid_tracking;
                    }
                }

                // Update owner_bid_tracking to mark vendor bid as placed
                if (updatedLot.owner_bid_tracking) {
                    updatedLot.owner_bid_tracking = {
                        ...updatedLot.owner_bid_tracking,
                        has_vendor_bid: true
                    };
                } else {
                    updatedLot.owner_bid_tracking = {
                        has_start_bid: false,
                        has_vendor_bid: true
                    };
                }

                // Ensure lot status remains active (vendor bids don't close lots)
                // But respect if lot is already closed from another event
                if (existingLot && (existingLot.status === 'closed' || existingLot.status === 'cancelled')) {
                    updatedLot.status = existingLot.status; // Preserve closed/cancelled status
                } else {
                    updatedLot.status = 'active'; // Vendor bid keeps lot active
                }

                // Batch state updates
                const updates = () => {
                    // Update lots array for all users (NO winner notifications, lot stays active)
                    setLots(prevLots => {
                        const newLots = prevLots.map(l => {
                            if (l.id === updatedLot.id) {
                                // Don't overwrite closed/cancelled status with active from stale vendor bid
                                const finalStatus = (l.status === 'closed' || l.status === 'cancelled')
                                    ? l.status
                                    : updatedLot.status;
                                return {
                                    ...l,
                                    ...updatedLot,
                                    status: finalStatus
                                };
                            }
                            return l;
                        });
                        updateSidebarCounts(newLots);
                        return newLots;
                    });

                    // Update selected lot if it matches
                    setSelectedLot(prevSelected => {
                        if (prevSelected && prevSelected.id === updatedLot.id) {
                            // Don't overwrite closed/cancelled status with active from stale vendor bid
                            const finalStatus = (prevSelected.status === 'closed' || prevSelected.status === 'cancelled')
                                ? prevSelected.status
                                : updatedLot.status;
                            return {
                                ...prevSelected,
                                ...updatedLot,
                                status: finalStatus
                            };
                        }
                        return prevSelected;
                    });

                    // Handle sequential lot activation (shouldn't happen for vendor bids, but handle it anyway)
                    if (isSequential && (updatedLot.status === 'closed' || updatedLot.status === 'cancelled')) {
                        const currentIndex = lots.findIndex(l => l.id === updatedLot.id);
                        if (currentIndex !== -1 && currentIndex < lots.length - 1) {
                            const nextLot = lots[currentIndex + 1];
                            setActiveLotId(nextLot.id);
                            setLots(prevLots =>
                                prevLots.map(l =>
                                    l.id === nextLot.id
                                        ? { ...l, status: 'active' }
                                        : l
                                )
                            );
                        }
                    }
                };

                // Execute updates in next tick to batch them
                setTimeout(updates, 0);

                // Clear loading state after a short delay
                setTimeout(() => {
                    setTimerLoading(prev => {
                        const newState = { ...prev };
                        delete newState[lotId];
                        return newState;
                    });
                }, 500);

                // Add announcement to Latest Announcement section
                if (data.announcement) {
                    setAnnouncements(prev => [...prev, {
                        message: data.announcement,
                        timestamp: data.timestamp || new Date().toISOString(),
                        user_name: 'Auction Owner',
                        type: 'owner_ended'
                    }]);
                }

                // Do NOT handle sequential lot activation - lot stays active
            }
        });

        // Handle lot timeout processing event
        channel.bind('lot.timeout.processing', (data) => {
            if (data.lot) {
                const lotId = data.lot.id;

                // Check if we've already processed this timeout processing event
                const processingKey = `processing-${lotId}`;
                if (processedTimeoutEvents.has(processingKey)) {
                    console.log('[Timeout Debug] Skipping duplicate timeout processing event for lot:', lotId);
                    return;
                }

                // Mark this timeout processing event as processed
                processedTimeoutEvents.add(processingKey);

                // Show loading state to all users (subtle indicator only)
                setTimeoutLoadingLots(prev => new Set([...prev, lotId]));

                // Don't show message to all users - just update the UI silently
                // The lot card will show a subtle "Timing Out" indicator
            }
        });

        // Handle lot timeout event
        channel.bind('lot.timeout', (data) => {
            if (data.lot) {
                const updatedLot = updateLotStatus(data.lot);
                const lotId = updatedLot.id;

                // Check if we've already processed this timeout event
                if (processedTimeoutEvents.has(lotId)) {
                    console.log('[Timeout Debug] Skipping duplicate timeout event for lot:', lotId);
                    return;
                }

                // Mark this timeout event as processed
                processedTimeoutEvents.add(lotId);

                // Remove loading state immediately
                setTimeoutLoadingLots(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(lotId);
                    return newSet;
                });

                // Also clear the processing key
                const processingKey = `processing-${lotId}`;
                processedTimeoutEvents.delete(processingKey);

                // Show timeout message only to auction owner (if they're viewing)
                // For other users, the lot status change is enough indication
                if (currentUser?.id === auction?.user_id) {
                    message.success(`Lot "${updatedLot.title}" has been timed out`, 3);
                }

                setLots(prevLots => {
                    const newLots = prevLots.map(l =>
                        l.id === updatedLot.id ? { ...l, ...updatedLot } : l
                    );
                    updateSidebarCounts(newLots);
                    return newLots;
                });

                // Update selected lot if it's the one being timed out
                if (selectedLot && selectedLot.id === updatedLot.id) {
                    setSelectedLot({ ...selectedLot, ...updatedLot });
                }

                // Sequential logic for timed out lots
                if (isSequential && updatedLot.status === 'timeout') {
                    const currentIndex = lots.findIndex(l => l.id === updatedLot.id);
                    if (currentIndex !== -1 && currentIndex < lots.length - 1) {
                        const nextActiveLot = lots.slice(currentIndex + 1).find(lot =>
                            lot.status === 'active'
                        );
                        if (nextActiveLot) {
                            setActiveLotId(nextActiveLot.id);
                            setLots(prevLots =>
                                prevLots.map(l =>
                                    l.id === nextActiveLot.id
                                        ? { ...l, status: 'active' }
                                        : l
                                )
                            );
                        }
                    }
                }

                // Close any open timeout modals
                Modal.destroyAll();
            }
        });

        // Handle auction cancellation event
        channel.bind('auction.cancelled', (data) => {
            if (data.auction) {
                console.log('[Auction] Auction cancelled:', data.auction);

                // Create a countdown component
                const CountdownComponent = () => {
                    const [countdown, setCountdown] = useState(10);

                    useEffect(() => {
                        const interval = setInterval(() => {
                            setCountdown(prev => {
                                if (prev <= 1) {
                                    clearInterval(interval);
                                    // Close the window when countdown reaches 0
                                    Modal.destroyAll();
                                    window.close();
                                    return 0;
                                }
                                return prev - 1;
                            });
                        }, 1000);

                        return () => clearInterval(interval);
                    }, []);

                    return (
                        <div style={{ textAlign: 'center', padding: '16px 0' }}>
                            <div style={{
                                fontSize: '18px',
                                color: '#ff4d4f',
                                marginBottom: '16px',
                                fontWeight: 'bold'
                            }}>
                                Auction has been cancelled
                            </div>
                            <div style={{
                                fontSize: '14px',
                                color: '#666',
                                marginBottom: '16px'
                            }}>
                                This auction has been cancelled by the auction owner.
                            </div>
                            <div style={{
                                background: 'linear-gradient(135deg, #fff2e8, #ffe7d9)',
                                padding: '12px',
                                borderRadius: '8px',
                                border: '1px solid #ffbb96'
                            }}>
                                <div style={{ fontSize: '14px', color: '#d4380d', fontWeight: 'bold' }}>
                                    Closing window in: {countdown} seconds
                                </div>
                            </div>
                        </div>
                    );
                };

                // Show cancellation popup
                Modal.warning({
                    title: (
                        <div style={{ textAlign: 'center', padding: '8px 0' }}>
                            <div style={{
                                fontSize: '24px',
                                marginBottom: '8px',
                                background: 'linear-gradient(135deg, #ff4d4f, #ff7875)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 'bold'
                            }}>
                                ⚠️ Auction Cancelled
                            </div>
                        </div>
                    ),
                    content: <CountdownComponent />,
                    okText: 'Close Window',
                    cancelText: null,
                    width: 500,
                    centered: true,
                    closable: false,
                    maskClosable: false,
                    onOk: () => {
                        Modal.destroyAll();
                        // Close the window when user clicks OK
                        window.close();
                    }
                });

                // Close window after timeout
                setTimeout(() => {
                    Modal.destroyAll();
                    window.close();
                }, 10000);

                // Update auction status locally
                setAuction(prevAuction => ({
                    ...prevAuction,
                    status: 'cancelled'
                }));
            }
        });

        // Handle auction completion event
        channel.bind('auction.completed', (data) => {
            if (data.auction) {
                console.log('[Auction] Auction completed:', data.auction);

                // Create a countdown component
                const CountdownComponent = () => {
                    const [countdown, setCountdown] = useState(10);

                    useEffect(() => {
                        const interval = setInterval(() => {
                            setCountdown(prev => {
                                if (prev <= 1) {
                                    clearInterval(interval);
                                    // Close the window when countdown reaches 0
                                    Modal.destroyAll();
                                    window.close();
                                    return 0;
                                }
                                return prev - 1;
                            });
                        }, 1000);

                        return () => clearInterval(interval);
                    }, []);

                    return (
                        <div style={{ textAlign: 'center', padding: '16px 0' }}>
                            <div style={{
                                fontSize: '18px',
                                color: '#52c41a',
                                marginBottom: '16px',
                                fontWeight: 'bold'
                            }}>
                                Thank you for participating!
                            </div>
                            <div style={{
                                fontSize: '14px',
                                color: '#666',
                                marginBottom: '16px'
                            }}>
                                All lots have been processed.
                            </div>
                            <div style={{
                                background: 'linear-gradient(135deg, #f6ffed, #d9f7be)',
                                padding: '12px',
                                borderRadius: '8px',
                                border: '1px solid #b7eb8f'
                            }}>
                                <div style={{ fontSize: '14px', color: '#389e0d', fontWeight: 'bold' }}>
                                    Closing window in: {countdown} seconds
                                </div>
                            </div>
                        </div>
                    );
                };

                // Show completion popup
                Modal.success({
                    title: (
                        <div style={{ textAlign: 'center', padding: '8px 0' }}>
                            <div style={{
                                fontSize: '24px',
                                marginBottom: '8px',
                                background: 'linear-gradient(135deg, #52c41a, #73d13d)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 'bold'
                            }}>
                                🎉 Auction Completed!
                            </div>
                        </div>
                    ),
                    content: <CountdownComponent />,
                    okText: 'Close Window',
                    cancelText: null,
                    width: 500,
                    centered: true,
                    closable: false,
                    maskClosable: false,
                    onOk: () => {
                        Modal.destroyAll();
                        // Close the window when user clicks OK
                        window.close();
                    }
                });

                // Close window after timeout
                setTimeout(() => {
                    Modal.destroyAll();
                    window.close();
                }, 10000);

                // Update auction status locally
                setAuction(prevAuction => ({
                    ...prevAuction,
                    status: 'completed'
                }));
            }
        });

        // Handle auction announcements - bind after subscription is confirmed
        const handleAnnouncement = (data) => {
            console.log('[Announcement] Received announcement:', data);

            // Create a unique identifier for this announcement to prevent duplicates
            const announcementId = `${data.timestamp || Date.now()}-${data.message || ''}-${data.sound_file || ''}`;
            const now = Date.now();

            // Skip if this is the same announcement we just processed within the last 2 seconds
            // This prevents duplicate event bindings from causing multiple plays
            if (lastProcessedAnnouncementRef.current.id === announcementId &&
                (now - lastProcessedAnnouncementRef.current.timestamp) < 2000) {
                console.log('[Announcement] Duplicate announcement detected within 2 seconds, skipping:', announcementId);
                return;
            }

            // Mark this announcement as processed
            lastProcessedAnnouncementRef.current = {
                id: announcementId,
                timestamp: now
            };

            // Only add to announcements list if there's a message (not sound-only)
            if (data.message && data.message.trim()) {
                setAnnouncements(prev => [
                    {
                        message: data.message,
                        timestamp: data.timestamp,
                        user_name: data.user_name || 'Auctioneer'
                    },
                    ...prev.slice(0, 9) // Keep last 10 announcements
                ]);
            }

            // Stop any previous announcement (sound or speech) completely and start new one
            // Always read aloud automatically for all users (removed read_aloud check)
            processAnnouncement({
                message: data.message || '',
                sound_file: data.sound_file || null
            });
        };

        // Handle sound stop event - stops any currently playing sounds and speech completely
        const handleSoundStop = (data) => {
            console.log('[Sound Stop] Received stop sound event:', data);
            // Stop any currently playing sound completely
            if (currentPlayingSoundRef.current) {
                currentPlayingSoundRef.current.pause();
                currentPlayingSoundRef.current.currentTime = 0;
                currentPlayingSoundRef.current = null;
            }
            // Stop any ongoing speech completely
            if ('speechSynthesis' in window) {
                window.speechSynthesis.cancel();
                currentUtteranceRef.current = null;
            }
            // Reset processing flag and clear queue
            isProcessingAnnouncementRef.current = false;
            announcementQueueRef.current = [];
        };

        // Store handler references
        announcementHandlersRef.current.announcement = handleAnnouncement;
        announcementHandlersRef.current.soundStop = handleSoundStop;

        // Bind events - only bind once to prevent duplicates
        const bindAnnouncementEvents = () => {
            // Only bind if not already bound
            if (announcementHandlersRef.current.bound) {
                console.log('[Announcement] Handlers already bound, skipping');
                return;
            }

            console.log('[Announcement] Binding announcement event handlers for channel:', channel.name);

            // Unbind any existing handlers first (safety check)
            try {
                if (announcementHandlersRef.current.announcement) {
                    channel.unbind('auction.announcement', announcementHandlersRef.current.announcement);
                }
                if (announcementHandlersRef.current.soundStop) {
                    channel.unbind('auction.sound.stop', announcementHandlersRef.current.soundStop);
                }
            } catch (error) {
                console.warn('[Announcement] Error unbinding previous handlers:', error);
            }

            // Bind announcement event with handler reference
            try {
                channel.bind('auction.announcement', handleAnnouncement);
                console.log('[Announcement] Successfully bound auction.announcement event');
            } catch (error) {
                console.error('[Announcement] Error binding auction.announcement:', error);
            }

            // Bind sound stop event with handler reference
            try {
                channel.bind('auction.sound.stop', handleSoundStop);
                console.log('[Announcement] Successfully bound auction.sound.stop event');
            } catch (error) {
                console.error('[Announcement] Error binding auction.sound.stop:', error);
            }

            announcementHandlersRef.current.bound = true;
        };

        // Bind after subscription is confirmed
        channel.bind('pusher:subscription_succeeded', () => {
            console.log('[Bid Debug] Channel subscription succeeded:', {
                channel: channel.name,
                timestamp: new Date().toISOString()
            });
            setChannelSubscribed(true);

            // Bind announcement events after subscription is confirmed
            bindAnnouncementEvents();
        });

        // Also bind immediately if subscription already succeeded
        if (channel.subscribed) {
            bindAnnouncementEvents();
        }


        channel.bind('pusher:subscription_error', (error) => {
            console.error('[Bid Debug] Channel subscription error:', {
                channel: channel.name,
                error,
                timestamp: new Date().toISOString()
            });
            setChannelSubscribed(false);
        });

        // Bind to the new events
        channel.bind('bid.placed', handleBidEvent);
        channel.bind('lot.updated', handleBidEvent);


        return () => {
            if (channelSubscribed) {
                console.log('[Bid Debug] Unsubscribing from channel:', channelName);
                channel.unbind('bid.pending');
                channel.unbind('bid.placed', handleBidEvent);
                channel.unbind('lot.updated', handleBidEvent);
                channel.unbind('lot.closed');
                channel.unbind('lot.purchased.buy.now');
                channel.unbind('vendor.bid.placed');
                channel.unbind('lot.timeout.processing');
                channel.unbind('lot.timeout');
                channel.unbind('auction.completed');
                channel.unbind('auction.cancelled');
                // Unbind announcement handlers with specific handler references
                if (announcementHandlersRef.current.announcement) {
                    channel.unbind('auction.announcement', announcementHandlersRef.current.announcement);
                }
                if (announcementHandlersRef.current.soundStop) {
                    channel.unbind('auction.sound.stop', announcementHandlersRef.current.soundStop);
                }
                // Reset bound flag
                announcementHandlersRef.current.bound = false;
                pusherService.pusher.unsubscribe(channelName);
                setChannelSubscribed(false);
            }
            if (soundTimeout) {
                clearTimeout(soundTimeout);
            }
        };
    }, [auction?.id, onlineUsers, currentUser, processAnnouncement]); // Include onlineUsers and currentUser for real-time bid history

    // Add function to check if a lot is available for bidding
    const isLotAvailableForBidding = (lot) => {
        if (!isSequential) return true;

        // If the lot is closed or cancelled, it's not available
        if (lot.status === 'closed' || lot.status === 'cancelled') {
            return false;
        }

        // If no active lot is set, the first active lot should be available
        if (!activeLotId) {
            const firstActiveLot = lots.find(l => l.status === 'active');
            return lot.id === firstActiveLot?.id;
        }

        // If this is the active lot, it's available
        if (lot.id === activeLotId) {
            return true;
        }

        // If the active lot is closed or cancelled, the next active lot should be available
        const activeLot = lots.find(l => l.id === activeLotId);
        if (activeLot && (activeLot.status === 'closed' || activeLot.status === 'cancelled')) {
            const activeLotIndex = lots.findIndex(l => l.id === activeLotId);
            const nextActiveLot = lots.slice(activeLotIndex + 1).find(l => l.status === 'active');
            return lot.id === nextActiveLot?.id;
        }

        return false;
    };

    const playSound = (type, bidId) => {
        // Only play sound if user has interacted with the page
        if (!hasInteracted) return;

        // Check if we've played a sound for this bid recently
        if (lastPlayedBid === bidId) {
            //console.log('Skipping duplicate sound for bid:', bidId);
            return;
        }

        // Clear any existing timeout
        if (soundTimeout) {
            clearTimeout(soundTimeout);
        }

        // Set a timeout to clear the last played bid after 1 second
        const timeout = setTimeout(() => {
            setLastPlayedBid(null);
        }, 1000);
        setSoundTimeout(timeout);

        try {
            const audio = new Audio(type === 'your' ? '/sounds/ding.mp3' : '/sounds/ding-counter.mp3');
            // Stop any currently playing sound
            audio.pause();
            audio.currentTime = 0;

            // Add event listener to ensure sound plays
            audio.addEventListener('canplaythrough', () => {
                const playPromise = audio.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        //console.log('Sound play prevented:', error);
                    });
                }
            });

            // Load the audio
            audio.load();

            // Mark this bid as played
            setLastPlayedBid(bidId);
        } catch (error) {
            //console.log('Sound play error:', error);
        }
    };

    // Add click handler to the main container to detect user interaction
    const handleUserInteraction = () => {
        if (!hasInteracted) {
            setHasInteracted(true);
        }
    };

    const filterLots = () => {
        if (!lots) return [];

        let filtered = [...lots];

        // Apply basic search filter (backward compatibility)
        if (searchQuery) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter(lot =>
                lot.title.toLowerCase().includes(query) ||
                lot.description.toLowerCase().includes(query)
            );
        }

        // Apply simple search from modal (only when in simple mode)
        if (searchMode === 'simple' && simpleSearchQuery) {
            const query = simpleSearchQuery.toLowerCase();
            filtered = filtered.filter(lot =>
                lot.title?.toLowerCase().includes(query) ||
                lot.description?.toLowerCase().includes(query) ||
                lot.lot_number?.toString().toLowerCase().includes(query)
            );
        }

        // Apply advanced search filters (only when in advanced mode)
        if (searchMode === 'advanced') {
            if (advancedSearch.title) {
                const titleQuery = advancedSearch.title.toLowerCase();
                filtered = filtered.filter(lot =>
                    lot.title?.toLowerCase().includes(titleQuery)
                );
            }

            if (advancedSearch.description) {
                const descQuery = advancedSearch.description.toLowerCase();
                filtered = filtered.filter(lot =>
                    lot.description?.toLowerCase().includes(descQuery)
                );
            }

            if (advancedSearch.lotNumber) {
                const lotNumQuery = advancedSearch.lotNumber.toString().toLowerCase();
                filtered = filtered.filter(lot =>
                    lot.lot_number?.toString().toLowerCase().includes(lotNumQuery)
                );
            }

            if (advancedSearch.minPrice) {
                const minPrice = parseFloat(advancedSearch.minPrice);
                if (!isNaN(minPrice)) {
                    filtered = filtered.filter(lot => {
                        const currentPrice = parseFloat(lot.current_price || lot.starting_price || 0);
                        return currentPrice >= minPrice;
                    });
                }
            }

            if (advancedSearch.maxPrice) {
                const maxPrice = parseFloat(advancedSearch.maxPrice);
                if (!isNaN(maxPrice)) {
                    filtered = filtered.filter(lot => {
                        const currentPrice = parseFloat(lot.current_price || lot.starting_price || 0);
                        return currentPrice <= maxPrice;
                    });
                }
            }
        }

        // Apply status filter
        switch (sidebarFilter) {
            case 'favorite':
                filtered = filtered.filter(lot => lot.is_favorite);
                break;
            case 'actively_bidding':
                // Only show for regular users (not auction owner)
                // Show lots where user has bid and lot is active
                filtered = filtered.filter(lot => {
                    if (lot.status !== 'active') return false;
                    if (!currentUser?.id) return false;

                    // Quick check: if user is the last bidder, they definitely have bid
                    if (lot.last_bid_user_id && Number(lot.last_bid_user_id) === Number(currentUser.id)) {
                        return true;
                    }

                    // Primary check: has_bid property from backend (if available)
                    if (lot.has_bid === true) return true;

                    // Check bid history cache for this lot
                    const cachedBids = bidHistoryCache.get(lot.id);
                    if (cachedBids && Array.isArray(cachedBids) && cachedBids.length > 0) {
                        const userHasBid = cachedBids.some(bid => {
                            const bidUserId = bid.user?.id || bid.user_id;
                            return bidUserId && Number(bidUserId) === Number(currentUser.id);
                        });
                        if (userHasBid) return true;
                    }

                    // Fallback: check if user has any bids in the bids array (if loaded)
                    if (lot.bids && Array.isArray(lot.bids) && lot.bids.length > 0) {
                        const userHasBid = lot.bids.some(bid => {
                            const bidUserId = bid.user?.id || bid.user_id;
                            return bidUserId && Number(bidUserId) === Number(currentUser.id);
                        });
                        if (userHasBid) return true;
                    }

                    return false;
                });
                break;
            case 'held':
                filtered = filtered.filter(lot => lot.is_held);
                break;
            case 'lost':
                filtered = filtered.filter(lot => lot.is_lost);
                break;
            case 'sold':
                filtered = filtered.filter(lot => lot.status === 'closed');
                break;
            case 'cancelled':
                filtered = filtered.filter(lot => lot.status === 'cancelled');
                break;
            case 'timeout':
                filtered = filtered.filter(lot => lot.status === 'timeout');
                break;
            default:
                break;
        }

        return filtered;
    };

    // Sort lots based on selected sort option
    const sortLots = (lotsToSort) => {
        if (!lotsToSort || lotsToSort.length === 0) return lotsToSort;

        const sorted = [...lotsToSort];

        switch (sortBy) {
            case 'price':
                sorted.sort((a, b) => {
                    const priceA = parseFloat(a.current_price || a.starting_price || 0);
                    const priceB = parseFloat(b.current_price || b.starting_price || 0);
                    return priceA - priceB;
                });
                break;
            case 'lot_number':
                sorted.sort((a, b) => {
                    const numA = parseInt(a.lot_number || 0);
                    const numB = parseInt(b.lot_number || 0);
                    return numA - numB;
                });
                break;
            case 'time_remaining':
                sorted.sort((a, b) => {
                    // Get time remaining - closed lots go to the end
                    if (checkIfLotClosed(a) && !checkIfLotClosed(b)) return 1;
                    if (!checkIfLotClosed(a) && checkIfLotClosed(b)) return -1;
                    if (checkIfLotClosed(a) && checkIfLotClosed(b)) {
                        // If both closed, sort by lot number
                        return parseInt(a.lot_number || 0) - parseInt(b.lot_number || 0);
                    }
                    // Both active - sort by time remaining (soonest first)
                    const timeA = allLotsTimeRemaining[a.id] ?? Infinity;
                    const timeB = allLotsTimeRemaining[b.id] ?? Infinity;
                    return timeA - timeB;
                });
                break;
            case 'favorites':
                sorted.sort((a, b) => {
                    // Favorites first
                    if (a.is_favorite && !b.is_favorite) return -1;
                    if (!a.is_favorite && b.is_favorite) return 1;
                    // Then by lot number
                    return parseInt(a.lot_number || 0) - parseInt(b.lot_number || 0);
                });
                break;
            default:
                break;
        }

        return sorted;
    };

    // Auto-set sort order based on filter for better UX
    useEffect(() => {
        const isAuctionOwner = currentUser?.id === auction?.user_id;

        if (sidebarFilter === 'actively_bidding' && !isAuctionOwner) {
            // Store current sort order before changing (only if not already time_remaining)
            if (sortBy !== 'time_remaining') {
                previousSortByRef.current = sortBy;
            }
            // For regular users viewing actively bidding: sort by time remaining (soonest first)
            if (sortBy !== 'time_remaining') {
                setSortBy('time_remaining');
            }
        } else if (sidebarFilter !== 'actively_bidding') {
            // Restore previous sort order when leaving actively_bidding filter
            // Only restore if we have a stored previous value and current sort is time_remaining
            if (previousSortByRef.current && sortBy === 'time_remaining') {
                setSortBy(previousSortByRef.current);
                previousSortByRef.current = 'lot_number'; // Reset to default after restoring
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sidebarFilter, currentUser?.id, auction?.user_id]);

    // Memoize filtered and sorted lots to avoid expensive computation on every render
    // This significantly improves performance when selecting lots
    const filteredAndSortedLots = useMemo(() => {
        const filtered = filterLots();
        return sortLots(filtered);
    }, [lots, sidebarFilter, sortBy, searchQuery, simpleSearchQuery, advancedSearch, searchMode, allLotsTimeRemaining]);

    // Keep the function for backward compatibility but use memoized value
    const getFilteredAndSortedLots = useCallback(() => {
        return filteredAndSortedLots;
    }, [filteredAndSortedLots]);

    // Auto-select first lot when filter changes and no lot is selected
    // Optimized: Only run when filteredAndSortedLots changes, not on every selectedLot change
    useEffect(() => {
        // Use memoized filteredAndSortedLots directly for better performance
        if (filteredAndSortedLots.length > 0 && !selectedLot) {
            setSelectedLot(filteredAndSortedLots[0]);
        } else if (filteredAndSortedLots.length > 0 && selectedLot) {
            // Use Set for O(1) lookup instead of O(n) find
            const filteredLotIds = new Set(filteredAndSortedLots.map(lot => lot.id));
            if (!filteredLotIds.has(selectedLot.id)) {
                // If current selected lot is not in filtered results, select first available
                setSelectedLot(filteredAndSortedLots[0]);
            }
        } else if (filteredAndSortedLots.length === 0) {
            // If no lots in filter, clear selection
            setSelectedLot(null);
        }
    }, [filteredAndSortedLots]); // Removed selectedLot dependency - only run when filter changes

    // Function to get dynamic background based on lot status and properties
    const getLotHeaderBackground = (lot) => {
        if (!lot) return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';

        // Check if lot is effectively cancelled (closed without reaching reserve)
        if (isLotCancelled(lot)) {
            return 'linear-gradient(135deg, #722ed1 0%, #531dab 100%)'; // Purple for cancelled
        }

        // Closed lots (that reached reserve)
        if (lot.status === 'closed') {
            if (currentUser?.id === auction?.user_id) {
                return 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'; // Blue for auction owner
            } else if (lot.last_bid_user_id === currentUser?.id) {
                return 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)'; // Green for winner
            } else if (lot.last_bid_user_id) {
                return 'linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%)'; // Red for lost
            } else {
                return 'linear-gradient(135deg, #faad14 0%, #d48806 100%)'; // Orange for no bids
            }
        }

        // Timeout lots
        if (lot.status === 'timeout') {
            return 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)'; // Orange for timeout
        }

        // Active lots
        if (lot.status === 'active') {
            if (lot.last_bid_user_id === currentUser?.id) {
                return 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'; // Blue for leading
            } else if (lot.last_bid_user_id) {
                return 'linear-gradient(135deg, #faad14 0%, #d48806 100%)'; // Orange for other leading
            } else {
                return 'linear-gradient(135deg, #13c2c2 0%, #08979c 100%)'; // Teal for no bids yet
            }
        }

        // Default gradient
        return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
    };

    // Check if there's an active search
    const hasActiveSearch = () => {
        if (searchQuery) return true;
        if (simpleSearchQuery) return true;
        if (advancedSearch.title || advancedSearch.description || advancedSearch.lotNumber || advancedSearch.minPrice || advancedSearch.maxPrice) {
            return true;
        }
        return false;
    };

    // Get search query text for display
    const getSearchQueryText = () => {
        if (simpleSearchQuery) return `"${simpleSearchQuery}"`;
        if (searchQuery) return `"${searchQuery}"`;

        // Build advanced search description
        const criteria = [];
        if (advancedSearch.title) criteria.push(`title: "${advancedSearch.title}"`);
        if (advancedSearch.description) criteria.push(`description: "${advancedSearch.description}"`);
        if (advancedSearch.lotNumber) criteria.push(`lot #${advancedSearch.lotNumber}`);
        if (advancedSearch.minPrice || advancedSearch.maxPrice) {
            const priceRange = [];
            if (advancedSearch.minPrice) priceRange.push(`min: PKR ${parseFloat(advancedSearch.minPrice).toLocaleString()}`);
            if (advancedSearch.maxPrice) priceRange.push(`max: PKR ${parseFloat(advancedSearch.maxPrice).toLocaleString()}`);
            criteria.push(`price (${priceRange.join(', ')})`);
        }

        if (criteria.length > 0) {
            return criteria.join(', ');
        }

        return 'your search criteria';
    };

    const getEmptyStateMessage = () => {
        // Check for active search first
        if (hasActiveSearch()) {
            return {
                icon: <SearchOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />,
                title: 'No lots found',
                description: `No lots match ${getSearchQueryText()}. Try adjusting your search terms or clear the search to see all lots.`,
                showClearButton: true
            };
        }

        switch (sidebarFilter) {
            case 'favorite':
                return {
                    icon: <StarOutlined style={{ fontSize: '48px', color: '#faad14' }} />,
                    title: 'No Favorite Lots',
                    description: 'You haven\'t marked any lots as favorites yet. Click the star icon on lots you\'re interested in to add them here.'
                };
            case 'actively_bidding':
                return {
                    icon: <DollarOutlined style={{ fontSize: '48px', color: '#1890ff' }} />,
                    title: 'No Active Bidding',
                    description: 'You haven\'t placed any bids on active lots yet. Start bidding on lots you\'re interested in to see them here.'
                };
            case 'held':
                return {
                    icon: <CheckCircleOutlined style={{ fontSize: '48px', color: '#1890ff' }} />,
                    title: 'No Held Lots',
                    description: 'You don\'t have any winning bids yet. Keep bidding to see your held lots here!'
                };
            case 'lost':
                return {
                    icon: <CloseCircleOutlined style={{ fontSize: '48px', color: '#f5222d' }} />,
                    title: 'No Lost Lots',
                    description: 'Great news! You haven\'t lost any bids yet. Keep up the good work!'
                };
            case 'sold':
                return {
                    icon: <DollarOutlined style={{ fontSize: '48px', color: '#52c41a' }} />,
                    title: 'No Sold Lots',
                    description: 'No lots have been sold yet. Check back later as the auction progresses.'
                };
            case 'cancelled':
                return {
                    icon: <CloseOutlined style={{ fontSize: '48px', color: '#722ed1' }} />,
                    title: 'No Cancelled Lots',
                    description: 'No lots have been cancelled. All lots are currently active.'
                };
            case 'timeout':
                return {
                    icon: <ClockCircleOutlined style={{ fontSize: '48px', color: '#fa8c16' }} />,
                    title: 'No Timed Out Lots',
                    description: 'No lots have timed out yet. All lots are still active for bidding.'
                };
            default:
                return {
                    icon: <UserOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />,
                    title: 'No Lots Available',
                    description: 'There are no lots in this auction yet. Check back later.'
                };
        }
    };

    // Handle matching reserve price
    const handleMatchReservePrice = async () => {
        if (!selectedLot || !auction || !selectedLot.reserve_price || !selectedLot.is_reserve) return;
        if (currentUser?.id === auction?.user_id) {
            message.error('You cannot bid on your own auction');
            return;
        }
        if (timeRemaining !== null && timeRemaining <= 5) {
            message.warning(`Bidding is disabled in the last 5 seconds. (${timeRemaining}s remaining)`);
            return;
        }

        setBidError(null);
        const reservePrice = parseFloat(selectedLot.reserve_price);
        const currentPrice = parseFloat(selectedLot.current_price || selectedLot.starting_price);

        if (currentPrice >= reservePrice) {
            message.warning('Current price is already at or above reserve price');
            return;
        }

        const startTime = performance.now();
        const bidId = `${selectedLot.id}-${Date.now()}`;
        console.log('[Bid Debug] Starting match reserve price bid:', {
            lotId: selectedLot.id,
            currentPrice: currentPrice,
            reservePrice: reservePrice,
            bidId,
            timestamp: new Date().toISOString()
        });

        // Store original lot state BEFORE optimistic update (for revert on error)
        const originalLotState = { ...selectedLot };
        const originalLotFromArray = lots.find(l => l.id === selectedLot.id);
        const originalLot = originalLotFromArray ? { ...originalLotFromArray } : originalLotState;

        // Create optimistic lot update
        const optimisticLot = {
            ...selectedLot,
            current_price: reservePrice,
            last_bid_user_id: currentUser.id,
            last_bid_time: new Date(getServerNow()).toISOString(),
            pending_bid_user_id: currentUser.id,
            pending_bid_amount: reservePrice
        };

        // Store the pending bid with original state for revert
        pendingBids.set(bidId, {
            lotId: selectedLot.id,
            amount: reservePrice,
            timestamp: Date.now(),
            originalLot: originalLot // Store original state for revert
        });

        // Update UI immediately for all users
        setLots(prevLots => {
            const newLots = prevLots.map(l => l.id === optimisticLot.id ? optimisticLot : l);
            return newLots;
        });

        setSelectedLot(prevSelected => {
            if (prevSelected && prevSelected.id === optimisticLot.id) {
                return optimisticLot;
            }
            return prevSelected;
        });

        // Stop all timers and show loading
        setLotTimers({});
        setTimerLoading(prev => ({ ...prev, [optimisticLot.id]: true }));

        // Play sound for your bid immediately
        if (hasInteracted) {
            playSound('your', `${optimisticLot.id}-${Date.now()}`);
        }

        message.success(`Your bid: ${formatCurrency(reservePrice)} (Reserve Price) placed!`);

        try {
            console.log('[Bid Debug] Sending reserve price bid to server');
            const response = await auctionService.placeBid(auction.slug, selectedLot.slug, {
                amount: reservePrice,
                bid_id: bidId
            });
            console.log('[Bid Debug] Server response:', response);

            if (!response) {
                throw new Error('Invalid server response');
            }

            // Check for unlocked achievements
            if (response.achievements && response.achievements.length > 0) {
                setUnlockedAchievements(response.achievements);
                setAchievementModalVisible(true);
            }

            // Remove the pending bid since we got a response
            pendingBids.delete(bidId);

            // Ensure the lot remains subscribed
            if (!subscribedLotIds.includes(selectedLot.id)) {
                setSubscribedLotIds(prev => [...prev, selectedLot.id]);
            }

            console.log('[Bid Debug] Reserve price bid completed successfully:', {
                timeElapsed: `${(performance.now() - startTime).toFixed(2)}ms`,
                lotId: selectedLot.id,
                reservePrice: reservePrice,
                bidId
            });
        } catch (err) {
            console.error('[Bid Debug] Error placing reserve price bid:', {
                error: err,
                response: err.response,
                timeElapsed: `${(performance.now() - startTime).toFixed(2)}ms`,
                bidId
            });
            // Remove the pending bid on error
            pendingBids.delete(bidId);

            // Fetch fresh lot data from server to ensure accurate state
            const refreshLotData = async () => {
                try {
                    const lotResponse = await auctionService.getLot(auction.slug, selectedLot.slug);
                    if (lotResponse?.data) {
                        const freshLot = lotResponse.data;

                        // Update lots with fresh data
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => l.id === freshLot.id ? {
                                ...l,
                                ...freshLot,
                                pending_bid_user_id: null,
                                pending_bid_amount: null,
                                is_favorite: l.is_favorite // Preserve favorite status
                            } : l);
                            updateSidebarCounts(newLots);
                            return newLots;
                        });

                        // Update selected lot with fresh data
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === freshLot.id) {
                                return {
                                    ...prevSelected,
                                    ...freshLot,
                                    pending_bid_user_id: null,
                                    pending_bid_amount: null,
                                    is_favorite: prevSelected.is_favorite
                                };
                            }
                            return prevSelected;
                        });

                        // Restart timer with fresh last_bid_time
                        if (freshLot.status === 'active' && freshLot.last_bid_time) {
                            const lastBidTime = moment(freshLot.last_bid_time);
                            if (lastBidTime.isValid()) {
                                const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                                const endTime = lastBidTime.add(closeTimeSeconds, 'seconds').valueOf();
                                const now = Date.now();
                                const remaining = Math.max(0, endTime - now);

                                if (remaining > 0) {
                                    setLotTimers(prev => ({
                                        ...prev,
                                        [freshLot.id]: endTime
                                    }));
                                } else {
                                    setLotTimers(prev => {
                                        const newTimers = { ...prev };
                                        delete newTimers[freshLot.id];
                                        return newTimers;
                                    });
                                }
                            }
                        }
                    }
                } catch (fetchErr) {
                    console.warn('[Bid Error] Failed to refresh lot data:', fetchErr);
                    // Fallback to revert using current state
                    const revertStates = () => {
                        // Get current lot state from lots array (before optimistic update)
                        const currentLot = lots.find(l => l.id === selectedLot.id) || selectedLot;
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => l.id === selectedLot.id ? {
                                ...currentLot,
                                pending_bid_user_id: null,
                                pending_bid_amount: null
                            } : l);
                            return newLots;
                        });
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === selectedLot.id) {
                                return {
                                    ...currentLot,
                                    pending_bid_user_id: null,
                                    pending_bid_amount: null
                                };
                            }
                            return prevSelected;
                        });
                    };
                    setTimeout(revertStates, 0);
                }
            };

            // Clear timer loading state immediately
            setTimerLoading(prev => {
                const newState = { ...prev };
                delete newState[selectedLot.id];
                return newState;
            });

            // Fetch fresh lot data
            refreshLotData();

            const errorMessage = err?.response?.data?.message || err?.message || 'Your bid could not be placed. The price may have changed. Please try again.';
            setBidError(errorMessage);

            // Track rejected bid if it's a validation error
            if (errorMessage.includes('already bid ahead of you')) {
                const minimumBidMatch = errorMessage.match(/at least ([\d,]+\.?\d*)/);
                const minimumBid = minimumBidMatch ? parseFloat(minimumBidMatch[1].replace(/,/g, '')) : null;

                setRejectedBids(prev => {
                    const newMap = new Map(prev);
                    const lotId = selectedLot.id;
                    const rejectedBidsForLot = newMap.get(lotId) || [];

                    rejectedBidsForLot.push({
                        amount: reservePrice,
                        minimumBid: minimumBid,
                        errorMessage: errorMessage,
                        timestamp: new Date().toISOString(),
                        user: currentUser
                    });

                    newMap.set(lotId, rejectedBidsForLot);
                    return newMap;
                });

                // Show modal with details
                const lotNumber = selectedLot?.lot_number || 'Unknown';
                setBidRejectionModal({
                    visible: true,
                    lotNumber: lotNumber,
                    errorMessage: errorMessage,
                    minimumBid: minimumBid,
                    isAutoBid: false,
                    lotName: selectedLot?.title || ''
                });
            }
            // else {
            //     // Show friendly notification for other errors
            //     message.error({
            //         content: (
            //             <div>
            //                 <div style={{ fontWeight: 600, marginBottom: '4px' }}>⚠️ Bid Failed</div>
            //                 <div style={{ fontSize: '13px' }}>{errorMessage}</div>
            //             </div>
            //         ),
            //         duration: 5,
            //         style: { marginTop: '20vh' }
            //     });
            // }
        }
    };

    // Function to get rounding options (lower and upper) for custom bid
    const getRoundingOptions = (amount, increment) => {
        if (!amount || !increment || increment <= 0) return { lower: amount, upper: amount };
        const lower = Math.floor(amount / increment) * increment;
        const upper = Math.ceil(amount / increment) * increment;
        return { lower, upper };
    };

    // Function to round custom bid to nearest increment
    const roundToIncrement = (amount, increment) => {
        if (!amount || !increment || increment <= 0) return amount;
        return Math.round(amount / increment) * increment;
    };

    // Function to round custom bid up to next increment
    const roundUpToIncrement = (amount, increment) => {
        if (!amount || !increment || increment <= 0) return amount;
        return Math.ceil(amount / increment) * increment;
    };

    // Function to get template bids based on current price and increment
    const getTemplateBids = () => {
        if (!selectedLot) return [];

        const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
        const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
        const minBid = current + increment;

        // Generate template bids: fractional, small, medium, and large increments
        const multipliers = [];

        // Add fractional bids (0.5x, 0.75x) - only if increment allows
        if (increment % 2 === 0) {
            multipliers.push(0.5);
        }
        if (increment % 4 === 0) {
            multipliers.push(0.75);
        }

        // Add small increments (1x through 10x)
        multipliers.push(1, 2, 3, 4, 5, 6, 7, 8, 9, 10);

        // Add medium increments (15x, 20x, 25x, then 30x through 200x in steps of 5x)
        multipliers.push(15, 20, 25);
        for (let i = 30; i <= 200; i += 5) {
            multipliers.push(i);
        }

        // Add large increments
        multipliers.push(250, 500, 750, 1000);

        return multipliers.map(mult => ({
            label: mult < 1 ? `${mult}x` : `${mult}x increment`,
            amount: current + (increment * mult),
            multiplier: mult,
            incrementAmount: increment * mult
        })).filter(template => template.amount >= minBid);
    };

    // Handle template bid selection
    const handleTemplateBidSelect = (amount) => {
        setCustomBidAmount(amount);
        setValidRoundedAmountApplied(true);
        setShowTemplateBidsModal(false);
        setShowCustomBid(true);

        // Scroll to bottom on mobile/tablet after template bid selection
        if (window.innerWidth < 992) {
            // Wait for modal to close and DOM to update
            setTimeout(() => {
                // Try scrolling to anchor first
                const bottomAnchor = document.getElementById('bid-section-bottom');
                if (bottomAnchor) {
                    bottomAnchor.scrollIntoView({ behavior: 'smooth', block: 'end' });
                } else {
                    // Fallback: scroll to bottom of page
                    const scrollToBottom = () => {
                        const body = document.body;
                        const html = document.documentElement;
                        const height = Math.max(
                            body.scrollHeight,
                            body.offsetHeight,
                            html.clientHeight,
                            html.scrollHeight,
                            html.offsetHeight
                        );
                        window.scrollTo({
                            top: height,
                            behavior: 'smooth'
                        });
                    };
                    scrollToBottom();
                    // Additional attempts to ensure scroll happens
                    setTimeout(scrollToBottom, 200);
                    setTimeout(scrollToBottom, 400);
                }
            }, 300);
        }
    };

    // Handle custom bid
    const handleCustomBid = async () => {
        if (!selectedLot || !auction || !customBidAmount) return;
        setBidError(null);
        if (timeRemaining !== null && timeRemaining <= 5) {
            message.warning(`Bidding is disabled in the last 5 seconds. (${timeRemaining}s remaining)`);
            return;
        }

        const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
        const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
        const minBid = current + increment;

        const customAmount = parseFloat(customBidAmount);

        if (isNaN(customAmount)) {
            setBidError('Please enter a valid bid amount');
            return;
        }

        // Check if amount meets minimum requirement
        if (customAmount < minBid) {
            setBidError(`Your bid of ${formatCurrency(customAmount)} is below the minimum of ${formatCurrency(minBid)}. Please enter at least ${formatCurrency(minBid)}.`);
            return;
        }

        // Check if amount is an exact multiple of the increment above the current price
        const excessAboveCurrent = customAmount - current;
        if (excessAboveCurrent % increment !== 0) {
            const nearestLower = current + (Math.floor(excessAboveCurrent / increment) * increment);
            const nearestUpper = current + (Math.ceil(excessAboveCurrent / increment) * increment);
            setBidError(`Bid amount must be an exact multiple of the increment (${formatCurrency(increment)}). Valid amounts: ${formatCurrency(nearestLower >= minBid ? nearestLower : nearestUpper)} or ${nearestUpper !== nearestLower ? formatCurrency(nearestUpper) : ''}`);
            return;
        }

        // Use the exact amount as the final bid
        const finalBidAmount = customAmount;

        const startTime = performance.now();
        const bidId = `${selectedLot.id}-${Date.now()}`;

        // Store original lot state BEFORE optimistic update (for revert on error)
        const originalLotState = { ...selectedLot };
        const originalLotFromArray = lots.find(l => l.id === selectedLot.id);
        const originalLot = originalLotFromArray ? { ...originalLotFromArray } : originalLotState;

        // Create optimistic lot update
        const optimisticLot = {
            ...selectedLot,
            current_price: finalBidAmount,
            last_bid_user_id: currentUser.id,
            last_bid_time: new Date(getServerNow()).toISOString(),
            pending_bid_user_id: currentUser.id,
            pending_bid_amount: finalBidAmount
        };

        // Store the pending bid with original state for revert
        pendingBids.set(bidId, {
            lotId: selectedLot.id,
            amount: finalBidAmount,
            timestamp: Date.now(),
            originalLot: originalLot // Store original state for revert
        });

        // Update UI immediately
        setLots(prevLots => {
            const newLots = prevLots.map(l => l.id === optimisticLot.id ? optimisticLot : l);
            return newLots;
        });

        setSelectedLot(prevSelected => {
            if (prevSelected && prevSelected.id === optimisticLot.id) {
                return optimisticLot;
            }
            return prevSelected;
        });

        // Stop all timers and show loading
        setLotTimers({});
        setTimerLoading(prev => ({ ...prev, [optimisticLot.id]: true }));

        // Play sound for your bid immediately
        if (hasInteracted) {
            playSound('your', `${optimisticLot.id}-${Date.now()}`);
        }

        message.success(`Your bid: ${formatCurrency(finalBidAmount)} placed!`);

        try {
            const response = await auctionService.placeBid(auction.slug, selectedLot.slug, {
                amount: finalBidAmount,
                bid_id: bidId
            });

            if (!response) {
                throw new Error('Invalid server response');
            }

            // Check for unlocked achievements
            if (response.achievements && response.achievements.length > 0) {
                setUnlockedAchievements(response.achievements);
                setAchievementModalVisible(true);
            }

            // Remove the pending bid since we got a response
            pendingBids.delete(bidId);

            // Ensure the lot remains subscribed
            if (!subscribedLotIds.includes(selectedLot.id)) {
                setSubscribedLotIds(prev => [...prev, selectedLot.id]);
            }

            // Clear custom bid amount
            setCustomBidAmount('');
            setShowCustomBid(false);
            setValidRoundedAmountApplied(false);
        } catch (err) {
            // Get original lot state from pendingBids BEFORE deleting (stored before optimistic update)
            const pendingBidInfo = pendingBids.get(bidId);
            const originalLot = pendingBidInfo?.originalLot || selectedLot;

            // Remove the pending bid on error (after getting original state)
            pendingBids.delete(bidId);

            // Fetch fresh lot data from server to ensure accurate state
            const refreshLotData = async () => {
                try {
                    const lotResponse = await auctionService.getLot(auction.slug, selectedLot.slug);
                    if (lotResponse?.data) {
                        const freshLot = lotResponse.data;

                        // Update lots with fresh data - ensure ALL instances are updated
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => {
                                if (l.id === freshLot.id) {
                                    return {
                                        ...l,
                                        ...freshLot,
                                        pending_bid_user_id: null,
                                        pending_bid_amount: null,
                                        is_favorite: l.is_favorite // Preserve favorite status
                                    };
                                }
                                return l;
                            });
                            updateSidebarCounts(newLots);
                            return newLots;
                        });

                        // Update selected lot with fresh data
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === freshLot.id) {
                                return {
                                    ...prevSelected,
                                    ...freshLot,
                                    pending_bid_user_id: null,
                                    pending_bid_amount: null,
                                    is_favorite: prevSelected.is_favorite
                                };
                            }
                            return prevSelected;
                        });

                        // Restart timer with fresh last_bid_time
                        if (freshLot.status === 'active' && freshLot.last_bid_time) {
                            const lastBidTime = moment(freshLot.last_bid_time);
                            if (lastBidTime.isValid()) {
                                const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                                const endTime = lastBidTime.add(closeTimeSeconds, 'seconds').valueOf();
                                const now = Date.now();
                                const remaining = Math.max(0, endTime - now);

                                if (remaining > 0) {
                                    setLotTimers(prev => ({
                                        ...prev,
                                        [freshLot.id]: endTime
                                    }));
                                } else {
                                    setLotTimers(prev => {
                                        const newTimers = { ...prev };
                                        delete newTimers[freshLot.id];
                                        return newTimers;
                                    });
                                }
                            }
                        }
                    }
                } catch (fetchErr) {
                    console.warn('[Bid Error] Failed to refresh lot data:', fetchErr);
                    // Fallback to revert using stored original state
                    const revertStates = () => {
                        // Use stored original lot state (before optimistic update)
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => {
                                if (l.id === originalLot.id) {
                                    return {
                                        ...originalLot,
                                        pending_bid_user_id: null,
                                        pending_bid_amount: null,
                                        is_favorite: l.is_favorite // Preserve favorite
                                    };
                                }
                                return l;
                            });
                            updateSidebarCounts(newLots);
                            return newLots;
                        });
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === originalLot.id) {
                                return {
                                    ...originalLot,
                                    pending_bid_user_id: null,
                                    pending_bid_amount: null,
                                    is_favorite: prevSelected.is_favorite
                                };
                            }
                            return prevSelected;
                        });

                        // Restart timer with original last_bid_time
                        if (originalLot.status === 'active' && originalLot.last_bid_time) {
                            const lastBidTime = moment(originalLot.last_bid_time);
                            if (lastBidTime.isValid()) {
                                const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                                const endTime = lastBidTime.add(closeTimeSeconds, 'seconds').valueOf();
                                const now = Date.now();
                                const remaining = Math.max(0, endTime - now);

                                if (remaining > 0) {
                                    setLotTimers(prev => ({
                                        ...prev,
                                        [originalLot.id]: endTime
                                    }));
                                } else {
                                    setLotTimers(prev => {
                                        const newTimers = { ...prev };
                                        delete newTimers[originalLot.id];
                                        return newTimers;
                                    });
                                }
                            }
                        }
                    };
                    setTimeout(revertStates, 0);
                }
            };

            // Clear timer loading state immediately
            setTimerLoading(prev => {
                const newState = { ...prev };
                delete newState[selectedLot.id];
                return newState;
            });

            // Fetch fresh lot data
            refreshLotData();

            const errorMessage = err?.response?.data?.message || err?.message || 'Your bid could not be placed. The price may have changed. Please try again.';
            setBidError(errorMessage);

            // Track rejected bid if it's a validation error
            if (errorMessage.includes('already bid ahead of you')) {
                const minimumBidMatch = errorMessage.match(/at least ([\d,]+\.?\d*)/);
                const minimumBid = minimumBidMatch ? parseFloat(minimumBidMatch[1].replace(/,/g, '')) : null;

                setRejectedBids(prev => {
                    const newMap = new Map(prev);
                    const lotId = selectedLot.id;
                    const rejectedBidsForLot = newMap.get(lotId) || [];

                    rejectedBidsForLot.push({
                        amount: finalBidAmount,
                        minimumBid: minimumBid,
                        errorMessage: errorMessage,
                        timestamp: new Date().toISOString(),
                        user: currentUser
                    });

                    newMap.set(lotId, rejectedBidsForLot);
                    return newMap;
                });

                // Show modal with details
                const lotNumber = selectedLot?.lot_number || 'Unknown';
                setBidRejectionModal({
                    visible: true,
                    lotNumber: lotNumber,
                    errorMessage: errorMessage,
                    minimumBid: minimumBid,
                    isAutoBid: false,
                    lotName: selectedLot?.title || ''
                });
            }
            // Removed generic error popup - only show specific validation errors
        }
    };

    // Handle "Start lot with your bid" - owner's first bid (vendor bid)
    const handleStartLotWithBid = async (lotToUse) => {
        const targetLot = lotToUse || selectedLot;
        if (!targetLot || !auction) return;
        setBidError(null);
        if (timeRemaining !== null && timeRemaining <= 5) {
            message.warning(`Bidding is disabled in the last 5 seconds. (${timeRemaining}s remaining)`);
            return;
        }

        // Check if lot already has bids
        const lotBids = bidHistoryCache.get(targetLot.id) || [];
        if (lotBids.length > 0) {
            message.error('This lot already has bids. You can only start a lot with your bid if it has no bids yet.');
            return;
        }

        // Check if owner already placed a start bid using owner_bid_tracking
        const ownerBidTracking = targetLot.owner_bid_tracking || {};
        if (ownerBidTracking.has_start_bid) {
            message.error('You have already placed your start bid for this lot.');
            return;
        }

        // Calculate the starting bid (starting_price + increment)
        const increment = parseInt(targetLot.default_increment) || parseInt(targetLot.increment) || 5;
        const startingPrice = parseInt(targetLot.starting_price) || 0;
        const startBidAmount = startingPrice + increment;

        const startTime = performance.now();
        const bidId = `${targetLot.id}-${Date.now()}`;

        // Create optimistic lot update
        const optimisticLot = {
            ...targetLot,
            current_price: startBidAmount,
            last_bid_user_id: currentUser.id,
            last_bid_time: new Date(getServerNow()).toISOString(),
            pending_bid_user_id: currentUser.id,
            pending_bid_amount: startBidAmount,
            owner_bid_tracking: {
                ...ownerBidTracking,
                has_start_bid: true,
                has_vendor_bid: false
            }
        };

        // Store the pending bid
        pendingBids.set(bidId, {
            lotId: targetLot.id,
            amount: startBidAmount,
            timestamp: Date.now()
        });

        // Update bid history cache immediately so button disappears
        setBidHistoryCache(prevCache => {
            const newCache = new Map(prevCache);
            const optimisticBid = {
                id: bidId,
                lot_id: targetLot.id,
                amount: startBidAmount,
                user_id: currentUser.id,
                created_at: new Date().toISOString(),
                user: {
                    id: currentUser.id,
                    first_name: currentUser.first_name,
                    last_name: currentUser.last_name,
                    email: currentUser.email
                }
            };
            newCache.set(targetLot.id, [optimisticBid]);
            return newCache;
        });

        // Update UI immediately
        setLots(prevLots => {
            const newLots = prevLots.map(l => l.id === optimisticLot.id ? optimisticLot : l);
            return newLots;
        });

        setSelectedLot(prevSelected => {
            if (prevSelected && prevSelected.id === optimisticLot.id) {
                return optimisticLot;
            }
            return prevSelected;
        });

        // Stop all timers and show loading
        setLotTimers({});
        setTimerLoading(prev => ({ ...prev, [optimisticLot.id]: true }));

        // Play sound for your bid immediately
        if (hasInteracted) {
            playSound('your', `${optimisticLot.id}-${Date.now()}`);
        }

        message.success(`Lot started with your bid: ${formatCurrency(startBidAmount)}!`);

        try {
            const response = await auctionService.placeBid(auction.slug, targetLot.slug, {
                amount: startBidAmount,
                bid_id: bidId
            });

            if (!response) {
                throw new Error('Invalid server response');
            }

            // Check for unlocked achievements
            if (response.achievements && response.achievements.length > 0) {
                setUnlockedAchievements(response.achievements);
                setAchievementModalVisible(true);
            }

            // Remove the pending bid since we got a response
            pendingBids.delete(bidId);

            // Ensure the lot remains subscribed
            if (!subscribedLotIds.includes(targetLot.id)) {
                setSubscribedLotIds(prev => [...prev, targetLot.id]);
            }
        } catch (err) {
            // Remove the pending bid on error
            pendingBids.delete(bidId);

            // Revert optimistic updates on error
            const revertStates = () => {
                // Remove the bid from cache
                setBidHistoryCache(prevCache => {
                    const newCache = new Map(prevCache);
                    newCache.delete(targetLot.id);
                    return newCache;
                });

                setLots(prevLots => {
                    const newLots = prevLots.map(l => l.id === targetLot.id ? {
                        ...targetLot,
                        pending_bid_user_id: null,
                        pending_bid_amount: null
                    } : l);
                    return newLots;
                });
                setSelectedLot(prevSelected => {
                    if (prevSelected && prevSelected.id === targetLot.id) {
                        return {
                            ...targetLot,
                            pending_bid_user_id: null,
                            pending_bid_amount: null
                        };
                    }
                    return prevSelected;
                });
                setTimerLoading(prev => {
                    const newState = { ...prev };
                    delete newState[targetLot.id];
                    return newState;
                });
            };

            // Execute revert updates in next tick
            setTimeout(revertStates, 0);

            setBidError(err?.response?.data?.message || 'Failed to start lot with your bid. Please try again.');
        }
    };


    // Handle Buy Now purchase
    const handleBuyNow = async () => {
        if (!selectedLot || !auction) return;

        // Validate Buy Now is available - only if no reserve price and buy_now_price exists
        if (!selectedLot.can_buy_now || !selectedLot.buy_now_price) {
            message.error('Buy Now option is not available for this lot');
            return;
        }

        // Don't allow Buy Now if lot has a reserve price
        if (selectedLot.reserve_price) {
            message.error('Buy Now is not available for lots with reserve price');
            return;
        }

        // Check if lot is active
        if (selectedLot.status !== 'active') {
            message.error('This lot is not available for purchase');
            return;
        }

        // Check if user is the auction owner
        if (currentUser?.id === auction?.user_id) {
            message.error('You cannot buy your own lot');
            return;
        }

        // Check if auction is private and user has access (skip check for auction owner)
        if (auction?.is_private && currentUser?.id !== auction?.user_id && (!isInvited || invitationStatus !== 'accepted')) {
            message.error('You are not authorized to purchase from this private auction');
            return;
        }

        setBuyingNow(true);
        setBidError(null);

        try {
            const response = await auctionService.buyNow(auction.slug, selectedLot.slug);

            if (response?.status === 'success') {
                message.success(`Lot purchased successfully at ${formatCurrency(selectedLot.buy_now_price)}!`);

                // Play success sound
                if (hasInteracted) {
                    playSound('your', `${selectedLot.id}-${Date.now()}`);
                }

                // Refresh lot data to get updated status
                try {
                    const lotResponse = await auctionService.getLot(auction.slug, selectedLot.slug);
                    if (lotResponse?.data) {
                        const updatedLot = lotResponse.data;

                        // Update lots array
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => {
                                if (l.id === updatedLot.id) {
                                    return {
                                        ...l,
                                        ...updatedLot,
                                        is_favorite: l.is_favorite // Preserve favorite status
                                    };
                                }
                                return l;
                            });
                            updateSidebarCounts(newLots);
                            return newLots;
                        });

                        // Update selected lot
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === updatedLot.id) {
                                return {
                                    ...prevSelected,
                                    ...updatedLot,
                                    is_favorite: prevSelected.is_favorite
                                };
                            }
                            return prevSelected;
                        });
                    }
                } catch (refreshErr) {
                    console.warn('Failed to refresh lot data after Buy Now:', refreshErr);
                }

                // Check for unlocked achievements
                if (response?.achievements && response.achievements.length > 0) {
                    setUnlockedAchievements(response.achievements);
                    setAchievementModalVisible(true);
                }
            } else {
                throw new Error(response?.message || 'Failed to complete purchase');
            }
        } catch (err) {
            console.error('Buy Now error:', err);
            const errorMessage = err.response?.data?.message || err.message || 'Failed to complete purchase';
            message.error(errorMessage);
            setBidError(errorMessage);
        } finally {
            setBuyingNow(false);
        }
    };

    const handleBid = async (multiplier = 1) => {
        if (!selectedLot || !auction) return;
        setBidError(null);
        if (timeRemaining !== null && timeRemaining <= 5) {
            message.warning(`Bidding is disabled in the last 5 seconds. (${timeRemaining}s remaining)`);
            return;
        }

        const startTime = performance.now();
        const bidId = `${selectedLot.id}-${Date.now()}`;
        console.log('[Bid Debug] Starting bid process:', {
            lotId: selectedLot.id,
            currentPrice: selectedLot.current_price,
            multiplier,
            bidId,
            timestamp: new Date().toISOString()
        });

        // Calculate next bid amount
        const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
        let current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
        const nextBid = current + (increment * multiplier);

        // Store original lot state BEFORE optimistic update (for revert on error)
        const originalLotState = { ...selectedLot };
        const originalLotFromArray = lots.find(l => l.id === selectedLot.id);
        const originalLot = originalLotFromArray ? { ...originalLotFromArray } : originalLotState;

        // Create optimistic lot update
        const optimisticLot = {
            ...selectedLot,
            current_price: nextBid,
            last_bid_user_id: currentUser.id,
            last_bid_time: new Date(getServerNow()).toISOString(),
            pending_bid_user_id: currentUser.id,
            pending_bid_amount: nextBid
        };

        // Store the pending bid with original state for revert
        pendingBids.set(bidId, {
            lotId: selectedLot.id,
            amount: nextBid,
            timestamp: Date.now(),
            originalLot: originalLot // Store original state for revert
        });

        // Update UI immediately for all users
        setLots(prevLots => {
            const newLots = prevLots.map(l => l.id === optimisticLot.id ? optimisticLot : l);
            return newLots;
        });

        setSelectedLot(prevSelected => {
            if (prevSelected && prevSelected.id === optimisticLot.id) {
                return optimisticLot;
            }
            return prevSelected;
        });

        // Stop all timers and show loading
        setLotTimers({});
        setTimerLoading(prev => ({ ...prev, [optimisticLot.id]: true }));

        // Play sound for your bid immediately
        if (hasInteracted) {
            playSound('your', `${optimisticLot.id}-${Date.now()}`);
        }

        message.success(`Your bid: ${formatCurrency(nextBid)} placed!`);

        try {
            console.log('[Bid Debug] Sending bid to server');
            const response = await auctionService.placeBid(auction.slug, selectedLot.slug, {
                amount: nextBid,
                bid_id: bidId
            });
            console.log('[Bid Debug] Server response:', response);

            if (!response) {
                throw new Error('Invalid server response');
            }

            // Check for unlocked achievements
            if (response.achievements && response.achievements.length > 0) {
                setUnlockedAchievements(response.achievements);
                setAchievementModalVisible(true);
            }

            // Remove the pending bid since we got a response
            pendingBids.delete(bidId);

            // Don't clear pending state immediately - let real-time events handle it
            // This ensures outbid detection works properly

            // Ensure the lot remains subscribed
            if (!subscribedLotIds.includes(selectedLot.id)) {
                setSubscribedLotIds(prev => [...prev, selectedLot.id]);
            }

            console.log('[Bid Debug] Bid process completed successfully:', {
                timeElapsed: `${(performance.now() - startTime).toFixed(2)}ms`,
                lotId: selectedLot.id,
                newPrice: nextBid,
                bidId
            });
        } catch (err) {
            console.error('[Bid Debug] Error placing bid:', {
                error: err,
                response: err.response,
                timeElapsed: `${(performance.now() - startTime).toFixed(2)}ms`,
                bidId
            });

            // Get original lot state from pendingBids BEFORE deleting (stored before optimistic update)
            const pendingBidInfo = pendingBids.get(bidId);
            const originalLot = pendingBidInfo?.originalLot || selectedLot;

            // Remove the pending bid on error (after getting original state)
            pendingBids.delete(bidId);

            // Fetch fresh lot data from server to ensure accurate state
            const refreshLotData = async () => {
                try {
                    const lotResponse = await auctionService.getLot(auction.slug, selectedLot.slug);
                    if (lotResponse?.data) {
                        const freshLot = lotResponse.data;

                        // Update lots with fresh data - ensure ALL instances are updated
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => {
                                if (l.id === freshLot.id) {
                                    return {
                                        ...l,
                                        ...freshLot,
                                        pending_bid_user_id: null,
                                        pending_bid_amount: null,
                                        is_favorite: l.is_favorite // Preserve favorite status
                                    };
                                }
                                return l;
                            });
                            updateSidebarCounts(newLots);
                            return newLots;
                        });

                        // Update selected lot with fresh data
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === freshLot.id) {
                                return {
                                    ...prevSelected,
                                    ...freshLot,
                                    pending_bid_user_id: null,
                                    pending_bid_amount: null,
                                    is_favorite: prevSelected.is_favorite
                                };
                            }
                            return prevSelected;
                        });

                        // Restart timer with fresh last_bid_time
                        if (freshLot.status === 'active' && freshLot.last_bid_time) {
                            const lastBidTime = moment(freshLot.last_bid_time);
                            if (lastBidTime.isValid()) {
                                const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                                const endTime = lastBidTime.add(closeTimeSeconds, 'seconds').valueOf();
                                const now = Date.now();
                                const remaining = Math.max(0, endTime - now);

                                if (remaining > 0) {
                                    setLotTimers(prev => ({
                                        ...prev,
                                        [freshLot.id]: endTime
                                    }));
                                } else {
                                    setLotTimers(prev => {
                                        const newTimers = { ...prev };
                                        delete newTimers[freshLot.id];
                                        return newTimers;
                                    });
                                }
                            }
                        }
                    }
                } catch (fetchErr) {
                    console.warn('[Bid Error] Failed to refresh lot data:', fetchErr);
                    // Fallback to revert using stored original state
                    const revertStates = () => {
                        // Use stored original lot state (before optimistic update)
                        setLots(prevLots => {
                            const newLots = prevLots.map(l => {
                                if (l.id === originalLot.id) {
                                    return {
                                        ...originalLot,
                                        pending_bid_user_id: null,
                                        pending_bid_amount: null,
                                        is_favorite: l.is_favorite // Preserve favorite
                                    };
                                }
                                return l;
                            });
                            updateSidebarCounts(newLots);
                            return newLots;
                        });
                        setSelectedLot(prevSelected => {
                            if (prevSelected && prevSelected.id === originalLot.id) {
                                return {
                                    ...originalLot,
                                    pending_bid_user_id: null,
                                    pending_bid_amount: null,
                                    is_favorite: prevSelected.is_favorite
                                };
                            }
                            return prevSelected;
                        });

                        // Restart timer with original last_bid_time
                        if (originalLot.status === 'active' && originalLot.last_bid_time) {
                            const lastBidTime = moment(originalLot.last_bid_time);
                            if (lastBidTime.isValid()) {
                                const closeTimeSeconds = auction?.lot_close_time_seconds || 60;
                                const endTime = lastBidTime.add(closeTimeSeconds, 'seconds').valueOf();
                                const now = Date.now();
                                const remaining = Math.max(0, endTime - now);

                                if (remaining > 0) {
                                    setLotTimers(prev => ({
                                        ...prev,
                                        [originalLot.id]: endTime
                                    }));
                                } else {
                                    setLotTimers(prev => {
                                        const newTimers = { ...prev };
                                        delete newTimers[originalLot.id];
                                        return newTimers;
                                    });
                                }
                            }
                        }
                    };
                    setTimeout(revertStates, 0);
                }
            };

            // Clear timer loading state immediately
            setTimerLoading(prev => {
                const newState = { ...prev };
                delete newState[selectedLot.id];
                return newState;
            });

            // Fetch fresh lot data
            refreshLotData();

            const errorMessage = err?.response?.data?.message || err?.message || 'Your bid could not be placed. The price may have changed. Please try again.';

            // Only set bidError for validation errors (will show in Alert component)
            // Don't show generic popup - only show specific validation error messages
            if (errorMessage.includes('already bid ahead of you')) {
                setBidError(errorMessage);
            } else {
                // Don't set bidError for generic errors to avoid showing popup
                setBidError(null);
            }
        }
    };

    // Handle lot timeout
    const handleTimeout = async (lot) => {
        if (!lot || !auction) return;

        // Check if user is the auction owner
        if (currentUser?.id !== auction.user_id) {
            message.error('Only the auction owner can timeout lots');
            return;
        }

        // Check if lot is active
        if (lot.status !== 'active') {
            message.error('Can only timeout active lots');
            return;
        }

        // Check if there are any bids on this lot
        if (lot.last_bid_user_id) {
            message.error('Cannot timeout lot with existing bids');
            return;
        }

        // Show confirmation modal
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #ff4d4f, #ff7875)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: 'bold'
                    }}>
                        ⏰
                    </div>
                    <div>
                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#262626' }}>
                            Close Lot – No Bids
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
                            This action cannot be undone
                        </div>
                    </div>
                </div>
            ),
            content: (
                <div style={{ padding: '8px 0' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #fff2f0, #ffe7e6)',
                        border: '1px solid #ffccc7',
                        borderRadius: '12px',
                        padding: '20px',
                        marginBottom: '20px'
                    }}>
                        <div style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#a8071a',
                            marginBottom: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <ClockCircleOutlined />
                            Are you sure you want to close this lot?
                        </div>
                        <div style={{ color: '#595959', lineHeight: '1.6' }}>
                            This will immediately stop all bidding on this lot and mark it as "Timed Out".
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <div style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#262626',
                            marginBottom: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            What happens next:
                        </div>
                        <div style={{
                            background: '#f6ffed',
                            border: '1px solid #b7eb8f',
                            borderRadius: '8px',
                            padding: '16px'
                        }}>
                            <ul style={{
                                margin: 0,
                                paddingLeft: '20px',
                                color: '#389e0d',
                                lineHeight: '1.8'
                            }}>
                                <li>No users will be able to place bids on this lot</li>
                                <li>The lot status will change to "Timed Out"</li>
                                {auction.is_sequential && (
                                    <li>For sequential auctions: The next lot will automatically become active</li>
                                )}
                                {!auction.is_sequential && (
                                    <li>For simultaneous auctions: Only this lot will be affected</li>
                                )}
                                <li>This action cannot be undone</li>
                            </ul>
                        </div>
                    </div>

                    <div style={{
                        background: 'linear-gradient(135deg, #e6f7ff, #f0f9ff)',
                        border: '1px solid #91d5ff',
                        borderRadius: '12px',
                        padding: '16px'
                    }}>
                        <div style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#0958d9',
                            marginBottom: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <DollarOutlined />
                            Lot Information
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            color: '#262626'
                        }}>
                            <div style={{ flex: 1, marginRight: '16px' }}>
                                <div style={{ fontSize: '16px', color: '#1890ff', marginBottom: '4px', fontWeight: 'bold' }}>Lot #{lot.lot_number}</div>
                                <div style={{
                                    fontWeight: 'bold',
                                    fontSize: '13px',
                                    lineHeight: '1.3',
                                    maxHeight: '52px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical'
                                }}>
                                    {lot.title || 'Untitled Lot'}
                                </div>
                            </div>
                            <div>
                                <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '4px' }}>Current Price</div>
                                <div style={{ fontWeight: 'bold', color: '#52c41a', fontSize: '16px' }}>
                                    {formatCurrency(lot.current_price || lot.starting_price)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ),
            okText: 'Yes, Close Lot',
            cancelText: 'Cancel',
            okType: 'danger',
            width: 600,
            centered: true,
            onOk: async () => {
                // Update modal to show loading state
                modal.update({
                    title: (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #1890ff, #40a9ff)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontSize: '18px',
                                fontWeight: 'bold'
                            }}>
                                <Spin size="small" />
                            </div>
                            <div>
                                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#262626' }}>
                                    Processing Close Request
                                </div>
                                <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
                                    Please wait while we process your request
                                </div>
                            </div>
                        </div>
                    ),
                    content: (
                        <div style={{ padding: '8px 0', textAlign: 'center' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #e6f7ff, #f0f9ff)',
                                border: '1px solid #91d5ff',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '20px'
                            }}>
                                <div style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#0958d9',
                                    marginBottom: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px'
                                }}>
                                    <ClockCircleOutlined />
                                    Processing Close Request
                                </div>
                                <div style={{ color: '#595959', lineHeight: '1.6' }}>
                                    We're updating the lot status and notifying all participants. This may take a few moments.
                                </div>
                            </div>
                        </div>
                    ),
                    okText: 'Processing...',
                    okButtonProps: { loading: true, disabled: true },
                    cancelButtonProps: { disabled: true },
                    closable: false
                });

                try {
                    setStatusLoadingLots(prev => new Set([...prev, lot.id]));
                    setTimeoutLoadingLots(prev => new Set([...prev, lot.id]));

                    // Immediately update the lot status to prevent button from showing
                    setLots(prevLots => {
                        return prevLots.map(l =>
                            l.id === lot.id
                                ? { ...l, status: 'timeout' }
                                : l
                        );
                    });

                    // Update selected lot if it's the one being timed out
                    if (selectedLot?.id === lot.id) {
                        setSelectedLot(prev =>
                            prev?.id === lot.id
                                ? { ...prev, status: 'timeout' }
                                : prev
                        );
                    }

                    const response = await auctionService.timeoutLot(auction.slug, lot.slug);

                    if (response.data.status === 'success') {
                        // Don't close modal yet - wait for the event to be broadcasted
                        // The modal will be closed when the lot.timeout event is received
                        console.log('Timeout request sent successfully, waiting for broadcast event...');
                    }
                } catch (error) {
                    console.error('Failed to timeout lot:', error);

                    // Revert the lot status back to active if the request failed
                    setLots(prevLots => {
                        return prevLots.map(l =>
                            l.id === lot.id
                                ? { ...l, status: 'active' }
                                : l
                        );
                    });

                    // Update selected lot if it's the one being timed out
                    if (selectedLot?.id === lot.id) {
                        setSelectedLot(prev =>
                            prev?.id === lot.id
                                ? { ...prev, status: 'active' }
                                : prev
                        );
                    }

                    // Update modal to show error state
                    modal.update({
                        title: (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #ff4d4f, #ff7875)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '18px',
                                    fontWeight: 'bold'
                                }}>
                                    ✗
                                </div>
                                <div>
                                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#262626' }}>
                                        Close Failed
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
                                        Unable to close the lot
                                    </div>
                                </div>
                            </div>
                        ),
                        content: (
                            <div style={{ padding: '8px 0', textAlign: 'center' }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, #fff2f0, #ffe7e6)',
                                    border: '1px solid #ffccc7',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        color: '#a8071a',
                                        marginBottom: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}>
                                        <CloseCircleOutlined />
                                        Close Failed
                                    </div>
                                    <div style={{ color: '#595959', lineHeight: '1.6' }}>
                                        {error.response?.data?.message || 'Failed to close lot. Please try again.'}
                                    </div>
                                </div>
                            </div>
                        ),
                        okText: 'Try Again',
                        okButtonProps: { loading: false, disabled: false },
                        cancelButtonProps: { disabled: false },
                        closable: true,
                        onOk: () => {
                            modal.destroy();
                            handleTimeout(lot); // Retry
                        }
                    });

                    message.error(error.response?.data?.message || 'Failed to close lot');
                } finally {
                    setStatusLoadingLots(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(lot.id);
                        return newSet;
                    });
                    setTimeoutLoadingLots(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(lot.id);
                        return newSet;
                    });
                }
            }
        });
    };

    // Advanced Auto-Bid Logic (updated to support multiple lots)
    const handleAutoBid = async () => {
        console.log('[Auto-Bid Debug] handleAutoBid called');
        if (!canUserBid()) {
            console.log('[Auto-Bid Debug] canUserBid returned false');
            message.error('You are not authorized to use max-bid in this auction');
            return;
        }
        if (!selectedLot || !auction) {
            console.log('[Auto-Bid Debug] Missing selectedLot or auction:', { selectedLot, auction });
            return;
        }
        if (timeRemaining !== null && timeRemaining <= 5) {
            message.warning(`Bidding is disabled in the last 5 seconds. (${timeRemaining}s remaining)`);
            return;
        }
        if (!autoBidAmount || isNaN(autoBidAmount) || Number(autoBidAmount) <= 0) {
            console.log('[Auto-Bid Debug] Invalid autoBidAmount:', autoBidAmount);
            setBidError('Please enter a valid max-bid increment amount.');
            return;
        }
        if (!autoBidMaxAmount || isNaN(autoBidMaxAmount) || Number(autoBidMaxAmount) <= 0) {
            console.log('[Auto-Bid Debug] Invalid autoBidMaxAmount:', autoBidMaxAmount);
            setBidError('Please enter a valid maximum bid amount.');
            return;
        }

        const max = parseInt(autoBidMaxAmount);
        const increment = parseInt(autoBidAmount);
        const lotId = selectedLot.id;
        const lotSlug = selectedLot.slug;
        const lotName = selectedLot.title || `Lot #${selectedLot.lot_number}`;

        // Validate increment meets minimum requirement
        const minimumIncrement = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
        if (increment < minimumIncrement) {
            console.log('[Auto-Bid Debug] Increment validation failed:', { increment, minimumIncrement });
            setBidError(`Bid increment must be at least ${formatCurrency(minimumIncrement)} (the lot's minimum increment). You entered ${formatCurrency(increment)}.`);
            return;
        }

        // Check if auto-bid already exists for this lot
        if (activeAutoBids.has(lotId)) {
            console.log('[Auto-Bid Debug] Auto-bid already exists for lot:', lotId);
            message.warning(`Max-bid is already active for ${lotName}. Please stop it first to change settings.`);
            return;
        }

        console.log('[Auto-Bid Debug] Starting auto-bid for lot:', { lotId, lotName, increment, max });

        // Validate that max amount is greater than current price + increment
        const currentPrice = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
        const nextBid = currentPrice + increment;

        if (max < nextBid) {
            console.log('[Auto-Bid Debug] Validation failed: max < nextBid', { max, nextBid, currentPrice, increment });
            setBidError(`Maximum bid amount (${formatCurrency(max)}) must be at least ${formatCurrency(nextBid)} (current price + increment).`);
            return;
        }

        setBidding(true);
        setBidError(null);
        // Don't set global autoBidActive - we're using activeAutoBids Map now for multiple auto-bids
        // Keep autoBidLotId for UI reference (which lot's form is displayed)
        setAutoBidLotId(selectedLot.id);
        setAutoBidLotSlug(selectedLot.slug);
        setStopAutoBid(false);

        // Create stop ref for this specific lot
        const stopRef = { current: false };
        let intervalRef = null;

        // Add to active auto-bids map (checkAndBid will be added later after it's defined)
        setActiveAutoBids(prev => {
            const newMap = new Map(prev);
            newMap.set(lotId, {
                increment,
                maxAmount: max,
                lotSlug,
                lotName,
                lotNumber: selectedLot.lot_number,
                intervalRef: null, // Will be set after interval is created
                stopRef,
                startedAt: new Date().toISOString(),
                isBidding: false
            });
            return newMap;
        });

        try {
            // Capture lot-specific values for this auto-bid instance
            const thisLotId = lotId;
            const thisLotSlug = lotSlug;
            const thisLotName = lotName;
            const thisIncrement = increment;
            const thisMax = max;
            const thisCurrentUserId = currentUser?.id; // Capture current user ID to avoid stale closure
            const thisAuctionSlug = auction?.slug; // Capture auction slug to avoid stale closure

            // Helper function to stop auto-bid for this specific lot
            const stopAutoBidForLot = () => {
                // Use the captured lotId to ensure we're stopping the right lot
                setActiveAutoBids(prev => {
                    const newMap = new Map(prev);
                    const autoBidInfo = newMap.get(thisLotId);

                    // Clear the interval if it exists
                    if (autoBidInfo?.intervalRef) {
                        clearInterval(autoBidInfo.intervalRef);
                    }

                    // Remove from map
                    newMap.delete(thisLotId);
                    return newMap;
                });

                // Remove checkAndBid function from ref
                autoBidCheckFunctionsRef.current.delete(thisLotId);

                // Clear bidding in progress flag for this lot
                biddingInProgressRef.current.delete(thisLotId);

                // Update legacy state if this was the selected lot
                if (thisLotId === autoBidLotId) {
                    setBidding(false);
                    setAutoBidActive(false);
                    setStopAutoBid(false);
                }
            };

            // Define the check function that will run periodically for THIS specific lot
            const checkAndBid = async () => {
                console.log('[Auto-Bid Debug] checkAndBid called for lot:', thisLotId, {
                    lotName: thisLotName,
                    lotSlug: thisLotSlug,
                    increment: thisIncrement,
                    maxAmount: thisMax,
                    auctionSlug: thisAuctionSlug,
                    currentUserId: thisCurrentUserId,
                    timestamp: new Date().toISOString()
                });

                // Check stopRef directly (captured in closure, so it's lot-specific)
                // This is the primary way to stop an auto-bid
                if (stopRef.current) {
                    console.log('[Auto-Bid Debug] stopRef.current is true, stopping auto-bid for lot:', thisLotId);
                    stopAutoBidForLot();
                    message.info(`Max-bid stopped for ${thisLotName}.`);
                    return;
                }

                // Prevent concurrent bid attempts for the same lot
                // But add a timeout safety - if flag has been set for more than 30 seconds, clear it
                const biddingFlag = biddingInProgressRef.current.get(thisLotId);
                if (biddingFlag) {
                    // If it's a timestamp, check if it's been more than 30 seconds
                    if (typeof biddingFlag === 'number') {
                        const timeSinceSet = Date.now() - biddingFlag;
                        if (timeSinceSet > 30000) {
                            console.warn('[Auto-Bid Debug] Bidding flag stuck for more than 30 seconds, clearing it for lot:', thisLotId, {
                                timeSinceSet,
                                lotName: thisLotName
                            });
                            biddingInProgressRef.current.delete(thisLotId);
                        } else {
                            console.log('[Auto-Bid Debug] Bid already in progress for lot:', thisLotId, {
                                timeSinceSet,
                                lotName: thisLotName
                            });
                            return; // Skip this iteration if a bid is already in progress
                        }
                    } else {
                        // Legacy boolean flag - treat as active
                        console.log('[Auto-Bid Debug] Bid already in progress for lot:', thisLotId);
                        return; // Skip this iteration if a bid is already in progress
                    }
                }

                try {
                    // Mark bidding as in progress for THIS lot (store timestamp for safety check)
                    biddingInProgressRef.current.set(thisLotId, Date.now());

                    // Fetch the latest lot data for THIS lot
                    let latestLot;
                    try {
                        console.log('[Auto-Bid Debug] Fetching lot data for:', thisLotSlug, {
                            lotId: thisLotId,
                            auctionSlug: thisAuctionSlug,
                            lotName: thisLotName
                        });
                        if (!thisAuctionSlug) {
                            console.error('[Auto-Bid Debug] No auction slug available for lot:', thisLotId);
                            biddingInProgressRef.current.delete(thisLotId);
                            return;
                        }
                        const lotResponse = await auctionService.getLot(thisAuctionSlug, thisLotSlug);
                        latestLot = lotResponse.data;
                        console.log('[Auto-Bid Debug] Lot data fetched:', {
                            lotId: latestLot.id,
                            currentPrice: latestLot.current_price,
                            lastBidUserId: latestLot.last_bid_user_id,
                            status: latestLot.status,
                            currentUserId: thisCurrentUserId
                        });
                    } catch (fetchErr) {
                        // If fetching lot data fails, log but don't stop auto-bid (might be temporary network issue)
                        console.warn(`[Auto-Bid Debug] Failed to fetch lot data for ${thisLotName}:`, fetchErr);
                        biddingInProgressRef.current.delete(thisLotId);
                        return; // Skip this iteration, will retry on next interval
                    }

                    if (!latestLot) {
                        console.log('[Auto-Bid Debug] No lot data returned');
                        biddingInProgressRef.current.delete(thisLotId);
                        return; // Skip if no lot data
                    }

                    // Check if lot is closed
                    if (latestLot.status === 'closed' || latestLot.status === 'cancelled') {
                        console.log('[Auto-Bid Debug] Lot is closed/cancelled, stopping auto-bid');
                        stopAutoBidForLot();
                        message.info(`Max-bid stopped: ${thisLotName} is closed.`);
                        return;
                    }

                    // Check if current user is already the highest bidder
                    // Use Number() comparison to handle string vs number ID mismatches
                    const isUserHighestBidder = Number(latestLot.last_bid_user_id) === Number(thisCurrentUserId);
                    if (isUserHighestBidder) {
                        console.log('[Auto-Bid Debug] User is already highest bidder, waiting for outbid', {
                            lastBidUserId: latestLot.last_bid_user_id,
                            currentUserId: thisCurrentUserId,
                            lotId: thisLotId,
                            lotName: thisLotName,
                            numericComparison: {
                                lastBidUserIdNum: Number(latestLot.last_bid_user_id),
                                currentUserIdNum: Number(thisCurrentUserId),
                                match: isUserHighestBidder
                            }
                        });
                        // Wait for another user to outbid - don't place a bid
                        biddingInProgressRef.current.delete(thisLotId);
                        return;
                    }

                    // Calculate next bid using THIS lot's increment
                    const current = parseInt(latestLot.current_price) || parseInt(latestLot.starting_price);
                    const nextBid = current + thisIncrement;
                    console.log('[Auto-Bid Debug] Calculated bid:', {
                        lotId: thisLotId,
                        lotName: thisLotName,
                        current,
                        increment: thisIncrement,
                        nextBid,
                        max: thisMax,
                        lastBidUserId: latestLot.last_bid_user_id,
                        currentUserId: thisCurrentUserId
                    });

                    // Check if next bid would exceed THIS lot's max
                    if (nextBid > thisMax) {
                        // Check if current price is already at or above max (can't bid at all)
                        if (current >= thisMax) {
                            stopAutoBidForLot();
                            message.info(`Max-bid stopped: Current price (${formatCurrency(current)}) is at or above maximum bid amount (${formatCurrency(thisMax)}) for ${thisLotName}.`);
                            return;
                        } else {
                            // Current price is below max, but next bid would exceed it
                            // Try to place a bid at the max amount instead
                            const bidAtMax = thisMax;
                            try {
                                if (!thisAuctionSlug) {
                                    console.error('[Auto-Bid Debug] No auction slug available for placing bid at max');
                                    biddingInProgressRef.current.delete(thisLotId);
                                    return;
                                }
                                const bidResponse = await auctionService.placeBid(thisAuctionSlug, thisLotSlug, { amount: bidAtMax });
                                // Check for unlocked achievements
                                if (bidResponse?.achievements && bidResponse.achievements.length > 0) {
                                    setUnlockedAchievements(bidResponse.achievements);
                                    setAchievementModalVisible(true);
                                }
                                // Success - clear the flag after a short delay
                                setTimeout(() => {
                                    biddingInProgressRef.current.delete(thisLotId);
                                }, 500);

                                // Stop auto-bid after placing bid at max
                                stopAutoBidForLot();
                                message.info(`Max-bid stopped: Final bid placed at maximum amount (${formatCurrency(thisMax)}) for ${thisLotName}.`);
                                return;
                            } catch (bidErr) {
                                // If placing bid at max fails, stop auto-bid
                                stopAutoBidForLot();
                                const errorMessage = bidErr?.response?.data?.message || bidErr?.message || 'Your bid could not be placed';

                                // Track rejected bid if it's a validation error
                                if (errorMessage.includes('already bid ahead of you')) {
                                    const minimumBidMatch = errorMessage.match(/at least ([\d,]+\.?\d*)/);
                                    const minimumBid = minimumBidMatch ? parseFloat(minimumBidMatch[1].replace(/,/g, '')) : null;

                                    setRejectedBids(prev => {
                                        const newMap = new Map(prev);
                                        const rejectedBidsForLot = newMap.get(thisLotId) || [];

                                        rejectedBidsForLot.push({
                                            amount: bidAtMax,
                                            minimumBid: minimumBid,
                                            errorMessage: errorMessage,
                                            timestamp: new Date().toISOString(),
                                            user: currentUser
                                        });

                                        newMap.set(thisLotId, rejectedBidsForLot);
                                        return newMap;
                                    });

                                    // Show modal
                                    const lotNumber = selectedLot?.lot_number || 'Unknown';
                                    setBidRejectionModal({
                                        visible: true,
                                        lotNumber: lotNumber,
                                        errorMessage: errorMessage,
                                        minimumBid: minimumBid,
                                        isAutoBid: true,
                                        lotName: thisLotName
                                    });
                                } else {
                                    message.error({
                                        content: (
                                            <div>
                                                <div style={{ fontWeight: 600, marginBottom: '4px' }}>⚠️ Auto-Bid Failed</div>
                                                <div style={{ fontSize: '13px' }}>Max-bid stopped for {thisLotName}: {errorMessage}</div>
                                            </div>
                                        ),
                                        duration: 5,
                                        style: { marginTop: '20vh' }
                                    });
                                }

                                return;
                            }
                        }
                    }

                    // Place the bid for THIS lot
                    try {
                        console.log('[Auto-Bid Debug] Placing bid:', {
                            amount: nextBid,
                            lotSlug: thisLotSlug,
                            auctionSlug: thisAuctionSlug,
                            lotId: thisLotId,
                            lotName: thisLotName
                        });
                        if (!thisAuctionSlug) {
                            console.error('[Auto-Bid Debug] No auction slug available for placing bid');
                            biddingInProgressRef.current.delete(thisLotId);
                            return;
                        }
                        const bidResponse = await auctionService.placeBid(thisAuctionSlug, thisLotSlug, { amount: nextBid });
                        console.log('[Auto-Bid Debug] Bid placed successfully:', nextBid);
                        // Check for unlocked achievements
                        if (bidResponse?.achievements && bidResponse.achievements.length > 0) {
                            setUnlockedAchievements(bidResponse.achievements);
                            setAchievementModalVisible(true);
                        }
                        // Success - clear the flag after a short delay to allow the bid to process
                        setTimeout(() => {
                            biddingInProgressRef.current.delete(thisLotId);
                        }, 500);
                    } catch (bidErr) {
                        // Handle bid errors more gracefully
                        const errorMessage = bidErr?.response?.data?.message || bidErr?.message || 'Bid rejected';
                        console.error('[Auto-Bid Debug] Bid placement error:', {
                            error: bidErr,
                            errorMessage,
                            nextBid,
                            lotSlug: thisLotSlug
                        });

                        // Track rejected bid if it's a validation error
                        if (errorMessage.includes('already bid ahead of you')) {
                            const minimumBidMatch = errorMessage.match(/at least ([\d,]+\.?\d*)/);
                            const minimumBid = minimumBidMatch ? parseFloat(minimumBidMatch[1].replace(/,/g, '')) : null;

                            setRejectedBids(prev => {
                                const newMap = new Map(prev);
                                const rejectedBidsForLot = newMap.get(thisLotId) || [];

                                rejectedBidsForLot.push({
                                    amount: nextBid,
                                    minimumBid: minimumBid,
                                    errorMessage: errorMessage,
                                    timestamp: new Date().toISOString(),
                                    user: currentUser
                                });

                                newMap.set(thisLotId, rejectedBidsForLot);
                                return newMap;
                            });

                            // Show modal for rejected auto-bid
                            const lotNumber = selectedLot?.lot_number || 'Unknown';
                            setBidRejectionModal({
                                visible: true,
                                lotNumber: lotNumber,
                                errorMessage: errorMessage,
                                minimumBid: minimumBid,
                                isAutoBid: true,
                                lotName: thisLotName
                            });
                        }

                        // Don't stop auto-bid for certain recoverable errors
                        const recoverableErrors = [
                            'Failed to place bid',
                            'Bid is being processed',
                            'Bidding is locked',
                            'amount must be at least',
                            'network',
                            'timeout',
                            'fetch',
                            'request failed',
                            'connection',
                            'unauthorized',
                            'forbidden',
                            'not found',
                            'server error',
                            'service unavailable'
                        ];

                        // Only stop for truly fatal errors (like validation errors that won't resolve)
                        const fatalErrors = [
                            'invalid',
                            'validation',
                            'unauthorized user',
                            'auction owner cannot bid'
                        ];

                        const isFatal = fatalErrors.some(msg =>
                            errorMessage.toLowerCase().includes(msg.toLowerCase())
                        );

                        const isRecoverable = recoverableErrors.some(msg =>
                            errorMessage.toLowerCase().includes(msg.toLowerCase())
                        );

                        if (isFatal) {
                            // Truly fatal error - stop auto-bid for THIS lot
                            console.error(`Fatal error for auto-bid on ${thisLotName}:`, bidErr);
                            stopAutoBidForLot();
                            if (thisLotId === autoBidLotId) {
                                setBidError('Max-bid stopped: ' + errorMessage);
                            }
                            message.error(`Max-bid stopped for ${thisLotName}: ${errorMessage}`);
                            return;
                        } else if (isRecoverable) {
                            // These are usually race conditions or temporary issues - just wait and retry
                            console.log(`Recoverable error for ${thisLotName}: ${errorMessage}. Will retry.`);
                            biddingInProgressRef.current.delete(thisLotId);
                            return; // Continue auto-bid, will retry on next interval
                        } else {
                            // Unknown error - treat as recoverable to avoid stopping unnecessarily
                            console.warn(`Unknown error for ${thisLotName}: ${errorMessage}. Will retry.`);
                            biddingInProgressRef.current.delete(thisLotId);
                            return; // Continue auto-bid, will retry on next interval
                        }
                    }

                } catch (err) {
                    console.warn(`Max-bid general error for ${thisLotName}:`, err);
                    biddingInProgressRef.current.delete(thisLotId);
                    // For general errors, treat most as recoverable to avoid stopping unnecessarily
                    const errorMessage = err?.response?.data?.message || err?.message || 'Unknown error';

                    // Only stop for truly fatal errors
                    const fatalErrors = [
                        'invalid',
                        'validation',
                        'unauthorized user',
                        'auction owner cannot bid'
                    ];

                    const isFatal = fatalErrors.some(msg =>
                        errorMessage.toLowerCase().includes(msg.toLowerCase())
                    );

                    if (isFatal) {
                        stopAutoBidForLot();
                        if (thisLotId === autoBidLotId) {
                            setBidError('Max-bid stopped: ' + errorMessage);
                        }
                        message.error(`Max-bid stopped for ${thisLotName}: ${errorMessage}`);
                    }
                    // Otherwise, just retry on next interval
                    return;
                }
            };

            // IMPORTANT: Store checkAndBid function in ref BEFORE creating interval
            // This ensures the function is available immediately when the interval runs
            autoBidCheckFunctionsRef.current.set(thisLotId, checkAndBid);
            console.log('[Auto-Bid Debug] Stored checkAndBid function for lot:', thisLotId, {
                totalAutoBids: autoBidCheckFunctionsRef.current.size,
                allLotIds: Array.from(autoBidCheckFunctionsRef.current.keys()),
                lotName: thisLotName,
                auctionSlug: thisAuctionSlug,
                hasFunction: !!checkAndBid
            });

            // Set up the interval AFTER storing the function
            // This ensures intervalRef is available immediately
            console.log('[Auto-Bid Debug] Creating interval for lot:', thisLotId, {
                lotName: thisLotName,
                lotSlug: thisLotSlug,
                increment: thisIncrement,
                maxAmount: thisMax,
                currentActiveAutoBids: activeAutoBids.size
            });

            // Create interval with explicit lot ID to ensure closure is correct
            intervalRef = setInterval(() => {
                const currentLotId = thisLotId; // Capture in closure
                const currentLotName = thisLotName;
                console.log('[Auto-Bid Debug] Interval tick for lot:', currentLotId, {
                    lotName: currentLotName,
                    timestamp: new Date().toISOString(),
                    totalActiveIntervals: autoBidCheckFunctionsRef.current.size,
                    allLotIds: Array.from(autoBidCheckFunctionsRef.current.keys())
                });
                // Verify the function still exists before calling
                const fn = autoBidCheckFunctionsRef.current.get(currentLotId);
                if (fn) {
                    console.log('[Auto-Bid Debug] Calling checkAndBid for lot:', currentLotId);
                    fn();
                } else {
                    console.error('[Auto-Bid Debug] checkAndBid function not found for lot:', currentLotId, {
                        availableLotIds: Array.from(autoBidCheckFunctionsRef.current.keys()),
                        totalFunctions: autoBidCheckFunctionsRef.current.size
                    });
                }
            }, 2000);

            console.log('[Auto-Bid Debug] Interval created:', intervalRef, 'for lot:', thisLotId);

            // Update the interval ref in the map immediately so it's available
            setActiveAutoBids(prev => {
                const newMap = new Map(prev);
                const existing = newMap.get(thisLotId);
                if (existing) {
                    console.log('[Auto-Bid Debug] Updating existing auto-bid entry with interval');
                    newMap.set(thisLotId, { ...existing, intervalRef });
                } else {
                    console.log('[Auto-Bid Debug] Creating new auto-bid entry with interval');
                    // Shouldn't happen, but just in case - recreate the entry
                    newMap.set(thisLotId, {
                        increment: thisIncrement,
                        maxAmount: thisMax,
                        lotSlug: thisLotSlug,
                        lotName: thisLotName,
                        lotNumber: selectedLot.lot_number,
                        intervalRef,
                        stopRef,
                        startedAt: new Date().toISOString(),
                        isBidding: false
                    });
                }
                console.log('[Auto-Bid Debug] Active auto-bids after update:', Array.from(newMap.keys()));

                // Verify the function is still in the ref after state update
                const verifyFn = autoBidCheckFunctionsRef.current.get(thisLotId);
                if (!verifyFn) {
                    console.error('[Auto-Bid Debug] Function lost after state update! Re-storing for lot:', thisLotId);
                    autoBidCheckFunctionsRef.current.set(thisLotId, checkAndBid);
                }

                return newMap;
            });

            // Run the first check after a short delay to allow state updates to complete
            setTimeout(async () => {
                console.log('[Auto-Bid Debug] Running first checkAndBid for lot:', thisLotId);
                // Verify function exists before calling
                const fn = autoBidCheckFunctionsRef.current.get(thisLotId);
                if (fn) {
                    await fn();
                } else {
                    console.error('[Auto-Bid Debug] Function not found for first check, re-storing for lot:', thisLotId);
                    autoBidCheckFunctionsRef.current.set(thisLotId, checkAndBid);
                    await checkAndBid();
                }
            }, 500);

            // Reset bidding state after auto-bid is successfully started
            setBidding(false);
            console.log('[Auto-Bid Debug] Auto-bid successfully started for lot:', lotId);
            message.success(`Max-bid started for ${lotName}!`);

        } catch (err) {
            console.error('[Auto-Bid Debug] Max-bid setup error:', err);
            setActiveAutoBids(prev => {
                const newMap = new Map(prev);
                newMap.delete(lotId);
                return newMap;
            });
            setBidding(false);
            setAutoBidActive(false);
            setStopAutoBid(false);
            setBidError('Max-bid failed to start: ' + (err?.message || 'Unknown error'));
            message.error('Max-bid failed to start. Please try again.');
        }
    };

    const handleStopAutoBid = (lotIdToStop = null) => {
        const targetLotId = lotIdToStop || autoBidLotId;

        if (!targetLotId) {
            message.warning('No active max-bid to stop.');
            return;
        }

        // Get the auto-bid info
        const autoBidInfo = activeAutoBids.get(targetLotId);

        if (autoBidInfo) {
            // Set the stop flag
            autoBidInfo.stopRef.current = true;

            // Clear the interval if it exists
            if (autoBidInfo.intervalRef) {
                clearInterval(autoBidInfo.intervalRef);
            }

            // Remove checkAndBid function from ref
            autoBidCheckFunctionsRef.current.delete(targetLotId);

            // Clear bidding in progress flag
            biddingInProgressRef.current.delete(targetLotId);

            // Remove from active auto-bids
            setActiveAutoBids(prev => {
                const newMap = new Map(prev);
                newMap.delete(targetLotId);
                return newMap;
            });

            // Update legacy state if this was the selected lot
            if (targetLotId === autoBidLotId) {
                setStopAutoBid(true);
                setAutoBidActive(false);
                setBidding(false);
            }

            message.info(`Stopping Max-bid for ${autoBidInfo.lotName}...`);
        } else {
            // Fallback to legacy method
            autoBidStopRef.current = true;
            if (autoBidIntervalRef.current) {
                clearInterval(autoBidIntervalRef.current);
                autoBidIntervalRef.current = null;
            }
            biddingInProgressRef.current.delete(targetLotId);
            setStopAutoBid(true);
            setAutoBidActive(false);
            setBidding(false);
            message.info('Stopping Max-bid...');
        }
    };

    // Reset bidding state and update form inputs when switching lots - optimized
    useEffect(() => {
        if (!selectedLot) return;

        const hasAutoBidForSelectedLot = activeAutoBids.has(selectedLot.id);

        // Batch state updates using React's automatic batching (React 18+)
        if (!hasAutoBidForSelectedLot) {
            setBidding(false);
            // Clear form inputs if no active auto-bid for this lot
            // Only clear if form is not shown or if we're switching to a different lot
            if (!showAutoBidForm || !autoBidLotId || autoBidLotId !== selectedLot.id) {
                setAutoBidAmount('');
                setAutoBidMaxAmount('');
            }
        } else {
            // If this lot has an active auto-bid, populate the form with its values
            const autoBidInfo = activeAutoBids.get(selectedLot.id);
            if (autoBidInfo && showAutoBidForm) {
                setAutoBidAmount(autoBidInfo.increment.toString());
                setAutoBidMaxAmount(autoBidInfo.maxAmount.toString());
            }
        }
    }, [selectedLot?.id, activeAutoBids, showAutoBidForm, autoBidLotId]);

    // Helper to check if a lot is closed
    const isLotClosed = (lot) => {
        return lot.status === 'closed' || closedLots.includes(lot.id);
    };

    // Fetch bid history for a lot (only from server)
    const fetchBidHistory = useCallback(async (lotSlug, lotId) => {
        if (!auction?.slug || !lotSlug) return;

        setBidHistoryLoading(true);
        try {
            const response = await auctionService.getBidHistory(auction.slug, lotSlug);
            console.log('Bid history response:', response); // Debug log

            // Handle different response structures
            let bids = [];
            if (response?.data) {
                // Response has data wrapper
                bids = Array.isArray(response.data) ? response.data : [];
            } else if (Array.isArray(response)) {
                // Response is directly an array
                bids = response;
            } else if (response?.status === 'success' && response?.data) {
                // Response has status and data
                bids = Array.isArray(response.data) ? response.data : [];
            }

            // Sort by created_at descending (newest first)
            const sortedBids = bids.sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // Descending order
            });

            // Cache user info from fetched bid history
            sortedBids.forEach(bid => {
                if (bid.user && bid.user.id) {
                    setUserInfoCache(prev => {
                        const newCache = new Map(prev);
                        // Only update if we don't have this user's info yet, or if the new info has names
                        if (!newCache.has(bid.user.id) || (bid.user.first_name || bid.user.last_name)) {
                            newCache.set(bid.user.id, {
                                id: bid.user.id,
                                first_name: bid.user.first_name,
                                last_name: bid.user.last_name
                            });
                        }
                        return newCache;
                    });
                }
            });

            // Cache the bid history for this lot
            // Note: We don't update bidActivityCount here because this is just fetching existing bid history for display.
            // The counter should only update when NEW bids arrive via Pusher, not when selecting a lot to view its history.
            if (lotId) {
                setBidHistoryCache(prev => {
                    const newCache = new Map(prev);
                    newCache.set(lotId, sortedBids);
                    return newCache;
                });
            }

            // Enrich any existing bids in bidHistory state that might be missing user info
            setBidHistory(prevBidHistory => {
                // If we have existing bids, enrich them with user info from fetched bids
                if (prevBidHistory.length > 0) {
                    const enrichedBids = prevBidHistory.map(bid => {
                        // If this bid is missing user info, try to find it in the fetched bids
                        if (!bid.user?.first_name && !bid.user?.last_name && bid.user?.id) {
                            const fetchedBid = sortedBids.find(b =>
                                Number(b.user?.id) === Number(bid.user.id) ||
                                Number(b.user_id) === Number(bid.user.id)
                            );
                            if (fetchedBid && fetchedBid.user && (fetchedBid.user.first_name || fetchedBid.user.last_name)) {
                                return {
                                    ...bid,
                                    user: {
                                        ...bid.user,
                                        first_name: fetchedBid.user.first_name,
                                        last_name: fetchedBid.user.last_name
                                    }
                                };
                            }
                        }
                        return bid;
                    });

                    // Merge fetched bids with enriched existing bids, avoiding duplicates
                    const mergedBids = [...sortedBids];
                    enrichedBids.forEach(existingBid => {
                        if (!mergedBids.some(b => b.id === existingBid.id)) {
                            mergedBids.push(existingBid);
                        }
                    });

                    // Sort merged bids by created_at descending
                    const finalBids = mergedBids.sort((a, b) => {
                        const dateA = new Date(a.created_at);
                        const dateB = new Date(b.created_at);
                        return dateB - dateA;
                    });

                    return finalBids;
                }

                // No existing bids, just use fetched bids
                return sortedBids;
            });

            setBidHistory(sortedBids);
        } catch (error) {
            console.error('Error fetching bid history:', error);
            console.error('Error details:', error.response?.data || error.message);
            message.error(error.response?.data?.message || 'Failed to load bid history');
            setBidHistory([]);
        } finally {
            setBidHistoryLoading(false);
        }
    }, [auction?.slug]);

    // Derive selected lot's bid history from bid activity (primary) + real-time cache (supplemental)
    const computedBidHistory = useMemo(() => {
        if (!selectedLot?.id || !auction?.slug) {
            return [];
        }

        const lotId = Number(selectedLot.id);
        const bidsFromActivity = getLotBidsFromActivity(bidActivityData, lotId);
        const cachedBids =
            bidHistoryCache.get(lotId) ||
            bidHistoryCache.get(selectedLot.id) ||
            [];

        return mergeLotBidHistories(bidsFromActivity, cachedBids);
    }, [selectedLot?.id, auction?.slug, bidActivityData, bidHistoryCache]);

    // Update bidHistory state when selected lot or underlying bid data changes
    useEffect(() => {
        setBidHistory(computedBidHistory);
        setBidHistoryLoading(
            loadingBidActivity &&
            bidActivityData.length === 0 &&
            computedBidHistory.length === 0
        );
    }, [computedBidHistory, loadingBidActivity, bidActivityData.length]);

    // Update renderBidButtons to handle loading state and time-based disabling
    const renderBidButtons = (lot) => {
        // First check if lot is closed or cancelled
        if (lot.status === 'closed' || lot.status === 'cancelled') {
            return null;
        }

        if (isSequential && !isLotAvailableForBidding(lot)) {
            return (
                <div style={{ textAlign: "center", color: "#999" }}>
                    Waiting for previous lots to complete
                </div>
            );
        }

        // Show loading state while checking invitation status
        if (isInvitationLoading) {
            return (
                <div style={{ textAlign: "center" }}>
                    <Spin size="small" /> Loading bidding options...
                </div>
            );
        }

        // Disable buttons if 5 seconds or less remaining (no one can bid in last 5 seconds)
        const isTimeCritical = timeRemaining !== null && timeRemaining > 0 && timeRemaining <= 5;
        // Check if THIS specific lot has an auto-bid active (not any lot)
        const hasAutoBidForThisLot = activeAutoBids.has(lot.id);
        const isDisabled = lot.last_bid_user_id === currentUser?.id || hasAutoBidForThisLot || isTimeCritical;

        // Calculate bid amounts for each multiplier
        const increment = parseInt(lot.default_increment) || parseInt(lot.increment) || 5;
        const current = parseInt(lot.current_price) || parseInt(lot.starting_price);
        const bidAmount1x = current + (increment * 1);
        const bidAmount2x = current + (increment * 2);
        const bidAmount5x = current + (increment * 5);

        // Helper function to format button text
        const getButtonText = (multiplier, amount) => {
            return `Bid x${multiplier} (${formatCurrency(amount)})`;
        };

        // Render owner-specific bid buttons (vendor bids)
        const renderOwnerBidButtons = () => {
            if (!lot || lot.status !== 'active' || checkIfLotClosed(lot)) {
                return null;
            }

            // Use owner_bid_tracking from API instead of checking bid history
            const ownerBidTracking = lot.owner_bid_tracking || {};
            const hasStartBid = ownerBidTracking.has_start_bid || false;
            const hasVendorBid = ownerBidTracking.has_vendor_bid || false;

            // Check if lot has any bids (for start bid button - only show if no bids exist)
            const lotBids = bidHistoryCache.get(lot.id) || [];
            const hasBids = lotBids.length > 0;

            const increment = parseInt(lot.default_increment) || parseInt(lot.increment) || 5;
            const startingPrice = parseInt(lot.starting_price) || 0;
            const startBidAmount = startingPrice + increment;

            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    width: '100%'
                }}>
                    {/* Start Lot Button - Only show if lot has a reserve price and is available for bidding */}
                    {!hasBids && !hasStartBid && lot.status === 'active' && lot.reserve_price && lot.reserve_price > 0 && isLotAvailableForBidding(lot) && (
                        <Button
                            type="primary"
                            icon={<PlayCircleOutlined />}
                            disabled={isDisabled}
                            onClick={() => handleStartLotWithBid(lot)}
                            size="large"
                            block
                            data-tour="start-lot-bid"
                            style={{
                                height: '56px',
                                fontSize: '15px',
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #52c41a, #73d13d)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(82, 196, 26, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                whiteSpace: 'nowrap',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(82, 196, 26, 0.5), 0 4px 8px rgba(82, 196, 26, 0.3)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #73d13d, #95de64)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(82, 196, 26, 0.3)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #52c41a, #73d13d)';
                            }}
                        >
                            <span>Start Lot with Your Bid</span>
                            <span style={{
                                fontSize: '16px',
                                fontWeight: 700,
                                opacity: 1,
                                marginLeft: '4px'
                            }}>
                                {formatCurrency(startBidAmount)}
                            </span>
                        </Button>
                    )}

                </div>
            );
        };

        const renderBidButtonsContainer = () => {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '8px',
                    justifyContent: 'center',
                    width: '100%',
                    padding: '0 4px'
                }}>
                    <Button
                        type="primary"
                        disabled={isDisabled}
                        onClick={() => handleBid(1)}
                        data-tour="bid-x1"
                        style={{
                            flex: '1 1 auto',
                            minWidth: '90px',
                            maxWidth: '100%',
                            height: '48px',
                            fontSize: 'clamp(12px, 2.5vw, 14px)',
                            fontWeight: 600,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '4px',
                            padding: '30px 8px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            lineHeight: '1.2'
                        }}
                    >
                        <span style={{ fontSize: 'clamp(14px, 3vw, 16px)', fontWeight: 700 }}>Bid x1</span>
                        <span style={{ fontSize: 'clamp(12px, 2.5vw, 14px)', opacity: 0.95, lineHeight: '1.2' }}>
                            {formatCurrency(bidAmount1x)}
                        </span>
                    </Button>
                    <Button
                        type="primary"
                        disabled={isDisabled}
                        onClick={() => handleBid(2)}
                        data-tour="bid-x2"
                        style={{
                            flex: '1 1 auto',
                            minWidth: '90px',
                            maxWidth: '100%',
                            height: '48px',
                            fontSize: 'clamp(12px, 2.5vw, 14px)',
                            fontWeight: 600,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '4px',
                            padding: '30px 8px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            lineHeight: '1.2'
                        }}
                    >
                        <span style={{ fontSize: 'clamp(14px, 3vw, 16px)', fontWeight: 700 }}>Bid x2</span>
                        <span style={{ fontSize: 'clamp(12px, 2.5vw, 14px)', opacity: 0.95, lineHeight: '1.2' }}>
                            {formatCurrency(bidAmount2x)}
                        </span>
                    </Button>
                    <Button
                        type="primary"
                        disabled={isDisabled}
                        onClick={() => handleBid(5)}
                        data-tour="bid-x5"
                        style={{
                            flex: '1 1 auto',
                            minWidth: '90px',
                            maxWidth: '100%',
                            height: '48px',
                            fontSize: 'clamp(12px, 2.5vw, 14px)',
                            fontWeight: 600,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '4px',
                            padding: '30px 8px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            lineHeight: '1.2'
                        }}
                    >
                        <span style={{ fontSize: 'clamp(14px, 3vw, 16px)', fontWeight: 700 }}>Bid x5</span>
                        <span style={{ fontSize: 'clamp(12px, 2.5vw, 14px)', opacity: 0.95, lineHeight: '1.2' }}>
                            {formatCurrency(bidAmount5x)}
                        </span>
                    </Button>
                    <Button
                        type="default"
                        icon={<UnorderedListOutlined />}
                        disabled={isDisabled}
                        onClick={() => setShowTemplateBidsModal(true)}
                        data-tour="template-bids"
                        style={{
                            flex: '1 1 auto',
                            minWidth: '90px',
                            maxWidth: '100%',
                            height: '48px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '30px 8px',
                            fontSize: '18px',
                            borderRadius: '6px',
                            borderColor: '#d9d9d9'
                        }}
                        title="Template Bids"
                    />
                </div>
            );
        };

        // Show owner vendor bid buttons if user is the auction owner
        if (currentUser?.id === auction?.user_id) {
            // Debug: Check why buttons might not show
            console.log('[Vendor Bid Debug] Owner check passed:', {
                userId: currentUser?.id,
                auctionOwnerId: auction?.user_id,
                lotStatus: lot?.status,
                isClosed: checkIfLotClosed(lot),
                lotId: lot?.id
            });

            if (lot?.status === 'active' && !checkIfLotClosed(lot)) {
                const ownerButtons = renderOwnerBidButtons();
                console.log('[Vendor Bid Debug] Owner buttons rendered:', ownerButtons !== null);
                return ownerButtons;
            } else {
                console.log('[Vendor Bid Debug] Lot not active or closed:', {
                    status: lot?.status,
                    isClosed: checkIfLotClosed(lot)
                });
            }
        }

        // For private auctions
        if (auction?.is_private) {
            // Only show buttons if user is invited and accepted (non-owner)
            if (isInvited && invitationStatus === 'accepted' &&
                currentUser?.id !== auction?.user_id &&
                lot.status === 'active' &&
                !checkIfLotClosed(lot)) {
                return renderBidButtonsContainer();
            }
            return null;
        }

        // For public auctions, show buttons to everyone except the owner
        if (currentUser?.id !== auction?.user_id) {
            return renderBidButtonsContainer();
        }

        return null;
    };

    useEffect(() => {
        if (lots.length > 0) {
            const updatedLots = lots.map(lot => updateLotStatus(lot));
            setLots(updatedLots);
            updateSidebarCounts(updatedLots);
        }
    }, [lots.length, currentUser?.id]);

    // Toggle lot for comparison (max 4 lots)
    // Memoize toggleComparison to prevent LotCard re-renders
    const toggleComparison = useCallback((lotId) => {
        setComparisonLots(prev => {
            if (prev.includes(lotId)) {
                return prev.filter(id => id !== lotId);
            } else if (prev.length >= 4) {
                message.warning('You can compare up to 4 lots at once');
                return prev;
            } else {
                return [...prev, lotId];
            }
        });
    }, []);

    // Clear all comparison lots
    const clearComparison = () => {
        setComparisonLots([]);
        setComparisonModalVisible(false);
    };

    // Remove a lot from comparison
    const removeFromComparison = (lotId) => {
        setComparisonLots(prev => {
            const newLots = prev.filter(id => id !== lotId);
            // Close modal if no lots remain
            if (newLots.length === 0) {
                setComparisonModalVisible(false);
            }
            return newLots;
        });
    };

    // Memoize toggleFavorite to prevent LotCard re-renders
    const toggleFavorite = useCallback(async (lotId, e) => {
        if (e) {
            e.stopPropagation();
        }

        if (!currentUser) {
            message.warning('Please login to add favorites');
            return;
        }

        // Update Redux state
        dispatch(toggleFavoriteLot(lotId));

        // Update local state immediately
        setLots(prevLots => {
            const newLots = prevLots.map(lot =>
                lot.id === lotId
                    ? { ...lot, is_favorite: !lot.is_favorite }
                    : lot
            );
            // Update sidebar counts
            updateSidebarCounts(newLots);
            return newLots;
        });

        // Update selectedLot if it's the same lot being favorited
        if (selectedLot && selectedLot.id === lotId) {
            setSelectedLot(prevSelected => ({
                ...prevSelected,
                is_favorite: !prevSelected.is_favorite
            }));
        }

        // Make the API call in the background
        try {
            await favoriteService.toggleFavoriteLot(lotId);
        } catch (error) {
            //console.error('Error toggling favorite:', error);
            // Revert the changes on error
            dispatch(toggleFavoriteLot(lotId));
            setLots(prevLots => {
                const newLots = prevLots.map(lot =>
                    lot.id === lotId
                        ? { ...lot, is_favorite: !lot.is_favorite }
                        : lot
                );
                updateSidebarCounts(newLots);
                return newLots;
            });
            // Revert selectedLot if it was the same lot
            if (selectedLot && selectedLot.id === lotId) {
                setSelectedLot(prevSelected => ({
                    ...prevSelected,
                    is_favorite: !prevSelected.is_favorite
                }));
            }
            message.error('Failed to update favorite status');
        }
    }, [currentUser, dispatch, selectedLot]);

    // Add this function to check if user can bid
    const canUserBid = () => {
        if (!currentUser) return false;
        if (!auction) return false;
        // Check if user is the auction owner
        if (auction.user_id === currentUser.id) return false;
        if (!auction.is_private) return true;
        return isInvited && invitationStatus === 'accepted';
    };

    // Add this function to check if auto-bid should be shown
    const shouldShowAutoBid = () => {
        if (isInvitationLoading) return false;
        if (currentUser?.id === auction?.user_id) return false;
        if (auction?.is_private) {
            return isInvited && invitationStatus === 'accepted';
        }
        return true;
    };

    // Helper function to get the correct lot for auto bid form
    const getAutoBidLot = () => {
        // Always use the selected lot (can have multiple auto-bids now)
        return selectedLot;
    };

    // Update the auto-bid section render
    const renderAutoBidSection = () => {
        if (isInvitationLoading) {
            return (
                <div style={{ margin: '16px 0', textAlign: 'center' }}>
                    <Spin size="small" /> Loading Max-bid options...
                </div>
            );
        }

        if (!shouldShowAutoBid()) {
            return null;
        }

        // Disable auto-bid if 5 seconds or less remaining AND user is not the last bidder
        const autoBidLot = getAutoBidLot();
        const isTimeCritical = timeRemaining !== null && timeRemaining <= 5 && autoBidLot?.last_bid_user_id !== currentUser?.id;
        // Check if THIS specific lot has an auto-bid active (not any lot)
        const hasAutoBidForThisLot = autoBidLot ? activeAutoBids.has(autoBidLot.id) : false;
        const isAutoBidDisabled = autoBidLot?.last_bid_user_id === currentUser?.id || isTimeCritical || checkIfLotClosed(getAutoBidLot());

        // Get active auto-bid values for this lot (if exists)
        const activeAutoBidInfo = autoBidLot ? activeAutoBids.get(autoBidLot.id) : null;
        const displayIncrement = activeAutoBidInfo ? activeAutoBidInfo.increment.toString() : autoBidAmount;
        const displayMaxAmount = activeAutoBidInfo ? activeAutoBidInfo.maxAmount.toString() : autoBidMaxAmount;

        // Validate increment if entered
        const isIncrementValid = (() => {
            if (!displayIncrement || !autoBidLot) return true; // Allow empty for now
            const increment = parseInt(autoBidLot.default_increment) || parseInt(autoBidLot.increment) || 5;
            const enteredValue = parseFloat(displayIncrement);
            if (isNaN(enteredValue)) return true; // Let handleAutoBid handle NaN validation
            return enteredValue >= increment;
        })();

        return (
            <div style={{ margin: '16px 0' }}>
                {!showAutoBidForm ? (
                    <Button
                        type="dashed"
                        data-tour="show-max-bid"
                        onClick={() => {
                            // When opening form, populate with active auto-bid values if exists
                            if (autoBidLot && activeAutoBids.has(autoBidLot.id)) {
                                const autoBidInfo = activeAutoBids.get(autoBidLot.id);
                                setAutoBidAmount(autoBidInfo.increment.toString());
                                setAutoBidMaxAmount(autoBidInfo.maxAmount.toString());
                            } else {
                                // Clear form if no active auto-bid
                                setAutoBidAmount('');
                                setAutoBidMaxAmount('');
                            }
                            setShowAutoBidForm(true);
                        }}
                        style={{ width: '100%' }}
                        disabled={isAutoBidDisabled}
                    >
                        Show Max-Bid Options
                    </Button>
                ) : (
                    <div data-tour="max-bid-form" style={{
                        padding: '14px 16px',
                        background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
                        borderRadius: '8px',
                        border: '1px solid #e8e8e8',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
                    }}>
                        <Space direction="vertical" style={{ width: '100%' }} size="small">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Text strong style={{ fontSize: '14px', color: '#262626' }}>
                                        🤖 Max-Bid Settings
                                    </Text>
                                    {hasAutoBidForThisLot && autoBidLot ? (
                                        <Tag color="success" style={{ fontSize: '11px', padding: '2px 6px', margin: 0 }}>
                                            Active Lot #{autoBidLot.lot_number}
                                        </Tag>
                                    ) : null}
                                </div>
                                <Button
                                    type="text"
                                    onClick={() => setShowAutoBidForm(false)}
                                    icon={<CloseOutlined />}
                                    style={{ color: '#8c8c8c', padding: '4px', height: 'auto' }}
                                />
                            </div>

                            <div>
                                <Text style={{
                                    display: 'block',
                                    marginBottom: 6,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#595959'
                                }}>
                                    Bid Increment
                                </Text>
                                <Input
                                    type="number"
                                    min={autoBidLot ? (parseInt(autoBidLot.default_increment) || parseInt(autoBidLot.increment) || 5) : 5}
                                    placeholder="e.g., 100"
                                    value={displayIncrement}
                                    onChange={e => {
                                        setAutoBidAmount(e.target.value);
                                        setBidError(null);
                                    }}
                                    style={{
                                        width: '100%',
                                        height: '36px',
                                        fontSize: '14px',
                                        borderColor: (() => {
                                            if (!displayIncrement || !autoBidLot) return undefined;
                                            const increment = parseInt(autoBidLot.default_increment) || parseInt(autoBidLot.increment) || 5;
                                            const enteredValue = parseFloat(displayIncrement);
                                            if (!isNaN(enteredValue) && enteredValue < increment) {
                                                return '#ff4d4f';
                                            }
                                            return undefined;
                                        })()
                                    }}
                                    disabled={hasAutoBidForThisLot || isAutoBidDisabled}
                                    prefix="PKR"
                                />
                                <div style={{
                                    marginTop: 4,
                                    fontSize: '10px',
                                    color: '#8c8c8c',
                                    padding: '4px 8px',
                                    background: '#f5f5f5',
                                    borderRadius: '3px'
                                }}>
                                    {(() => {
                                        if (!autoBidLot) return 'Amount to increase bid by when outbid';
                                        const increment = parseInt(autoBidLot.default_increment) || parseInt(autoBidLot.increment) || 5;
                                        return `Minimum increment: ${formatCurrency(increment)} • Amount to increase bid by when outbid`;
                                    })()}
                                </div>
                                {displayIncrement && autoBidLot && (() => {
                                    const increment = parseInt(autoBidLot.default_increment) || parseInt(autoBidLot.increment) || 5;
                                    const enteredValue = parseFloat(displayIncrement);

                                    if (isNaN(enteredValue)) {
                                        return null;
                                    }

                                    if (enteredValue < increment) {
                                        // Generate valid increment suggestions (1x, 2x, 5x, 10x of minimum increment)
                                        const validSuggestions = [
                                            increment * 1,
                                            increment * 2,
                                            increment * 5,
                                            increment * 10
                                        ].filter(sug => sug > enteredValue); // Only show suggestions higher than entered value

                                        return (
                                            <div style={{
                                                marginTop: 6,
                                                padding: '10px 12px',
                                                background: 'linear-gradient(135deg, #fffbe6 0%, #fff7e6 100%)',
                                                border: '1px solid #ffe58f',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                boxShadow: '0 1px 4px rgba(250, 173, 20, 0.12)'
                                            }}>
                                                <Space align="start" style={{ width: '100%' }}>
                                                    <span style={{ fontSize: '16px', marginTop: 1 }}>💡</span>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontWeight: 600, marginBottom: '6px', color: '#d48806' }}>
                                                            ⚠️ Increment too low
                                                        </div>
                                                        <div style={{ color: '#8c8c8c', marginBottom: '8px', fontSize: '11px' }}>
                                                            Bid increment must be at least {formatCurrency(increment)} (the lot's minimum increment).
                                                            You entered {formatCurrency(enteredValue)}.
                                                        </div>
                                                        {validSuggestions.length > 0 && (
                                                            <>
                                                                <div style={{ color: '#8c8c8c', marginBottom: '6px', fontSize: '11px' }}>
                                                                    Click a valid increment below:
                                                                </div>
                                                                <Space size="small" wrap style={{ width: '100%' }}>
                                                                    {validSuggestions.map((suggestion, idx) => (
                                                                        <Button
                                                                            key={idx}
                                                                            size="small"
                                                                            type="default"
                                                                            onClick={() => {
                                                                                setAutoBidAmount(suggestion.toString());
                                                                                setBidError(null);
                                                                            }}
                                                                            style={{
                                                                                padding: '3px 10px',
                                                                                height: 'auto',
                                                                                fontSize: '12px',
                                                                                fontWeight: 600,
                                                                                color: '#d48806',
                                                                                borderColor: '#ffd591',
                                                                                background: '#fff',
                                                                                borderRadius: '5px',
                                                                                transition: 'all 0.3s ease',
                                                                                boxShadow: '0 1px 2px rgba(250, 173, 20, 0.1)'
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.currentTarget.style.background = '#fffbe6';
                                                                                e.currentTarget.style.borderColor = '#ffd591';
                                                                                e.currentTarget.style.transform = 'translateY(-1px)';
                                                                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(250, 173, 20, 0.2)';
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.currentTarget.style.background = '#fff';
                                                                                e.currentTarget.style.borderColor = '#ffd591';
                                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                                                e.currentTarget.style.boxShadow = '0 1px 2px rgba(250, 173, 20, 0.1)';
                                                                            }}
                                                                        >
                                                                            {formatCurrency(suggestion)}
                                                                        </Button>
                                                                    ))}
                                                                </Space>
                                                            </>
                                                        )}
                                                    </div>
                                                </Space>
                                            </div>
                                        );
                                    }

                                    // Show valid increment suggestions (common multiples)
                                    const validSuggestions = [
                                        increment * 1,
                                        increment * 2,
                                        increment * 5,
                                        increment * 10
                                    ].filter(sug => sug !== enteredValue); // Don't show the current value

                                    return (
                                        <div>
                                            <div style={{
                                                marginTop: 6,
                                                padding: '8px 12px',
                                                background: '#f6ffed',
                                                border: '1px solid #b7eb8f',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                color: '#52c41a',
                                                marginBottom: validSuggestions.length > 0 ? 8 : 0
                                            }}>
                                                ✓ Valid increment
                                            </div>
                                            {validSuggestions.length > 0 && (
                                                <div style={{
                                                    marginTop: 6,
                                                    padding: '8px 12px',
                                                    background: '#f0f9ff',
                                                    border: '1px solid #91d5ff',
                                                    borderRadius: '4px',
                                                    fontSize: '11px'
                                                }}>
                                                    <div style={{ color: '#1890ff', marginBottom: '6px', fontWeight: 600 }}>
                                                        💡 Quick select:
                                                    </div>
                                                    <Space size="small" wrap style={{ width: '100%' }}>
                                                        {validSuggestions.map((suggestion, idx) => (
                                                            <Button
                                                                key={idx}
                                                                size="small"
                                                                type="default"
                                                                onClick={() => {
                                                                    setAutoBidAmount(suggestion.toString());
                                                                    setBidError(null);
                                                                }}
                                                                style={{
                                                                    padding: '3px 10px',
                                                                    height: 'auto',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    color: '#1890ff',
                                                                    borderColor: '#91d5ff',
                                                                    background: '#fff',
                                                                    borderRadius: '5px',
                                                                    transition: 'all 0.3s ease',
                                                                    boxShadow: '0 1px 2px rgba(24, 144, 255, 0.1)'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.background = '#e6f7ff';
                                                                    e.currentTarget.style.borderColor = '#40a9ff';
                                                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(24, 144, 255, 0.2)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.background = '#fff';
                                                                    e.currentTarget.style.borderColor = '#91d5ff';
                                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                                    e.currentTarget.style.boxShadow = '0 1px 2px rgba(24, 144, 255, 0.1)';
                                                                }}
                                                            >
                                                                {formatCurrency(suggestion)}
                                                            </Button>
                                                        ))}
                                                    </Space>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>

                            <div>
                                <Text style={{
                                    display: 'block',
                                    marginBottom: 6,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#595959'
                                }}>
                                    Maximum Bid
                                </Text>
                                <Input
                                    type="number"
                                    min={getAutoBidLot() ? (getAutoBidLot().current_price || getAutoBidLot().starting_price) + parseInt(displayIncrement || 0) : 1}
                                    placeholder="e.g., 10000"
                                    value={displayMaxAmount}
                                    onChange={e => setAutoBidMaxAmount(e.target.value)}
                                    style={{ width: '100%', height: '36px', fontSize: '14px' }}
                                    disabled={hasAutoBidForThisLot || isAutoBidDisabled}
                                    prefix="PKR"
                                />
                                <div style={{
                                    marginTop: 4,
                                    fontSize: '10px',
                                    color: '#8c8c8c',
                                    padding: '4px 8px',
                                    background: '#f5f5f5',
                                    borderRadius: '3px'
                                }}>
                                    Your maximum spending limit for this lot
                                </div>
                            </div>

                            {!hasAutoBidForThisLot ? (
                                <Space style={{ width: '100%' }} size="small">
                                    <Button
                                        type="primary"
                                        loading={bidding}
                                        onClick={handleAutoBid}
                                        disabled={isAutoBidDisabled || !autoBidAmount || !autoBidMaxAmount || !isIncrementValid}
                                        style={{
                                            flex: 1,
                                            height: '38px',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            borderRadius: '6px',
                                            marginTop: 4
                                        }}
                                    >
                                        {bidding ? 'Starting Max-Bid...' : '🚀 Start Max-Bid'}
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            setShowAutoBidForm(false);
                                            setAutoBidAmount('');
                                            setAutoBidMaxAmount('');
                                        }}
                                        style={{
                                            height: '38px',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Space>
                            ) : (
                                <div>
                                    <Button
                                        type="primary"
                                        danger
                                        onClick={() => {
                                            if (autoBidLot) {
                                                handleStopAutoBid(autoBidLot.id);
                                            }
                                        }}
                                        style={{
                                            width: '100%',
                                            marginBottom: 8,
                                            height: '38px',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            borderRadius: '6px',
                                            marginTop: 4
                                        }}
                                    >
                                        ⏹ Stop Max-Bid
                                    </Button>
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: '11px',
                                        color: '#52c41a',
                                        backgroundColor: '#f6ffed',
                                        padding: '6px 10px',
                                        borderRadius: '4px',
                                        border: '1px solid #b7eb8f',
                                        fontWeight: 500
                                    }}>
                                        ✓ Active on Lot #{autoBidLot?.lot_number} - monitoring for outbids
                                    </div>
                                </div>
                            )}
                        </Space>
                    </div>
                )}
            </div>
        );
    };

    // Update the updateSidebarCounts function
    const updateSidebarCounts = (updatedLots) => {
        const isAuctionOwner = currentUser?.id === auction?.user_id;

        // Calculate actively bidding count for regular users (not auction owner)
        const activelyBiddingCount = isAuctionOwner
            ? 0 // Auction owners don't see this filter
            : updatedLots.filter(l => {
                if (l.status !== 'active') return false;
                if (!currentUser?.id) return false;

                // Quick check: if user is the last bidder, they definitely have bid
                if (l.last_bid_user_id && Number(l.last_bid_user_id) === Number(currentUser.id)) {
                    return true;
                }

                // Primary check: has_bid property from backend (if available)
                if (l.has_bid === true) return true;

                // Check bid history cache for this lot
                const cachedBids = bidHistoryCache.get(l.id);
                if (cachedBids && Array.isArray(cachedBids) && cachedBids.length > 0) {
                    const userHasBid = cachedBids.some(bid => {
                        const bidUserId = bid.user?.id || bid.user_id;
                        return bidUserId && Number(bidUserId) === Number(currentUser.id);
                    });
                    if (userHasBid) return true;
                }

                // Fallback: check if user has any bids in the bids array (if loaded)
                if (l.bids && Array.isArray(l.bids) && l.bids.length > 0) {
                    const userHasBid = l.bids.some(bid => {
                        const bidUserId = bid.user?.id || bid.user_id;
                        return bidUserId && Number(bidUserId) === Number(currentUser.id);
                    });
                    if (userHasBid) return true;
                }

                return false;
            }).length;

        const counts = {
            total: updatedLots.length,
            favorite: updatedLots.filter(l => l.is_favorite).length,
            held: updatedLots.filter(l => l.is_held).length,
            lost: updatedLots.filter(l => l.is_lost).length,
            sold: updatedLots.filter(l => l.status === 'closed').length,
            cancelled: updatedLots.filter(l => l.status === 'cancelled').length,
            timeout: updatedLots.filter(l => l.status === 'timeout').length,
            actively_bidding: activelyBiddingCount
        };

        setSidebarCounts(counts);
    };

    // Render horizontal scrollable menu for mobile/tablet
    // Function to check scroll position and update arrow visibility
    const checkScrollPosition = useCallback(() => {
        if (horizontalMenuRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = horizontalMenuRef.current;
            setShowLeftArrow(scrollLeft > 0);
            setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
        }
    }, []);

    // Scroll handlers
    const scrollLeft = () => {
        if (horizontalMenuRef.current) {
            horizontalMenuRef.current.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (horizontalMenuRef.current) {
            horizontalMenuRef.current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    // Memoize scrollToDetails to prevent LotCard re-renders
    const scrollToDetails = useCallback(() => {
        if (detailPanelRef.current) {
            detailPanelRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Show the "Back to Lot" button after scrolling to details
            setTimeout(() => {
                setShowScrollToLot(true);
            }, 500); // Wait for scroll animation to complete
        }
    }, []);

    // Scroll back to selected lot function
    const scrollToSelectedLot = () => {
        if (selectedLotRef.current) {
            selectedLotRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Hide the button after scrolling back to the lot
            setTimeout(() => {
                setShowScrollToLot(false);
            }, 500);
        }
    };

    // Effect to check scroll position on mount and resize
    useEffect(() => {
        // Delay to ensure DOM is ready
        const timer = setTimeout(() => {
            checkScrollPosition();
        }, 100);

        const handleResize = () => {
            setIsTabletOrMobile(window.innerWidth <= 991);
            setTimeout(checkScrollPosition, 100);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', handleResize);
        };
    }, [checkScrollPosition, sidebarFilter, sidebarCounts]); // Re-check when filter or counts change (menu items might change)

    // Effect to track scroll position and show/hide scroll to lot button
    useEffect(() => {
        if (!isTabletOrMobile || !selectedLot) {
            setShowScrollToLot(false);
            return;
        }

        const handleScroll = () => {
            if (!detailPanelRef.current) {
                setShowScrollToLot(false);
                return;
            }

            const detailPanelRect = detailPanelRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Show button when detail panel is visible in viewport
            // (top is less than viewport height and bottom is greater than 0)
            const isDetailPanelInView = detailPanelRect.top < windowHeight && detailPanelRect.bottom > 0;

            setShowScrollToLot(isDetailPanelInView);
        };

        // Use a throttled scroll handler for better performance
        let ticking = false;
        const throttledHandleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', throttledHandleScroll, { passive: true });

        // Check immediately and also after a short delay to catch initial render
        handleScroll();
        const initialCheck = setTimeout(handleScroll, 300);

        return () => {
            window.removeEventListener('scroll', throttledHandleScroll);
            clearTimeout(initialCheck);
        };
    }, [isTabletOrMobile]); // Removed selectedLot dependency - scroll handler doesn't need to re-register on lot change

    const renderHorizontalMenu = () => {
        const menuItems = GetSidebarMenu(currentUser, auction, sidebarCounts);
        return (
            <div style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                width: '100%'
            }}>
                {/* Left Arrow */}
                {showLeftArrow && (
                    <Button
                        type="text"
                        icon={<LeftOutlined />}
                        onClick={scrollLeft}
                        style={{
                            position: 'absolute',
                            left: 0,
                            zIndex: 10,
                            background: 'rgba(255, 255, 255, 0.9)',
                            border: '1px solid #d9d9d9',
                            borderRadius: '50%',
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            padding: 0
                        }}
                    />
                )}

                {/* Scrollable Menu Container */}
                <div
                    ref={horizontalMenuRef}
                    onScroll={checkScrollPosition}
                    style={{
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        whiteSpace: 'nowrap',
                        padding: '0 40px',
                        WebkitOverflowScrolling: 'touch',
                        scrollbarWidth: 'none', // Hide scrollbar for Firefox
                        msOverflowStyle: 'none', // Hide scrollbar for IE and Edge
                        flex: 1
                    }}
                    className="horizontal-menu-scroll"
                >
                    <div style={{
                        display: 'inline-flex',
                        gap: '8px',
                        padding: '4px 0'
                    }}>
                        {menuItems.map(item => (
                            <div
                                key={item.key}
                                onClick={() => {
                                    setShowAutoBidDashboardView(false);
                                    setSidebarFilter(item.key);
                                }}
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '20px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: sidebarFilter === item.key ? '#1890ff' : '#fff',
                                    color: sidebarFilter === item.key ? '#fff' : '#595959',
                                    border: sidebarFilter === item.key ? 'none' : '1px solid #d9d9d9',
                                    transition: 'all 0.3s ease',
                                    whiteSpace: 'nowrap',
                                    minWidth: 'fit-content',
                                    boxShadow: sidebarFilter === item.key ? '0 2px 4px rgba(24, 144, 255, 0.3)' : 'none'
                                }}
                            >
                                {item.icon && <span style={{ fontSize: '14px' }}>{item.icon}</span>}
                                <span style={{
                                    fontSize: '13px',
                                    fontWeight: sidebarFilter === item.key ? 600 : 500
                                }}>
                                    {item.label}
                                </span>
                                <Badge
                                    count={item.count}
                                    size="small"
                                    style={{
                                        backgroundColor: sidebarFilter === item.key ? '#fff' : '#1890ff',
                                        color: sidebarFilter === item.key ? '#1890ff' : '#fff'
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Arrow */}
                {showRightArrow && (
                    <Button
                        type="text"
                        icon={<RightOutlined />}
                        onClick={scrollRight}
                        style={{
                            position: 'absolute',
                            right: 0,
                            zIndex: 10,
                            background: 'rgba(255, 255, 255, 0.9)',
                            border: '1px solid #d9d9d9',
                            borderRadius: '50%',
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            padding: 0
                        }}
                    />
                )}
            </div>
        );
    };

    // Update the renderDesktopMenu function
    const renderDesktopMenu = () => {
        const menuItems = GetSidebarMenu(currentUser, auction, sidebarCounts);
        const isAuctionOwner = currentUser?.id === auction?.user_id;
        return (
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                {/* Logo and Collapse/Expand Button */}
                <div style={{
                    padding: sidebarCollapsed ? '8px 4px' : '12px 8px',
                    borderBottom: '1px solid #d9d9d9',
                    display: 'flex',
                    flexDirection: sidebarCollapsed ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: sidebarCollapsed ? '8px' : '12px',
                    background: '#f0f9ff'
                }}>
                    {/* Logo */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: sidebarCollapsed ? 'center' : 'flex-start',
                        flex: sidebarCollapsed ? 0 : 1
                    }}>
                        <img
                            src={sidebarCollapsed ? "/assets/images/small-logo.jpg" : "/assets/images/logo.png"}
                            alt="MaveshiBids"
                            style={{
                                height: sidebarCollapsed ? '32px' : '40px',
                                width: 'auto',
                                maxWidth: sidebarCollapsed ? '32px' : '120px',
                                objectFit: 'contain',
                                transition: 'all 0.3s ease'
                            }}
                        />
                    </div>

                    {/* Collapse/Expand Button */}
                    <Button
                        type="text"
                        size="small"
                        icon={sidebarCollapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
                        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                        style={{
                            color: '#1890ff',
                            fontSize: sidebarCollapsed ? '18px' : '20px',
                            height: sidebarCollapsed ? '32px' : '36px',
                            width: sidebarCollapsed ? '32px' : '36px',
                            minWidth: sidebarCollapsed ? '32px' : '36px',
                            padding: '0',
                            flexShrink: 0
                        }}
                    />
                </div>

                {/* Content area with gradient background */}
                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'linear-gradient(135deg, rgb(214, 223, 237) 0%, rgb(195, 207, 226) 100%)'
                }}>
                    {/* Menu Content */}
                    {!sidebarCollapsed && (
                        <Menu
                            mode="inline"
                            selectedKeys={[sidebarFilter]}
                            style={{ height: '100%', borderRight: 0, flex: 1, background: 'transparent' }}
                            onClick={({ key }) => {
                                setShowAutoBidDashboardView(false);
                                setSidebarFilter(key);
                            }}
                        >
                            {menuItems.map(item => (
                                <Menu.Item key={item.key} icon={item.icon}>
                                    <span>{item.label}</span>
                                    <Badge count={item.count} style={{ backgroundColor: '#1890ff', marginLeft: 8 }} />
                                </Menu.Item>
                            ))}
                        </Menu>
                    )}

                    {/* Collapsed Menu - Show only icons */}
                    {sidebarCollapsed && (
                        <div style={{ padding: '4px 0', flex: 1 }}>
                            {menuItems.map(item => (
                                <Tooltip key={item.key} title={item.label} placement="right">
                                    <div
                                        onClick={() => setSidebarFilter(item.key)}
                                        style={{
                                            padding: '6px',
                                            margin: '2px 4px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            background: sidebarFilter === item.key ? '#e6f7ff' : 'transparent',
                                            border: sidebarFilter === item.key ? '1px solid #91d5ff' : '1px solid transparent',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {item.icon || <div style={{ width: '16px', height: '16px' }} />}
                                        <Badge
                                            count={item.count}
                                            size="small"
                                            style={{
                                                backgroundColor: '#1890ff',
                                                marginTop: '2px',
                                                fontSize: '9px',
                                                minWidth: '14px',
                                                height: '14px',
                                                lineHeight: '14px'
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            ))}
                        </div>
                    )}

                    {/* Connected Users - Only show when not collapsed AND user is auction owner */}
                    {!sidebarCollapsed && auction && currentUser && currentUser.id === auction.user_id && (
                        <div style={{
                            padding: '12px',
                            borderTop: '1px solid #d9d9d9',
                            background: 'transparent'
                        }}>
                            <div data-tour="online-users">
                                <OnlineUsers
                                    onlineUsers={onlineUsers}
                                    isConnected={isPresenceConnected}
                                    currentUser={currentUser}
                                    auctionOwnerId={auction.user_id}
                                />
                            </div>
                        </div>
                    )}

                    {/* Auction Organizer Section - Show for all users */}
                    {!sidebarCollapsed && auction && (
                        <div
                            data-tour="auction-host"
                            style={{
                                padding: '8px 12px',
                                borderTop: '1px solid #d9d9d9',
                                background: 'transparent'
                            }}>
                            <Card
                                hoverable
                                onClick={() => setOrganizerModalVisible(true)}
                                style={{
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    border: '1px solid #d9d9d9',
                                    background: 'linear-gradient(135deg, #fff 0%, #f0f9ff 100%)',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                }}
                                bodyStyle={{ padding: '6px 10px' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                    <div style={{
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        color: '#1890ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        lineHeight: '1.3'
                                    }}>
                                        {auction.agents && auction.agents.length > 0 ? (
                                            <TeamOutlined style={{ fontSize: '14px' }} />
                                        ) : (
                                            <UserOutlined style={{ fontSize: '14px' }} />
                                        )}
                                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {isAuctionOwner ? 'You are hosting this auction' : 'Auction Host'}
                                        </span>
                                    </div>
                                    <div style={{ color: '#1890ff', fontSize: '10px', flexShrink: 0 }}>
                                        <RightOutlined />
                                    </div>
                                </div>
                            </Card>
                        </div>
                    )}

                    {/* Collapsed: Auction Organizer Icon */}
                    {sidebarCollapsed && auction && (
                        <div style={{
                            padding: '4px 0',
                            borderTop: '1px solid #d9d9d9'
                        }}>
                            <Tooltip title={isAuctionOwner ? "You are organizing this auction" : "Auction Organizer"} placement="right">
                                <div
                                    onClick={() => setOrganizerModalVisible(true)}
                                    style={{
                                        padding: '6px',
                                        margin: '2px 4px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        background: 'transparent',
                                        border: '1px solid transparent',
                                        transition: 'all 0.3s ease',
                                        color: '#1890ff'
                                    }}
                                >
                                    <UserOutlined style={{ fontSize: '18px' }} />
                                </div>
                            </Tooltip>
                        </div>
                    )}

                    {/* Max-Bid Dashboard Button - Fixed at bottom (only for non-owners) */}
                    {!isAuctionOwner && (
                        <>
                            {/* Expanded: Full button */}
                            {!sidebarCollapsed && (
                                <div style={{
                                    padding: '12px',
                                    borderTop: '1px solid #d9d9d9',
                                    background: showAutoBidDashboardView ? '#e6f7ff' : 'transparent',
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 10
                                }}>
                                    <Button
                                        type={showAutoBidDashboardView ? 'primary' : 'default'}
                                        block
                                        icon={<ThunderboltOutlined />}
                                        onClick={() => {
                                            setShowAutoBidDashboardView(!showAutoBidDashboardView);
                                            if (!showAutoBidDashboardView) {
                                                setSidebarFilter('all');
                                            }
                                        }}
                                        data-tour="max-bid-dashboard"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            height: '40px',
                                            fontWeight: 600
                                        }}
                                    >
                                        Max-Bid Dashboard
                                        {activeAutoBids.size > 0 && (
                                            <Badge count={activeAutoBids.size} size="small" style={{ backgroundColor: showAutoBidDashboardView ? '#fff' : '#ff4d4f' }} />
                                        )}
                                    </Button>
                                </div>
                            )}

                            {/* Collapsed: Icon only */}
                            {sidebarCollapsed && (
                                <div style={{
                                    padding: '4px 0',
                                    borderTop: '1px solid #d9d9d9',
                                    background: showAutoBidDashboardView ? '#e6f7ff' : 'transparent',
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 10
                                }}>
                                    <Tooltip title="Max-Bid Dashboard" placement="right">
                                        <div
                                            onClick={() => {
                                                setShowAutoBidDashboardView(!showAutoBidDashboardView);
                                                if (!showAutoBidDashboardView) {
                                                    setSidebarFilter('all');
                                                }
                                            }}
                                            style={{
                                                padding: '6px',
                                                margin: '2px 4px',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                background: showAutoBidDashboardView ? '#1890ff' : 'transparent',
                                                border: showAutoBidDashboardView ? '1px solid #91d5ff' : '1px solid transparent',
                                                transition: 'all 0.3s ease',
                                                color: showAutoBidDashboardView ? '#fff' : '#1890ff'
                                            }}
                                        >
                                            <ThunderboltOutlined style={{ fontSize: '18px' }} />
                                            {activeAutoBids.size > 0 && (
                                                <Badge
                                                    count={activeAutoBids.size}
                                                    size="small"
                                                    style={{
                                                        backgroundColor: showAutoBidDashboardView ? '#fff' : '#ff4d4f',
                                                        color: showAutoBidDashboardView ? '#1890ff' : '#fff',
                                                        marginTop: '2px',
                                                        fontSize: '9px',
                                                        minWidth: '14px',
                                                        height: '14px',
                                                        lineHeight: '14px'
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Tooltip>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    };

    // Update the renderMobileMenu function
    const renderMobileMenu = () => {
        const menuItems = GetSidebarMenu(currentUser, auction, sidebarCounts);
        return (
            <div style={{
                background: '#fff',
                padding: '8px 0',
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                borderBottom: '1px solid #f0f0f0'
            }}>
                <Tabs
                    activeKey={sidebarFilter}
                    onChange={setSidebarFilter}
                    type="card"
                    size="small"
                    tabBarStyle={{ margin: 0 }}
                    items={menuItems.map(item => ({
                        key: item.key,
                        label: (
                            <Space>
                                {item.icon}
                                <span>{item.label}</span>
                                <Badge count={item.count} style={{ backgroundColor: '#1890ff' }} />
                            </Space>
                        )
                    }))}
                />
            </div>
        );
    };

    // Add function to handle outbid notifications
    const handleOutbidNotification = (lotId, newBidAmount, outbidAmount) => {
        // Check for duplicate notification
        if (isDuplicateBidNotification(lotId, newBidAmount, outbidAmount, 'outbid')) {
            return;
        }

        const now = Date.now();
        const lastOutbid = lastOutbidTime[lotId] || 0;

        // Prevent spam notifications (only show once every 3 seconds per lot)
        if (now - lastOutbid < 3000) {
            return;
        }

        setLastOutbidTime(prev => ({ ...prev, [lotId]: now }));

        // Show notification with both amounts
        message.warning(
            `You've been outbid! Your bid: ${formatCurrency(outbidAmount)} → New bid: ${formatCurrency(newBidAmount)}`,
            5
        );

        // Add visual indicator
        console.log('[Visual Debug] Adding outbid notification for lot:', lotId);
        setOutbidNotifications(prev => {
            const newSet = new Set([...prev, lotId]);
            console.log('[Visual Debug] Updated outbidNotifications:', Array.from(newSet));
            return newSet;
        });

        // Remove visual indicator after 5 seconds
        setTimeout(() => {
            setOutbidNotifications(prev => {
                const newSet = new Set(prev);
                newSet.delete(lotId);
                console.log('[Visual Debug] Removed outbid notification for lot:', lotId, 'Remaining:', Array.from(newSet));
                return newSet;
            });
        }, 5000);

        // Play outbid sound
        if (hasInteracted) {
            try {
                const audio = new Audio('/sounds/ding-counter.mp3');
                audio.volume = 0.7;
                audio.play().catch(() => {
                    // Ignore autoplay restrictions
                });
            } catch (error) {
                // Ignore sound errors
            }
        }
    };

    // Add function to handle successful outbid notifications
    const handleSuccessfulOutbidNotification = (lotId, newBidAmount, previousBidAmount) => {
        console.log('[Notification Debug] Attempting successful outbid notification:', {
            lotId,
            newBidAmount,
            previousBidAmount,
            timestamp: new Date().toISOString()
        });

        // Check for duplicate notification
        if (isDuplicateBidNotification(lotId, newBidAmount, previousBidAmount, 'successful')) {
            console.log('[Notification Debug] Skipping duplicate successful outbid notification');
            return;
        }

        console.log('[Notification Debug] Showing successful outbid notification');

        const now = Date.now();
        const lastSuccessfulOutbid = lastSuccessfulOutbidTime[lotId] || 0;

        // Prevent spam notifications (only show once every 3 seconds per lot)
        if (now - lastSuccessfulOutbid < 3000) {
            console.log('[Notification Debug] Skipping due to spam protection');
            return;
        }

        setLastSuccessfulOutbidTime(prev => ({ ...prev, [lotId]: now }));

        // Show success notification
        message.success(
            `You outbid the competition! Previous bid: ${formatCurrency(previousBidAmount)} → Your bid: ${formatCurrency(newBidAmount)}`,
            4
        );

        // Add visual indicator
        console.log('[Visual Debug] Adding successful outbid notification for lot:', lotId);
        setSuccessfulOutbidNotifications(prev => {
            const newSet = new Set([...prev, lotId]);
            console.log('[Visual Debug] Updated successfulOutbidNotifications:', Array.from(newSet));
            return newSet;
        });

        // Remove visual indicator after 4 seconds
        setTimeout(() => {
            setSuccessfulOutbidNotifications(prev => {
                const newSet = new Set(prev);
                newSet.delete(lotId);
                console.log('[Visual Debug] Removed successful outbid notification for lot:', lotId, 'Remaining:', Array.from(newSet));
                return newSet;
            });
        }, 4000);

        // Play success sound
        if (hasInteracted) {
            try {
                const audio = new Audio('/sounds/ding.mp3');
                audio.volume = 0.7;
                audio.play().catch(() => {
                    // Ignore autoplay restrictions
                });
            } catch (error) {
                // Ignore sound errors
            }
        }
    };

    // Add function to handle competition outbid notifications (for other users)
    const handleCompetitionOutbidNotification = (lotId, newBidAmount, previousBidAmount) => {
        console.log('[Notification Debug] Attempting competition outbid notification:', {
            lotId,
            newBidAmount,
            previousBidAmount,
            timestamp: new Date().toISOString()
        });

        // Check for duplicate notification
        if (isDuplicateBidNotification(lotId, newBidAmount, previousBidAmount, 'competition')) {
            console.log('[Notification Debug] Skipping duplicate competition outbid notification');
            return;
        }

        console.log('[Notification Debug] Showing competition outbid notification');

        const now = Date.now();
        const lastCompetitionOutbid = lastCompetitionOutbidTime[lotId] || 0;

        // Prevent spam notifications (only show once every 3 seconds per lot)
        if (now - lastCompetitionOutbid < 3000) {
            console.log('[Notification Debug] Skipping due to spam protection');
            return;
        }

        setLastCompetitionOutbidTime(prev => ({ ...prev, [lotId]: now }));

        // Show competition notification
        message.info(
            `Competition heated up! Previous bid: ${formatCurrency(previousBidAmount)} → New bid: ${formatCurrency(newBidAmount)}`,
            4
        );

        // Add visual indicator
        console.log('[Visual Debug] Adding competition outbid notification for lot:', lotId);
        setCompetitionOutbidNotifications(prev => {
            const newSet = new Set([...prev, lotId]);
            console.log('[Visual Debug] Updated competitionOutbidNotifications:', Array.from(newSet));
            return newSet;
        });

        // Remove visual indicator after 4 seconds
        setTimeout(() => {
            setCompetitionOutbidNotifications(prev => {
                const newSet = new Set(prev);
                newSet.delete(lotId);
                console.log('[Visual Debug] Removed competition outbid notification for lot:', lotId, 'Remaining:', Array.from(newSet));
                return newSet;
            });
        }, 4000);

        // Play competition sound
        if (hasInteracted) {
            try {
                const audio = new Audio('/sounds/ding-counter.mp3');
                audio.volume = 0.5;
                audio.play().catch(() => {
                    // Ignore autoplay restrictions
                });
            } catch (error) {
                // Ignore sound errors
            }
        }
    };

    // Add confetti initialization function
    const particlesInit = useCallback(async (engine) => {
        await loadConfettiPreset(engine);
    }, []);

    // Add function to trigger confetti celebration
    const triggerConfetti = (lotId = null) => {
        console.log('[Confetti Debug] Attempting to trigger confetti for lot:', lotId);

        // If lotId is provided, check if confetti was already triggered for this lot (persisted in localStorage)
        if (lotId && confettiTriggeredLotsRef.current.has(lotId)) {
            console.log('[Confetti Debug] Confetti already triggered for lot:', lotId);
            return;
        }

        // Mark this lot as having triggered confetti
        if (lotId) {
            confettiTriggeredLotsRef.current.add(lotId);
            console.log('[Confetti Debug] Marking lot as confetti triggered:', lotId);

            // Persist to localStorage
            try {
                const lotIds = Array.from(confettiTriggeredLotsRef.current);
                localStorage.setItem('confettiTriggeredLots', JSON.stringify(lotIds));
            } catch (e) {
                console.warn('Error saving confetti tracking to localStorage:', e);
            }
        }

        console.log('[Confetti Debug] Triggering confetti animation');
        setConfettiKey(prev => prev + 1);
        setShowConfetti(true);

        // Hide confetti after 5 seconds
        setTimeout(() => {
            setShowConfetti(false);
        }, 5000);
    };

    // Add function to show success message with duplicate protection
    const showSuccessMessage = (lotId, isWinner, isAuctionOwner, currentPrice) => {
        console.log('[Message Debug] Attempting to show success message for lot:', lotId);

        // Check if success message was already shown for this lot (persisted in localStorage)
        if (successMessageTriggeredLotsRef.current.has(lotId)) {
            console.log('[Message Debug] Success message already shown for lot:', lotId);
            return;
        }

        // Mark this lot as having shown success message
        successMessageTriggeredLotsRef.current.add(lotId);
        console.log('[Message Debug] Marking lot as success message shown:', lotId);

        // Persist to localStorage
        try {
            const lotIds = Array.from(successMessageTriggeredLotsRef.current);
            localStorage.setItem('successMessageTriggeredLots', JSON.stringify(lotIds));
        } catch (e) {
            console.warn('Error saving success message tracking to localStorage:', e);
        }

        // Find the lot to get the lot number
        const lot = lots.find(l => l.id === lotId);
        const lotNumber = lot?.lot_number || 'this lot';

        // Show appropriate success message
        if (isWinner) {
            message.success(`🎉 Congratulations! You won lot #${lotNumber} for ${formatCurrency(currentPrice)}!`, 6);
            console.log('[Message Debug] Showing winner message for lot:', lotId);
        } else if (isAuctionOwner) {
            message.success(`🎉 Lot #${lotNumber} sold for ${formatCurrency(currentPrice)}!`, 6);
            console.log('[Message Debug] Showing auction owner message for lot:', lotId);
        }
    };

    const isAuctionOwner = currentUser?.id === (auction?.user_id ?? prefetchAuctionOwnerId);

    const liveStreamScreenProps = {
        liveStreamUrl,
        liveStreamInput,
        onInputChange: setLiveStreamInput,
        onUpdate: () => handleUpdateLiveStream(),
        onRemove: () => {
            setLiveStreamInput('');
            handleUpdateLiveStream('');
        },
        updating: updatingLiveStream,
        isOwner: isAuctionOwner
    };

    const auctionAlreadyStarted = (() => {
        const startTime = auction?.start_time || prefetchAuctionStartTime;
        if (!startTime) return false;
        return moment().isAfter(moment(startTime));
    })();

    if (loading) {
        return (
            <div className="auction-detail-fullscreen notranslate"
            translate="no" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100%',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                zIndex: 1000
            }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return (
            <div className="auction-detail-fullscreen notranslate"
            translate="no" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                    style={{ maxWidth: '500px' }}
                />
            </div>
        );
    }

    if (!auction) {
        return (
            <div className="auction-detail-fullscreen notranslate"
            translate="no" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Alert
                    message="Not Found"
                    description="The auction you're looking for doesn't exist."
                    type="error"
                    showIcon
                    style={{ maxWidth: '500px' }}
                />
            </div>
        );
    }

    // Show countdown if auction hasn't started yet
    if (!auctionHasStarted && auction.start_time) {
        return (
            <div className="auction-detail-fullscreen notranslate"
            translate="no" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                zIndex: 1000
            }}>
                <AuctionCountdown
                    auction={auction}
                    onCountdownComplete={handleCountdownComplete}
                    {...liveStreamScreenProps}
                />
            </div>
        );
    }

    return (
        <div className="auction-detail-fullscreen notranslate"
            translate="no" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            overflow: 'auto',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            zIndex: 1000
        }}>
            <Row gutter={16} style={{ height: window.innerWidth < 992 ? 'auto' : '100vh', margin: 0, overflow: window.innerWidth < 992 ? 'visible' : 'hidden', maxWidth: '100%', boxSizing: 'border-box', alignItems: 'stretch' }} onClick={handleUserInteraction}>
                <style>{styles}</style>

                {/* Reserve Met Animated Notification - Only for Auction Owner */}
                {reserveMetNotification && currentUser?.id === auction?.user_id && (
                    <div
                        style={{
                            position: 'fixed',
                            top: '20px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 10000,
                            animation: 'reserveMetSlideIn 0.5s ease-out',
                            maxWidth: window.innerWidth < 576 ? '90%' : '500px',
                            width: '100%'
                        }}
                        onAnimationEnd={(e) => {
                            if (e.animationName === 'reserveMetSlideOut') {
                                setReserveMetNotification(null);
                            }
                        }}
                    >
                        <Alert
                            message={
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <TrophyOutlined style={{ fontSize: '32px', color: '#52c41a', animation: 'pulse 1s ease-in-out infinite' }} />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#52c41a', marginBottom: '4px' }}>
                                            🎉 Reserve Price Met!
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#595959' }}>
                                            Lot #{reserveMetNotification.lotNumber}: {reserveMetNotification.lotTitle}
                                        </div>
                                        <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1890ff', marginTop: '4px' }}>
                                            Current Price: {formatCurrency(reserveMetNotification.currentPrice)}
                                        </div>
                                    </div>
                                    <Button
                                        type="text"
                                        icon={<CloseOutlined />}
                                        onClick={() => setReserveMetNotification(null)}
                                        style={{ color: '#8c8c8c' }}
                                    />
                                </div>
                            }
                            type="success"
                            showIcon={false}
                            closable={false}
                            style={{
                                background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
                                border: '3px solid #52c41a',
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(82, 196, 26, 0.4)',
                                padding: '16px 20px'
                            }}
                        />
                    </div>
                )}

                {/* Confetti Celebration */}
                {showConfetti && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 9999,
                        pointerEvents: 'none'
                    }}>
                        <Particles
                            key={confettiKey}
                            id="confetti"
                            init={particlesInit}
                            options={{
                                preset: "confetti",
                                particles: {
                                    number: {
                                        value: 50
                                    },
                                    color: {
                                        value: ["#ff0000", "#00ff00", "#0000ff", "#ffff00", "#ff00ff", "#00ffff"]
                                    },
                                    shape: {
                                        type: "circle"
                                    },
                                    opacity: {
                                        value: 1,
                                        animation: {
                                            enable: true,
                                            minimumValue: 0,
                                            speed: 2,
                                            startValue: "max",
                                            destroy: "min"
                                        }
                                    },
                                    size: {
                                        value: 2,
                                        random: {
                                            enable: true,
                                            minimumValue: 2
                                        }
                                    },
                                    move: {
                                        direction: "bottom",
                                        enable: true,
                                        outModes: {
                                            default: "out"
                                        },
                                        random: false,
                                        speed: 3,
                                        straight: false
                                    }
                                },
                                interactivity: {
                                    detectsOn: "canvas",
                                    events: {
                                        resize: true
                                    }
                                },
                                detectRetina: true,
                                emitters: {
                                    direction: "top",
                                    life: {
                                        count: 0,
                                        duration: 0.1,
                                        delay: 0.1
                                    },
                                    rate: {
                                        delay: 0.15,
                                        quantity: 1
                                    },
                                    size: {
                                        width: 100,
                                        height: 10
                                    },
                                    position: {
                                        y: 100,
                                        x: 50
                                    }
                                }
                            }}
                        />
                    </div>
                )}

                {/* Horizontal Scrollable Menu - Mobile/Tablet */}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={0}
                    className="horizontal-menu-mobile"
                    style={{
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        padding: '8px 0',
                        borderBottom: '1px solid #d9d9d9',
                        marginBottom: '8px'
                    }}
                >
                    {renderHorizontalMenu()}
                </Col>

                {/* Desktop Menu - Vertical Sidebar - Hidden on Mobile/Tablet */}
                <Col
                    xs={0}
                    sm={0}
                    md={0}
                    lg={sidebarCollapsed ? 1 : 4}
                    xl={sidebarCollapsed ? 1 : 4}
                    className="sidebar-desktop"
                    data-tour="sidebar-menu"
                    style={{
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        padding: 0,
                        transition: 'all 0.3s ease',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {renderDesktopMenu()}
                </Col>

                {/* Main Content */}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={sidebarCollapsed ? 17 : 12}
                    xl={sidebarCollapsed ? 17 : 12}
                    className="main-content-section"
                    style={{
                        padding: 0,
                        transition: 'all 0.3s ease',
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        overflowX: 'hidden',
                        overflowY: 'hidden', // Remove scroll from main container
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        height: window.innerWidth < 992 ? 'auto' : '100vh',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Auction Title Header */}
                    <div
                        className="auction-header-mobile"
                        data-tour="auction-header"
                        style={{
                            background: '#fafafa',
                            padding: '6px 12px',
                            marginBottom: '18px',
                            borderRadius: '6px',
                            borderBottom: '1px solid #f0f0f0',
                            position: window.innerWidth < 992 ? 'fixed' : 'sticky',
                            top: 0,
                            left: 0,
                            right: 0,
                            width: window.innerWidth < 992 ? '100%' : 'auto',
                            zIndex: 100,
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            flexShrink: 0 // Prevent header from shrinking
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                        }}>
                            <div style={{ width: '100%' }}>
                                <Title level={5} className="auction-title-mobile" style={{
                                    color: '#262626',
                                    margin: 0,
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    lineHeight: '1.2',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    {currentUser?.favorite_auctions?.includes(auction?.id) && (
                                        <HeartFilled style={{
                                            color: '#ff4d4f',
                                            fontSize: '14px',
                                            marginRight: '2px'
                                        }} />
                                    )}
                                    {auction?.video_url && (
                                        <PlayCircleOutlined
                                            style={{
                                                color: '#1890ff',
                                                fontSize: '14px',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setAuctionVideoModalVisible(true);
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#40a9ff';
                                                e.target.style.transform = 'scale(1.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = '#1890ff';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        />
                                    )}
                                    {auction?.title}
                                </Title>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#8c8c8c',
                                    marginTop: '1px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}>
                                    {/* <ClockCircleOutlined style={{ fontSize: '10px' }} />
                                <span>Live</span> */}
                                    {auction?.is_private && (
                                        <>
                                            <span>•</span>
                                            <LockOutlined style={{ fontSize: '10px' }} />
                                            <span>Private</span>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                width: '100%',
                                justifyContent: 'flex-start',
                                overflowX: window.innerWidth < 992 ? 'auto' : 'visible',
                                overflowY: 'hidden',
                                WebkitOverflowScrolling: 'touch',
                                scrollbarWidth: 'thin',
                                msOverflowStyle: 'auto',
                                paddingRight: window.innerWidth < 992 ? '12px' : '0',
                                flexShrink: 0,
                                flexWrap: 'nowrap',
                                position: 'relative'
                            }}
                                className="toolbar-scrollable"
                            >
                                <div style={{
                                    background: '#f5f5f5',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: '500',
                                    color: '#595959'
                                }}>
                                    {getFilteredAndSortedLots().length} Lots
                                </div>

                                {/* Sort Selector */}
                                {!sidebarCollapsed && (
                                    <Select
                                        size="small"
                                        value={sortBy}
                                        onChange={setSortBy}
                                        data-tour="sort-selector"
                                        style={{
                                            width: 120,
                                            fontSize: '11px'
                                        }}
                                        options={[
                                            { label: 'Lot Number', value: 'lot_number' },
                                            { label: 'Price', value: 'price' },
                                            { label: 'Time Remaining', value: 'time_remaining' },
                                            { label: 'Favorites', value: 'favorites' }
                                        ]}
                                    />
                                )}

                                {/* Layout Switcher */}
                                <div
                                    data-tour="layout-switcher"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        background: '#f5f5f5',
                                        padding: '2px',
                                        borderRadius: '8px'
                                    }}>
                                    <Button
                                        type={lotLayout === 'grid' ? 'primary' : 'text'}
                                        size="small"
                                        icon={<div style={{ width: '12px', height: '12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1px' }}>
                                            <div style={{ background: lotLayout === 'grid' ? '#fff' : '#8c8c8c', borderRadius: '1px' }}></div>
                                            <div style={{ background: lotLayout === 'grid' ? '#fff' : '#8c8c8c', borderRadius: '1px' }}></div>
                                            <div style={{ background: lotLayout === 'grid' ? '#fff' : '#8c8c8c', borderRadius: '1px' }}></div>
                                            <div style={{ background: lotLayout === 'grid' ? '#fff' : '#8c8c8c', borderRadius: '1px' }}></div>
                                        </div>}
                                        onClick={() => setLotLayout('grid')}
                                        data-tour="grid-view-button"
                                        style={{
                                            padding: '2px 6px',
                                            height: 'auto',
                                            minWidth: 'auto'
                                        }}
                                    />
                                    <Button
                                        type={lotLayout === 'list' ? 'primary' : 'text'}
                                        size="small"
                                        icon={<div style={{ width: '12px', height: '12px', display: 'flex', flexDirection: 'column', gap: '1px' }}>
                                            <div style={{ background: lotLayout === 'list' ? '#fff' : '#8c8c8c', height: '2px', borderRadius: '1px' }}></div>
                                            <div style={{ background: lotLayout === 'list' ? '#fff' : '#8c8c8c', height: '2px', borderRadius: '1px' }}></div>
                                            <div style={{ background: lotLayout === 'list' ? '#fff' : '#8c8c8c', height: '2px', borderRadius: '1px' }}></div>
                                        </div>}
                                        onClick={() => setLotLayout('list')}
                                        data-tour="list-view-button"
                                        style={{
                                            padding: '2px 6px',
                                            height: 'auto',
                                            minWidth: 'auto'
                                        }}
                                    />
                                </div>

                                <Tooltip title="Advanced Search & Filter">
                                    <Button
                                        type="text"
                                        size="small"
                                        icon={<SearchOutlined />}
                                        onClick={() => setSearchModalVisible(true)}
                                        data-tour="search-filter"
                                        style={{
                                            padding: '2px 6px',
                                            height: 'auto',
                                            fontSize: '12px',
                                            color: '#1890ff'
                                        }}
                                    />
                                </Tooltip>

                                <Tooltip title={isFullscreen ? "Exit Fullscreen (F11)" : "Enter Fullscreen (F11)"}>
                                    <Button
                                        type="text"
                                        size="small"
                                        icon={isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                                        onClick={toggleFullscreen}
                                        data-tour="fullscreen-button"
                                        style={{
                                            padding: '2px 6px',
                                            height: 'auto',
                                            fontSize: '12px',
                                            color: '#1890ff'
                                        }}
                                    />
                                </Tooltip>

                                <Tooltip title="Bid Notifications">
                                    <Button
                                        type="text"
                                        size="small"
                                        icon={<BellOutlined />}
                                        onClick={() => setReminderDrawerVisible(true)}
                                        data-tour="notifications"
                                        style={{
                                            padding: '2px 6px',
                                            height: 'auto',
                                            fontSize: '12px',
                                            color: '#1890ff'
                                        }}
                                    >
                                        {(() => {
                                            // Use total bids from bidActivityData (fetched from API) if available
                                            // Otherwise fall back to calculating from cache
                                            const totalBids = bidActivityData.length > 0
                                                ? bidActivityData.length
                                                : (() => {
                                                    let total = 0;
                                                    bidHistoryCache.forEach((bids) => {
                                                        if (Array.isArray(bids)) {
                                                            total += bids.length;
                                                        }
                                                    });
                                                    return total;
                                                })();

                                            // Only show badge if drawer is closed AND there are bids
                                            return !reminderDrawerVisible && totalBids > 0 ? (
                                                <Badge
                                                    count={totalBids}
                                                    size="small"
                                                />
                                            ) : null;
                                        })()}
                                    </Button>
                                </Tooltip>

                                {/* Owner-only buttons */}
                                {auction?.user_id === currentUser?.id && (
                                    <>
                                        <Tooltip title="Broadcast Announcement">
                                            <Button
                                                type="text"
                                                size="small"
                                                icon={<SoundOutlined />}
                                                onClick={() => setAnnouncementModalVisible(true)}
                                                data-tour="announcement"
                                                style={{
                                                    padding: '2px 6px',
                                                    height: 'auto',
                                                    fontSize: '12px',
                                                    color: '#faad14'
                                                }}
                                            >
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Play Sound">
                                            <Button
                                                type="text"
                                                size="small"
                                                icon={<PlayCircleOutlined />}
                                                onClick={() => setSoundModalVisible(true)}
                                                data-tour="broadcast-sound"
                                                style={{
                                                    padding: '2px 6px',
                                                    height: 'auto',
                                                    fontSize: '12px',
                                                    color: '#52c41a'
                                                }}
                                            >
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="View Statistics">
                                            <Button
                                                type="text"
                                                size="small"
                                                icon={<BarChartOutlined />}
                                                data-tour="statistics"
                                                onClick={async () => {
                                                    setStatisticsModalVisible(true);
                                                    setLoadingStatistics(true);
                                                    try {
                                                        const response = await auctionService.getAuctionStatistics(auction.slug);
                                                        setStatistics(response.data);
                                                    } catch (error) {
                                                        console.error('Error loading statistics:', error);
                                                        message.error('Failed to load statistics');
                                                        setStatisticsModalVisible(false);
                                                    } finally {
                                                        setLoadingStatistics(false);
                                                    }
                                                }}
                                                style={{
                                                    padding: '2px 6px',
                                                    height: 'auto',
                                                    fontSize: '12px',
                                                    color: '#722ed1'
                                                }}
                                            >
                                            </Button>
                                        </Tooltip>
                                    </>
                                )}

                                {/* Control Panel - Second to last */}
                                {auction?.user_id === currentUser?.id && (
                                    <Tooltip title="Control Panel">
                                        <Button
                                            type="text"
                                            size="small"
                                            icon={<SettingOutlined />}
                                            onClick={() => setControlPanelVisible(true)}
                                            data-tour="control-panel"
                                            style={{
                                                padding: '2px 6px',
                                                height: 'auto',
                                                fontSize: '12px',
                                                color: '#722ed1'
                                            }}
                                        >
                                        </Button>
                                    </Tooltip>
                                )}

                                {/* Help - Last icon */}
                                <Button
                                    type="text"
                                    size="small"
                                    icon={<QuestionCircleOutlined />}
                                    onClick={() => setHelpModalVisible(true)}
                                    style={{
                                        padding: '2px 6px',
                                        height: 'auto',
                                        fontSize: '12px',
                                        color: '#1890ff'
                                    }}
                                >
                                    Help
                                </Button>

                                {comparisonLots.length > 0 && (
                                    <Tooltip title={`Compare ${comparisonLots.length} lot(s)`}>
                                        <Badge count={comparisonLots.length} size="small">
                                            <Button
                                                type="primary"
                                                size="small"
                                                icon={<SwapOutlined />}
                                                onClick={() => setComparisonModalVisible(true)}
                                                data-tour="compare-lots"
                                                style={{
                                                    padding: '2px 12px',
                                                    height: 'auto',
                                                    fontSize: '12px',
                                                    marginLeft: '8px'
                                                }}
                                            >
                                                Compare
                                            </Button>
                                        </Badge>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Scrollable Lots Container - Only this area scrolls */}
                    <div
                        style={{
                            flex: 1,
                            overflowY: window.innerWidth < 992 ? 'hidden' : 'auto',
                            overflowX: 'hidden',
                            minHeight: 0, // Important for flex children to allow scrolling
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {console.log('[Visual Debug] Rendering lots with notifications:', {
                            outbidNotifications: Array.from(outbidNotifications),
                            successfulOutbidNotifications: Array.from(successfulOutbidNotifications),
                            competitionOutbidNotifications: Array.from(competitionOutbidNotifications),
                            totalLots: getFilteredAndSortedLots().length
                        })}

                        {/* Max-Bid Dashboard View */}
                        {showAutoBidDashboardView ? (
                            <div style={{
                                padding: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                minHeight: 'calc(100vh - 200px)',
                                overflowX: 'hidden',
                                maxWidth: '100%',
                                boxSizing: 'border-box'
                            }}>
                                {activeAutoBids.size === 0 ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flex: 1,
                                        minHeight: '400px'
                                    }}>
                                        <Empty
                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                            description={
                                                <div>
                                                    <div style={{ fontSize: '16px', fontWeight: 600, color: '#8c8c8c', marginBottom: '8px' }}>
                                                        No Active Max-Bids
                                                    </div>
                                                    <div style={{ fontSize: '14px', color: '#bfbfbf' }}>
                                                        Start a max-bid on any lot to see it here
                                                    </div>
                                                </div>
                                            }
                                            style={{ padding: '60px 20px' }}
                                        />
                                    </div>
                                ) : (
                                    <div>
                                        <div style={{
                                            marginBottom: 20,
                                            padding: '16px 20px',
                                            background: 'linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%)',
                                            borderRadius: '10px',
                                            border: '2px solid #ffd591',
                                            boxShadow: '0 2px 8px rgba(250, 173, 20, 0.15)',
                                            overflowX: 'hidden',
                                            maxWidth: '100%',
                                            boxSizing: 'border-box'
                                        }}>
                                            <Row gutter={16} style={{ margin: 0 }}>
                                                <Col span={8}>
                                                    <Statistic
                                                        title="Active Auto-Bids"
                                                        value={activeAutoBids.size}
                                                        valueStyle={{ color: '#faad14', fontSize: '24px', fontWeight: 700 }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <Statistic
                                                        title="Total Max Budget"
                                                        value={formatCurrency(Array.from(activeAutoBids.values()).reduce((sum, bid) => sum + bid.maxAmount, 0))}
                                                        valueStyle={{ color: '#ff4d4f', fontSize: '18px', fontWeight: 700 }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <Statistic
                                                        title="Total Increment"
                                                        value={formatCurrency(Array.from(activeAutoBids.values()).reduce((sum, bid) => sum + bid.increment, 0))}
                                                        valueStyle={{ color: '#52c41a', fontSize: '18px', fontWeight: 700 }}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>

                                        <div style={{ overflowX: 'hidden', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <List
                                                dataSource={Array.from(activeAutoBids.entries())}
                                                renderItem={([lotId, autoBidInfo]) => {
                                                    const lot = lots.find(l => l.id === lotId);
                                                    const isWinning = lot?.last_bid_user_id === currentUser?.id;
                                                    const timeRemaining = allLotsTimeRemaining[lotId] ?? lot?.time_remaining;
                                                    const status = lot?.status;
                                                    const isClosed = status === 'closed' || status === 'cancelled';

                                                    return (
                                                        <List.Item
                                                            style={{
                                                                padding: '16px',
                                                                marginBottom: '12px',
                                                                background: isWinning
                                                                    ? 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)'
                                                                    : 'linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%)',
                                                                borderRadius: '8px',
                                                                border: isWinning
                                                                    ? '2px solid #52c41a'
                                                                    : '1px solid #ffd591',
                                                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                                                            }}
                                                        >
                                                            <div style={{ width: '100%' }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                                                                    <div style={{ flex: 1 }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                                                            <Tag color={isWinning ? 'green' : 'orange'} style={{ margin: 0, fontSize: '11px', padding: '2px 8px', fontWeight: 600 }}>
                                                                                {isWinning ? '⚡ Winning' : '⏸ Active'}
                                                                            </Tag>
                                                                            <div style={{ fontSize: '16px', fontWeight: 700, color: '#262626' }}>
                                                                                Lot #{autoBidInfo.lotNumber}: {autoBidInfo.lotName}
                                                                            </div>
                                                                        </div>
                                                                        {isClosed && (
                                                                            <Tag color="red" style={{ marginTop: '4px', fontSize: '11px' }}>
                                                                                Lot Closed
                                                                            </Tag>
                                                                        )}
                                                                    </div>
                                                                    <div style={{ textAlign: 'right' }}>
                                                                        {timeRemaining !== null && timeRemaining !== undefined && !isClosed && timeRemaining > 0 && (
                                                                            <div style={{
                                                                                fontSize: '13px',
                                                                                color: '#1890ff',
                                                                                marginBottom: '4px',
                                                                                fontWeight: 600,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '4px'
                                                                            }}>
                                                                                <span>⏱️</span>
                                                                                <span>{Math.floor(timeRemaining / 60)}:{(timeRemaining % 60).toString().padStart(2, '0')}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <Row gutter={16} style={{ marginBottom: '12px' }}>
                                                                    <Col span={8}>
                                                                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '4px' }}>Increment</div>
                                                                        <div style={{ fontSize: '16px', fontWeight: 700, color: '#1890ff' }}>
                                                                            {formatCurrency(autoBidInfo.increment)}
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '4px' }}>Max Amount</div>
                                                                        <div style={{ fontSize: '16px', fontWeight: 700, color: '#ff4d4f' }}>
                                                                            {formatCurrency(autoBidInfo.maxAmount)}
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '4px' }}>Current Price</div>
                                                                        <div style={{ fontSize: '16px', fontWeight: 700, color: '#52c41a' }}>
                                                                            {lot ? formatCurrency(lot.current_price || lot.starting_price) : 'N/A'}
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                                                    <Button
                                                                        size="small"
                                                                        danger
                                                                        onClick={() => handleStopAutoBid(lotId)}
                                                                    >
                                                                        Stop
                                                                    </Button>
                                                                    <Button
                                                                        size="small"
                                                                        type="primary"
                                                                        onClick={() => {
                                                                            const lot = lots.find(l => l.id === lotId);
                                                                            if (lot) {
                                                                                setSelectedLot(lot);
                                                                                setShowAutoBidDashboardView(false);
                                                                            }
                                                                        }}
                                                                    >
                                                                        View Lot
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </List.Item>
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : getFilteredAndSortedLots().length > 0 ? (
                            <div style={{ paddingLeft: sidebarCollapsed ? '8px' : '11px', paddingRight: sidebarCollapsed ? '8px' : '11px' }} data-tour="lot-cards">
                                {lotLayout === 'grid' && (
                                    <Row gutter={[8, 16]}>
                                        {getFilteredAndSortedLots().map(lot => (
                                            <Col
                                                xs={12}
                                                sm={12}
                                                md={8}
                                                lg={6}
                                                key={lot.id}
                                                className="lot-container"
                                                ref={selectedLot?.id === lot.id ? (el) => { selectedLotRef.current = el; } : null}
                                            >
                                                <MemoizedLotCard
                                                    lot={lot}
                                                    isSelected={selectedLot?.id === lot.id}
                                                    onSelect={setSelectedLot}
                                                    onFavorite={toggleFavorite}
                                                    isFavorite={isLotFavorite(lot.id)}
                                                    isAvailable={isLotAvailableForBidding(lot)}
                                                    currentUser={currentUser}
                                                    auctionOwnerId={auction?.user_id}
                                                    renderTimer={renderLotTimer}
                                                    statusLoadingLots={statusLoadingLots}
                                                    timeoutLoadingLots={timeoutLoadingLots}
                                                    outbidNotifications={outbidNotifications}
                                                    successfulOutbidNotifications={successfulOutbidNotifications}
                                                    competitionOutbidNotifications={competitionOutbidNotifications}
                                                    newBidLots={newBidLots}
                                                    timeRemaining={allLotsTimeRemaining[lot.id]}
                                                    auction={auction}
                                                    bidReminders={bidReminders}
                                                    setReminderModalVisible={setReminderModalVisible}
                                                    isInComparison={comparisonLotsSet.has(lot.id)}
                                                    onToggleComparison={toggleComparison}
                                                    scrollToDetails={scrollToDetails}
                                                    isTabletOrMobile={isTabletOrMobile}
                                                    activeAutoBids={activeAutoBids}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                )}

                                {lotLayout === 'list' && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        {getFilteredAndSortedLots().map(lot => {
                                            const isAvailable = isLotAvailableForBidding(lot);
                                            const isWaiting = isSequential && !isAvailable && lot.status === 'active';

                                            const isCancelled = isLotCancelled(lot);
                                            return (
                                                <div key={lot.id} style={{
                                                    background: isCancelled ? '#f9f0ff' :
                                                        lot.status === 'timeout' ? '#fff7e6' :
                                                            lot.status === 'closed' ? (
                                                                currentUser?.id === auction?.user_id ? '#e6f7ff' :
                                                                    lot.last_bid_user_id === currentUser?.id ? '#f6ffed' :
                                                                        lot.last_bid_user_id ? '#fff1f0' : '#fffbe6'
                                                            ) :
                                                                currentUser && lot.last_bid_user_id === currentUser.id ? '#e6f7ff' :
                                                                    currentUser && lot.last_bid_user_id ? '#fffbe6' :
                                                                        isWaiting ? '#f5f5f5' : '#fff',
                                                    borderRadius: '4px',
                                                    padding: '8px',
                                                    border: selectedLot?.id === lot.id ? '2px solid #1890ff' :
                                                        isCancelled ? '2px solid #722ed1' :
                                                            lot.status === 'timeout' ? '2px solid #fa8c16' :
                                                                lot.status === 'closed' ? (
                                                                    currentUser?.id === auction?.user_id ? '2px solid #1890ff' :
                                                                        lot.last_bid_user_id === currentUser?.id ? '2px solid #52c41a' :
                                                                            lot.last_bid_user_id ? '2px solid #ff4d4f' : '2px solid #faad14'
                                                                ) :
                                                                    currentUser && lot.last_bid_user_id === currentUser.id ? '2px solid #1890ff' :
                                                                        currentUser && lot.last_bid_user_id ? '2px solid #faad14' :
                                                                            isWaiting ? '1px solid #d9d9d9' : '1px solid #f0f0f0',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease',
                                                    opacity: (isCancelled || lot.status === 'timeout' || lot.status === 'closed' || isWaiting) ? 0.8 : 1,
                                                    animation: newBidLots.has(lot.id) ? 'newBidHighlight 2s ease-in-out infinite' : undefined
                                                }}
                                                    className="notranslate"
                                                    translate="no"
                                                    onClick={() => setSelectedLot(lot)}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                                                                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#1890ff' }}>
                                                                    Lot #{lot.lot_number}
                                                                </span>
                                                                <Tag color={lot.status === 'active' ? (isWaiting ? 'default' : 'green') :
                                                                    isCancelled ? 'purple' :
                                                                        lot.status === 'closed' ? 'green' :
                                                                            'orange'}>
                                                                    {lot.status === 'closed' && !isCancelled ? 'sold' :
                                                                        isCancelled ? 'cancelled' :
                                                                            isWaiting ? 'waiting' : lot.status}
                                                                </Tag>
                                                            </div>
                                                            <h4 style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: '600' }}>
                                                                {lot.title}
                                                            </h4>
                                                            <p style={{ margin: '0 0 4px 0', color: '#8c8c8c', fontSize: '12px' }}>
                                                                {lot.description?.substring(0, 60)}...
                                                            </p>
                                                            {isWaiting && (
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: '#999',
                                                                    fontStyle: 'italic',
                                                                    marginTop: '2px'
                                                                }}>
                                                                    Waiting for previous lots to complete
                                                                </div>
                                                            )}
                                                            {!isWaiting && lot.status === 'active' && renderListTimer(lot)}
                                                            {/* Close to Reserve Indicator */}
                                                            {isCloseToReserve(lot) && !isWaiting && lot.status === 'active' && (
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: '#faad14',
                                                                    fontWeight: 'bold',
                                                                    marginTop: '4px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '4px',
                                                                    background: 'rgba(250, 173, 20, 0.1)',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '4px',
                                                                    border: '1px solid #faad14'
                                                                }}>
                                                                    <span>⚠️</span>
                                                                    <span>Close to Reserve</span>
                                                                </div>
                                                            )}
                                                            {/* Urgency Message - Show when <= 15 seconds (only for users who don't have the last bid and are not the auction owner) */}
                                                            {allLotsTimeRemaining[lot.id] !== undefined &&
                                                                allLotsTimeRemaining[lot.id] <= 15 &&
                                                                allLotsTimeRemaining[lot.id] > 5 &&
                                                                lot.status === 'active' &&
                                                                lot.last_bid_user_id !== currentUser?.id &&
                                                                currentUser?.id !== auction?.user_id && (
                                                                    <div style={{
                                                                        fontSize: '11px',
                                                                        color: '#faad14',
                                                                        fontWeight: 'bold',
                                                                        marginTop: '4px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        background: 'rgba(250, 173, 20, 0.1)',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #faad14',
                                                                        animation: 'pulse 1s ease-in-out infinite'
                                                                    }}>
                                                                        <span>⏰</span>
                                                                        <span>Hurry up! {allLotsTimeRemaining[lot.id]}s remaining</span>
                                                                    </div>
                                                                )}
                                                            {/* Critical Time Message - Show when <= 5 seconds */}
                                                            {allLotsTimeRemaining[lot.id] !== undefined &&
                                                                allLotsTimeRemaining[lot.id] <= 5 &&
                                                                allLotsTimeRemaining[lot.id] > 0 &&
                                                                lot.status === 'active' &&
                                                                lot.last_bid_user_id !== currentUser?.id &&
                                                                currentUser?.id !== auction?.user_id && (
                                                                    <div style={{
                                                                        fontSize: '11px',
                                                                        color: '#ff4d4f',
                                                                        fontWeight: 'bold',
                                                                        marginTop: '4px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        background: 'rgba(255, 77, 79, 0.1)',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #ff4d4f',
                                                                        animation: 'pulse 0.5s ease-in-out infinite'
                                                                    }}>
                                                                        <span>🚨</span>
                                                                        <span>Time's up! Bidding disabled</span>
                                                                    </div>
                                                                )}
                                                            {statusLoadingLots.has(lot.id) && (
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: '#1890ff',
                                                                    fontWeight: 'bold',
                                                                    marginTop: '2px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '4px',
                                                                    background: 'rgba(24, 144, 255, 0.1)',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '4px',
                                                                    border: '1px solid rgba(24, 144, 255, 0.3)'
                                                                }}>
                                                                    <div style={{
                                                                        width: '8px',
                                                                        height: '8px',
                                                                        border: '1px solid rgba(24, 144, 255, 0.5)',
                                                                        borderTop: '1px solid #1890ff',
                                                                        borderRadius: '50%',
                                                                        animation: 'spin 1s linear infinite'
                                                                    }} />
                                                                    {currentUser?.id === auction?.user_id ? 'Finalizing Lot...' : 'Determining Winner...'}
                                                                </div>
                                                            )}
                                                            {timeoutLoadingLots.has(lot.id) && !checkIfLotClosed(lot) && (
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: '#ff4d4f',
                                                                    fontWeight: 'bold',
                                                                    marginTop: '2px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '4px',
                                                                    background: 'rgba(255, 77, 79, 0.1)',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '4px',
                                                                    border: '1px solid rgba(255, 77, 79, 0.3)'
                                                                }}>
                                                                    <div style={{
                                                                        width: '8px',
                                                                        height: '8px',
                                                                        border: '1px solid rgba(255, 77, 79, 0.5)',
                                                                        borderTop: '1px solid #ff4d4f',
                                                                        borderRadius: '50%',
                                                                        animation: 'spin 1s linear infinite'
                                                                    }} />
                                                                    Timing Out...
                                                                </div>
                                                            )}
                                                            {lot.status === 'closed' && lot.last_bid_user_id && !statusLoadingLots.has(lot.id) && (
                                                                <div style={{
                                                                    fontSize: '10px',
                                                                    color: lot.last_bid_user_id === currentUser?.id ? '#52c41a' : '#ff4d4f',
                                                                    fontWeight: 'bold',
                                                                    marginTop: '2px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '2px'
                                                                }}>
                                                                    {lot.last_bid_user_id === currentUser?.id ? '🎉 You won!' : 'Sold to Other'}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div style={{ textAlign: 'right' }}>
                                                            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1890ff', marginBottom: '2px' }}>
                                                                {formatCurrency(lot.current_price || lot.starting_price)}
                                                            </div>
                                                            {/* {lot.reserve_price && (
                                                        <div style={{ fontSize: '10px', color: '#8c8c8c' }}>
                                                            Reserve: ${formatCurrency(lot.reserve_price)}
                                                        </div>
                                                    )} */}
                                                            <div style={{ marginTop: '4px', display: 'flex', gap: '4px', alignItems: 'center' }}>
                                                                <Button
                                                                    type="text"
                                                                    size="small"
                                                                    icon={isLotFavorite(lot.id) ? <HeartFilled style={{ color: '#ff4d4f' }} /> : <HeartOutlined />}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleFavorite(lot.id, e);
                                                                    }}
                                                                />
                                                                {currentUser?.id === auction?.user_id &&
                                                                    lot.status === 'active' &&
                                                                    !lot.last_bid_user_id &&
                                                                    !timeoutLoadingLots.has(lot.id) && (
                                                                        <Button
                                                                            type="text"
                                                                            size="small"
                                                                            danger
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleTimeout(lot);
                                                                            }}
                                                                            loading={timeoutLoadingLots.has(lot.id)}
                                                                            style={{
                                                                                fontSize: '10px',
                                                                                padding: '2px 6px',
                                                                                height: 'auto'
                                                                            }}
                                                                        >
                                                                            Close Lot
                                                                        </Button>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '60px 20px',
                                textAlign: 'center',
                                minHeight: 'calc(100vh - 40px)',
                                background: '#fafafa',
                                borderRadius: '12px',
                                margin: '0 10px',
                                // border: '2px dashed #d9d9d9'
                            }}>
                                <div style={{ marginBottom: '24px' }}>
                                    {getEmptyStateMessage().icon}
                                </div>

                                <h3 style={{
                                    margin: '0 0 16px 0',
                                    color: '#262626',
                                    fontSize: '24px',
                                    fontWeight: '600'
                                }}>
                                    {getEmptyStateMessage().title}
                                </h3>

                                <p style={{
                                    margin: '0 0 24px 0',
                                    color: '#8c8c8c',
                                    fontSize: '16px',
                                    lineHeight: '1.6',
                                    maxWidth: '500px'
                                }}>
                                    {getEmptyStateMessage().description}
                                </p>

                                {getEmptyStateMessage().showClearButton && (
                                    <Button
                                        type="primary"
                                        size="large"
                                        onClick={() => {
                                            // Clear all search queries
                                            setSearchQuery('');
                                            setSimpleSearchQuery('');
                                            setAdvancedSearch({
                                                title: '',
                                                description: '',
                                                lotNumber: '',
                                                minPrice: '',
                                                maxPrice: ''
                                            });
                                            setSearchMode('simple');
                                        }}
                                        style={{
                                            marginTop: '8px'
                                        }}
                                    >
                                        Clear Search
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                    {/* End of Scrollable Lots Container */}
                </Col>

                {/* Scroll to Selected Lot Button - Mobile/Tablet Only */}
                {/* {isTabletOrMobile && showScrollToLot && selectedLot && (
                <Button
                    type="primary"
                    icon={<UpOutlined />}
                    onClick={scrollToSelectedLot}
                    size="small"
                    style={{
                        position: 'fixed',
                        bottom: '90px',
                        right: '16px',
                        zIndex: 1002,
                        height: '36px',
                        padding: '0 14px',
                        fontSize: '12px',
                        fontWeight: 500,
                        borderRadius: '18px',
                        boxShadow: '0 4px 12px rgba(24, 144, 255, 0.4)',
                        background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                >
                    Back to Lot
                </Button>
            )} */}

                {showAutoBidDashboardView ? (
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={sidebarCollapsed ? 6 : 8}
                        xl={sidebarCollapsed ? 6 : 8}
                        className="detail-panel-desktop"
                        style={{
                            padding: sidebarCollapsed ? 8 : 10,
                            paddingTop: sidebarCollapsed ? 8 : 2,
                            transition: 'all 0.3s ease',
                            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                            display: 'flex',
                            flexDirection: 'column',
                            overflowX: 'hidden',
                            maxWidth: '100%',
                            boxSizing: 'border-box'
                        }}
                    >
                        <Card
                            title={
                                <div style={{ fontSize: '16px', fontWeight: 700, color: '#262626' }}>
                                    ⚡ Max-Bid Guide
                                </div>
                            }
                            style={{
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                            bodyStyle={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                fontSize: '14px',
                                color: '#595959',
                                lineHeight: '1.6',
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontWeight: 600, marginBottom: '8px', color: '#262626' }}>
                                        What is Max Bid?
                                    </div>
                                    <div style={{ paddingLeft: '8px' }}>
                                        Max Bid automatically places bids for you when you're outbid, up to your specified maximum amount. Set your bid increment and maximum limit, and the system will handle the rest!
                                    </div>
                                </div>
                                <div style={{ marginBottom: '16px', flex: 1 }}>
                                    <div style={{ fontWeight: 600, marginBottom: '8px', color: '#262626' }}>
                                        How it works:
                                    </div>
                                    <ul style={{ paddingLeft: '24px', marginBottom: 0, color: '#595959' }}>
                                        <li style={{ marginBottom: '8px' }}>Set a <strong>bid increment</strong> - the amount to increase your bid by when outbid</li>
                                        <li style={{ marginBottom: '8px' }}>Set a <strong>maximum bid amount</strong> - your spending limit for that lot</li>
                                        <li style={{ marginBottom: '8px' }}>The system automatically places bids when you're outbid</li>
                                        <li style={{ marginBottom: '8px' }}>Max bid stops when you reach your maximum or win the lot</li>
                                        <li>You can manage multiple max bids simultaneously for different lots</li>
                                    </ul>
                                </div>
                                <div style={{
                                    marginTop: 'auto',
                                    padding: '12px',
                                    background: '#f0f9ff',
                                    borderRadius: '6px',
                                    border: '1px solid #91d5ff'
                                }}>
                                    <div style={{ fontSize: '13px', color: '#1890ff', fontWeight: 600, marginBottom: '4px' }}>
                                        💡 Tip:
                                    </div>
                                    <div style={{ fontSize: '13px', color: '#595959' }}>
                                        To start a max bid, select any lot and use the "Show Max-Bid Options" button in the lot details section.
                                    </div>
                                </div>
                                <Button
                                    type="primary"
                                    icon={<UnorderedListOutlined />}
                                    block
                                    onClick={() => setShowAutoBidDashboardView(false)}
                                    style={{ marginTop: '16px' }}
                                >
                                    Go to All Lots
                                </Button>
                            </div>
                        </Card>
                    </Col>
                ) : (
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={sidebarCollapsed ? 6 : 8}
                        xl={sidebarCollapsed ? 6 : 8}
                        ref={detailPanelRef}
                        className="detail-panel-desktop"
                        data-tour="lot-details"
                        style={{
                            padding: sidebarCollapsed ? 8 : 10,
                            paddingTop: sidebarCollapsed ? 8 : 2,
                            transition: 'all 0.3s ease',
                            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                            height: window.innerWidth < 992 ? 'auto' : '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: window.innerWidth < 992 ? 'visible' : 'auto',
                            overflowX: 'hidden'
                        }}
                    >
                        {selectedLot ? (
                            <Card
                                style={{
                                    height: window.innerWidth < 992 ? 'auto' : '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                                title={
                                    <div style={{
                                        background: getLotHeaderBackground(selectedLot),
                                        color: 'white',
                                        padding: '24px 28px',
                                        borderRadius: '12px 12px 0 0',
                                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                                        border: '1px solid rgba(255, 255, 255, 0.1)',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%, rgba(255,255,255,0.1) 100%)',
                                            transform: 'translateX(-100%)',
                                            animation: 'shimmer 3s ease-in-out infinite'
                                        }} />
                                        <Space style={{ position: 'relative', zIndex: 1 }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '12px'
                                            }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    background: 'rgba(255, 255, 255, 0.2)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backdropFilter: 'blur(10px)',
                                                    border: '2px solid rgba(255, 255, 255, 0.3)',
                                                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
                                                    flexShrink: 0
                                                }}>
                                                    <BellFilled style={{
                                                        color: 'white',
                                                        fontSize: '18px',
                                                        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                                                    }} />
                                                </div>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div style={{
                                                        fontSize: '18px',
                                                        fontWeight: '700',
                                                        textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                                        lineHeight: '1.2',
                                                        wordWrap: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}>
                                                        {selectedLot.title}
                                                    </div>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        opacity: 0.9,
                                                        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                                                        marginTop: '2px'
                                                    }}>
                                                        Lot #{selectedLot.lot_number}
                                                    </div>
                                                </div>
                                            </div>
                                        </Space>
                                    </div>
                                }
                                headStyle={{
                                    border: 'none',
                                    padding: 0
                                }}
                                bodyStyle={{
                                    padding: '18px',
                                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                                    borderRadius: '0 0 12px 12px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: window.innerWidth < 992 ? 'none' : 1,
                                    overflow: window.innerWidth < 992 ? 'visible' : 'hidden'
                                }}
                            >
                                {/* Scrollable Content Area */}
                                <div style={{
                                    flex: window.innerWidth < 992 ? 'none' : 1,
                                    overflowY: window.innerWidth < 992 ? 'visible' : 'auto',
                                    overflowX: 'hidden',
                                    paddingRight: window.innerWidth < 992 ? '0' : '4px',
                                    marginRight: window.innerWidth < 992 ? '0' : '-4px',
                                    paddingBottom: window.innerWidth < 992 ? '120px' : '0'
                                }}>
                                    {/* Bidding Section */}
                                    <div style={{ marginBottom: 16 }}>
                                        <div style={{ textAlign: 'center', marginBottom: 12 }}>
                                            {renderSelectedLotTimer(selectedLot)}
                                        </div>

                                        {/* Urgency Message - Show when <= 15 seconds (only for users who don't have the last bid and are not the auction owner) */}
                                        {timeRemaining !== null &&
                                            timeRemaining <= 15 &&
                                            timeRemaining > 5 &&
                                            !checkIfLotClosed(selectedLot) &&
                                            isLotAvailableForBidding(selectedLot) &&
                                            selectedLot.last_bid_user_id !== currentUser?.id &&
                                            currentUser?.id !== auction?.user_id && (
                                                <Alert
                                                    message={
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                            <span style={{ fontSize: '18px' }}>⏰</span>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                                Hurry up! Only {timeRemaining} second{timeRemaining !== 1 ? 's' : ''} remaining!
                                                            </span>
                                                        </div>
                                                    }
                                                    type="warning"
                                                    showIcon={false}
                                                    style={{
                                                        marginBottom: 16,
                                                        background: 'linear-gradient(135deg, #fff7e6, #fffbe6)',
                                                        border: '2px solid #faad14',
                                                        borderRadius: '8px',
                                                        animation: 'pulse 1s ease-in-out infinite'
                                                    }}
                                                />
                                            )}

                                        {/* Critical Time Message - Show when <= 5 seconds (only for users who don't have the last bid and are not the auction owner) */}
                                        {timeRemaining !== null &&
                                            timeRemaining <= 5 &&
                                            timeRemaining > 0 &&
                                            !checkIfLotClosed(selectedLot) &&
                                            isLotAvailableForBidding(selectedLot) &&
                                            selectedLot.last_bid_user_id !== currentUser?.id &&
                                            currentUser?.id !== auction?.user_id && (
                                                <Alert
                                                    message={
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                            <span style={{ fontSize: '18px' }}>🚨</span>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                                Time's almost up! Bidding disabled. {timeRemaining} second{timeRemaining !== 1 ? 's' : ''} remaining!
                                                            </span>
                                                        </div>
                                                    }
                                                    type="error"
                                                    showIcon={false}
                                                    style={{
                                                        marginBottom: 16,
                                                        background: 'linear-gradient(135deg, #fff1f0, #fff2f0)',
                                                        border: '2px solid #ff4d4f',
                                                        borderRadius: '8px',
                                                        animation: 'pulse 0.5s ease-in-out infinite'
                                                    }}
                                                />
                                            )}

                                        {/* Status Badge Section - Only show meaningful badges */}
                                        {(selectedLot.is_favorite || selectedLot.held_by_user || (selectedLot.last_bid_user_id === currentUser?.id && !checkIfLotClosed(selectedLot))) && (
                                            <div style={{
                                                margin: '12px 0',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                gap: 6,
                                                flexWrap: 'wrap'
                                            }}>
                                                {selectedLot.is_favorite && (
                                                    <Tag
                                                        color="gold"
                                                        icon={<StarFilled />}
                                                        style={{
                                                            fontSize: '13px',
                                                            padding: '6px 16px',
                                                            borderRadius: '20px',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        Favorite
                                                    </Tag>
                                                )}

                                                {selectedLot.held_by_user && (
                                                    <Tag
                                                        color="blue"
                                                        icon={<TrophyOutlined />}
                                                        style={{
                                                            fontSize: '13px',
                                                            padding: '6px 16px',
                                                            borderRadius: '20px',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        Your Winning Bid
                                                    </Tag>
                                                )}

                                                {selectedLot.last_bid_user_id === currentUser?.id && !checkIfLotClosed(selectedLot) && (
                                                    <Tag
                                                        color="cyan"
                                                        icon={<CrownOutlined />}
                                                        style={{
                                                            fontSize: '13px',
                                                            padding: '6px 16px',
                                                            borderRadius: '20px',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        Leading
                                                    </Tag>
                                                )}
                                            </div>
                                        )}

                                        {/* Enhanced Current Price Display */}
                                        <div style={{
                                            margin: '12px 0',
                                            textAlign: 'center',
                                            padding: '14px',
                                            background: 'linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)',
                                            borderRadius: '10px',
                                            border: '2px solid #e6f7ff',
                                            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.1)'
                                        }}>
                                            <Text type="secondary" style={{ fontSize: '13px', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Current Price
                                            </Text>
                                            <div style={{
                                                fontSize: 36,
                                                fontWeight: '800',
                                                color: '#1890ff',
                                                margin: '6px 0',
                                                textShadow: '0 2px 4px rgba(24, 144, 255, 0.2)',
                                                background: 'linear-gradient(135deg, #1890ff, #40a9ff)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                backgroundClip: 'text'
                                            }}>
                                                {formatCurrency(selectedLot.current_price || selectedLot.starting_price)}
                                            </div>

                                            {/* Starting Price Comparison */}
                                            {selectedLot.current_price && selectedLot.starting_price && selectedLot.current_price > selectedLot.starting_price && (
                                                <div style={{
                                                    marginTop: 8,
                                                    fontSize: '12px',
                                                    color: '#52c41a',
                                                    fontWeight: 500
                                                }}>
                                                    ↑ {((selectedLot.current_price - selectedLot.starting_price) / selectedLot.starting_price * 100).toFixed(1)}% above starting
                                                </div>
                                            )}

                                            {selectedLot.last_bid_user_id && (
                                                <div style={{ marginTop: 8 }}>
                                                    {selectedLot.last_bid_user_id === currentUser?.id ? (
                                                        (() => {
                                                            // Check if this is a vendor bid or start bid from auction owner
                                                            // Vendor bid takes precedence over start bid
                                                            const ownerBidTracking = selectedLot.owner_bid_tracking || {};
                                                            const isAuctionOwner = currentUser?.id === auction?.user_id;
                                                            const hasVendorBid = ownerBidTracking.has_vendor_bid || false;
                                                            const hasStartBid = ownerBidTracking.has_start_bid || false;

                                                            // Check vendor bid first (takes precedence)
                                                            if (isAuctionOwner && hasVendorBid) {
                                                                return (
                                                                    <Tag
                                                                        color="purple"
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            padding: '6px 16px',
                                                                            fontWeight: 'bold',
                                                                            borderRadius: '20px',
                                                                            boxShadow: '0 2px 6px rgba(114, 46, 209, 0.3)'
                                                                        }}
                                                                    >
                                                                        🎯 Vendor bid is used
                                                                    </Tag>
                                                                );
                                                            }

                                                            // Only show "started the lot" if vendor bid is not present
                                                            if (isAuctionOwner && hasStartBid && !hasVendorBid) {
                                                                return (
                                                                    <Tag
                                                                        color="purple"
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            padding: '6px 16px',
                                                                            fontWeight: 'bold',
                                                                            borderRadius: '20px',
                                                                            boxShadow: '0 2px 6px rgba(114, 46, 209, 0.3)'
                                                                        }}
                                                                    >
                                                                        🏁 Vendor started the lot
                                                                    </Tag>
                                                                );
                                                            }

                                                            return (
                                                                <Tag
                                                                    color="blue"
                                                                    style={{
                                                                        fontSize: '13px',
                                                                        padding: '6px 16px',
                                                                        fontWeight: 'bold',
                                                                        borderRadius: '20px',
                                                                        boxShadow: '0 2px 6px rgba(24, 144, 255, 0.3)'
                                                                    }}
                                                                >
                                                                    🎯 Your Leading Bid
                                                                </Tag>
                                                            );
                                                        })()
                                                    ) : (
                                                        (() => {
                                                            // Check if lot is cancelled - don't show anything if cancelled
                                                            const isCancelled = selectedLot.status === 'cancelled' || isLotCancelled(selectedLot);
                                                            if (isCancelled) {
                                                                return null;
                                                            }

                                                            // Check if lot is sold and user is auction owner
                                                            const isSold = selectedLot.status === 'closed' && !isLotCancelled(selectedLot);
                                                            const isAuctionOwner = currentUser?.id === auction?.user_id;

                                                            if (isSold && isAuctionOwner) {
                                                                // Get winner information from bid history cache
                                                                const lotBids = bidHistoryCache.get(selectedLot.id) || [];
                                                                const winningBid = lotBids.find(bid => bid.is_winning) || lotBids[0];
                                                                const winnerName = winningBid?.user
                                                                    ? `${winningBid.user.first_name || ''} ${winningBid.user.last_name || ''}`.trim()
                                                                    : 'Unknown User';

                                                                return (
                                                                    <Tag
                                                                        color="green"
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            padding: '6px 16px',
                                                                            fontWeight: 'bold',
                                                                            borderRadius: '20px'
                                                                        }}
                                                                    >
                                                                        ✅ Sold to {winnerName}
                                                                    </Tag>
                                                                );
                                                            }

                                                            // Check if the last bidder is the auction owner (vendor bid)
                                                            // Vendor bid takes precedence over start bid
                                                            const ownerBidTracking = selectedLot.owner_bid_tracking || {};
                                                            const lastBidderIsOwner = selectedLot.last_bid_user_id === auction?.user_id;
                                                            const hasVendorBid = ownerBidTracking.has_vendor_bid || false;
                                                            const hasStartBid = ownerBidTracking.has_start_bid || false;

                                                            // Check vendor bid first (takes precedence)
                                                            if (lastBidderIsOwner && hasVendorBid) {
                                                                return (
                                                                    <Tag
                                                                        color="purple"
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            padding: '6px 16px',
                                                                            fontWeight: 'bold',
                                                                            borderRadius: '20px'
                                                                        }}
                                                                    >
                                                                        🎯 Vendor bid is used
                                                                    </Tag>
                                                                );
                                                            }

                                                            // Only show "started the lot" if vendor bid is not present
                                                            if (lastBidderIsOwner && hasStartBid && !hasVendorBid) {
                                                                return (
                                                                    <Tag
                                                                        color="purple"
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            padding: '6px 16px',
                                                                            fontWeight: 'bold',
                                                                            borderRadius: '20px'
                                                                        }}
                                                                    >
                                                                        🏁 Vendor started the lot
                                                                    </Tag>
                                                                );
                                                            }

                                                            return (
                                                                <Tag
                                                                    color="orange"
                                                                    style={{
                                                                        fontSize: '13px',
                                                                        padding: '6px 16px',
                                                                        fontWeight: 'bold',
                                                                        borderRadius: '20px'
                                                                    }}
                                                                >
                                                                    👤 Other User Leading
                                                                </Tag>
                                                            );
                                                        })()
                                                    )}
                                                </div>
                                            )}

                                            {/* Lot Settings Info - Only show to auction owner and only if enabled */}
                                            {currentUser?.id === auction?.user_id && (
                                                ((selectedLot?.can_buy_now && selectedLot?.buy_now_price) ||
                                                    (selectedLot?.reserve_price && selectedLot?.reserve_price > 0)) && (
                                                    <div style={{ marginTop: 12 }}>
                                                        <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                            {/* Buy Now Status - Only show if enabled */}
                                                            {selectedLot?.can_buy_now && selectedLot?.buy_now_price && (
                                                                <div style={{
                                                                    padding: '10px',
                                                                    background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #b7eb8f'
                                                                }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                            <ShoppingOutlined style={{
                                                                                fontSize: '14px',
                                                                                color: '#52c41a'
                                                                            }} />
                                                                            <Text style={{ fontSize: '12px', color: '#595959', fontWeight: 500 }}>
                                                                                Buy Now
                                                                            </Text>
                                                                        </div>
                                                                        <Tag color="success" style={{ fontSize: '11px', padding: '2px 8px', fontWeight: 'bold' }}>
                                                                            <Space size={4}>
                                                                                <CheckCircleOutlined />
                                                                                <span>{formatCurrency(selectedLot.buy_now_price)}</span>
                                                                            </Space>
                                                                        </Tag>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Reserve Price Status - Only show if set */}
                                                            {selectedLot?.reserve_price && selectedLot?.reserve_price > 0 && (
                                                                <div style={{
                                                                    padding: '10px',
                                                                    background: 'linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%)',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ffd591'
                                                                }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                            <SafetyOutlined style={{
                                                                                fontSize: '14px',
                                                                                color: '#faad14'
                                                                            }} />
                                                                            <Text style={{ fontSize: '12px', color: '#595959', fontWeight: 500 }}>
                                                                                Reserve Price
                                                                            </Text>
                                                                        </div>
                                                                        <Tag color="warning" style={{ fontSize: '11px', padding: '2px 8px', fontWeight: 'bold' }}>
                                                                            <Space size={4}>
                                                                                <CheckCircleOutlined />
                                                                                <span>{formatCurrency(selectedLot.reserve_price)}</span>
                                                                            </Space>
                                                                        </Tag>
                                                                    </div>
                                                                    {/* Reserve Price Progress */}
                                                                    {selectedLot.current_price && (
                                                                        <>
                                                                            <Progress
                                                                                percent={Math.min((selectedLot.current_price / selectedLot.reserve_price) * 100, 100)}
                                                                                strokeColor={{
                                                                                    '0%': '#ff4d4f',
                                                                                    '50%': '#faad14',
                                                                                    '100%': '#52c41a',
                                                                                }}
                                                                                showInfo={false}
                                                                                size="small"
                                                                                style={{ marginTop: '8px' }}
                                                                            />
                                                                            {isCloseToReserve(selectedLot) && (
                                                                                <div style={{ marginTop: 8 }}>
                                                                                    <Tag color="gold" style={{ fontSize: '11px', padding: '3px 10px', fontWeight: 'bold' }}>
                                                                                        Close to Reserve
                                                                                    </Tag>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Space>
                                                    </div>
                                                )
                                            )}

                                            {/* Show "Close to Reserve" tag to users without showing the actual price */}
                                            {selectedLot.reserve_price && selectedLot.current_price && selectedLot.reserve_price > 0 && currentUser?.id !== auction?.user_id && isCloseToReserve(selectedLot) && (
                                                <div style={{ marginTop: 12 }}>
                                                    <Tag color="gold" style={{ fontSize: '11px', padding: '3px 10px', fontWeight: 'bold' }}>
                                                        Close to Reserve
                                                    </Tag>
                                                </div>
                                            )}
                                        </div>

                                        {/* Quick Stats Section */}
                                        <div style={{
                                            margin: '12px 0',
                                            padding: window.innerWidth <= 576 ? '12px' : '16px',
                                            background: 'linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%)',
                                            borderRadius: window.innerWidth <= 576 ? '8px' : '12px',
                                            border: '1px solid #d9e7ff',
                                            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.08)'
                                        }}>
                                            <Row gutter={[window.innerWidth <= 576 ? 8 : 12, window.innerWidth <= 576 ? 8 : 12]}>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <div style={{
                                                        textAlign: 'center',
                                                        padding: window.innerWidth <= 576 ? '10px 6px' : '12px 8px',
                                                        background: 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)',
                                                        borderRadius: window.innerWidth <= 576 ? '8px' : '10px',
                                                        border: '1px solid #91d5ff',
                                                        transition: 'all 0.3s ease',
                                                        cursor: 'default'
                                                    }}
                                                        onMouseEnter={(e) => {
                                                            if (window.innerWidth > 576) {
                                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(24, 144, 255, 0.2)';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (window.innerWidth > 576) {
                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                                e.currentTarget.style.boxShadow = 'none';
                                                            }
                                                        }}>
                                                        <div style={{ marginBottom: window.innerWidth <= 576 ? '4px' : '6px' }}>
                                                            <HistoryOutlined style={{
                                                                fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                                color: '#1890ff'
                                                            }} />
                                                        </div>
                                                        <div style={{
                                                            fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                            fontWeight: '700',
                                                            color: '#1890ff',
                                                            marginBottom: '4px',
                                                            lineHeight: '1.2'
                                                        }}>
                                                            {bidHistory?.length || 0}
                                                        </div>
                                                        <div style={{
                                                            fontSize: window.innerWidth <= 576 ? '9px' : '11px',
                                                            color: '#595959',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            fontWeight: '600'
                                                        }}>
                                                            Total Bids
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <div style={{
                                                        textAlign: 'center',
                                                        padding: window.innerWidth <= 576 ? '10px 6px' : '12px 8px',
                                                        background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
                                                        borderRadius: window.innerWidth <= 576 ? '8px' : '10px',
                                                        border: '1px solid #b7eb8f',
                                                        transition: 'all 0.3s ease',
                                                        cursor: 'default'
                                                    }}
                                                        onMouseEnter={(e) => {
                                                            if (window.innerWidth > 576) {
                                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(82, 196, 26, 0.2)';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (window.innerWidth > 576) {
                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                                e.currentTarget.style.boxShadow = 'none';
                                                            }
                                                        }}>
                                                        <div style={{ marginBottom: window.innerWidth <= 576 ? '4px' : '6px' }}>
                                                            <DollarOutlined style={{
                                                                fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                                color: '#52c41a'
                                                            }} />
                                                        </div>
                                                        <div style={{
                                                            fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                            fontWeight: '700',
                                                            color: '#52c41a',
                                                            marginBottom: '4px',
                                                            lineHeight: '1.2'
                                                        }}>
                                                            {selectedLot.starting_price ? formatPrice(selectedLot.starting_price) : '0'}
                                                        </div>
                                                        <div style={{
                                                            fontSize: window.innerWidth <= 576 ? '9px' : '11px',
                                                            color: '#595959',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            fontWeight: '600'
                                                        }}>
                                                            Start Price
                                                        </div>
                                                    </div>
                                                </Col>
                                                {selectedLot.increment && (
                                                    <>
                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <div style={{
                                                                textAlign: 'center',
                                                                padding: window.innerWidth <= 576 ? '10px 6px' : '12px 8px',
                                                                background: 'linear-gradient(135deg, #fffbe6 0%, #ffe58f 100%)',
                                                                borderRadius: window.innerWidth <= 576 ? '8px' : '10px',
                                                                border: '1px solid #ffd591',
                                                                transition: 'all 0.3s ease',
                                                                cursor: 'default'
                                                            }}
                                                                onMouseEnter={(e) => {
                                                                    if (window.innerWidth > 576) {
                                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(250, 173, 20, 0.2)';
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (window.innerWidth > 576) {
                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                        e.currentTarget.style.boxShadow = 'none';
                                                                    }
                                                                }}>
                                                                <div style={{ marginBottom: window.innerWidth <= 576 ? '4px' : '6px' }}>
                                                                    <LineChartOutlined style={{
                                                                        fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                                        color: '#faad14'
                                                                    }} />
                                                                </div>
                                                                <div style={{
                                                                    fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                                    fontWeight: '700',
                                                                    color: '#faad14',
                                                                    marginBottom: '4px',
                                                                    lineHeight: '1.2'
                                                                }}>
                                                                    {formatPrice(selectedLot.increment || selectedLot.default_increment || 5)}
                                                                </div>
                                                                <div style={{
                                                                    fontSize: window.innerWidth <= 576 ? '9px' : '11px',
                                                                    color: '#595959',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.5px',
                                                                    fontWeight: '600'
                                                                }}>
                                                                    Increment
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <div style={{
                                                                textAlign: 'center',
                                                                padding: window.innerWidth <= 576 ? '10px 6px' : '12px 8px',
                                                                background: 'linear-gradient(135deg, #f9f0ff 0%, #efdbff 100%)',
                                                                borderRadius: window.innerWidth <= 576 ? '8px' : '10px',
                                                                border: '1px solid #d3adf7',
                                                                transition: 'all 0.3s ease',
                                                                cursor: 'default'
                                                            }}
                                                                onMouseEnter={(e) => {
                                                                    if (window.innerWidth > 576) {
                                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(114, 46, 209, 0.2)';
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (window.innerWidth > 576) {
                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                        e.currentTarget.style.boxShadow = 'none';
                                                                    }
                                                                }}>
                                                                <div style={{ marginBottom: window.innerWidth <= 576 ? '4px' : '6px' }}>
                                                                    <TrophyOutlined style={{
                                                                        fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                                        color: '#722ed1'
                                                                    }} />
                                                                </div>
                                                                <div style={{
                                                                    fontSize: window.innerWidth <= 576 ? '18px' : '24px',
                                                                    fontWeight: '700',
                                                                    color: '#722ed1',
                                                                    marginBottom: '4px',
                                                                    lineHeight: '1.2'
                                                                }}>
                                                                    {(() => {
                                                                        const increment = parseInt(selectedLot.increment || selectedLot.default_increment || 5);
                                                                        const current = parseInt(selectedLot.current_price || selectedLot.starting_price);
                                                                        return formatPrice(current + increment);
                                                                    })()}
                                                                </div>
                                                                <div style={{
                                                                    fontSize: window.innerWidth <= 576 ? '9px' : '11px',
                                                                    color: '#595959',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.5px',
                                                                    fontWeight: '600'
                                                                }}>
                                                                    Next Bid
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </>
                                                )}
                                            </Row>
                                        </div>

                                        <Divider style={{ margin: '12px 0' }} />

                                        {/* Match Reserve Price Button - Available to all users (except auction owner) when 90% close to reserve */}
                                        {isCloseToReserve(selectedLot) &&
                                            !checkIfLotClosed(selectedLot) &&
                                            isLotAvailableForBidding(selectedLot) &&
                                            currentUser?.id !== auction?.user_id &&
                                            (!auction?.is_private || (isInvited && invitationStatus === 'accepted')) && (
                                                <div style={{ margin: '12px 0', textAlign: 'center' }}>
                                                    <Button
                                                        type="primary"
                                                        size="large"
                                                        onClick={handleMatchReservePrice}
                                                        disabled={bidding || (timeRemaining !== null && timeRemaining <= 5)}
                                                        loading={bidding}
                                                        style={{
                                                            width: '100%',
                                                            height: '48px',
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            background: 'linear-gradient(135deg, #faad14, #ffc53d)',
                                                            border: 'none',
                                                            boxShadow: '0 4px 12px rgba(250, 173, 20, 0.4)'
                                                        }}
                                                    >
                                                        🎯 Match Reserve Price
                                                    </Button>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        color: '#8c8c8c',
                                                        marginTop: '8px',
                                                        textAlign: 'center'
                                                    }}>
                                                        Bid at the reserve price
                                                    </div>
                                                </div>
                                            )}

                                        {/* Owner Lot Actions - Combined container for Close Lot and Start Lot buttons */}
                                        {currentUser?.id === auction?.user_id &&
                                            selectedLot?.status === 'active' &&
                                            !checkIfLotClosed(selectedLot) && (
                                                <div data-tour="owner-lot-actions" style={{ margin: '12px 0' }}>
                                                    {/* Timeout button for auction owners */}
                                                    {selectedLot.status === 'active' &&
                                                        !selectedLot.last_bid_user_id &&
                                                        isLotAvailableForBidding(selectedLot) &&
                                                        !timeoutLoadingLots.has(selectedLot.id) && (
                                                            <div style={{ marginBottom: '12px' }}>
                                                                <div style={{ marginBottom: '12px' }}>
                                                                    <Text strong style={{ fontSize: '14px', color: '#d48806', display: 'block', marginBottom: 4 }}>
                                                                        Auction Owner Actions
                                                                    </Text>
                                                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                                                        Close the lot if no bids have been placed. This will mark the lot as closed without any sale.
                                                                    </Text>
                                                                </div>
                                                                <Button
                                                                    type="primary"
                                                                    danger
                                                                    icon={<CloseCircleOutlined style={{ fontSize: '16px' }} />}
                                                                    onClick={() => handleTimeout(selectedLot)}
                                                                    loading={statusLoadingLots.has(selectedLot.id)}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '44px',
                                                                        fontSize: '14px',
                                                                        fontWeight: '600',
                                                                        background: 'linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%)',
                                                                        border: 'none',
                                                                        borderRadius: '8px',
                                                                        boxShadow: '0 4px 16px rgba(255, 77, 79, 0.4), 0 2px 4px rgba(255, 77, 79, 0.2)',
                                                                        transition: 'all 0.3s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        gap: '8px'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 77, 79, 0.5), 0 4px 8px rgba(255, 77, 79, 0.3)';
                                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #ff7875 0%, #ff4d4f 100%)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                        e.currentTarget.style.boxShadow = '0 4px 16px rgba(255, 77, 79, 0.4), 0 2px 4px rgba(255, 77, 79, 0.2)';
                                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%)';
                                                                    }}
                                                                >
                                                                    Close Lot – No Bids
                                                                </Button>
                                                            </div>
                                                        )}

                                                    {/* Vendor Bid Buttons for Auction Owner */}
                                                    {(() => {
                                                        // Use owner_bid_tracking from API instead of checking bid history
                                                        const ownerBidTracking = selectedLot.owner_bid_tracking || {};
                                                        const hasStartBid = ownerBidTracking.has_start_bid || false;
                                                        const hasVendorBid = ownerBidTracking.has_vendor_bid || false;

                                                        // Check if lot has any bids (for start bid button - only show if no bids exist)
                                                        const lotBids = bidHistoryCache.get(selectedLot.id) || [];
                                                        const hasBids = lotBids.length > 0;

                                                        // Check if current price is at or above reserve price
                                                        const currentPrice = parseFloat(selectedLot.current_price) || parseFloat(selectedLot.starting_price) || 0;
                                                        const reservePrice = parseFloat(selectedLot.reserve_price) || 0;
                                                        const isAtOrAboveReserve = reservePrice > 0 && currentPrice >= reservePrice;

                                                        const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;

                                                        // Calculate what the vendor bid amount would be (same logic as backend)
                                                        const highestBidAmount = parseFloat(selectedLot.current_price) || parseFloat(selectedLot.starting_price) || 0;
                                                        let vendorBidAmount = reservePrice - increment;
                                                        if (vendorBidAmount < highestBidAmount) {
                                                            vendorBidAmount = Math.min(highestBidAmount + increment, reservePrice - increment);
                                                        }

                                                        // Check if vendor bid amount would meet or exceed reserve price
                                                        // Auction owner's bid must ALWAYS be strictly less than reserve price
                                                        const vendorBidWouldMeetReserve = reservePrice > 0 && vendorBidAmount >= reservePrice;

                                                        // Vendor bid is disabled only if the bid amount itself meets or exceeds reserve price
                                                        // We allow vendor bids as long as the bid amount is strictly less than reserve price
                                                        const vendorBidDisabledByReserve = vendorBidWouldMeetReserve;

                                                        // Check if time remaining is 20 seconds or less (vendor bid only available in last 20 seconds)
                                                        // Vendor bid is only available when time is between 1-20 seconds (not 0 or null)
                                                        const canPlaceVendorBid = timeRemaining !== null && timeRemaining > 0 && timeRemaining <= 20;
                                                        // Calculate when vendor bid will become active (timeRemaining - 20)
                                                        const secondsUntilActive = timeRemaining !== null && timeRemaining > 20 ? timeRemaining - 20 : null;
                                                        const startingPrice = parseInt(selectedLot.starting_price) || 0;
                                                        const startBidAmount = startingPrice + increment;

                                                        // Check if start bid amount would meet or exceed reserve price
                                                        // Auction owner's start bid must ALWAYS be strictly less than reserve price
                                                        const startBidWouldMeetReserve = reservePrice > 0 && startBidAmount >= reservePrice;

                                                        return (
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '12px',
                                                                width: '100%'
                                                            }}>
                                                                {/* Start Lot Button - Only show if lot has a reserve price and is available for bidding */}
                                                                {!hasBids && !hasStartBid && selectedLot.status === 'active' && selectedLot.reserve_price && selectedLot.reserve_price > 0 && isLotAvailableForBidding(selectedLot) && (
                                                                    <div>
                                                                        <div style={{ marginBottom: '12px' }}>
                                                                            <Text strong style={{ fontSize: '14px', color: '#d48806', display: 'block', marginBottom: 4 }}>
                                                                                Auction Owner Actions
                                                                            </Text>
                                                                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                                                                Start the lot by placing the first bid. This opens the lot for other participants to bid.
                                                                            </Text>
                                                                        </div>
                                                                        <Button
                                                                            type="primary"
                                                                            icon={<PlayCircleOutlined />}
                                                                            onClick={() => handleStartLotWithBid(selectedLot)}
                                                                            disabled={startBidWouldMeetReserve}
                                                                            size="large"
                                                                            block
                                                                            style={{
                                                                                height: '56px',
                                                                                fontSize: '15px',
                                                                                fontWeight: 600,
                                                                                background: startBidWouldMeetReserve ? '#d9d9d9' : 'linear-gradient(135deg, #52c41a, #73d13d)',
                                                                                border: 'none',
                                                                                boxShadow: startBidWouldMeetReserve ? 'none' : '0 4px 12px rgba(82, 196, 26, 0.3)',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                gap: '8px',
                                                                                whiteSpace: 'nowrap',
                                                                                transition: 'all 0.3s ease',
                                                                                color: startBidWouldMeetReserve ? '#8c8c8c' : '#ffffff',
                                                                                cursor: startBidWouldMeetReserve ? 'not-allowed' : 'pointer'
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                if (!startBidWouldMeetReserve) {
                                                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(82, 196, 26, 0.5), 0 4px 8px rgba(82, 196, 26, 0.3)';
                                                                                    e.currentTarget.style.background = 'linear-gradient(135deg, #73d13d, #95de64)';
                                                                                }
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                if (!startBidWouldMeetReserve) {
                                                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(82, 196, 26, 0.3)';
                                                                                    e.currentTarget.style.background = 'linear-gradient(135deg, #52c41a, #73d13d)';
                                                                                }
                                                                            }}
                                                                        >
                                                                            <span style={{ color: startBidWouldMeetReserve ? '#8c8c8c' : '#ffffff' }}>
                                                                                {startBidWouldMeetReserve ? 'Start Lot (Would Meet Reserve)' : 'Start Lot with Your Bid'}
                                                                            </span>
                                                                            <span style={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 700,
                                                                                opacity: 1,
                                                                                marginLeft: '4px',
                                                                                color: startBidWouldMeetReserve ? '#8c8c8c' : '#ffffff'
                                                                            }}>
                                                                                {formatCurrency(startBidAmount)}
                                                                            </span>
                                                                        </Button>
                                                                    </div>
                                                                )}

                                                                {/* Place Vendor Bid Button - Adjust price close to reserve */}
                                                                {selectedLot?.reserve_price &&
                                                                    selectedLot?.reserve_price > 0 &&
                                                                    selectedLot.status === 'active' &&
                                                                    selectedLot.last_bid_user_id &&
                                                                    !checkIfLotClosed(selectedLot) && (
                                                                        <div>
                                                                            <div style={{ marginBottom: '12px' }}>
                                                                                <Text strong style={{ fontSize: '14px', color: '#d48806', display: 'block', marginBottom: 4 }}>
                                                                                    Auction Owner Actions
                                                                                </Text>
                                                                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                                                                    Place a vendor bid to adjust price close to the reserve price (respecting increment rules). Available only when 20 seconds or less remain.
                                                                                </Text>
                                                                            </div>
                                                                            <Button
                                                                                type="primary"
                                                                                icon={<DollarOutlined />}
                                                                                onClick={() => {
                                                                                    // Double-check time remaining before opening modal
                                                                                    const currentTimeRemaining = timeRemaining;
                                                                                    if (currentTimeRemaining !== null && currentTimeRemaining <= 5) {
                                                                                        message.warning(`Vendor bid is disabled in the last 5 seconds. (${currentTimeRemaining}s remaining)`);
                                                                                        return;
                                                                                    }
                                                                                    if (!selectedLot || !auction || hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || currentTimeRemaining === null || currentTimeRemaining <= 0) {
                                                                                        if (currentTimeRemaining === null || currentTimeRemaining <= 0) {
                                                                                            message.warning('Vendor bid is no longer available. The lot time has finished.');
                                                                                        }
                                                                                        return;
                                                                                    }

                                                                                    // Calculate vendor bid amount: reserve_price - increment (one increment below reserve)
                                                                                    const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
                                                                                    const reservePrice = parseFloat(selectedLot.reserve_price);
                                                                                    const highestBidAmount = parseFloat(selectedLot.current_price) || parseFloat(selectedLot.starting_price);

                                                                                    // Calculate the highest valid bid amount that is less than reserve price
                                                                                    let calculatedVendorBidAmount = reservePrice - increment;

                                                                                    // Ensure the adjusted price is not less than the current highest bid
                                                                                    if (calculatedVendorBidAmount < highestBidAmount) {
                                                                                        // If calculated price is less than highest bid, use highest bid + increment
                                                                                        // But ensure it's still less than reserve
                                                                                        calculatedVendorBidAmount = Math.min(highestBidAmount + increment, reservePrice - increment);
                                                                                    }

                                                                                    setVendorBidAmount(calculatedVendorBidAmount);
                                                                                    setVendorBidModalVisible(true);
                                                                                }}
                                                                                loading={statusLoadingLots.has(selectedLot.id)}
                                                                                disabled={statusLoadingLots.has(selectedLot.id) || checkIfLotClosed(selectedLot) || hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5}
                                                                                size="large"
                                                                                block
                                                                                style={{
                                                                                    height: '56px',
                                                                                    fontSize: '15px',
                                                                                    fontWeight: 600,
                                                                                    background: (hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5) ? '#d9d9d9' : 'linear-gradient(135deg, #fa8c16, #ffa940)',
                                                                                    border: 'none',
                                                                                    boxShadow: (hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5) ? 'none' : '0 4px 12px rgba(250, 140, 22, 0.3)',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    gap: '8px',
                                                                                    whiteSpace: 'nowrap',
                                                                                    transition: 'all 0.3s ease',
                                                                                    color: (hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5) ? '#8c8c8c' : '#ffffff',
                                                                                    cursor: (hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5) ? 'not-allowed' : 'pointer'
                                                                                }}
                                                                                onMouseEnter={(e) => {
                                                                                    if (!hasVendorBid && !isAtOrAboveReserve && !vendorBidDisabledByReserve && canPlaceVendorBid && !statusLoadingLots.has(selectedLot.id) && !checkIfLotClosed(selectedLot) && timeRemaining !== null && timeRemaining > 5) {
                                                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(250, 140, 22, 0.5), 0 4px 8px rgba(250, 140, 22, 0.3)';
                                                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #ffa940, #ffc53d)';
                                                                                        e.currentTarget.style.color = '#ffffff';
                                                                                    }
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    if (!hasVendorBid && !isAtOrAboveReserve && !vendorBidDisabledByReserve && canPlaceVendorBid && !statusLoadingLots.has(selectedLot.id) && !checkIfLotClosed(selectedLot) && timeRemaining !== null && timeRemaining > 5) {
                                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(250, 140, 22, 0.3)';
                                                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #fa8c16, #ffa940)';
                                                                                        e.currentTarget.style.color = '#ffffff';
                                                                                    }
                                                                                }}
                                                                                onMouseDown={(e) => {
                                                                                    if (!hasVendorBid && !isAtOrAboveReserve && !vendorBidDisabledByReserve && canPlaceVendorBid && timeRemaining !== null && timeRemaining > 5) {
                                                                                        e.currentTarget.style.color = '#ffffff';
                                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                                    }
                                                                                }}
                                                                                onMouseUp={(e) => {
                                                                                    if (!hasVendorBid && !isAtOrAboveReserve && !vendorBidDisabledByReserve && canPlaceVendorBid && timeRemaining !== null && timeRemaining > 5) {
                                                                                        e.currentTarget.style.color = '#ffffff';
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span style={{ color: (hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5) ? '#8c8c8c' : '#ffffff' }}>
                                                                                    {hasVendorBid ? 'Place Vendor Bid (Already Used)' : isAtOrAboveReserve ? 'Place Vendor Bid (Reserve Reached)' : vendorBidWouldMeetReserve ? 'Place Vendor Bid (Would Meet Reserve)' : (timeRemaining === null || timeRemaining <= 0) ? 'Place Vendor Bid (Time Finished)' : (timeRemaining !== null && timeRemaining <= 5) ? `Place Vendor Bid (Locked: ${timeRemaining}s)` : !canPlaceVendorBid && secondsUntilActive !== null ? `Place Vendor Bid (Active in ${secondsUntilActive}s)` : !canPlaceVendorBid ? 'Place Vendor Bid (Active when ≤20s)' : 'Place Vendor Bid'}
                                                                                </span>
                                                                                <span style={{
                                                                                    fontSize: '16px',
                                                                                    fontWeight: 700,
                                                                                    opacity: 1,
                                                                                    marginLeft: '4px',
                                                                                    color: (hasVendorBid || isAtOrAboveReserve || vendorBidDisabledByReserve || !canPlaceVendorBid || timeRemaining === null || timeRemaining <= 5) ? '#8c8c8c' : '#ffffff'
                                                                                }}>
                                                                                    {(() => {
                                                                                        const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
                                                                                        const reservePrice = parseFloat(selectedLot.reserve_price);
                                                                                        const highestBidAmount = parseFloat(selectedLot.current_price) || parseFloat(selectedLot.starting_price);
                                                                                        let vendorBidAmount = reservePrice - increment;
                                                                                        if (vendorBidAmount < highestBidAmount) {
                                                                                            vendorBidAmount = Math.min(highestBidAmount + increment, reservePrice - increment);
                                                                                        }
                                                                                        return formatCurrency(vendorBidAmount);
                                                                                    })()}
                                                                                </span>
                                                                            </Button>
                                                                        </div>
                                                                    )}


                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            )}
                                    </div>


                                    {/* Lot Details Section */}
                                    <div style={{ marginTop: 0 }}>
                                        {/* <div style={{ 
                                marginBottom: 16,
                                padding: '12px 16px',
                                background: 'linear-gradient(135deg, #f6ffed 0%, #fcffe6 100%)',
                                borderRadius: '8px',
                                border: '1px solid #b7eb8f'
                            }}>
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: 8,
                                    marginBottom: 4
                                }}>
                                    <UnorderedListOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
                                    <Text strong style={{ fontSize: '14px', color: '#52c41a' }}>
                                        Lot Information
                                    </Text>
                                </div>
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    View details, photos, specifications, and bid history
                                </Text>
                            </div> */}
                                        <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 0 }}>
                                            <Tabs
                                                className="lot-details-tabs"
                                                data-tour="lot-details-tabs"
                                                activeKey={lotDetailsActiveTab ?? (liveStreamUrl ? 'live-stream' : '1')}
                                                onChange={setLotDetailsActiveTab}
                                                destroyInactiveTabPane
                                                size="small"
                                                style={{
                                                    margin: 0,
                                                    padding: 0
                                                }}
                                                tabBarStyle={{
                                                    margin: 0,
                                                    marginBottom: 0,
                                                    padding: 0,
                                                    background: 'transparent'
                                                }}
                                                items={(() => {
                                                    const tabs = [];

                                                    if (liveStreamUrl) {
                                                        tabs.push({
                                                            key: 'live-stream',
                                                            label: (
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    <PlayCircleOutlined style={{ color: '#ff4d4f' }} />
                                                                    Live Stream
                                                                </span>
                                                            ),
                                                            children: (
                                                                <div style={{ padding: '8px 0' }}>
                                                                    <LiveStreamEmbed
                                                                        url={liveStreamUrl}
                                                                        title="Auction Live Stream"
                                                                        maxHeight={180}
                                                                        active={(lotDetailsActiveTab ?? (liveStreamUrl ? 'live-stream' : '1')) === 'live-stream'}
                                                                    />
                                                                </div>
                                                            )
                                                        });
                                                    }

                                                    tabs.push(
                                                        {
                                                            key: '1',
                                                            label: 'Details',
                                                            children: <LotDetails lot={selectedLot} auctionSlug={auction?.slug} />
                                                        },
                                                        {
                                                            key: '2',
                                                            label: 'Photos',
                                                            children: (
                                                                <div>
                                                                    {Array.isArray(selectedLot.images) && selectedLot.images.length > 0 ? (
                                                                        <Carousel
                                                                            autoplay={selectedLot.images.length > 1}
                                                                            dots={true}
                                                                            arrows={true}
                                                                            style={{ borderRadius: 8, overflow: 'hidden' }}
                                                                        >
                                                                            {selectedLot.images.map((image, index) => (
                                                                                <div key={index}>
                                                                                    <img
                                                                                        src={env.BACKEND_STORAGE_URL + '/' + image.path}
                                                                                        alt={`${selectedLot.title} - Image ${index + 1}`}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            height: 300,
                                                                                            objectFit: 'cover'
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ))}
                                                                        </Carousel>
                                                                    ) : (
                                                                        <div style={{
                                                                            width: '100%',
                                                                            height: 300,
                                                                            background: '#f0f0f0',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            flexDirection: 'column',
                                                                            gap: '16px',
                                                                            borderRadius: 8
                                                                        }}>
                                                                            <div style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                borderRadius: '50%',
                                                                                background: '#1890ff',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                color: 'white',
                                                                                fontSize: '32px',
                                                                                fontWeight: 'bold'
                                                                            }}>
                                                                                M
                                                                            </div>
                                                                            <div style={{
                                                                                color: '#666',
                                                                                fontSize: '16px',
                                                                                fontWeight: '500'
                                                                            }}>
                                                                                Maveshibids
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        }
                                                    );

                                                    // Add video tab if lot has video
                                                    if (selectedLot?.video_url) {
                                                        tabs.push({
                                                            key: '3',
                                                            label: 'Video',
                                                            children: (
                                                                <div style={{ padding: '0' }}>
                                                                    <div style={{
                                                                        position: 'relative',
                                                                        width: '100%',
                                                                        height: '0',
                                                                        paddingBottom: '56.25%', // 16:9 aspect ratio
                                                                        borderRadius: '8px',
                                                                        overflow: 'hidden',
                                                                        background: '#000'
                                                                    }}>
                                                                        <iframe
                                                                            src={validateVideoUrl(selectedLot.video_url).embedUrl}
                                                                            title="Lot Video Preview"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: 0,
                                                                                left: 0,
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                border: 'none',
                                                                                borderRadius: '8px'
                                                                            }}
                                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                            allowFullScreen
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        });
                                                    }

                                                    // Add specifications tab
                                                    tabs.push({
                                                        key: selectedLot?.video_url ? '4' : '3',
                                                        label: 'Specifications',
                                                        children: <LotSpecifications lot={selectedLot} />
                                                    });

                                                    // Calculate key based on whether video exists and adjust subsequent tabs
                                                    const baseTabKey = selectedLot?.video_url ? 4 : 3;
                                                    /* AI Recommendations (price recommendation) tab - disabled
                                                    if (currentUser?.id !== auction?.user_id) {
                                                        const aiRecommendationsKey = String(baseTabKey + 0.5).replace('.5', 'a'); // Use 'a' suffix for AI tab
                                                        tabs.push({
                                                            key: aiRecommendationsKey,
                                                            label: (
                                                                <span>
                                                                    <RobotOutlined style={{ marginRight: '4px', color: '#1890ff' }} />
                                                                    AI Recommendations
                                                                </span>
                                                            ),
                                                            children: (
                                                                <div style={{ padding: '8px 0' }}>
                                                                    <AIPriceRecommendation
                                                                        lot={selectedLot}
                                                                        bidHistory={bidHistory}
                                                                        lots={lots}
                                                                        currentUser={currentUser}
                                                                        auctionOwnerId={auction?.user_id}
                                                                    />
                                                                </div>
                                                            )
                                                        });
                                                    }
                                                    */

                                                    tabs.push({
                                                        key: String(baseTabKey + 1),
                                                        label: (
                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                <HistoryOutlined />
                                                                Bid History
                                                                {bidHistory.length > 0 && (
                                                                    <Badge count={bidHistory.length} size="small" />
                                                                )}
                                                            </span>
                                                        ),
                                                        children: (
                                                            <div>
                                                                {bidHistory.length > 0 && (
                                                                    <div style={{
                                                                        marginBottom: 16,
                                                                        padding: '12px 16px',
                                                                        background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #91d5ff'
                                                                    }}>
                                                                        <Text strong style={{ fontSize: '14px', color: '#1890ff', display: 'block', marginBottom: 4 }}>
                                                                            Total Bids: {bidHistory.length}
                                                                        </Text>
                                                                        <Text type="secondary" style={{ fontSize: '12px' }}>
                                                                            Highest: {formatCurrency(Math.max(...bidHistory.map(b => b.amount)))}
                                                                        </Text>
                                                                    </div>
                                                                )}
                                                                <BidHistoryViewer
                                                                    bidHistory={bidHistory}
                                                                    loading={bidHistoryLoading}
                                                                    currentUser={currentUser}
                                                                    lot={selectedLot}
                                                                    auctionOwnerId={auction?.user_id}
                                                                    rejectedBids={selectedLot ? (rejectedBids.get(selectedLot.id) || []) : []}
                                                                />
                                                            </div>
                                                        )
                                                    });


                                                    return tabs;
                                                })()}
                                            />
                                        </div>
                                    </div>

                                    {/* Bidding Options - Sticky at Bottom */}
                                    {!checkIfLotClosed(selectedLot) && selectedLot.status === 'active' && currentUser?.id !== auction?.user_id &&
                                        (!auction?.is_private || (isInvited && invitationStatus === 'accepted')) && (
                                            <div data-tour="bidding-section" style={{
                                                marginTop: 'auto',
                                                paddingTop: '12px',
                                                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                                                position: 'sticky',
                                                bottom: 0,
                                                zIndex: 10
                                            }}>
                                                {/* Toggle Button */}
                                                <div style={{
                                                    marginBottom: 8,
                                                    display: 'flex',
                                                    justifyContent: 'center'
                                                }}>
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        icon={showBiddingOptions ? <DownOutlined /> : <UpOutlined />}
                                                        onClick={() => setShowBiddingOptions(!showBiddingOptions)}
                                                        style={{
                                                            color: '#1890ff',
                                                            fontSize: '12px'
                                                        }}
                                                    >
                                                        {showBiddingOptions ? 'Hide Bidding Options' : 'Show Bidding Options'}
                                                    </Button>
                                                </div>

                                                {showBiddingOptions && (
                                                    <div style={{ margin: '16px 0' }}>
                                                        {/* <div style={{ 
                                    marginBottom: 12,
                                    padding: '10px 12px',
                                    background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)',
                                    borderRadius: '8px',
                                    border: '1px solid #91d5ff'
                                }}>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: 8,
                                        marginBottom: 4
                                    }}>
                                        <ThunderboltOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
                                        <Text strong style={{ fontSize: '14px', color: '#1890ff' }}>
                                            Bidding Options
                                        </Text>
                                    </div>
                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                        Choose your bid amount or set up auto-bidding
                                    </Text>
                                </div> */}
                                                        {!checkIfLotClosed(selectedLot) && (
                                                            <>
                                                                <div style={{ margin: window.innerWidth < 992 ? '0' : '12px 0' }}>
                                                                    {selectedLot && !subscribedLotIds.includes(selectedLot.id) ? (
                                                                        window.innerWidth < 992 ? (
                                                                            <div
                                                                                className="bidding-buttons-mobile"
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    bottom: 0,
                                                                                    left: 0,
                                                                                    right: 0,
                                                                                    width: '100%',
                                                                                    padding: '12px',
                                                                                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                                                                                    borderTop: '2px solid #d9d9d9',
                                                                                    boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.15)',
                                                                                    zIndex: 999
                                                                                }}
                                                                            >
                                                                                <div data-tour="subscribe-bidding">
                                                                                    <SubscribeButton
                                                                                        selectedLot={selectedLot}
                                                                                        isInvitationLoading={isInvitationLoading}
                                                                                        auction={auction}
                                                                                        isInvited={isInvited}
                                                                                        invitationStatus={invitationStatus}
                                                                                        currentUser={currentUser}
                                                                                        onSubscribe={() => setSubscribedLotIds((ids) => [...ids, selectedLot.id])}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div data-tour="subscribe-bidding">
                                                                                <SubscribeButton
                                                                                    selectedLot={selectedLot}
                                                                                    isInvitationLoading={isInvitationLoading}
                                                                                    auction={auction}
                                                                                    isInvited={isInvited}
                                                                                    invitationStatus={invitationStatus}
                                                                                    currentUser={currentUser}
                                                                                    onSubscribe={() => setSubscribedLotIds((ids) => [...ids, selectedLot.id])}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            {/* Buy Now Button - Prominently Displayed */}
                                                                            {/* Show Buy Now only if: no reserve price AND buy_now_price is available */}
                                                                            {selectedLot?.can_buy_now &&
                                                                                selectedLot?.buy_now_price &&
                                                                                !selectedLot?.reserve_price &&
                                                                                !checkIfLotClosed(selectedLot) &&
                                                                                selectedLot.status === 'active' &&
                                                                                currentUser?.id !== auction?.user_id &&
                                                                                (!auction?.is_private || (isInvited && invitationStatus === 'accepted')) && (
                                                                                    <div style={{
                                                                                        marginBottom: '16px',
                                                                                        width: '100%'
                                                                                    }}>
                                                                                        <Button
                                                                                            type="primary"
                                                                                            size="large"
                                                                                            icon={<ThunderboltOutlined />}
                                                                                            onClick={handleBuyNow}
                                                                                            loading={buyingNow}
                                                                                            disabled={
                                                                                                buyingNow ||
                                                                                                checkIfLotClosed(selectedLot) ||
                                                                                                selectedLot.status !== 'active' ||
                                                                                                currentUser?.id === auction?.user_id ||
                                                                                                (auction?.is_private && (!isInvited || invitationStatus !== 'accepted'))
                                                                                            }
                                                                                            block
                                                                                            style={{
                                                                                                height: '56px',
                                                                                                fontSize: '16px',
                                                                                                fontWeight: 700,
                                                                                                background: 'linear-gradient(135deg, #ff6b35, #f7931e)',
                                                                                                border: 'none',
                                                                                                boxShadow: '0 4px 16px rgba(255, 107, 53, 0.4)',
                                                                                                borderRadius: '8px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                                gap: '8px',
                                                                                                transition: 'all 0.3s ease',
                                                                                                color: '#ffffff'
                                                                                            }}
                                                                                            onMouseEnter={(e) => {
                                                                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 107, 53, 0.6)';
                                                                                                e.currentTarget.style.background = 'linear-gradient(135deg, #f7931e, #ff8c42)';
                                                                                                e.currentTarget.style.color = '#ffffff';
                                                                                            }}
                                                                                            onMouseLeave={(e) => {
                                                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                                                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(255, 107, 53, 0.4)';
                                                                                                e.currentTarget.style.background = 'linear-gradient(135deg, #ff6b35, #f7931e)';
                                                                                                e.currentTarget.style.color = '#ffffff';
                                                                                            }}
                                                                                            onMouseDown={(e) => {
                                                                                                e.currentTarget.style.color = '#ffffff';
                                                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                                                            }}
                                                                                            onMouseUp={(e) => {
                                                                                                e.currentTarget.style.color = '#ffffff';
                                                                                            }}
                                                                                        >
                                                                                            <span style={{ color: '#ffffff' }}>Buy Now</span>
                                                                                            <span style={{
                                                                                                fontSize: '18px',
                                                                                                fontWeight: 800,
                                                                                                marginLeft: '4px',
                                                                                                color: '#ffffff'
                                                                                            }}>
                                                                                                {formatCurrency(selectedLot.buy_now_price)}
                                                                                            </span>
                                                                                        </Button>
                                                                                        <div style={{
                                                                                            marginTop: '8px',
                                                                                            textAlign: 'center',
                                                                                            fontSize: '12px',
                                                                                            color: '#8c8c8c'
                                                                                        }}>
                                                                                            Instant purchase - No bidding required
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            <div
                                                                                className="bidding-buttons-mobile"
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    alignItems: 'center',
                                                                                    gap: '12px',
                                                                                    width: '100%',
                                                                                    padding: window.innerWidth < 992 ? '12px' : '0 8px',
                                                                                    position: window.innerWidth < 992 ? 'fixed' : 'relative',
                                                                                    bottom: window.innerWidth < 992 ? 0 : 'auto',
                                                                                    left: window.innerWidth < 992 ? 0 : 'auto',
                                                                                    right: window.innerWidth < 992 ? 0 : 'auto',
                                                                                    background: window.innerWidth < 992 ? 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' : 'transparent',
                                                                                    borderTop: window.innerWidth < 992 ? '2px solid #d9d9d9' : 'none',
                                                                                    boxShadow: window.innerWidth < 992 ? '0 -4px 12px rgba(0, 0, 0, 0.15)' : 'none',
                                                                                    zIndex: window.innerWidth < 992 ? 999 : 'auto'
                                                                                }}
                                                                            >
                                                                                {renderBidButtons(selectedLot)}
                                                                            </div>

                                                                            {/* Custom Bid Section */}
                                                                            {isLotAvailableForBidding(selectedLot) &&
                                                                                !checkIfLotClosed(selectedLot) &&
                                                                                (!auction?.is_private || (isInvited && invitationStatus === 'accepted')) &&
                                                                                currentUser?.id !== auction?.user_id && (
                                                                                    <div data-tour="custom-bid-section" style={{ marginTop: 16 }}>
                                                                                        {!showCustomBid ? (
                                                                                            <Button
                                                                                                type="dashed"
                                                                                                onClick={() => setShowCustomBid(true)}
                                                                                                style={{ width: '100%' }}
                                                                                                disabled={selectedLot.last_bid_user_id === currentUser?.id || (timeRemaining !== null && timeRemaining <= 5)}
                                                                                            >
                                                                                                Custom Bid Amount
                                                                                            </Button>
                                                                                        ) : (
                                                                                            <div style={{
                                                                                                padding: '12px',
                                                                                                background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
                                                                                                borderRadius: '8px',
                                                                                                border: '1px solid #e8e8e8',
                                                                                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
                                                                                            }}>
                                                                                                {/* Instruction message when template bid is selected */}
                                                                                                {validRoundedAmountApplied && customBidAmount && (
                                                                                                    <Alert
                                                                                                        message={
                                                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                                                <span style={{ fontSize: '18px' }}>✅</span>
                                                                                                                <span style={{ fontSize: '14px', fontWeight: 500 }}>
                                                                                                                    Template bid selected: {formatCurrency(customBidAmount)}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        }
                                                                                                        description={
                                                                                                            <div style={{ marginTop: '8px', fontSize: '13px', color: '#595959' }}>
                                                                                                                Review the bid amount above and click "Place Bid" to submit your bid.
                                                                                                            </div>
                                                                                                        }
                                                                                                        type="success"
                                                                                                        showIcon={false}
                                                                                                        style={{
                                                                                                            marginBottom: 16,
                                                                                                            background: 'linear-gradient(135deg, #f6ffed 0%, #e6f7ff 100%)',
                                                                                                            border: '2px solid #52c41a',
                                                                                                            borderRadius: '8px'
                                                                                                        }}
                                                                                                        closable={false}
                                                                                                    />
                                                                                                )}
                                                                                                <Space direction="vertical" style={{ width: '100%' }} size="small">
                                                                                                    <div>
                                                                                                        <Text strong style={{
                                                                                                            display: 'block',
                                                                                                            marginBottom: 6,
                                                                                                            fontSize: '14px',
                                                                                                            color: '#262626'
                                                                                                        }}>
                                                                                                            {validRoundedAmountApplied && customBidAmount ? 'Review Your Bid Amount' : 'Enter Custom Bid Amount'}
                                                                                                        </Text>
                                                                                                        <InputNumber
                                                                                                            min={(() => {
                                                                                                                const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
                                                                                                                const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
                                                                                                                return current + increment;
                                                                                                            })()}
                                                                                                            step={parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5}
                                                                                                            prefix="PKR"
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                height: '36px',
                                                                                                                fontSize: '14px'
                                                                                                            }}
                                                                                                            placeholder="Enter bid amount"
                                                                                                            value={customBidAmount}
                                                                                                            onChange={(value) => {
                                                                                                                setCustomBidAmount(value);
                                                                                                                setBidError(null);
                                                                                                                // Check if entered amount is a valid exact increment
                                                                                                                if (value) {
                                                                                                                    const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
                                                                                                                    const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
                                                                                                                    const minBid = current + increment;
                                                                                                                    const customAmount = parseFloat(value);
                                                                                                                    if (!isNaN(customAmount)) {
                                                                                                                        const excessAboveCurrent = customAmount - current;
                                                                                                                        const isValidIncrement = excessAboveCurrent % increment === 0;
                                                                                                                        const meetsMinimum = customAmount >= minBid;
                                                                                                                        if (isValidIncrement && meetsMinimum) {
                                                                                                                            setValidRoundedAmountApplied(true);
                                                                                                                        } else {
                                                                                                                            setValidRoundedAmountApplied(false);
                                                                                                                        }
                                                                                                                    } else {
                                                                                                                        setValidRoundedAmountApplied(false);
                                                                                                                    }
                                                                                                                } else {
                                                                                                                    setValidRoundedAmountApplied(false);
                                                                                                                }
                                                                                                            }}
                                                                                                            onPressEnter={handleCustomBid}
                                                                                                            disabled={bidding || selectedLot.last_bid_user_id === currentUser?.id || (timeRemaining !== null && timeRemaining <= 5)}
                                                                                                            parser={(value) => {
                                                                                                                if (!value) return '';
                                                                                                                return value.replace(/PKR\s?/g, '');
                                                                                                            }}
                                                                                                        />
                                                                                                        <div style={{
                                                                                                            marginTop: 6,
                                                                                                            fontSize: '10px',
                                                                                                            color: '#8c8c8c',
                                                                                                            padding: '4px 8px',
                                                                                                            background: '#f5f5f5',
                                                                                                            borderRadius: '3px'
                                                                                                        }}>
                                                                                                            {(() => {
                                                                                                                const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
                                                                                                                const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
                                                                                                                const minBid = current + increment;
                                                                                                                return `Minimum: ${formatCurrency(minBid)} • Must be exact multiple of increment (${formatCurrency(increment)})`;
                                                                                                            })()}
                                                                                                        </div>
                                                                                                        {customBidAmount && (() => {
                                                                                                            const increment = parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5;
                                                                                                            const current = parseInt(selectedLot.current_price) || parseInt(selectedLot.starting_price);
                                                                                                            const minBid = current + increment;
                                                                                                            const customAmount = parseFloat(customBidAmount);

                                                                                                            if (isNaN(customAmount)) {
                                                                                                                return null;
                                                                                                            }

                                                                                                            // Check if amount is valid (exact multiple of increment)
                                                                                                            const excessAboveCurrent = customAmount - current;
                                                                                                            const isValidIncrement = excessAboveCurrent % increment === 0;
                                                                                                            const meetsMinimum = customAmount >= minBid;

                                                                                                            // Only show preview for invalid increment or valid amounts
                                                                                                            // Skip showing "below minimum" since validation already prevents submission
                                                                                                            if (!isValidIncrement) {
                                                                                                                const nearestLower = current + (Math.floor(excessAboveCurrent / increment) * increment);
                                                                                                                const nearestUpper = current + (Math.ceil(excessAboveCurrent / increment) * increment);
                                                                                                                const validOptions = [];
                                                                                                                if (nearestLower >= minBid) validOptions.push(nearestLower);
                                                                                                                if (nearestUpper >= minBid && nearestUpper !== nearestLower) validOptions.push(nearestUpper);

                                                                                                                if (validOptions.length > 0) {
                                                                                                                    return (
                                                                                                                        <div style={{
                                                                                                                            marginTop: 8,
                                                                                                                            padding: '10px 12px',
                                                                                                                            background: 'linear-gradient(135deg, #fffbe6 0%, #fff7e6 100%)',
                                                                                                                            borderRadius: '6px',
                                                                                                                            border: '1px solid #ffe58f',
                                                                                                                            boxShadow: '0 1px 4px rgba(250, 173, 20, 0.12)'
                                                                                                                        }}>
                                                                                                                            <Space align="start" style={{ width: '100%' }}>
                                                                                                                                <span style={{ fontSize: '16px', marginTop: 1 }}>💡</span>
                                                                                                                                <div style={{ flex: 1 }}>
                                                                                                                                    <Text strong style={{ fontSize: '12px', color: '#d48806', display: 'block', marginBottom: 6 }}>
                                                                                                                                        Invalid Increment
                                                                                                                                    </Text>
                                                                                                                                    <Text style={{ fontSize: '11px', color: '#8c8c8c', display: 'block', marginBottom: 6 }}>
                                                                                                                                        Amount must be an exact multiple of {formatCurrency(increment)}. Click a valid amount below:
                                                                                                                                    </Text>
                                                                                                                                    <Space size="small" wrap style={{ width: '100%' }}>
                                                                                                                                        {validOptions.map((option, idx) => (
                                                                                                                                            <Button
                                                                                                                                                key={idx}
                                                                                                                                                size="small"
                                                                                                                                                type="default"
                                                                                                                                                style={{
                                                                                                                                                    padding: '3px 10px',
                                                                                                                                                    height: 'auto',
                                                                                                                                                    fontSize: '12px',
                                                                                                                                                    fontWeight: 600,
                                                                                                                                                    color: '#d48806',
                                                                                                                                                    borderColor: '#ffd591',
                                                                                                                                                    background: '#fff',
                                                                                                                                                    borderRadius: '5px',
                                                                                                                                                    transition: 'all 0.3s ease',
                                                                                                                                                    boxShadow: '0 1px 2px rgba(250, 173, 20, 0.1)'
                                                                                                                                                }}
                                                                                                                                                onMouseEnter={(e) => {
                                                                                                                                                    e.target.style.background = '#fffbe6';
                                                                                                                                                    e.target.style.borderColor = '#ffc53d';
                                                                                                                                                    e.target.style.transform = 'translateY(-1px)';
                                                                                                                                                    e.target.style.boxShadow = '0 2px 4px rgba(250, 173, 20, 0.2)';
                                                                                                                                                }}
                                                                                                                                                onMouseLeave={(e) => {
                                                                                                                                                    e.target.style.background = '#fff';
                                                                                                                                                    e.target.style.borderColor = '#ffd591';
                                                                                                                                                    e.target.style.transform = 'translateY(0)';
                                                                                                                                                    e.target.style.boxShadow = '0 1px 2px rgba(250, 173, 20, 0.1)';
                                                                                                                                                }}
                                                                                                                                                onClick={() => {
                                                                                                                                                    setCustomBidAmount(option);
                                                                                                                                                    setBidError(null);
                                                                                                                                                    setValidRoundedAmountApplied(true);
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                {formatCurrency(option)}
                                                                                                                                            </Button>
                                                                                                                                        ))}
                                                                                                                                    </Space>
                                                                                                                                </div>
                                                                                                                            </Space>
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                }
                                                                                                            }

                                                                                                            // Valid amount - show success indicator
                                                                                                            if (isValidIncrement && meetsMinimum) {
                                                                                                                return (
                                                                                                                    <div style={{
                                                                                                                        marginTop: 8,
                                                                                                                        padding: '10px 12px',
                                                                                                                        background: 'linear-gradient(135deg, #f6ffed 0%, #f0f9ff 100%)',
                                                                                                                        borderRadius: '6px',
                                                                                                                        border: '1px solid #b7eb8f',
                                                                                                                        boxShadow: '0 1px 3px rgba(82, 196, 26, 0.1)'
                                                                                                                    }}>
                                                                                                                        <Space align="start" style={{ width: '100%' }}>
                                                                                                                            <span style={{ fontSize: '14px' }}>✓</span>
                                                                                                                            <div style={{ flex: 1 }}>
                                                                                                                                <Text strong style={{ fontSize: '12px', color: '#52c41a', display: 'block', marginBottom: 3 }}>
                                                                                                                                    Valid Bid Amount
                                                                                                                                </Text>
                                                                                                                                <Text style={{ fontSize: '11px', color: '#8c8c8c', display: 'block' }}>
                                                                                                                                    Your bid of <strong style={{ color: '#52c41a' }}>{formatCurrency(customAmount)}</strong> is valid and ready to place
                                                                                                                                </Text>
                                                                                                                            </div>
                                                                                                                        </Space>
                                                                                                                    </div>
                                                                                                                );
                                                                                                            }

                                                                                                            return null;
                                                                                                        })()}
                                                                                                    </div>
                                                                                                    <Space style={{ width: '100%' }} size="small">
                                                                                                        <Button
                                                                                                            type="primary"
                                                                                                            onClick={handleCustomBid}
                                                                                                            loading={bidding}
                                                                                                            disabled={
                                                                                                                !customBidAmount ||
                                                                                                                bidding ||
                                                                                                                selectedLot.last_bid_user_id === currentUser?.id ||
                                                                                                                (timeRemaining !== null && timeRemaining <= 5) ||
                                                                                                                !isLotAvailableForBidding(selectedLot) ||
                                                                                                                isLotClosed(selectedLot) ||
                                                                                                                (auction?.is_private && (!isInvited || invitationStatus !== 'accepted')) ||
                                                                                                                currentUser?.id === auction?.user_id ||
                                                                                                                selectedLot.status === 'closed' ||
                                                                                                                selectedLot.status === 'cancelled' ||
                                                                                                                !validRoundedAmountApplied
                                                                                                            }
                                                                                                            style={{
                                                                                                                flex: 1,
                                                                                                                height: '38px',
                                                                                                                fontSize: '14px',
                                                                                                                fontWeight: 600,
                                                                                                                borderRadius: '6px',
                                                                                                                boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)'
                                                                                                            }}
                                                                                                        >
                                                                                                            Place Bid
                                                                                                        </Button>
                                                                                                        <Button
                                                                                                            onClick={() => {
                                                                                                                setShowCustomBid(false);
                                                                                                                setCustomBidAmount('');
                                                                                                                setBidError(null);
                                                                                                                setValidRoundedAmountApplied(false);
                                                                                                            }}
                                                                                                            style={{
                                                                                                                height: '38px',
                                                                                                                borderRadius: '6px'
                                                                                                            }}
                                                                                                        >
                                                                                                            Cancel
                                                                                                        </Button>
                                                                                                    </Space>
                                                                                                </Space>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}

                                                                            {/* Anchor element for scrolling to bottom on mobile/tablet */}

                                                                            {isLotAvailableForBidding(selectedLot) && (
                                                                                <div style={{ margin: '12px 0' }}>
                                                                                    {renderAutoBidSection()}
                                                                                </div>
                                                                            )}

                                                                            {/* Reminder Button */}
                                                                            {selectedLot && selectedLot.status === 'active' && (
                                                                                <div style={{ margin: '12px 0' }}>
                                                                                    <Space>
                                                                                        {bidReminders[selectedLot.id] ? (
                                                                                            <>
                                                                                                <Tag color="orange" icon={<BellOutlined />}>
                                                                                                    Reminder set: {bidReminders[selectedLot.id].reminderSeconds}s before closing
                                                                                                </Tag>
                                                                                                <Button
                                                                                                    size="small"
                                                                                                    icon={<CloseOutlined />}
                                                                                                    onClick={() => removeReminder(selectedLot.id)}
                                                                                                >
                                                                                                    Remove Reminder
                                                                                                </Button>
                                                                                            </>
                                                                                        ) : (
                                                                                            <Button
                                                                                                size="small"
                                                                                                icon={<BellOutlined />}
                                                                                                onClick={() => setReminderModalVisible(true)}
                                                                                                data-tour="set-reminder"
                                                                                            >
                                                                                                Set Reminder
                                                                                            </Button>
                                                                                        )}
                                                                                    </Space>
                                                                                </div>
                                                                            )}

                                                                            <div id="bid-section-bottom" style={{ height: '1px', visibility: 'hidden' }}></div>

                                                                        </>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                        {bidError && <Alert message={bidError} type="error" showIcon style={{ marginTop: 8 }} />}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                </div>
                            </Card>
                        ) : (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '60px 20px',
                                textAlign: 'center',
                                minHeight: '100vh',
                                background: 'linear-gradient(135deg, #fafbfc 0%, #f0f2f5 100%)',
                                borderRadius: '12px'
                            }}>
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #1890ff, #40a9ff)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '24px',
                                    boxShadow: '0 8px 24px rgba(24, 144, 255, 0.2)'
                                }}>
                                    <div style={{
                                        fontSize: '36px',
                                        color: 'white',
                                        fontWeight: 'bold'
                                    }}>
                                        M
                                    </div>
                                </div>
                                <h3 style={{
                                    margin: '0 0 12px 0',
                                    color: '#262626',
                                    fontSize: '20px',
                                    fontWeight: '600'
                                }}>
                                    {getFilteredAndSortedLots().length === 0 ? 'No Lots Available' : 'Select a Lot'}
                                </h3>
                                <p style={{
                                    margin: '0 0 24px 0',
                                    color: '#8c8c8c',
                                    fontSize: '14px',
                                    lineHeight: '1.6',
                                    maxWidth: '320px'
                                }}>
                                    {getFilteredAndSortedLots().length === 0
                                        ? 'There are no lots in this category. Try selecting a different filter from the sidebar or check back later.'
                                        : 'Click on any lot card from the left to view its details, place bids, and see photos here.'
                                    }
                                </p>
                                {getFilteredAndSortedLots().length === 0 && (
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        alignItems: 'center'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            color: '#1890ff',
                                            fontSize: '13px',
                                            fontWeight: '500'
                                        }}>
                                            <span>💡</span>
                                            <span>Try these filters:</span>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            gap: '8px',
                                            flexWrap: 'wrap',
                                            justifyContent: 'center'
                                        }}>
                                            {(() => {
                                                const isAuctionOwner = currentUser?.id === auction?.user_id;
                                                const filters = [
                                                    { label: 'All Lots', key: 'all' },
                                                    { label: 'Favorite Lots', key: 'favorite' },
                                                    ...(isAuctionOwner ? [] : [{ label: 'Actively Bidding', key: 'actively_bidding' }]),
                                                    { label: 'My Held Lots', key: 'held' },
                                                    { label: 'My Lost Lots', key: 'lost' }
                                                ];
                                                return filters;
                                            })().map(filter => (
                                                <div
                                                    key={filter.key}
                                                    onClick={() => setSidebarFilter(filter.key)}
                                                    style={{
                                                        background: '#f0f9ff',
                                                        color: '#1890ff',
                                                        padding: '4px 12px',
                                                        borderRadius: '16px',
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        border: '1px solid #bae7ff',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        userSelect: 'none'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = '#e6f7ff';
                                                        e.target.style.borderColor = '#91d5ff';
                                                        e.target.style.transform = 'translateY(-1px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = '#f0f9ff';
                                                        e.target.style.borderColor = '#bae7ff';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    {filter.label}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Col>
                )}
            </Row>

            {/* Help Modal */}
            <HelpModal
                visible={helpModalVisible}
                onClose={() => setHelpModalVisible(false)}
                auction={auction}
            />


            {/* Search Modal */}
            <LotSearchModal
                visible={searchModalVisible}
                onClose={() => setSearchModalVisible(false)}
                searchMode={searchMode}
                setSearchMode={setSearchMode}
                simpleSearchQuery={simpleSearchQuery}
                setSimpleSearchQuery={setSimpleSearchQuery}
                advancedSearch={advancedSearch}
                setAdvancedSearch={setAdvancedSearch}
                getFilteredAndSortedLots={getFilteredAndSortedLots}
            />


            {/* Auction Video Preview Modal */}
            {auction?.video_url && (
                <VideoPreviewModal
                    visible={auctionVideoModalVisible}
                    onClose={() => setAuctionVideoModalVisible(false)}
                    videoUrl={auction.video_url}
                    title="Auction Promotional Video"
                    width={900}
                    height={500}
                />
            )}

            {/* Template Bids Modal */}
            <TemplateBidsModal
                visible={showTemplateBidsModal}
                onClose={() => setShowTemplateBidsModal(false)}
                selectedLot={selectedLot}
                getTemplateBids={getTemplateBids}
                handleTemplateBidSelect={handleTemplateBidSelect}
                formatCurrency={formatCurrency}
            />


            {/* Bid History Modal - disabled along with the Bid History tab (its only trigger) */}
            {/* <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '20px'
                        }}>
                            <HistoryOutlined />
                        </div>
                        <div>
                            <div style={{ fontSize: '18px', fontWeight: 700, color: '#262626', lineHeight: '1.2' }}>
                                Bid History
                            </div>
                            <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
                                {selectedLot && `Lot #${selectedLot.lot_number}: ${selectedLot.title}`}
                            </div>
                        </div>
                    </div>
                }
                open={bidHistoryModalVisible}
                onCancel={() => setBidHistoryModalVisible(false)}
                footer={null}
                width={800}
                style={{ top: 50 }}
                bodyStyle={{ padding: '24px' }}
            >
                {selectedLot && (
                    <div>
                        {/* Statistics Card *\/}
                        {bidHistory.length > 0 && (
                            <div style={{
                                marginBottom: 20,
                                padding: '16px 20px',
                                background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)',
                                borderRadius: '10px',
                                border: '2px solid #91d5ff',
                                boxShadow: '0 2px 8px rgba(24, 144, 255, 0.15)'
                            }}>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Statistic
                                            title="Total Bids"
                                            value={bidHistory.length}
                                            valueStyle={{ color: '#1890ff', fontSize: '24px', fontWeight: 700 }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Statistic
                                            title="Highest Bid"
                                            value={formatCurrency(Math.max(...bidHistory.map(b => b.amount)))}
                                            valueStyle={{ color: '#52c41a', fontSize: '24px', fontWeight: 700 }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Statistic
                                            title="Lowest Bid"
                                            value={formatCurrency(Math.min(...bidHistory.map(b => b.amount)))}
                                            valueStyle={{ color: '#faad14', fontSize: '24px', fontWeight: 700 }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {/* Tabs for Chart and List View *\/}
                        <Tabs
                            defaultActiveKey="chart"
                            items={[
                                {
                                    key: 'chart',
                                    label: (
                                        <span>
                                            <LineChartOutlined style={{ marginRight: '4px' }} />
                                            Price Chart
                                        </span>
                                    ),
                                    children: (
                                        <div>
                                            <PriceHistoryChart
                                                bidHistory={bidHistory}
                                                lot={selectedLot}
                                            />
                                        </div>
                                    )
                                },
                                {
                                    key: 'list',
                                    label: (
                                        <span>
                                            <HistoryOutlined style={{ marginRight: '4px' }} />
                                            Bid List
                                            {bidHistory.length > 0 && (
                                                <Badge count={bidHistory.length} size="small" style={{ marginLeft: '8px' }} />
                                            )}
                                        </span>
                                    ),
                                    children: (
                                        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                            <BidHistoryViewer
                                                bidHistory={bidHistory}
                                                loading={bidHistoryLoading}
                                                currentUser={currentUser}
                                                lot={selectedLot}
                                                auctionOwnerId={auction?.user_id}
                                                rejectedBids={selectedLot ? (rejectedBids.get(selectedLot.id) || []) : []}
                                            />
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </div>
                )}
            </Modal> */}

            {/* Max-Bid Dashboard Modal */}
            <MaxBidDashboardModal
                visible={showAutoBidDashboard}
                onClose={() => setShowAutoBidDashboard(false)}
                activeAutoBids={activeAutoBids}
                lots={lots}
                currentUser={currentUser}
                allLotsTimeRemaining={allLotsTimeRemaining}
                setSelectedLot={setSelectedLot}
                formatCurrency={formatCurrency}
                handleStopAutoBid={handleStopAutoBid}
            />


            {/* Reminder Set Modal */}
            <BidReminderModal
                visible={reminderModalVisible}
                onClose={() => setReminderModalVisible(false)}
                selectedLot={selectedLot}
                bidReminders={bidReminders}
                setReminder={setReminder}
            />


            {/* Bid Activity Drawer */}
            <BidActivityDrawer
                visible={reminderDrawerVisible}
                onClose={() => setReminderDrawerVisible(false)}
                loading={loadingBidActivity}
                bidActivityData={bidActivityData}
                currentUser={currentUser}
                auction={auction}
                lots={lots}
                setSelectedLot={setSelectedLot}
                bidActivityCount={bidActivityCount}
                setLastViewedActivityCount={setLastViewedActivityCount}
                formatCurrency={formatCurrency}
            />


            {/* Announcement Modal */}
            <AnnouncementModal
                visible={announcementModalVisible}
                onCancel={handleAnnouncementModalCancel}
                onSend={handleSendAnnouncement}
                sending={sendingAnnouncement}
                availableVoices={availableVoices}
            />

            {/* Sound Selection Modal */}
            <SoundModal
                visible={soundModalVisible}
                selectedSound={selectedSound}
                setSelectedSound={setSelectedSound}
                previewingSound={previewingSound}
                setPreviewingSound={setPreviewingSound}
                broadcastingSound={broadcastingSound}
                onClose={() => setSoundModalVisible(false)}
                handleBroadcastSound={handleBroadcastSound}
                announcementSounds={announcementSounds}
                previewSound={previewSound}
            />


            {/* Statistics Modal */}
            <StatisticsModal
                visible={statisticsModalVisible}
                statistics={statistics}
                loading={loadingStatistics}
                onClose={() => {
                    setStatisticsModalVisible(false);
                    setStatistics(null);
                }}
                formatCurrency={formatCurrency}
            />


            {/* Control Panel Drawer - Owner Only */}
            {auction?.user_id === currentUser?.id && (
                <Drawer
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <SettingOutlined style={{ color: '#722ed1' }} />
                            <span>Control Panel</span>
                        </div>
                    }
                    open={controlPanelVisible}
                    onClose={() => setControlPanelVisible(false)}
                    destroyOnClose
                    width={400}
                    placement="right"
                >
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        {/* Auction Status Section */}
                        <Card title="Auction Status" size="small">
                            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                                <div>
                                    <Text type="secondary" style={{ fontSize: '12px' }}>Current Status</Text>
                                    <div>
                                        <Tag color={
                                            auction.status === 'active' ? 'green' :
                                                auction.status === 'completed' ? 'blue' :
                                                    auction.status === 'cancelled' ? 'red' : 'default'
                                        }>
                                            {auction.status?.toUpperCase()}
                                        </Tag>
                                    </div>
                                </div>
                                {auction.status === 'pending' && (
                                    <Button
                                        type="primary"
                                        icon={<PlayCircleFilled />}
                                        block
                                        onClick={async () => {
                                            try {
                                                await auctionService.startAuction(auction.slug);
                                                message.success('Auction started successfully');
                                                // Refresh auction data
                                                const response = await auctionService.getAuctionBySlug(auction.slug);
                                                if (response?.data) {
                                                    setAuction(response.data);
                                                }
                                            } catch (error) {
                                                console.error('Error starting auction:', error);
                                                message.error(error.response?.data?.message || 'Failed to start auction');
                                            }
                                        }}
                                    >
                                        Start Auction
                                    </Button>
                                )}
                                {auction.status === 'active' && (
                                    <>
                                        <Button
                                            type="primary"
                                            danger
                                            icon={<StopOutlined />}
                                            block
                                            onClick={async () => {
                                                Modal.confirm({
                                                    title: 'Complete Auction',
                                                    content: 'Are you sure you want to complete this auction? This will mark the auction as completed. This action cannot be undone.',
                                                    okText: 'Yes, Complete',
                                                    okType: 'danger',
                                                    cancelText: 'No',
                                                    onOk: async () => {
                                                        try {
                                                            const response = await auctionService.endAuction(auction.slug);
                                                            // Check if response indicates success
                                                            if (response?.status === 'success' || response?.data) {
                                                                message.success('Auction completed successfully');
                                                                // Update auction status locally immediately
                                                                setAuction(prev => ({
                                                                    ...prev,
                                                                    status: 'completed'
                                                                }));
                                                                // Refresh auction data silently (don't show error if it fails)
                                                                try {
                                                                    const auctionResponse = await auctionService.getAuction(auction.slug);
                                                                    // The response might be an AuctionResource, check for data property or use directly
                                                                    if (auctionResponse) {
                                                                        setAuction(auctionResponse.data || auctionResponse);
                                                                    }
                                                                } catch (refreshError) {
                                                                    console.error('Error refreshing auction data:', refreshError);
                                                                    // Don't show error for refresh failure - auction is already completed
                                                                }
                                                            } else {
                                                                message.error(response?.message || 'Failed to complete auction');
                                                            }
                                                        } catch (error) {
                                                            console.error('Error completing auction:', error);
                                                            // Only show error if it's a real error (not a successful completion)
                                                            const errorMessage = error.response?.data?.message || error.message;
                                                            if (errorMessage && !errorMessage.includes('completed successfully')) {
                                                                message.error(errorMessage);
                                                            }
                                                        }
                                                    }
                                                });
                                            }}
                                        >
                                            Complete Auction
                                        </Button>
                                        {/* Only show Cancel button if no bids have been placed */}
                                        {bidActivityData.length === 0 && (
                                            <Button
                                                danger
                                                icon={<CloseCircleFilled />}
                                                block
                                                onClick={async () => {
                                                    Modal.confirm({
                                                        title: 'Cancel Auction',
                                                        content: 'Are you sure you want to cancel this auction? This action cannot be undone.',
                                                        okText: 'Yes, Cancel',
                                                        okType: 'danger',
                                                        cancelText: 'No',
                                                        onOk: async () => {
                                                            try {
                                                                const response = await auctionService.cancelAuction(auction.slug);
                                                                // Check if response indicates success
                                                                if (response?.status === 'success' || response?.data) {
                                                                    message.success('Auction cancelled successfully');
                                                                    // Update auction status locally immediately
                                                                    setAuction(prev => ({
                                                                        ...prev,
                                                                        status: 'cancelled'
                                                                    }));
                                                                    // Refresh auction data silently (don't show error if it fails)
                                                                    try {
                                                                        const auctionResponse = await auctionService.getAuction(auction.slug);
                                                                        if (auctionResponse) {
                                                                            setAuction(auctionResponse.data || auctionResponse);
                                                                        }
                                                                    } catch (refreshError) {
                                                                        console.error('Error refreshing auction data:', refreshError);
                                                                        // Don't show error for refresh failure - auction is already cancelled
                                                                    }
                                                                } else {
                                                                    message.error(response?.message || 'Failed to cancel auction');
                                                                }
                                                            } catch (error) {
                                                                console.error('Error cancelling auction:', error);
                                                                // Only show error if it's a real error (not a successful cancellation)
                                                                const errorMessage = error.response?.data?.message || error.message;
                                                                if (errorMessage && !errorMessage.includes('cancelled successfully')) {
                                                                    message.error(errorMessage);
                                                                }
                                                            }
                                                        }
                                                    });
                                                }}
                                            >
                                                Cancel Auction
                                            </Button>
                                        )}
                                        {bidActivityData.length > 0 && (
                                            <Alert
                                                message="Cancellation Not Available"
                                                description="This auction cannot be cancelled because one or more lots have received bids. You can only complete the auction."
                                                type="info"
                                                showIcon
                                                style={{ marginTop: '8px' }}
                                            />
                                        )}
                                    </>
                                )}
                            </Space>
                        </Card>

                        {controlPanelVisible && (
                            <Card title="Live Stream" size="small">
                                <LiveStreamPanel
                                    {...liveStreamScreenProps}
                                    isOwner
                                    active={controlPanelVisible}
                                />
                            </Card>
                        )}

                    </Space>
                </Drawer>
            )}

            {/* Achievement Unlocked Modal */}
            <AchievementUnlockedModal
                visible={achievementModalVisible}
                achievements={unlockedAchievements}
                onClose={handleAchievementModalClose}
            />

            {/* Auction Organizer Modal */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: '18px'
                        }}>
                            <UserOutlined />
                        </div>
                        <span>{currentUser?.id === auction?.user_id ? 'You are organizing this auction' : 'Auction Organizer'}</span>
                    </div>
                }
                open={organizerModalVisible}
                onCancel={() => setOrganizerModalVisible(false)}
                footer={null}
                width={600}
                style={{ top: 20 }}
                bodyStyle={{
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    padding: '20px',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
                className="hide-scrollbar"
            >
                {auction && (
                    <ContactAgentsOwner
                        agents={auction.agents}
                        user={auction.user}
                        isPrivate={auction.is_private}
                        onContactClick={(type, value) => {
                            console.log(`Contact ${type}:`, value);
                        }}
                    />
                )}
            </Modal>

            {/* Announcements Banner */}
            {announcements.length > 0 && (
                <AnnouncementBanner
                    announcements={announcements}
                    onClose={() => setAnnouncements([])}
                />

            )}

            {/* Comparison Modal */}
            <ComparisonModal
                visible={comparisonModalVisible}
                onClose={() => setComparisonModalVisible(false)}
                comparisonLots={comparisonLots}
                lots={lots}
                onRemoveLot={removeFromComparison}
                onClearAll={clearComparison}
                currentUser={currentUser}
                auctionOwnerId={auction?.user_id}
            />

            {/* Bid Rejection Modal */}
            <BidRejectionModal
                visible={bidRejectionModal.visible}
                lotNumber={bidRejectionModal.lotNumber}
                errorMessage={bidRejectionModal.errorMessage}
                minimumBid={bidRejectionModal.minimumBid}
                isAutoBid={bidRejectionModal.isAutoBid}
                lotName={bidRejectionModal.lotName}
                onClose={() => setBidRejectionModal({ ...bidRejectionModal, visible: false })}
            />

            {/* Vendor Bid Confirmation Modal */}
            <Modal
                title="Place Vendor Bid"
                open={vendorBidModalVisible}
                onCancel={() => {
                    setVendorBidModalVisible(false);
                    setVendorBidAmount(null);
                }}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setVendorBidModalVisible(false);
                        setVendorBidAmount(null);
                    }}>
                        Cancel
                    </Button>,
                    <Button
                        key="place"
                        type="primary"
                        loading={statusLoadingLots.has(selectedLot?.id)}
                        disabled={timeRemaining === null || timeRemaining <= 5 || statusLoadingLots.has(selectedLot?.id)}
                        onClick={async () => {
                            // Final check before placing bid - time might have finished while modal was open
                            if (timeRemaining === null || timeRemaining <= 5) {
                                message.warning(`Vendor bid is disabled in the last 5 seconds. (${timeRemaining ?? 0}s remaining)`);
                                setVendorBidModalVisible(false);
                                setVendorBidAmount(null);
                                return;
                            }
                            try {
                                setStatusLoadingLots(prev => new Set([...prev, selectedLot.id]));
                                const response = await auctionService.placeVendorBid(auction.slug, selectedLot.slug);

                                if (response?.status === 'success') {
                                    message.success('Vendor bid placed successfully!');
                                    setVendorBidModalVisible(false);
                                    setVendorBidAmount(null);

                                    // Immediately update the lot's owner_bid_tracking to disable the button
                                    if (selectedLot) {
                                        const updatedLot = {
                                            ...selectedLot,
                                            owner_bid_tracking: {
                                                ...(selectedLot.owner_bid_tracking || {}),
                                                has_vendor_bid: true
                                            }
                                        };
                                        setSelectedLot(updatedLot);

                                        // Also update in lots array
                                        setLots(prevLots =>
                                            prevLots.map(lot =>
                                                lot.id === selectedLot.id
                                                    ? { ...lot, owner_bid_tracking: updatedLot.owner_bid_tracking }
                                                    : lot
                                            )
                                        );
                                    }
                                } else {
                                    throw new Error(response?.message || 'Failed to place vendor bid');
                                }
                            } catch (error) {
                                console.error('Error placing vendor bid:', error);
                                const errorMessage = error?.response?.data?.message || error?.message || 'Failed to place vendor bid';
                                // Show error message to auction owner
                                message.error({
                                    content: `Vendor bid was not placed: ${errorMessage}`,
                                    duration: 6,
                                    style: {
                                        marginTop: '20vh',
                                    }
                                });
                            } finally {
                                setStatusLoadingLots(prev => {
                                    const newSet = new Set(prev);
                                    newSet.delete(selectedLot.id);
                                    return newSet;
                                });
                            }
                        }}
                        style={{
                            background: (timeRemaining === null || timeRemaining <= 5) ? '#d9d9d9' : 'linear-gradient(135deg, #fa8c16 0%, #ffa940 100%)',
                            border: 'none',
                            color: (timeRemaining === null || timeRemaining <= 5) ? '#8c8c8c' : '#ffffff'
                        }}
                    >
                        Place Vendor Bid
                    </Button>
                ]}
                centered
            >
                <div>
                    {vendorBidAmount && selectedLot && (
                        <>
                            <p>This will place a vendor bid of <strong>{formatCurrency(vendorBidAmount)}</strong> (close to reserve price: {formatCurrency(selectedLot.reserve_price)}).</p>
                            <p>The lot will continue as normal after the vendor bid is placed, and the timer will reset.</p>
                            {(timeRemaining === null || timeRemaining <= 0) && (
                                <Alert
                                    message="Vendor bid is no longer available"
                                    description="The lot time has finished. You cannot place a vendor bid now."
                                    type="warning"
                                    showIcon
                                    style={{ marginTop: 16 }}
                                />
                            )}
                        </>
                    )}
                </div>
            </Modal>

        </div>
    );
};

export default LiveAuctionDetail; 